import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import "./App.css";
import axios from "axios";
import { AuthProvider, useAuth } from "./AuthContext";
import AuthPages from "./AuthPages";
import { Button } from "./components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card";
import { Input } from "./components/ui/input";
import { Label } from "./components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { SimpleNativeSelect } from '@/components/ui/NativeSelect';
import { FraisSelector } from './components/FraisSelector';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./components/ui/dialog";
import { CustomModal } from "./components/CustomModal";
import { FullScreenModal } from "./components/FullScreenModal";
import { Badge } from "./components/ui/badge";
import { FileText, Download, Upload, Users, Building2, Calculator, BarChart3, TrendingUp, Mail, Plus, Minus, Edit, Trash2, Save, X, Check, Eye, AlertTriangle, Shield, Loader2, CheckCircle, Copy, RefreshCw, Settings, Clock, LogOut, ToggleLeft, ToggleRight, Printer, User, XCircle, Calendar, BarChart2, Search, Book, Filter, AlertCircle, Info, HardDrive, ArrowLeft, UserPlus, Bell, AlertOctagon, ChevronLeft, ChevronRight, Phone, Banknote, History, Wrench } from 'lucide-react';
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";
import hotToast, { Toaster as HotToaster } from 'react-hot-toast';
import PDFManagement from './components/PDFManagement';
import PendingUsersManagement from './components/PendingUsersManagement';
import { AnnualDashboard } from './components/AnnualDashboard';
import { OvertimeManagement } from './components/OvertimeManagement';
import { SalaryAdjustment } from './components/SalaryAdjustment';
import { DeclarationsTab } from './components/DeclarationsTab';
import './lib/resizeObserver';
import { CATEGORIES_PROFESSIONNELLES, GRILLE_SALAIRES_CATEGORIELS, getSalaireCategoriel } from './lib/salaryData';
import { SafeResponsiveContainer } from './components/SafeResponsiveContainer';
import { BACKEND_URL, API } from './lib/api';
import { SPECIAL_PRIME_PLAFONDS, SPECIAL_EXEMPT_PRIMES, getSpecialPrimeField } from './lib/primesConfig';
import { cache, debounce } from './lib/cacheUtils';

const MainApp = () => {
  const { user, logout, loading, token } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);
  const [payrollEmployeeSearch, setPayrollEmployeeSearch] = useState('');
  const [employeesPagination, setEmployeesPagination] = useState({
    page: 1,
    limit: 50,
    total_count: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false
  });
  const [pendingCompanies, setPendingCompanies] = useState([]);
  const [loadingPendingCompanies, setLoadingPendingCompanies] = useState(false);

  
  // États pour les dossiers administratifs
  const [selectedEmployeeForAdmin, setSelectedEmployeeForAdmin] = useState(null);
  const [isAdminFolderOpen, setIsAdminFolderOpen] = useState(false);
  const [adminFolderTab, setAdminFolderTab] = useState('contracts');
  const [droitsLegauxTab, setDroitsLegauxTab] = useState('gratifications'); // État pour les sous-onglets droits légaux
  const [documentsSortieTab, setDocumentsSortieTab] = useState('solde-compte'); // Nouvel état pour les sous-onglets documents de sortie
  
  // États pour contrôler l'ouverture des sous-modales du dossier administratif
  const [isNewContractOpen, setIsNewContractOpen] = useState(false);
  const [isNewExplanationOpen, setIsNewExplanationOpen] = useState(false);
  const [isNewSanctionOpen, setIsNewSanctionOpen] = useState(false);
  const [isNewGratificationOpen, setIsNewGratificationOpen] = useState(false);
  const [isNewCongeOpen, setIsNewCongeOpen] = useState(false);
  const [isNewBulletinOpen, setIsNewBulletinOpen] = useState(false);
  const [isNewSoldeCompteOpen, setIsNewSoldeCompteOpen] = useState(false);
  const [isNewCertificatOpen, setIsNewCertificatOpen] = useState(false);
  
  // États pour la modification des documents administratifs
  const [editingDocument, setEditingDocument] = useState(null);
  const [isEditDocumentOpen, setIsEditDocumentOpen] = useState(false);
  
  // État pour le bouton "Ajouter contrat" - feedback visuel
  const [isAddingContract, setIsAddingContract] = useState(false);
  
  const [contracts, setContracts] = useState([]);
  const [explanationRequests, setExplanationRequests] = useState([]);
  const [disciplinarySanctions, setDisciplinarySanctions] = useState([]);
  // Nouveaux états pour les nouvelles sections
  const [gratifications, setGratifications] = useState([]);
  const [conges, setConges] = useState([]);
  const [bulletinsEmarges, setBulletinsEmarges] = useState([]); // Nouvel état pour bulletins émargés
  const [soldesCompte, setSoldesCompte] = useState([]);
  const [certificatsTravail, setCertificatsTravail] = useState([]);
  const [loadingAdminData, setLoadingAdminData] = useState(false);
  const [downloadingContractId, setDownloadingContractId] = useState(null);
  const [viewingContractId, setViewingContractId] = useState(null);
  const [downloadingExplanationId, setDownloadingExplanationId] = useState(null);
  const [downloadingDocumentId, setDownloadingDocumentId] = useState(null);
  
  const [stats, setStats] = useState(null);
  const [payrolls, setPayrolls] = useState([]);
  const [salaryComponents, setSalaryComponents] = useState([]);
  const [isCreateCompanyOpen, setIsCreateCompanyOpen] = useState(false);
  const [isCreateEmployeeOpen, setIsCreateEmployeeOpen] = useState(false);
  const [isCalculatePayrollOpen, setIsCalculatePayrollOpen] = useState(false);
  const [documentsEmployee, setDocumentsEmployee] = useState(null);
  const [hrDocsHistory, setHrDocsHistory] = useState([]);
  const [generatingDocType, setGeneratingDocType] = useState(null);
  const [hrCongesDebut, setHrCongesDebut] = useState('');
  const [hrCongesFin, setHrCongesFin] = useState('');
  const [hrCongesMontant, setHrCongesMontant] = useState('');
  const [hrGratifAnnee, setHrGratifAnnee] = useState(new Date().getFullYear());
  const [hrGratifMontant, setHrGratifMontant] = useState('');
  const [hrSignatoryName, setHrSignatoryName] = useState('');
  const [hrSignatoryTitle, setHrSignatoryTitle] = useState('Représentant légal');
  const [isMonthlyPayrollOpen, setIsMonthlyPayrollOpen] = useState(false);
  const [monthlyPayrollSelection, setMonthlyPayrollSelection] = useState([]);
  const [monthlyPayrollPeriod, setMonthlyPayrollPeriod] = useState({ month: new Date().getMonth() + 1, year: new Date().getFullYear() });
  const [monthlyPayrollResult, setMonthlyPayrollResult] = useState(null);
  const [generatingMonthlyPayroll, setGeneratingMonthlyPayroll] = useState(false);
  const [isManageSalaryComponentsOpen, setIsManageSalaryComponentsOpen] = useState(false);
  const [isEditCompanyOpen, setIsEditCompanyOpen] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [isEditEmployeeOpen, setIsEditEmployeeOpen] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [activeTab, setActiveTab] = useState('employees');
  
  // États pour les alertes de contrats expirants
  const [expiringContracts, setExpiringContracts] = useState([]);
  const [showContractAlert, setShowContractAlert] = useState(false);
  const [hasPlayedAlertToday, setHasPlayedAlertToday] = useState(false);
  
  // 🚀 Optimisation réactivité onglets - Callback memoized pour changement ultra-rapide
  const handleTabChange = useCallback((newTab) => {
    // Transition immédiate sans délai
    setActiveTab(newTab);
    
    // Force le repaint immédiat pour éliminer la latence visuelle
    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(() => {
        // Trigger visual update immédiat
        document.documentElement.style.transform = 'translateZ(0)';
        setTimeout(() => {
          document.documentElement.style.transform = '';
        }, 0);
      });
    }
  }, []);

  // Navigation depuis la bibliothèque Documents vers la fiche employé
  const [highlightedEmployeeId, setHighlightedEmployeeId] = useState(null);
  const handleViewEmployeeFromDoc = useCallback((pdf) => {
    if (pdf.company_id && selectedCompany?.id !== pdf.company_id) {
      const comp = companies.find(c => c.id === pdf.company_id);
      if (comp) setSelectedCompany(comp);
    }
    setHighlightedEmployeeId(pdf.related_entity_id);
    handleTabChange('employees');
  }, [companies, selectedCompany, handleTabChange]);

  useEffect(() => {
    if (!highlightedEmployeeId || activeTab !== 'employees' || !selectedCompany) return;
    let cancelled = false;
    const locate = async () => {
      await new Promise(r => setTimeout(r, 700));
      if (cancelled) return;
      const inCurrentList = () => document.getElementById(`employee-card-${highlightedEmployeeId}`);
      if (!inCurrentList()) {
        try {
          for (let p = 1; p <= 20; p++) {
            const res = await axios.get(`${API}/companies/${selectedCompany.id}/employees?page=${p}&limit=50`);
            if (cancelled) return;
            if ((res.data.employees || []).some(e => e.id === highlightedEmployeeId)) {
              setEmployees(res.data.employees);
              setEmployeesPagination(res.data.pagination);
              break;
            }
            if (!res.data.pagination?.has_next) {
              toast.info("L'employé lié à ce document n'a pas été trouvé dans cette entreprise");
              setHighlightedEmployeeId(null);
              return;
            }
          }
        } catch (e) {
          return;
        }
      }
      setTimeout(() => {
        const el = inCurrentList();
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 400);
      setTimeout(() => { if (!cancelled) setHighlightedEmployeeId(null); }, 6000);
    };
    locate();
    return () => { cancelled = true; };
  }, [highlightedEmployeeId, activeTab, selectedCompany]);

  const [manageSection, setManageSection] = useState('users');
  const [approvalSubSection, setApprovalSubSection] = useState('users'); // 'users' ou 'companies'
  const [payrollSection, setPayrollSection] = useState('calculation'); // 'calculation', 'bulletin', or 'generated'
  const [bulletinEmployeeSearch, setBulletinEmployeeSearch] = useState('');
  const [loans, setLoans] = useState([]);
  const [isLoadingLoans, setIsLoadingLoans] = useState(false); // État de chargement pour les prêts
  const [loanRepaymentHistory, setLoanRepaymentHistory] = useState(null); // Historique des remboursements
  const [selectedLoanForHistory, setSelectedLoanForHistory] = useState(null);
  const [loanForm, setLoanForm] = useState({
    employee_id: '',
    amount: '',
    monthly_deduction: '',
    start_date: '',
    description: ''
  });
  const [companyFilter, setCompanyFilter] = useState("");
  const [companyStats, setCompanyStats] = useState({});
  const [emailSending, setEmailSending] = useState(false);
  const [pdfDownloading, setPdfDownloading] = useState(false);
  const [bulkPdfDownloading, setBulkPdfDownloading] = useState(false);
  const [emailResults, setEmailResults] = useState(null);
  const [smtpConfig, setSmtpConfig] = useState(null);
  const [isSmtpConfigOpen, setIsSmtpConfigOpen] = useState(false);
  const [smtpForm, setSmtpForm] = useState({
    smtp_server: '',
    smtp_port: 587,
    sender_email: '',
    sender_password: '',
    sender_name: 'Système RH',
    use_tls: true
  });

  // État pour la déclaration ITS (rapports)
  const [isITSDeclarationOpen, setIsITSDeclarationOpen] = useState(false);
  const [itsDeclarationForm, setItsDeclarationForm] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });

  // États pour la section Déclaration ITS complète
  
  // User management states
  const [users, setUsers] = useState([]);
  const [isCreateUserOpen, setIsCreateUserOpen] = useState(false);
  const [isEditUserOpen, setIsEditUserOpen] = useState(false);
  const [isUpdatingUser, setIsUpdatingUser] = useState(false);
  
  // System overview states
  const [systemOverview, setSystemOverview] = useState(null);
  const [loadingSystemOverview, setLoadingSystemOverview] = useState(false);
  
  // États pour les nouvelles fonctionnalités entreprises
  const [isDeleteCompanyDialogOpen, setIsDeleteCompanyDialogOpen] = useState(false);
  const [companyBeingDeleted, setCompanyBeingDeleted] = useState(null); // Pour formulaire inline de suppression
  const [companyBeingToggled, setCompanyBeingToggled] = useState(null); // Pour formulaire inline de désactivation
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [isToggleCompanyStatusOpen, setIsToggleCompanyStatusOpen] = useState(false);
  const [companyToToggle, setCompanyToToggle] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isBackupInProgress, setIsBackupInProgress] = useState(false);
  
  // États pour la restauration des données et photos
  const [restoreFile, setRestoreFile] = useState(null);
  const [isRestoreInProgress, setIsRestoreInProgress] = useState(false);
  const [isRestoreDialogOpen, setIsRestoreDialogOpen] = useState(false);
  const [isSystemRestoreDialogOpen, setIsSystemRestoreDialogOpen] = useState(false);
  const [systemRestoreFile, setSystemRestoreFile] = useState(null);
  const [isFileBackupInProgress, setIsFileBackupInProgress] = useState(false);
  const [isFileRestoreInProgress, setIsFileRestoreInProgress] = useState(false);
  const [backupsList, setBackupsList] = useState([]);
  const [fileRestoreUpload, setFileRestoreUpload] = useState(null);
  const [isUploadRestoreInProgress, setIsUploadRestoreInProgress] = useState(false);
  
  // États pour l'export et l'impression du registre chronologique
  const [isExportingExcel, setIsExportingExcel] = useState(false);
  const [isPrintingRegistre, setIsPrintingRegistre] = useState(false);
  const [isExportingPDF, setIsExportingPDF] = useState(false);
  
  // États pour le livre de paie (affichage à l'écran)
  const [isViewingLivrePaie, setIsViewingLivrePaie] = useState(false);
  const [livrePaieData, setLivrePaieData] = useState(null);
  const [livrePaiePeriod, setLivrePaiePeriod] = useState({ month: null, year: null });
  const [livrePaieStats, setLivrePaieStats] = useState({
    employeeCount: 0,
    totalBrut: 0,
    totalRetenues: 0,
    totalNet: 0
  });
  
  // États pour l'historique des bulletins
  const [bulletinsHistory, setBulletinsHistory] = useState([]);
  const [isLoadingBulletinsHistory, setIsLoadingBulletinsHistory] = useState(false);
  
  // État pour détecter les tablettes et optimiser l'affichage
  const [isTablet, setIsTablet] = useState(false);
  const [screenSize, setScreenSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [overviewRoleFilter, setOverviewRoleFilter] = useState('all');
  const [overviewStatusFilter, setOverviewStatusFilter] = useState('all');
  const [editingUser, setEditingUser] = useState(null);
  const [userFilter, setUserFilter] = useState("");
  
  // États pour le diagnostic des accès utilisateur
  const [userAccessDiagnostic, setUserAccessDiagnostic] = useState(null);
  const [isLoadingDiagnostic, setIsLoadingDiagnostic] = useState(false);
  const [showDiagnosticModal, setShowDiagnosticModal] = useState(false);
  const [isRepairingAccess, setIsRepairingAccess] = useState(false);
  
  // États pour la recherche globale
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState({ employees: [], companies: [], payrolls: [] });
  const [isSearching, setIsSearching] = useState(false);
  
  // États pour le résumé salarial d'un employé (affiché après clic dans la recherche)
  const [showSalaryPreview, setShowSalaryPreview] = useState(false);
  const [salaryPreviewData, setSalaryPreviewData] = useState(null);
  const [isLoadingSalaryPreview, setIsLoadingSalaryPreview] = useState(false);

  // Form states
  const [companyForm, setCompanyForm] = useState({
    name: "", address: "", phone: "", email: "", registration_number: "", cnps_number: "", ncc_number: "", gerant: "", ville: "autres", secteur_activite: "bureau", logo_url: null
  });
  
  // États pour la gestion des logos d'entreprise
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [selectedLogoFile, setSelectedLogoFile] = useState(null);
  const [employeeForm, setEmployeeForm] = useState({
    first_name: "", last_name: "", sexe: "M", email: "", phone: "", position: "",
    numero_cnps: "", // Numéro CNPS de l'employé
    secteur_activite_precis: "", // Secteur précis d'activité (grille salariale)
    categorie_professionnelle: "", // Catégorie professionnelle de l'employé
    sous_categorie_professionnelle: "", // Sous-catégorie selon la catégorie
    grade: "", // Grade saisi manuellement (ex: 3A, 2B, etc.)
    salary_categoriel: "", sursalaire: 0, prime_transport: 0,
    prime_anciennete: 0, allocations_familiales_imposables: 0,
    avantages_nature: 0, avantages_argent: 0, remboursement_frais: 0,
    indemnite_frais_emploi: 0, prime_panier: 0, prime_salissure: 0, prime_tenue: 0, prime_outillage: 0,
    cmu_employeur: 0, cmu_salarie: 0, cmu_active: false,
    formation_continue: 0, taxe_apprentissage: 0, is_patronal: 0, is_salarie: 0,
    // Nouveaux champs RICF (Réduction d'impôt pour charges de famille)
    statut_matrimonial: "celibataire", nombre_enfants: 0, nombre_enfants_infirmes: 0,
    indemnites: [], primes: [], complement_retraite: [], frais: [],
    special_allowance_amounts: {},  // Stocke les montants personnalisés {componentId: amount}
    component_amounts: {},  // Montants personnalisés des indemnités/primes {componentId: amount}
    contract_type: "CDI", hire_date: "", date_fin_activite: "",
    gratification_display_consent: true,  // Consentement pour l'affichage des gratifications
    allocations_familiales_consent: true,  // Autorisation pour les allocations familiales
    photo_url: null, photo_filename: null  // Pour la gestion des photos
  });

  // 🚀 OPTIMISATION CRITIQUE - Handler de formulaire ultra-rapide
  const updateEmployeeField = useCallback((field, value) => {
    setEmployeeForm(prev => {
      // Évite le re-render si la valeur n'a pas changé
      if (prev[field] === value) return prev;
      return { ...prev, [field]: value };
    });
  }, []);

  // 🚀 Handlers optimisés pour chaque champ (mémorisés)
  const handleFirstNameChange = useCallback((e) => {
    updateEmployeeField('first_name', e.target.value);
  }, [updateEmployeeField]);

  const handleLastNameChange = useCallback((e) => {
    updateEmployeeField('last_name', e.target.value);
  }, [updateEmployeeField]);

  const handleEmailChange = useCallback((e) => {
    updateEmployeeField('email', e.target.value);
  }, [updateEmployeeField]);

  const handlePhoneChange = useCallback((e) => {
    updateEmployeeField('phone', e.target.value);
  }, [updateEmployeeField]);

  const handlePositionChange = useCallback((e) => {
    updateEmployeeField('position', e.target.value);
  }, [updateEmployeeField]);

  const handleNumCNPSChange = useCallback((e) => {
    updateEmployeeField('numero_cnps', e.target.value);
  }, [updateEmployeeField]);

  const handleSalaryCategorielChange = useCallback((e) => {
    updateEmployeeField('salary_categoriel', e.target.value);
  }, [updateEmployeeField]);

  // 🚀 Optimisation réactivité - Callback pour type de contrat (ULTRA-OPTIMISÉ)
  const handleContractTypeChange = useCallback((value) => {
    // Utilisation de requestAnimationFrame pour une exécution immédiate
    requestAnimationFrame(() => {
      try {
        console.log('Sélection type de contrat:', value);
        // Mise à jour immédiate du formulaire employé
        setEmployeeForm(prev => ({
          ...prev,
          contract_type: value
        }));
      } catch (error) {
        console.error('Erreur sélection type de contrat:', error);
      }
    });
  }, []);

  // Fonction pour changer d'entreprise (définie avant handleCompanySelection)
  const switchToCompany = (company) => {
    setSelectedCompany(company);
    toast.success(`Basculé vers ${company.name}`);
  };

  // 🚀 Optimisation réactivité - Callback pour sélection d'entreprise (ULTRA-OPTIMISÉ)
  const handleCompanySelection = useCallback((value) => {
    // Utilisation de requestAnimationFrame pour une exécution immédiate
    requestAnimationFrame(() => {
      try {
        console.log('🏢 Sélection entreprise:', value);
        const company = companies.find(c => c.id === value);
        if (company) {
          console.log('✅ Entreprise trouvée:', company.name);
          switchToCompany(company);
        } else {
          console.error('❌ Entreprise non trouvée pour ID:', value);
        }
      } catch (error) {
        console.error('❌ Erreur sélection entreprise:', error);
      }
    });
  }, [companies, switchToCompany]);

  // 🚀 Optimisation réactivité - Callback pour sélection d'employé dans paie
  const handleEmployeeSelection = useCallback((value) => {
    const source = allEmployees.length > 0 ? allEmployees : employees;
    const selectedEmployee = source.find(emp => emp.id === value);
    setPayrollForm(prev => ({
      ...prev,
      employee_id: value,
      // Pré-remplir automatiquement TOUS les éléments de paie depuis le profil de l'employé
      prime_transport: selectedEmployee?.prime_transport || 0,
      avantages_nature: selectedEmployee?.avantages_nature || 0,
      avantages_argent: selectedEmployee?.avantages_argent || 0,
      anciennete: 0, // La prime d'ancienneté du profil est déjà appliquée automatiquement par le moteur de paie
      indemnite_frais_emploi: selectedEmployee?.indemnite_frais_emploi || 0,
      remboursement_frais: selectedEmployee?.remboursement_frais || 0,
      prime_panier: selectedEmployee?.prime_panier || 0,
      prime_salissure: selectedEmployee?.prime_salissure || 0,
      prime_tenue: selectedEmployee?.prime_tenue || 0,
      prime_outillage: selectedEmployee?.prime_outillage || 0,
      special_allowance_amounts: { ...(selectedEmployee?.special_allowance_amounts || {}) }
    }));
  }, [employees, allEmployees]);

  // 🚀 Optimisation réactivité - Callback pour ville entreprise
  const handleCompanyVilleChange = useCallback((value) => {
    setCompanyForm(prev => ({
      ...prev,
      ville: value
    }));
  }, []);

  // 🚀 Optimisation réactivité - Callback pour secteur d'activité
  const handleSecteurActiviteChange = useCallback((value) => {
    setCompanyForm(prev => ({
      ...prev,
      secteur_activite: value
    }));
  }, []);

  // 🚀 CALLBACKS OPTIMISÉS POUR SECTION EMPLOYÉS
  
  // Callback pour ouvrir modal nouvel employé
  const handleOpenCreateEmployee = useCallback(() => {
    try {
      console.log('Ouverture modal création employé');
      setIsCreateEmployeeOpen(true);
    } catch (error) {
      console.error('Erreur ouverture modal employé:', error);
    }
  }, []);

  // Callback pour type d'élément de salaire
  const handleSalaryComponentTypeChange = useCallback((value) => {
    try {
      setSalaryComponentForm(prev => ({
        ...prev,
        type: value
      }));
    } catch (error) {
      console.error('Erreur changement type élément salaire:', error);
    }
  }, []);

  // Callback pour indemnités
  const handleIndemniteChange = useCallback((value) => {
    try {
      if (!employeeForm.indemnites.includes(value)) {
        setEmployeeForm(prev => ({
          ...prev,
          indemnites: [...prev.indemnites, value]
        }));
      }
    } catch (error) {
      console.error('Erreur ajout indemnité:', error);
    }
  }, [employeeForm.indemnites]);

  // Callback pour primes
  const handlePrimeChange = useCallback((value) => {
    try {
      const component = salaryComponents.find(c => c.id === value);
      const specialField = component ? getSpecialPrimeField(component.name) : null;
      if (specialField) {
        // Prime spéciale exonérée → champ dédié avec montant prédéfini (modifiable ensuite)
        setEmployeeForm(prev => ({
          ...prev,
          [specialField]: parseFloat(prev[specialField]) > 0 ? prev[specialField] : (component.amount || 0)
        }));
        return;
      }
      if (!employeeForm.primes.includes(value)) {
        setEmployeeForm(prev => ({
          ...prev,
          primes: [...prev.primes, value],
          component_amounts: { ...prev.component_amounts, [value]: component?.amount || 0 }
        }));
      }
    } catch (error) {
      console.error('Erreur ajout prime:', error);
    }
  }, [employeeForm.primes, salaryComponents]);

  // Callback pour complément retraite
  const handleComplementRetraiteChange = useCallback((value) => {
    try {
      if (!employeeForm.complement_retraite.includes(value)) {
        // Trouver le composant pour obtenir son montant par défaut
        const component = salaryComponents.find(c => c.id === value);
        const defaultAmount = component?.amount || 0;
        
        setEmployeeForm(prev => ({
          ...prev,
          complement_retraite: [...prev.complement_retraite, value],
          // Initialiser le montant personnalisé avec le montant par défaut du composant
          special_allowance_amounts: {
            ...prev.special_allowance_amounts,
            [value]: defaultAmount
          }
        }));
      }
    } catch (error) {
      console.error('Erreur ajout complément retraite:', error);
    }
  }, [employeeForm.complement_retraite, salaryComponents]);

  // Callback pour supprimer indemnité
  const handleRemoveIndemnite = useCallback((indemniteId) => {
    try {
      setEmployeeForm(prev => {
        const newComponentAmounts = { ...prev.component_amounts };
        delete newComponentAmounts[indemniteId];
        return {
          ...prev,
          indemnites: prev.indemnites.filter(id => id !== indemniteId),
          component_amounts: newComponentAmounts
        };
      });
    } catch (error) {
      console.error('Erreur suppression indemnité:', error);
    }
  }, []);

  // Callback pour supprimer prime  
  const handleRemovePrime = useCallback((primeId) => {
    try {
      setEmployeeForm(prev => {
        const newComponentAmounts = { ...prev.component_amounts };
        delete newComponentAmounts[primeId];
        return {
          ...prev,
          primes: prev.primes.filter(id => id !== primeId),
          component_amounts: newComponentAmounts
        };
      });
    } catch (error) {
      console.error('Erreur suppression prime:', error);
    }
  }, []);

  // Callback pour supprimer complément retraite
  const handleRemoveComplementRetraite = useCallback((compId) => {
    try {
      setEmployeeForm(prev => {
        // Créer une copie de special_allowance_amounts sans le composant supprimé
        const newSpecialAllowanceAmounts = { ...prev.special_allowance_amounts };
        delete newSpecialAllowanceAmounts[compId];
        
        return {
          ...prev,
          complement_retraite: prev.complement_retraite.filter(id => id !== compId),
          special_allowance_amounts: newSpecialAllowanceAmounts
        };
      });
    } catch (error) {
      console.error('Erreur suppression complément retraite:', error);
    }
  }, []);

  // Callback pour statut matrimonial
  const handleStatutMatrimonialChange = useCallback((value) => {
    try {
      setEmployeeForm(prev => ({
        ...prev,
        statut_matrimonial: value
      }));
    } catch (error) {
      console.error('Erreur changement statut matrimonial:', error);
    }
  }, []);

  // 🚀 CALLBACKS OPTIMISÉS SUPPLÉMENTAIRES POUR TOUS LES SELECT

  // Callback pour mois paie
  const handlePayrollMonthChange = useCallback((value) => {
    try {
      setPayrollForm(prev => ({
        ...prev,
        month: parseInt(value)
      }));
    } catch (error) {
      console.error('Erreur changement mois paie:', error);
    }
  }, []);

  // Callback pour année paie
  const handlePayrollYearChange = useCallback((value) => {
    try {
      setPayrollForm(prev => ({
        ...prev,
        year: parseInt(value)
      }));
    } catch (error) {
      console.error('Erreur changement année paie:', error);
    }
  }, []);

  // Callback pour nombre d'enfants
  const handleNombreEnfantsChange = useCallback((value) => {
    try {
      setEmployeeForm(prev => ({
        ...prev,
        nombre_enfants: parseInt(value)
      }));
    } catch (error) {
      console.error('Erreur changement nombre enfants:', error);
    }
  }, []);

  // Callback pour nombre d'enfants infirmes
  const handleNombreEnfantsInfirmesChange = useCallback((value) => {
    try {
      setEmployeeForm(prev => ({
        ...prev,
        nombre_enfants_infirmes: parseInt(value)
      }));
    } catch (error) {
      console.error('Erreur changement nombre enfants infirmes:', error);
    }
  }, []);

  // Callback générique pour employé form
  const handleEmployeeFormFieldChange = useCallback((fieldName) => (value) => {
    try {
      setEmployeeForm(prev => ({
        ...prev,
        [fieldName]: value
      }));
    } catch (error) {
      console.error(`Erreur changement ${fieldName}:`, error);
    }
  }, []);

  // Callback générique pour company form
  const handleCompanyFormFieldChange = useCallback((fieldName) => (value) => {
    try {
      setCompanyForm(prev => ({
        ...prev,
        [fieldName]: value
      }));
    } catch (error) {
      console.error(`Erreur changement ${fieldName}:`, error);
    }
  }, []);

  // Callback générique pour payroll form
  const handlePayrollFormFieldChange = useCallback((fieldName) => (value) => {
    try {
      setPayrollForm(prev => ({
        ...prev,
        [fieldName]: value
      }));
    } catch (error) {
      console.error(`Erreur changement ${fieldName}:`, error);
    }
  }, []);

  // Callback pour userForm role
  const handleUserRoleChange = useCallback((value) => {
    try {
      setUserForm(prev => ({ ...prev, role: value }));
    } catch (error) {
      console.error('Erreur changement rôle utilisateur:', error);
    }
  }, []);

  // Callback pour ajouter une entreprise à un utilisateur
  const handleUserAddCompanyAccess = useCallback((value) => {
    try {
      setUserForm(prev => {
        if (!prev.company_access.includes(value)) {
          return { ...prev, company_access: [...prev.company_access, value] };
        }
        return prev;
      });
    } catch (error) {
      console.error('Erreur ajout entreprise utilisateur:', error);
    }
  }, []);

  const [payrollForm, setPayrollForm] = useState({
    employee_id: "", month: new Date().getMonth() + 1, year: new Date().getFullYear(),
    heures_sup: 0, primes: 0, avances: 0, absences_hours: 0,
    prime_transport: 0, // Prime de transport (pré-remplie depuis la fiche employé)
    avantages_nature: 0, // Avantages en nature (pré-remplis depuis la fiche employé)
    avantages_argent: 0, // Avantages en argent (pré-remplis depuis la fiche employé)
    anciennete: 0, // Ancienneté (totalement imposable)
    indemnite_frais_emploi: 0, // Indemnité pour frais d'emploi (partiellement non imposable - 10%)
    remboursement_frais: 0, // Remboursement de frais (totalement exonéré)
    prime_panier: 0, // Prime de panier (exonérée plafonnée)
    prime_salissure: 0, // Prime de salissure (exonérée plafonnée)
    prime_tenue: 0, // Indemnité de tenue de travail (exonérée plafonnée)
    prime_outillage: 0, // Prime d'outillage (exonérée plafonnée)
    special_allowance_amounts: {}, // Allocations spéciales Art. 116-1 (pré-remplies depuis la fiche employé)
    payment_method: 'espece' // Mode de paiement par défaut
  });

  // Pré-remplir automatiquement les heures supplémentaires saisies dans l'onglet dédié
  useEffect(() => {
    if (!payrollForm.employee_id || !payrollForm.month || !payrollForm.year) return;
    axios.get(`${API}/employees/${payrollForm.employee_id}/overtime-total?month=${payrollForm.month}&year=${payrollForm.year}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(res => {
      if (res.data && res.data.total_amount > 0) {
        setPayrollForm(prev => ({ ...prev, heures_sup: Math.round(res.data.total_amount) }));
        toast.info(`Heures supplémentaires pré-remplies : ${Math.round(res.data.total_amount).toLocaleString('fr-FR')} FCFA (${res.data.entries_count} saisie(s))`);
      }
    }).catch(() => {});
  }, [payrollForm.employee_id, payrollForm.month, payrollForm.year]);

  // Aperçu du salaire net en direct dans le formulaire "Calculer la paie"
  const [payrollLivePreview, setPayrollLivePreview] = useState(null);
  const [payrollPreviewLoading, setPayrollPreviewLoading] = useState(false);
  useEffect(() => {
    if (!payrollForm.employee_id) { setPayrollLivePreview(null); return; }
    setPayrollPreviewLoading(true);
    const timer = setTimeout(() => {
      axios.post(`${API}/payroll/calculate`, {
        ...payrollForm,
        heures_sup: parseFloat(payrollForm.heures_sup) || 0,
        primes: parseFloat(payrollForm.primes) || 0,
        avances: parseFloat(payrollForm.avances) || 0,
        absences_hours: parseFloat(payrollForm.absences_hours) || 0
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
        .then(res => setPayrollLivePreview(res.data.results))
        .catch(() => setPayrollLivePreview(null))
        .finally(() => setPayrollPreviewLoading(false));
    }, 600);
    return () => clearTimeout(timer);
  }, [JSON.stringify(payrollForm)]);

  const [salaryComponentForm, setSalaryComponentForm] = useState({
    name: "", type: "indemnite", is_special_allowance: false, auto_taxable_calculation: false, taxable_rate: 1.0, taxable_calculation_type: 'rate', fixed_taxable_amount: 0,
    auto_exempt_calculation: false, exempt_rate: 1.0, exempt_calculation_type: 'rate', fixed_exempt_amount: 0
  });
  const [editingSalaryComponent, setEditingSalaryComponent] = useState(null); // Pour l'édition
  const [userForm, setUserForm] = useState({
    username: "", email: "", full_name: "", password: "", role: "admin_single", company_access: []
  });
  
  // États pour la génération de bulletins
  const [isBulletinGenerationOpen, setIsBulletinGenerationOpen] = useState(false);
  const [selectedEmployeesForBulletin, setSelectedEmployeesForBulletin] = useState([]);
  const [bulletinPeriod, setBulletinPeriod] = useState({
    start: new Date().toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });
  const [generatedBulletins, setGeneratedBulletins] = useState(null);
  const [updateStatistics, setUpdateStatistics] = useState(false); // Nouveau état pour contrôler la mise à jour des statistiques

  // États pour la gestion des photos d'employés
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [deletingPhoto, setDeletingPhoto] = useState(false);

  // États pour l'ajustement automatique du sursalaire
  const [isSalaryAdjustmentOpen, setIsSalaryAdjustmentOpen] = useState(false);

  // États pour la paie journalière
  const [isDailyPayrollOpen, setIsDailyPayrollOpen] = useState(false);
  const [dailyPayrollForm, setDailyPayrollForm] = useState({
    employee_id: "",
    heures_travaillees_jour: 8.0,
    salaire_base_periode: "", // Salaire de base pour la période (obligatoire)
    periode_en_jours: 30, // NOUVEAU: Nombre de jours de la période (défaut: 30)
    type_calcul: "complet",
    periode: "", // Saisie manuelle (ex: "15 jours", "1 mois", etc.)
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    // Nouveau: pour le calcul inverse
    net_journalier_souhaite: "",
    mode_calcul: "normal" // "normal" ou "inverse"
  });
  const [dailyPayrollResult, setDailyPayrollResult] = useState(null);
  const [calculatingDailyPayroll, setCalculatingDailyPayroll] = useState(false);
  const [showDailyPayrollPreview, setShowDailyPayrollPreview] = useState(false);
  
  // Historique des calculs inverse
  const [inverseCalculationHistory, setInverseCalculationHistory] = useState(() => {
    const saved = localStorage.getItem('inverseCalculationHistory');
    return saved ? JSON.parse(saved) : [];
  });
  const [showInverseHistory, setShowInverseHistory] = useState(false);

  // États pour la création d'employés journaliers
  const [isCreateDailyEmployeeOpen, setIsCreateDailyEmployeeOpen] = useState(false);
  const [dailyEmployeeForm, setDailyEmployeeForm] = useState({
    first_name: "",
    last_name: "",
    position: "Ouvrier journalier",
    categorie_professionnelle: "",
    sous_categorie_professionnelle: "",
    grade: "",
    salary_categoriel: 0,
    phone: "",
    email: "",
    hire_date: new Date().toISOString().split('T')[0] // Date par défaut = aujourd'hui
  });
  const [creatingDailyEmployee, setCreatingDailyEmployee] = useState(false);

  useEffect(() => {
    // Gestionnaire d'erreurs global pour capturer les erreurs non gérées
    const handleGlobalError = (event) => {
      if (event.error && event.error.message) {
        const message = event.error.message.toLowerCase();
        // Capturer toutes les variantes d'erreurs ResizeObserver
        if (message.includes('resizeobserver') || 
            message.includes('resize observer') ||
            message.includes('undelivered notifications') ||
            message.includes('loop completed')) {
          // Empêcher l'affichage de l'erreur dans la console
          event.preventDefault();
          return false;
        }
      }
    };

    const handleUnhandledRejection = (event) => {
      if (event.reason && event.reason.message) {
        const message = event.reason.message.toLowerCase();
        // Capturer toutes les variantes d'erreurs ResizeObserver
        if (message.includes('resizeobserver') || 
            message.includes('resize observer') ||
            message.includes('undelivered notifications') ||
            message.includes('loop completed')) {
          // Empêcher l'affichage de l'erreur dans la console
          event.preventDefault();
          return false;
        }
      }
    };

    // Gestionnaire spécifique pour les erreurs ResizeObserver au niveau global
    const originalErrorHandler = window.onerror;
    window.onerror = function(message, source, lineno, colno, error) {
      if (typeof message === 'string') {
        const msg = message.toLowerCase();
        if (msg.includes('resizeobserver') || 
            msg.includes('undelivered notifications') ||
            msg.includes('loop completed')) {
          // Supprimer l'erreur ResizeObserver silencieusement
          return true;
        }
      }
      // Appeler le gestionnaire d'erreur original pour les autres erreurs
      if (originalErrorHandler) {
        return originalErrorHandler.apply(this, arguments);
      }
      return false;
    };

    // Intercepter et filtrer les erreurs de console
    const originalConsoleError = console.error;
    console.error = function(...args) {
      const message = args.join(' ').toLowerCase();
      if (message.includes('resizeobserver') || 
          message.includes('undelivered notifications') ||
          message.includes('loop completed')) {
        // Ne pas afficher les erreurs ResizeObserver
        return;
      }
      // Afficher les autres erreurs normalement
      originalConsoleError.apply(console, args);
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    loadCompanies();
    // Récupérer l'entreprise sélectionnée depuis localStorage
    const savedCompanyId = localStorage.getItem('selectedCompanyId');
    if (savedCompanyId && companies.length > 0) {
      const savedCompany = companies.find(c => c.id === savedCompanyId);
      if (savedCompany) {
        setSelectedCompany(savedCompany);
      }
    }

    // Cleanup
    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      // Restaurer le gestionnaire d'erreur original
      if (originalErrorHandler) {
        window.onerror = originalErrorHandler;
      } else {
        window.onerror = null;
      }
      // Restaurer console.error original
      console.error = originalConsoleError;
    };
  }, []);

  useEffect(() => {
    // Sauvegarder l'entreprise sélectionnée dans localStorage
    if (selectedCompany) {
      localStorage.setItem('selectedCompanyId', selectedCompany.id);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (selectedCompany) {
      console.log('🔄 Changement d\'entreprise détecté:', selectedCompany.name, selectedCompany.id);
      // Réinitialiser les stats pour éviter d'afficher les anciennes données
      setStats(null);
      // Charger les nouvelles données avec l'ID explicite
      loadEmployees();
      loadStats(selectedCompany.id);
      loadPayrolls();
      loadSalaryComponents();
      fetchSmtpConfig();
    }
    loadUsers();
  }, [selectedCompany]);

  // Calculer les statistiques du livre de paie quand les payrolls changent
  useEffect(() => {
    if (payrolls && payrolls.length > 0) {
      const stats = payrolls.reduce((acc, item) => {
        const payroll = item.payroll || item;
        return {
          employeeCount: acc.employeeCount + 1,
          totalBrut: acc.totalBrut + (payroll.salary_brut || 0),
          totalRetenues: acc.totalRetenues + (payroll.retenues_salariales_total || 0) + (payroll.cnps_salarie || 0) + (payroll.is_salarie || 0),
          totalNet: acc.totalNet + (payroll.salary_net || 0)
        };
      }, { employeeCount: 0, totalBrut: 0, totalRetenues: 0, totalNet: 0 });
      
      setLivrePaieStats(stats);
    } else {
      setLivrePaieStats({ employeeCount: 0, totalBrut: 0, totalRetenues: 0, totalNet: 0 });
    }
  }, [payrolls]);

  // Optimisation avancée pour tablettes Samsung S9 Ultra
  useEffect(() => {
    const updateScreenSize = () => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;
      const devicePixelRatio = window.devicePixelRatio || 1;
      
      // Détection améliorée Samsung S9 Ultra et tablettes haute résolution
      const isSamsungTablet = (
        newWidth >= 2560 || 
        (newWidth >= 1920 && newHeight >= 1200) ||
        (devicePixelRatio >= 2 && newWidth >= 1440)
      );
      const isGeneralTablet = newWidth >= 768 && newWidth <= 3200;
      
      setScreenSize({ width: newWidth, height: newHeight });
      setIsTablet(isSamsungTablet || isGeneralTablet);
      
      // Optimisations spéciales pour Samsung S9 Ultra
      if (isSamsungTablet) {
        // Ajouter classes CSS pour optimisations
        document.body.classList.add('samsung-s9-ultra');
        document.body.classList.add('high-res-tablet');
        
        // Optimisations performance spécifiques
        document.documentElement.style.setProperty('--touch-target-size', '48px');
        document.documentElement.style.setProperty('--font-scale', '1.3');
        document.documentElement.style.setProperty('--spacing-scale', '1.2');
        
        // Désactiver les animations coûteuses si nécessaire
        if (devicePixelRatio >= 3) {
          document.body.classList.add('reduce-animations');
        }
        
        // Améliorer la performance de scroll
        if (CSS.supports('scroll-behavior', 'smooth')) {
          document.documentElement.style.scrollBehavior = 'smooth';
        }
        
        // Forcer un re-render stable des composants avec délai optimisé
        setTimeout(() => {
          if (window.ResizeObserver) {
            // Déclencher un événement de redimensionnement pour forcer la stabilisation
            window.dispatchEvent(new Event('resize'));
            
            // Optimiser les performances des graphiques
            const rechartContainers = document.querySelectorAll('[class*="recharts"]');
            rechartContainers.forEach(container => {
              container.style.willChange = 'transform';
              container.style.transform = 'translateZ(0)';
            });
          }
        }, 150);
        
        // Améliorer la réactivité tactile
        document.body.style.touchAction = 'manipulation';
        
      } else {
        document.body.classList.remove('samsung-s9-ultra', 'high-res-tablet', 'reduce-animations');
        document.documentElement.style.removeProperty('--touch-target-size');
        document.documentElement.style.removeProperty('--font-scale');
        document.documentElement.style.removeProperty('--spacing-scale');
      }
    };

    // Écouteur de redimensionnement avec debouncing pour éviter les re-renders excessifs
    let resizeTimer;
    const debouncedResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateScreenSize, 150);
    };

    window.addEventListener('resize', debouncedResize);
    updateScreenSize(); // Initial call

    return () => {
      window.removeEventListener('resize', debouncedResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  useEffect(() => {
    if (payrollSection === 'generated' && selectedCompany) {
      fetchBulletinsHistory();
    }
  }, [payrollSection, selectedCompany]);

  // Charger les prêts quand on accède à la section
  useEffect(() => {
    if (payrollSection === 'loans' && selectedCompany) {
      const loadLoans = async () => {
        try {
          const response = await axios.get(`${API}/companies/${selectedCompany.id}/loans`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          setLoans(response.data);
        } catch (error) {
          console.error('Erreur chargement prêts:', error);
        }
      };
      loadLoans();
    }
  }, [payrollSection, selectedCompany]);

  // Charger les données de la vue d'ensemble quand on switch vers cette section
  useEffect(() => {
    if (manageSection === 'system-overview' && user && user.role === 'super_admin') {
      loadSystemOverview();
    }
  }, [manageSection, user]);

  // Charger les entreprises en attente quand on accède à la section
  useEffect(() => {
    if (manageSection === 'pending-approvals' && user && user.role === 'super_admin') {
      loadPendingCompanies();
    }
  }, [manageSection, user]);



  // Vérifier les contrats expirants quand une entreprise est sélectionnée
  useEffect(() => {
    if (selectedCompany && user) {
      checkExpiringContracts();
    }
  }, [selectedCompany]);

  // Fonction de recherche globale
  const performGlobalSearch = useCallback((query) => {
    if (!query || query.length < 2) {
      setSearchResults({ employees: [], companies: [], payrolls: [] });
      return;
    }
    
    setIsSearching(true);
    const lowerQuery = query.toLowerCase();
    
    // Recherche dans les employés de l'entreprise sélectionnée
    const matchedEmployees = employees.filter(emp => 
      emp.nom?.toLowerCase().includes(lowerQuery) ||
      emp.prenoms?.toLowerCase().includes(lowerQuery) ||
      emp.matricule?.toLowerCase().includes(lowerQuery) ||
      emp.email?.toLowerCase().includes(lowerQuery) ||
      emp.poste?.toLowerCase().includes(lowerQuery) ||
      emp.numero_cnps?.toLowerCase().includes(lowerQuery)
    ).slice(0, 10);
    
    // Recherche dans toutes les entreprises
    const matchedCompanies = companies.filter(comp =>
      comp.name?.toLowerCase().includes(lowerQuery) ||
      comp.email?.toLowerCase().includes(lowerQuery) ||
      comp.registration_number?.toLowerCase().includes(lowerQuery) ||
      comp.cnps_number?.toLowerCase().includes(lowerQuery) ||
      comp.gerant?.toLowerCase().includes(lowerQuery)
    ).slice(0, 5);
    
    // Recherche dans les bulletins de paie (par nom d'employé)
    const matchedPayrolls = payrolls.filter(p => {
      const payroll = p.payroll || p;
      const employee = p.employee || employees.find(e => e.id === payroll.employee_id);
      return employee && (
        employee.nom?.toLowerCase().includes(lowerQuery) ||
        employee.prenoms?.toLowerCase().includes(lowerQuery) ||
        employee.matricule?.toLowerCase().includes(lowerQuery)
      );
    }).slice(0, 5);
    
    setSearchResults({
      employees: matchedEmployees,
      companies: matchedCompanies,
      payrolls: matchedPayrolls
    });
    setIsSearching(false);
  }, [employees, companies, payrolls]);

  // Debounce la recherche pour éviter trop d'appels
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      performGlobalSearch(searchQuery);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchQuery, performGlobalSearch]);

  // Raccourci clavier pour ouvrir la recherche (Ctrl+K ou Cmd+K)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setIsSearchOpen(true);
      }
      if (e.key === 'Escape' && isSearchOpen) {
        setIsSearchOpen(false);
        setSearchQuery('');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSearchOpen]);

  // Fonction pour calculer le résumé salarial d'un employé
  const calculateSalaryPreview = (employee, company) => {
    const salaire_categoriel = employee.salary_categoriel || employee.salaire_base || 0;
    const sursalaire = employee.sursalaire || 0;
    const prime_transport = employee.prime_transport || 0;
    const prime_logement = employee.prime_logement || 0;
    const prime_fonction = employee.prime_fonction || 0;
    const prime_anciennete = employee.prime_anciennete || 0;
    const avantages_nature = employee.avantages_nature || 0;
    const avantages_argent = employee.avantages_argent || 0;
    const indemnite_representation = employee.indemnite_representation || 0;
    
    // Calcul du salaire brut
    const salaire_brut = salaire_categoriel + sursalaire + prime_transport + prime_logement + 
                         prime_fonction + prime_anciennete + avantages_nature + avantages_argent +
                         indemnite_representation;
    
    // Calcul des éléments non imposables
    const ville = company?.ville || 'autres';
    const seuils_transport = { 'abidjan': 30000, 'bouake': 24000, 'autres': 21000 };
    const seuil_transport = seuils_transport[ville] || 21000;
    const transport_non_imposable = Math.min(prime_transport, seuil_transport);
    
    // Salaire brut imposable
    const salaire_brut_imposable = salaire_brut - transport_non_imposable;
    
    // Cotisations salariales
    const cnps_salarie = Math.round(salaire_brut_imposable * 0.063); // 6.3%
    
    // ITS (Impôt sur Traitements et Salaires) - calcul simplifié
    let its = 0;
    const base_its = salaire_brut_imposable - cnps_salarie;
    if (base_its > 75000) {
      // Barème ITS simplifié
      if (base_its <= 300000) its = Math.round((base_its - 75000) * 0.10);
      else if (base_its <= 547000) its = Math.round(22500 + (base_its - 300000) * 0.15);
      else if (base_its <= 979000) its = Math.round(59550 + (base_its - 547000) * 0.20);
      else if (base_its <= 1519000) its = Math.round(145950 + (base_its - 979000) * 0.25);
      else its = Math.round(280950 + (base_its - 1519000) * 0.35);
    }
    
    // IGR (contribution nationale)
    const igr = Math.round(its * 0.10);
    
    // CMU (si applicable)
    const cmu = employee.cmu_active ? 500 : 0;
    
    // Total des retenues
    const total_retenues = cnps_salarie + its + igr + cmu;
    
    // Salaire net
    const salaire_net = salaire_brut - total_retenues;
    
    return {
      employee_name: `${employee.prenoms || employee.first_name || ''} ${employee.nom || employee.last_name || ''}`.trim(),
      matricule: employee.matricule || 'N/A',
      poste: employee.poste || employee.position || 'N/A',
      company_name: company?.name || 'N/A',
      // Éléments du salaire
      salaire_categoriel,
      sursalaire,
      prime_transport,
      prime_logement,
      prime_fonction,
      prime_anciennete,
      avantages_nature,
      avantages_argent,
      indemnite_representation,
      // Totaux
      salaire_brut,
      transport_non_imposable,
      salaire_brut_imposable,
      // Retenues
      cnps_salarie,
      its,
      igr,
      cmu,
      total_retenues,
      // Net
      salaire_net,
      // Infos supplémentaires
      ville,
      seuil_transport
    };
  };

  // Fonction pour naviguer vers un résultat de recherche
  const navigateToSearchResult = async (type, item) => {
    setIsSearchOpen(false);
    setSearchQuery('');
    
    if (type === 'employee') {
      // Si l'employé est dans une autre entreprise, changer d'entreprise
      let targetCompany = selectedCompany;
      if (item.company_id !== selectedCompany?.id) {
        const company = companies.find(c => c.id === item.company_id);
        if (company) {
          setSelectedCompany(company);
          targetCompany = company;
        }
      }
      
      // Calculer et afficher le résumé salarial
      setIsLoadingSalaryPreview(true);
      const salaryData = calculateSalaryPreview(item, targetCompany);
      salaryData.employee = item;
      salaryData.company = targetCompany;
      setSalaryPreviewData(salaryData);
      setShowSalaryPreview(true);
      setIsLoadingSalaryPreview(false);
      
    } else if (type === 'company') {
      setSelectedCompany(item);
      setActiveTab('employees');
      toast.success(`Entreprise sélectionnée: ${item.name}`);
    } else if (type === 'payroll') {
      setActiveTab('payroll');
      setPayrollSection('generated');
      toast.success(`Bulletin trouvé pour ${item.employee?.prenoms || ''} ${item.employee?.nom || ''}`);
    }
  };
  
  // Fonction pour aller voir le bulletin complet depuis le résumé
  const goToFullBulletin = async () => {
    if (!salaryPreviewData || !salaryPreviewData.employee) return;
    
    const item = salaryPreviewData.employee;
    const targetCompany = salaryPreviewData.company;
    
    setShowSalaryPreview(false);
    
    // Chercher et afficher le bulletin de l'employé
    try {
      toast.info("Recherche du bulletin...");
      
      const currentDate = new Date();
      let bulletinFound = false;
      
      // Essayer les 12 derniers mois
      for (let i = 0; i < 12 && !bulletinFound; i++) {
        const searchDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
        const month = searchDate.getMonth() + 1;
        const year = searchDate.getFullYear();
        
        try {
          const response = await axios.get(
            `${API}/companies/${item.company_id}/payroll/${month}/${year}`,
            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }}
          );
          
          if (response.data && response.data.length > 0) {
            const employeeBulletin = response.data.find(b => 
              (b.employee?.id === item.id) || 
              (b.payroll?.employee_id === item.id)
            );
            
            if (employeeBulletin) {
              const bulletinsData = {
                period_start: `${year}-${month.toString().padStart(2,'0')}-01`,
                period_end: `${year}-${month.toString().padStart(2,'0')}-28`,
                company_info: targetCompany,
                employees: [{
                  id: item.id,
                  first_name: item.first_name || item.prenoms || '',
                  last_name: item.last_name || item.nom || '',
                  full_name: `${item.prenoms || item.first_name || ''} ${item.nom || item.last_name || ''}`.trim(),
                  position: item.position || item.poste || '',
                  matricule: item.matricule || '',
                  numero_cnps: item.numero_cnps || '',
                  payroll: employeeBulletin.payroll || employeeBulletin
                }],
                generation_date: new Date().toISOString()
              };
              
              setGeneratedBulletins(bulletinsData);
              setActiveTab('payroll');
              setPayrollSection('bulletin');
              bulletinFound = true;
              
              const employeeName = `${item.prenoms || item.first_name || ''} ${item.nom || item.last_name || ''}`.trim();
              toast.success(`Bulletin de ${employeeName} (${month}/${year}) chargé`);
            }
          }
        } catch (err) {
          // Continuer à chercher
        }
      }
      
      if (!bulletinFound) {
        setActiveTab('payroll');
        setPayrollSection('generate');
        setSelectedEmployeesForBulletin([item.id]);
        
        const employeeName = `${item.prenoms || item.first_name || ''} ${item.nom || item.last_name || ''}`.trim();
        toast.warning(`Aucun bulletin trouvé pour ${employeeName}. Sélectionné pour génération.`);
      }
    } catch (error) {
      console.error('Erreur lors de la recherche du bulletin:', error);
      setActiveTab('payroll');
      setPayrollSection('generate');
      toast.error("Erreur lors de la recherche du bulletin");
    }
  };

  const loadCompanies = async (forceRefresh = false) => {
    try {
      // ⚡ Vérifier le cache d'abord (sauf si forceRefresh)
      if (!forceRefresh) {
        const cached = cache.get('companies');
        if (cached) {
          console.log('⚡ Chargement depuis le cache');
          setCompanies(cached.companies);
          setCompanyStats(cached.stats);
          
          if (cached.companies.length > 0 && !selectedCompany) {
            const savedCompanyId = localStorage.getItem('selectedCompanyId');
            const savedCompany = cached.companies.find(c => c.id === savedCompanyId);
            setSelectedCompany(savedCompany || cached.companies[0]);
          }
          return;
        }
      }
      
      console.log('🔄 Chargement depuis l\'API');
      const response = await axios.get(`${API}/companies`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setCompanies(response.data);
      
      // ⚡ Charger les statistiques en parallèle avec limite
      const BATCH_SIZE = 5; // Charger 5 stats à la fois maximum
      const statsMap = {};
      
      for (let i = 0; i < response.data.length; i += BATCH_SIZE) {
        const batch = response.data.slice(i, i + BATCH_SIZE);
        const statsPromises = batch.map(async (company) => {
          try {
            const statsResponse = await axios.get(`${API}/companies/${company.id}/stats`);
            return { companyId: company.id, stats: statsResponse.data };
          } catch (error) {
            return { companyId: company.id, stats: null };
          }
        });
        
        const batchStats = await Promise.all(statsPromises);
        batchStats.forEach(({ companyId, stats }) => {
          statsMap[companyId] = stats;
        });
      }
      
      setCompanyStats(statsMap);
      
      // ⚡ Sauvegarder dans le cache
      cache.set('companies', {
        companies: response.data,
        stats: statsMap
      });
      
      if (response.data.length > 0 && !selectedCompany) {
        const savedCompanyId = localStorage.getItem('selectedCompanyId');
        const savedCompany = response.data.find(c => c.id === savedCompanyId);
        setSelectedCompany(savedCompany || response.data[0]);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des entreprises");
    }
  };

  const loadEmployees = async (forceRefresh = false, page = 1) => {
    if (!selectedCompany) return;
    
    try {
      // ⚡ Vérifier le cache d'abord
      const cacheKey = `employees_${selectedCompany.id}_page_${page}`;
      if (!forceRefresh) {
        const cached = cache.get(cacheKey);
        if (cached) {
          console.log('⚡ Employés chargés depuis le cache (page', page, ')');
          setEmployees(cached.employees);
          setEmployeesPagination(cached.pagination);
          return;
        }
      }
      
      console.log('🔄 Chargement employés depuis l\'API (page', page, ')');
      const response = await axios.get(`${API}/companies/${selectedCompany.id}/employees?page=${page}&limit=50`);
      setEmployees(response.data.employees);
      setEmployeesPagination(response.data.pagination);
      
      // ⚡ Sauvegarder dans le cache
      cache.set(cacheKey, response.data);
    } catch (error) {
      toast.error("Erreur lors du chargement des employés");
    }
  };

  // Charge TOUS les employés actifs de l'entreprise (sans pagination) pour le sélecteur de paie
  const loadAllEmployees = useCallback(async () => {
    if (!selectedCompany) return;
    try {
      const response = await axios.get(`${API}/companies/${selectedCompany.id}/employees?page=1&limit=1000`);
      const actives = (response.data.employees || []).filter(emp => emp.is_active !== false);
      actives.sort((a, b) => `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`));
      setAllEmployees(actives);
    } catch (error) {
      console.error('Erreur chargement de tous les employés:', error);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if ((isCalculatePayrollOpen || isMonthlyPayrollOpen || payrollSection === 'bulletin') && selectedCompany) {
      loadAllEmployees();
      setPayrollEmployeeSearch('');
    }
  }, [isCalculatePayrollOpen, isMonthlyPayrollOpen, payrollSection, selectedCompany, loadAllEmployees]);

  // Sélection par défaut : tous les employés actifs pour la paie du mois
  useEffect(() => {
    if (isMonthlyPayrollOpen) {
      setMonthlyPayrollSelection(allEmployees.map(emp => emp.id));
    }
  }, [isMonthlyPayrollOpen, allEmployees]);

  const loadStats = async (companyId = null) => {
    const targetCompanyId = companyId || selectedCompany?.id;
    if (!targetCompanyId) return;
    try {
      console.log('📊 Chargement stats pour company ID:', targetCompanyId);
      const response = await axios.get(`${API}/companies/${targetCompanyId}/stats`);
      console.log('✅ Stats chargées:', response.data);
      setStats(response.data);
    } catch (error) {
      console.error("Erreur stats:", error);
      // En cas d'erreur, afficher des stats à zéro plutôt que de ne rien afficher
      setStats({
        employees_count: 0,
        total_salary_brut: 0,
        total_cnps: 0,
        payrolls_count: 0,
        current_month: new Date().getMonth() + 1,
        current_year: new Date().getFullYear()
      });
    }
  };

  const loadPendingCompanies = async () => {
    if (!user || user.role !== 'super_admin') return;
    
    setLoadingPendingCompanies(true);
    try {
      const response = await axios.get(`${API}/companies/pending`);
      setPendingCompanies(response.data);
    } catch (error) {
      console.error("Erreur chargement entreprises en attente:", error);
      toast.error("Erreur lors du chargement des entreprises en attente");
    } finally {
      setLoadingPendingCompanies(false);
    }
  };


  // Fonctions pour les dossiers administratifs
  const openAdminFolder = async (employee) => {
    setSelectedEmployeeForAdmin(employee);
    setIsAdminFolderOpen(true);
    setLoadingAdminData(true);
    
    try {
      // Charger les données du dossier administratif
      await Promise.all([
        loadEmployeeContracts(employee.id),
        loadEmployeeExplanationRequests(employee.id),
        loadEmployeeDisciplinarySanctions(employee.id),
        // Charger les nouveaux documents administratifs
        loadEmployeeDocuments(employee.id, 'gratifications'),
        loadEmployeeDocuments(employee.id, 'conges'),
        loadEmployeeDocuments(employee.id, 'bulletins-emarges'),
        loadEmployeeDocuments(employee.id, 'solde-compte'),
        loadEmployeeDocuments(employee.id, 'certificat')
      ]);
    } catch (error) {
      console.error('Erreur lors du chargement du dossier administratif:', error);
    } finally {
      setLoadingAdminData(false);
    }
  };

  // Fonction pour calculer l'alerte de fin de contrat
  const getContractAlert = (contract) => {
    if (!contract.end_date) return null;
    
    const today = new Date();
    const endDate = new Date(contract.end_date);
    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) {
      return {
        type: 'expired',
        message: `Contrat expiré depuis ${Math.abs(diffDays)} jour(s)`,
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: '🚨'
      };
    } else if (diffDays <= 7) {
      return {
        type: 'critical',
        message: `Expire dans ${diffDays} jour(s)`,
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: '⚠️'
      };
    } else if (diffDays <= 30) {
      return {
        type: 'warning',
        message: `Expire dans ${diffDays} jour(s)`,
        color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
        icon: '⏰'
      };
    } else if (diffDays <= 60) {
      return {
        type: 'info',
        message: `Expire dans ${diffDays} jour(s)`,
        color: 'bg-blue-100 text-blue-800 border-blue-200',
        icon: '📅'
      };
    }
    
    return null;
  };

  // Fonction pour obtenir les contrats avec alerte
  const getContractsWithAlerts = () => {
    return contracts.map(contract => ({
      ...contract,
      alert: getContractAlert(contract)
    })).sort((a, b) => {
      // Trier par priorité d'alerte (expired > critical > warning > info > no alert)
      const alertPriority = {
        'expired': 5,
        'critical': 4,
        'warning': 3,
        'info': 2,
        null: 1
      };
      
      const priorityA = alertPriority[a.alert?.type] || 1;
      const priorityB = alertPriority[b.alert?.type] || 1;
      
      return priorityB - priorityA;
    });
  };

  // Fonction pour compter les alertes par type
  const getContractAlertsCount = () => {
    const alertsCount = {
      expired: 0,
      critical: 0,
      warning: 0,
      info: 0,
      total: 0
    };
    
    contracts.forEach(contract => {
      const alert = getContractAlert(contract);
      if (alert) {
        alertsCount[alert.type]++;
        alertsCount.total++;
      }
    });
    
    return alertsCount;
  };

  const loadEmployeeContracts = async (employeeId) => {
    try {
      console.log(`📥 Chargement des contrats pour l'employé ${employeeId}...`);
      const response = await axios.get(`${BACKEND_URL}/api/employees/${employeeId}/contracts`);
      console.log(`✅ ${response.data.length} contrat(s) chargé(s)`);
      setContracts(response.data);
      
      // Pré-charger les fichiers en cache en arrière-plan pour un accès plus rapide
      if (response.data.length > 0) {
        try {
          axios.post(`${BACKEND_URL}/api/employees/${employeeId}/preload-contracts`, {}, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          }).then(res => {
            if (res.data.cached > 0) {
              console.log(`📦 ${res.data.cached} fichier(s) mis en cache pour un accès plus rapide`);
            }
          }).catch(() => {
            // Ignorer les erreurs de pré-chargement silencieusement
          });
        } catch (e) {
          // Ignorer
        }
      }
    } catch (error) {
      console.error('❌ Erreur lors du chargement des contrats:', error);
    }
  };

  const loadEmployeeExplanationRequests = async (employeeId) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/employees/${employeeId}/explanation-requests`);
      setExplanationRequests(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des demandes d\'explication:', error);
    }
  };

  const loadEmployeeDisciplinarySanctions = async (employeeId) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/employees/${employeeId}/disciplinary-sanctions`);
      setDisciplinarySanctions(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des sanctions:', error);
    }
  };

  const createContract = async (formData, employeeId = null) => {
    try {
      // Utiliser l'ID passé en paramètre ou le récupérer du formData pour éviter les problèmes de closure
      const targetEmployeeId = employeeId || formData.get('employee_id');
      console.log('📤 Envoi de la requête de création de contrat pour employé:', targetEmployeeId);
      
      const response = await axios.post(`${BACKEND_URL}/api/contracts`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      console.log('✅ Contrat créé avec succès:', response.data);
      
      // Forcer le rechargement immédiat avec l'ID correct
      if (targetEmployeeId) {
        console.log('🔄 Rechargement immédiat de la liste des contrats...');
        await loadEmployeeContracts(targetEmployeeId);
        console.log('✅ Liste des contrats rechargée avec succès');
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Erreur lors de la création du contrat:', error);
      throw error;
    }
  };

  const createExplanationRequest = async (formData) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/explanation-requests`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data'
        }
      });
      await loadEmployeeExplanationRequests(selectedEmployeeForAdmin.id);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la demande:', error);
      throw error;
    }
  };

  const createDisciplinarySanction = async (sanctionData) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/disciplinary-sanctions`, sanctionData);
      await loadEmployeeDisciplinarySanctions(selectedEmployeeForAdmin.id);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la sanction:', error);
      throw error;
    }
  };

  // Nouvelles fonctions pour les documents administratifs
  const loadEmployeeDocuments = async (employeeId, documentType) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/employees/${employeeId}/admin-documents/${documentType}`);
      
      switch (documentType) {
        case 'gratifications':
          setGratifications(response.data);
          break;
        case 'conges':
          setConges(response.data);
          break;
        case 'bulletins-emarges':
          setBulletinsEmarges(response.data);
          break;
        case 'solde-compte':
          setSoldesCompte(response.data);
          break;
        case 'certificat':
          setCertificatsTravail(response.data);
          break;
      }
    } catch (error) {
      console.error(`Erreur lors du chargement des documents ${documentType}:`, error);
    }
  };

  const uploadDocument = async (formData, documentType) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin-documents/${documentType}`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data'
        }
      });
      await loadEmployeeDocuments(selectedEmployeeForAdmin.id, documentType);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de l'upload du document ${documentType}:`, error);
      throw error;
    }
  };

  const deleteDocument = async (documentId, documentType) => {
    try {
      await axios.delete(`${BACKEND_URL}/api/admin-documents/${documentId}`);
      await loadEmployeeDocuments(selectedEmployeeForAdmin.id, documentType);
      return true;
    } catch (error) {
      console.error(`Erreur lors de la suppression du document:`, error);
      throw error;
    }
  };

  // Fonction pour mettre à jour un document administratif
  const updateDocument = async (documentId, formData, documentType) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin-documents/${documentId}`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      await loadEmployeeDocuments(selectedEmployeeForAdmin.id, documentType);
      return true;
    } catch (error) {
      console.error(`Erreur lors de la modification du document:`, error);
      throw error;
    }
  };

  // Fonction pour ouvrir le dialogue de modification
  const handleEditDocument = (document, documentType) => {
    setEditingDocument({ ...document, document_type: documentType });
    setIsEditDocumentOpen(true);
  };

  const loadPayrolls = async (month = null, year = null) => {
    if (!selectedCompany) return;
    const targetMonth = month || new Date().getMonth() + 1;
    const targetYear = year || new Date().getFullYear();
    try {
      const response = await axios.get(`${API}/companies/${selectedCompany.id}/payroll/${targetMonth}/${targetYear}`);
      setPayrolls(response.data);
    } catch (error) {
      console.error("Erreur payrolls:", error);
    }
  };

  const loadSalaryComponents = async () => {
    if (!selectedCompany) return;
    try {
      const response = await axios.get(`${API}/companies/${selectedCompany.id}/salary-components`);
      setSalaryComponents(response.data);
    } catch (error) {
      console.error("Erreur salary components:", error);
    }
  };

  // Fonction pour charger les contrats expirants et jouer l'alerte
  const checkExpiringContracts = async () => {
    if (!selectedCompany) return;
    
    try {
      const response = await axios.get(`${API}/companies/${selectedCompany.id}/expiring-contracts?days=5`);
      const contractsData = response.data;
      
      if (contractsData.total_count > 0) {
        setExpiringContracts(contractsData.contracts);
        
        // Vérifier si on a déjà joué l'alerte aujourd'hui
        const today = new Date().toDateString();
        const lastAlertDate = localStorage.getItem('lastContractAlertDate');
        
        if (lastAlertDate !== today) {
          // Jouer le son d'alerte
          playContractAlert();
          
          // Afficher le modal d'alerte
          setShowContractAlert(true);
          
          // Enregistrer la date de l'alerte
          localStorage.setItem('lastContractAlertDate', today);
          setHasPlayedAlertToday(true);
        }
      } else {
        setExpiringContracts([]);
      }
    } catch (error) {
      console.error("Erreur lors de la vérification des contrats expirants:", error);
    }
  };

  // Fonction pour jouer le son d'alerte
  const playContractAlert = () => {
    try {
      // Créer un son d'alerte distinctif avec Web Audio API
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // Créer une séquence de bips urgents
      const playBeep = (frequency, startTime, duration) => {
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        
        oscillator.frequency.value = frequency;
        oscillator.type = 'sine';
        
        gainNode.gain.setValueAtTime(0.3, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
        
        oscillator.start(startTime);
        oscillator.stop(startTime + duration);
      };
      
      // Séquence de 3 bips urgents (comme une alarme)
      const now = audioContext.currentTime;
      playBeep(800, now, 0.2);
      playBeep(1000, now + 0.25, 0.2);
      playBeep(800, now + 0.5, 0.2);
      playBeep(1000, now + 0.75, 0.3);
      
    } catch (error) {
      console.error("Erreur lors de la lecture du son d'alerte:", error);
    }
  };

  const handleCreateCompany = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/companies`, companyForm);
      toast.success("Entreprise créée avec succès");
      setIsCreateCompanyOpen(false);
      setCompanyForm({name: "", address: "", phone: "", email: "", registration_number: "", cnps_number: "", ncc_number: "", ville: "autres", secteur_activite: "bureau"});
      loadCompanies();
    } catch (error) {
      toast.error("Erreur lors de la création de l'entreprise");
    }
  };

  const handleCreateEmployee = async (e) => {
    e.preventDefault();
    try {
      const employeeData = {
        ...employeeForm,
        company_id: selectedCompany.id,
        salary_categoriel: parseFloat(employeeForm.salary_categoriel),
        sursalaire: parseFloat(employeeForm.sursalaire) || 0,
        prime_transport: parseFloat(employeeForm.prime_transport) || 0,
        prime_anciennete: parseFloat(employeeForm.prime_anciennete) || 0,
        allocations_familiales_imposables: parseFloat(employeeForm.allocations_familiales_imposables) || 0,
        avantages_nature: parseFloat(employeeForm.avantages_nature) || 0,
        avantages_argent: parseFloat(employeeForm.avantages_argent) || 0,
        remboursement_frais: parseFloat(employeeForm.remboursement_frais) || 0,
        indemnite_frais_emploi: parseFloat(employeeForm.indemnite_frais_emploi) || 0,
        prime_panier: parseFloat(employeeForm.prime_panier) || 0,
        prime_salissure: parseFloat(employeeForm.prime_salissure) || 0,
        prime_tenue: parseFloat(employeeForm.prime_tenue) || 0,
        prime_outillage: parseFloat(employeeForm.prime_outillage) || 0,
        cmu_employeur: parseFloat(employeeForm.cmu_employeur) || 0,
        cmu_salarie: parseFloat(employeeForm.cmu_salarie) || 0,
        cmu_active: employeeForm.cmu_active || false,
        formation_continue: parseFloat(employeeForm.formation_continue) || 0,
        taxe_apprentissage: parseFloat(employeeForm.taxe_apprentissage) || 0,
        is_patronal: parseFloat(employeeForm.is_patronal) || 0,
        is_salarie: parseFloat(employeeForm.is_salarie) || 0,
        // Nouveaux champs RICF
        statut_matrimonial: employeeForm.statut_matrimonial || "celibataire",
        nombre_enfants: parseInt(employeeForm.nombre_enfants) || 0,
        nombre_enfants_infirmes: parseInt(employeeForm.nombre_enfants_infirmes) || 0,
        special_allowance_amounts: employeeForm.special_allowance_amounts || {},  // Montants personnalisés des allocations
        hire_date: new Date(employeeForm.hire_date).toISOString(),
        date_fin_activite: employeeForm.date_fin_activite ? new Date(employeeForm.date_fin_activite).toISOString() : null,
        gratification_display_consent: employeeForm.gratification_display_consent,
        allocations_familiales_consent: employeeForm.allocations_familiales_consent,
      };
      await axios.post(`${API}/employees`, employeeData);
      toast.success("Employé créé avec succès");
      setIsCreateEmployeeOpen(false);
      setEmployeeForm({
        first_name: "", last_name: "", sexe: "M", email: "", phone: "", position: "", 
        salary_categoriel: "", sursalaire: 0, prime_transport: 0,
        prime_anciennete: 0, allocations_familiales_imposables: 0,
        avantages_nature: 0, avantages_argent: 0, remboursement_frais: 0,
    indemnite_frais_emploi: 0, prime_panier: 0, prime_salissure: 0, prime_tenue: 0, prime_outillage: 0,
        cmu_employeur: 0, cmu_salarie: 0, cmu_active: false,
        formation_continue: 0, taxe_apprentissage: 0, is_patronal: 0, is_salarie: 0,
        indemnites: [], primes: [], complement_retraite: [], frais: [],
        special_allowance_amounts: {},  // Réinitialiser les montants personnalisés
        component_amounts: {},
        contract_type: "CDI", hire_date: "", date_fin_activite: "",
        gratification_display_consent: true,
        allocations_familiales_consent: true,
        photo_url: null, photo_filename: null
      });
      loadEmployees();
    } catch (error) {
      toast.error("Erreur lors de la création de l'employé");
    }
  };

  // 🚀 Optimisation réactivité - Calcul de paie avec callback memoized
  const handleCalculatePayroll = useCallback(async (e) => {
    e.preventDefault();
    try {
      const payrollData = {
        ...payrollForm,
        heures_sup: parseFloat(payrollForm.heures_sup),
        primes: parseFloat(payrollForm.primes),
        avances: parseFloat(payrollForm.avances),
        absences_hours: parseFloat(payrollForm.absences_hours)
      };
      await axios.post(`${API}/payroll`, payrollData);
      toast.success("Bulletin de paie généré avec succès");
      setIsCalculatePayrollOpen(false);
      setPayrollForm({employee_id: "", month: new Date().getMonth() + 1, year: new Date().getFullYear(), heures_sup: 0, primes: 0, avances: 0, absences_hours: 0, prime_transport: 0, avantages_nature: 0, avantages_argent: 0, anciennete: 0, indemnite_frais_emploi: 0, remboursement_frais: 0, prime_panier: 0, prime_salissure: 0, prime_tenue: 0, prime_outillage: 0, special_allowance_amounts: {}, payment_method: 'espece'});
      loadPayrolls(payrollData.month, payrollData.year);
      loadStats();
    } catch (error) {
      toast.error("Erreur lors du calcul de la paie");
    }
  }, [payrollForm, loadPayrolls, loadStats]);

  const handleGenerateMonthlyPayroll = async () => {
    if (monthlyPayrollSelection.length === 0) {
      toast.error("Sélectionnez au moins un employé");
      return;
    }
    setGeneratingMonthlyPayroll(true);
    setMonthlyPayrollResult(null);
    try {
      const response = await axios.post(`${API}/payroll/generate-month`, {
        company_id: selectedCompany.id,
        month: monthlyPayrollPeriod.month,
        year: monthlyPayrollPeriod.year,
        employee_ids: monthlyPayrollSelection
      });
      setMonthlyPayrollResult(response.data);
      toast.success(`${response.data.generated} bulletin(s) généré(s) avec succès`);
      loadPayrolls();
      loadStats();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de la génération des bulletins du mois");
    } finally {
      setGeneratingMonthlyPayroll(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
  };

  const RATE_PRESETS = [0, 0.33333, 0.5, 0.66667, 1.0];
  const snapRate = (r) => {
    for (const p of RATE_PRESETS) { if (Math.abs(r - p) < 0.002) return p; }
    return Math.round(r * 100000) / 100000;
  };
  // Logique complémentaire : part imposable + part exonérée = 100%
  const applyTaxableRate = (rate) => {
    const complement = snapRate(1 - rate);
    setSalaryComponentForm(prev => ({
      ...prev,
      taxable_rate: rate,
      taxable_calculation_type: 'rate',
      exempt_rate: complement,
      exempt_calculation_type: 'rate',
      auto_exempt_calculation: complement > 0
    }));
  };
  const applyExemptRate = (rate) => {
    const complement = snapRate(1 - rate);
    setSalaryComponentForm(prev => ({
      ...prev,
      exempt_rate: rate,
      exempt_calculation_type: 'rate',
      taxable_rate: complement,
      taxable_calculation_type: 'rate',
      auto_taxable_calculation: complement > 0
    }));
  };

  const handleCreateSalaryComponent = async (e) => {
    e.preventDefault();
    try {
      // Déterminer les paramètres d'imposition
      let taxableRate = 1.0; // Par défaut 100%
      let calculationType = 'rate';
      let fixedAmount = 0;
      
      // Si calcul automatique activé
      if (salaryComponentForm.auto_taxable_calculation) {
        calculationType = salaryComponentForm.taxable_calculation_type || 'rate';
        
        if (calculationType === 'rate') {
          taxableRate = salaryComponentForm.taxable_rate ?? 1.0;
        } else if (calculationType === 'fixed') {
          fixedAmount = salaryComponentForm.fixed_taxable_amount || 0;
        }
      }
      
      // Déterminer les paramètres d'exonération
      let exemptRate = 1.0;
      let exemptCalculationType = 'rate';
      let fixedExemptAmount = 0;
      
      if (salaryComponentForm.auto_exempt_calculation) {
        exemptCalculationType = salaryComponentForm.exempt_calculation_type || 'rate';
        
        if (exemptCalculationType === 'rate') {
          exemptRate = salaryComponentForm.exempt_rate ?? 1.0;
        } else if (exemptCalculationType === 'fixed') {
          fixedExemptAmount = salaryComponentForm.fixed_exempt_amount || 0;
        }
      }
      
      const componentData = {
        name: salaryComponentForm.name,
        type: salaryComponentForm.type,
        is_special_allowance: salaryComponentForm.is_special_allowance || false, // Nouvelle propriété pour allocations spéciales Art. 116-1
        is_taxable: salaryComponentForm.auto_taxable_calculation && !(calculationType === 'rate' && taxableRate === 0), // Faux si taux imposable = 0% (exonéré à 100%)
        taxable_rate: taxableRate,
        taxable_calculation_type: calculationType,
        fixed_taxable_amount: fixedAmount,
        is_exempt: salaryComponentForm.auto_exempt_calculation && !(exemptCalculationType === 'rate' && exemptRate === 0), // Faux si taux exonéré = 0%
        exempt_rate: exemptRate,
        exempt_calculation_type: exemptCalculationType,
        fixed_exempt_amount: fixedExemptAmount,
        company_id: null,  // null = élément global disponible pour toutes les entreprises
        amount: 0  // Le montant sera renseigné lors de l'assignation à l'employé
      };
      
      if (editingSalaryComponent) {
        // Mode modification
        await axios.put(`${API}/salary-components/${editingSalaryComponent.id}`, componentData);
        toast.success("Élément de salaire modifié avec succès");
        setEditingSalaryComponent(null);
      } else {
        // Mode création
        await axios.post(`${API}/salary-components`, componentData);
        toast.success("Élément de salaire créé avec succès (disponible pour toutes les entreprises)");
      }
      
      setSalaryComponentForm({
        name: "", type: "indemnite", is_special_allowance: false, auto_taxable_calculation: false, taxable_rate: 1.0, taxable_calculation_type: 'rate', fixed_taxable_amount: 0,
        auto_exempt_calculation: false, exempt_rate: 1.0, exempt_calculation_type: 'rate', fixed_exempt_amount: 0
      });
      loadSalaryComponents();
    } catch (error) {
      toast.error(editingSalaryComponent ? "Erreur lors de la modification" : "Erreur lors de la création de l'élément");
    }
  };

  const handleEditSalaryComponent = (component) => {
    // Pré-remplir le formulaire avec les données de l'élément
    setEditingSalaryComponent(component);
    setSalaryComponentForm({
      name: component.name,
      type: component.type,
      is_special_allowance: component.is_special_allowance || false,
      auto_taxable_calculation: component.taxable_rate < 1.0 || component.fixed_taxable_amount > 0,
      taxable_rate: component.taxable_rate ?? 1.0,
      taxable_calculation_type: component.taxable_calculation_type || 'rate',
      fixed_taxable_amount: component.fixed_taxable_amount || 0,
      auto_exempt_calculation: component.exempt_rate < 1.0 || component.fixed_exempt_amount > 0,
      exempt_rate: component.exempt_rate ?? 1.0,
      exempt_calculation_type: component.exempt_calculation_type || 'rate',
      fixed_exempt_amount: component.fixed_exempt_amount || 0
    });
    // Faire défiler vers le formulaire
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setEditingSalaryComponent(null);
    setSalaryComponentForm({
      name: "", type: "indemnite", is_special_allowance: false, auto_taxable_calculation: false, taxable_rate: 1.0, taxable_calculation_type: 'rate', fixed_taxable_amount: 0,
      auto_exempt_calculation: false, exempt_rate: 1.0, exempt_calculation_type: 'rate', fixed_exempt_amount: 0
    });
  };

  const handleDeleteSalaryComponent = async (componentId) => {
    try {
      await axios.delete(`${API}/salary-components/${componentId}`);
      toast.success("Élément supprimé avec succès");
      loadSalaryComponents();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  const handleEditCompany = (company) => {
    setEditingCompany(company);
    setCompanyForm({
      name: company.name,
      address: company.address,
      phone: company.phone,
      email: company.email,
      registration_number: company.registration_number,
      cnps_number: company.cnps_number,
      ncc_number: company.ncc_number || "",
      ville: company.ville,
      secteur_activite: company.secteur_activite
    });
    setIsEditCompanyOpen(true);
  };

  const handleUpdateCompany = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/companies/${editingCompany.id}`, companyForm);
      toast.success("Entreprise mise à jour avec succès");
      setIsEditCompanyOpen(false);
      setEditingCompany(null);
      setCompanyForm({name: "", address: "", phone: "", email: "", registration_number: "", cnps_number: "", ncc_number: "", ville: "autres", secteur_activite: "bureau"});
      loadCompanies();
    } catch (error) {
      toast.error("Erreur lors de la mise à jour de l'entreprise");
    }
  };

  // Fonction pour ouvrir le modal de confirmation de changement de statut
  const openToggleCompanyStatusModal = (company) => {
    setCompanyToToggle(company);
    setIsToggleCompanyStatusOpen(true);
  };

  // Fonction pour confirmer le changement de statut
  const handleToggleCompanyStatus = async () => {
    if (!companyToToggle) return;
    
    try {
      await axios.put(`${API}/companies/${companyToToggle.id}`, {
        ...companyToToggle,
        is_active: !companyToToggle.is_active
      });
      toast.success(`Entreprise ${companyToToggle.is_active ? 'désactivée' : 'activée'} avec succès`);
      setIsToggleCompanyStatusOpen(false);
      setCompanyToToggle(null);
      loadCompanies();
    } catch (error) {
      toast.error("Erreur lors du changement de statut");
    }
  };

  // Fonction pour supprimer une entreprise
  const handleDeleteCompany = async () => {
    if (!companyToDelete) return;
    
    try {
      await axios.delete(`${API}/companies/${companyToDelete.id}`);
      toast.success(`Entreprise "${companyToDelete.name}" supprimée avec succès`);
      
      // Si l'entreprise supprimée était sélectionnée, on déselectionne
      if (selectedCompany?.id === companyToDelete.id) {
        setSelectedCompany(null);
        setEmployees([]);
        localStorage.removeItem('selectedCompanyId');
      }
      
      loadCompanies();
      setIsDeleteCompanyDialogOpen(false);
      setCompanyToDelete(null);
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else if (error.response?.status === 400) {
        toast.error("Impossible de supprimer cette entreprise car elle contient des employés. Supprimez d'abord tous les employés.");
      } else {
        toast.error("Erreur lors de la suppression de l'entreprise");
      }
    }
  };

  // Fonction pour ouvrir le dialog de suppression
  const openDeleteCompanyDialog = (company) => {
    setCompanyToDelete(company);
    setIsDeleteCompanyDialogOpen(true);
  };

  // Fonctions de gestion des logos d'entreprise
  const openDocumentsDialog = async (employee) => {
    setDocumentsEmployee(employee);
    setHrDocsHistory([]);
    // Pré-remplir le signataire mémorisé pour l'entreprise (ou le gérant)
    const saved = selectedCompany?.document_signatory;
    setHrSignatoryName(saved?.name || selectedCompany?.gerant || '');
    setHrSignatoryTitle(saved?.title || 'Représentant légal');
    try {
      const response = await axios.get(`${API}/employees/${employee.id}/documents`);
      setHrDocsHistory(response.data.documents || []);
    } catch (error) {
      console.error('Erreur chargement historique documents:', error);
    }
  };

  const HR_DOC_LABELS = {
    attestation: 'Attestation de travail',
    certificat: 'Certificat de travail',
    certificat_salaire: 'Certificat de salaire',
    attestation_conges: 'Attestation de congés',
    attestation_gratification: 'Attestation de gratification',
    solde_tout_compte: 'Solde de tout compte'
  };

  const generateHrDocument = async (docType) => {
    if (!documentsEmployee) return;
    if (!hrSignatoryName.trim()) {
      toast.error("Veuillez renseigner le nom et prénoms du signataire");
      return;
    }
    if (docType === 'attestation_conges' && (!hrCongesDebut || !hrCongesFin)) {
      toast.error("Veuillez renseigner les dates de début et de fin de congés");
      return;
    }
    setGeneratingDocType(docType);
    try {
      const response = await axios.post(`${API}/employees/${documentsEmployee.id}/documents/${docType}`, {
        signatory_name: hrSignatoryName.trim(),
        signatory_title: hrSignatoryTitle,
        date_debut_conges: docType === 'attestation_conges' ? hrCongesDebut : undefined,
        date_fin_conges: docType === 'attestation_conges' ? hrCongesFin : undefined,
        montant_conges: docType === 'attestation_conges' && hrCongesMontant ? parseFloat(hrCongesMontant) : undefined,
        annee_gratification: docType === 'attestation_gratification' ? (parseInt(hrGratifAnnee) || new Date().getFullYear()) : undefined,
        montant_gratification: docType === 'attestation_gratification' && hrGratifMontant ? parseFloat(hrGratifMontant) : undefined
      }, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `${HR_DOC_LABELS[docType].replace(/ /g, '_')}_${documentsEmployee.last_name || 'document'}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`${HR_DOC_LABELS[docType]} généré(e) avec succès`);
      // Rafraîchir l'historique
      const hist = await axios.get(`${API}/employees/${documentsEmployee.id}/documents`);
      setHrDocsHistory(hist.data.documents || []);
    } catch (error) {
      console.error('Erreur génération document:', error);
      let msg = "Erreur lors de la génération du document";
      if (error.response?.data instanceof Blob) {
        try {
          const parsed = JSON.parse(await error.response.data.text());
          if (parsed.detail) msg = parsed.detail;
        } catch (e) { /* ignore */ }
      }
      toast.error(msg);
    } finally {
      setGeneratingDocType(null);
    }
  };

  const downloadHrDocument = async (doc) => {
    try {
      const response = await axios.get(`${API}/hr-documents/${doc.id}/download`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `${doc.reference}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Document ${doc.reference} téléchargé`);
    } catch (error) {
      let msg = "Erreur lors du téléchargement";
      if (error.response?.data instanceof Blob) {
        try {
          const parsed = JSON.parse(await error.response.data.text());
          if (parsed.detail) msg = parsed.detail;
        } catch (e) { /* ignore */ }
      }
      toast.error(msg);
    }
  };

  const handleLogoFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Vérifier le type de fichier
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        toast.error("Format de fichier non supporté. Utilisez PNG, JPG, JPEG ou WEBP");
        return;
      }
      
      // Vérifier la taille (2MB max)
      if (file.size > 2 * 1024 * 1024) {
        toast.error("Fichier trop volumineux. Taille maximale: 2MB");
        return;
      }
      
      setSelectedLogoFile(file);
      
      // Créer un aperçu
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadCompanyLogo = async (companyId) => {
    if (!selectedLogoFile) return null;
    
    setIsUploadingLogo(true);
    
    try {
      const formData = new FormData();
      formData.append('logo', selectedLogoFile);
      
      const response = await axios.post(
        `${API}/companies/${companyId}/logo`, 
        formData, 
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      
      toast.success("Logo uploadé avec succès !");
      return response.data.logo_url;
    } catch (error) {
      console.error("Erreur upload logo:", error);
      toast.error("Erreur lors de l'upload du logo");
      return null;
    } finally {
      setIsUploadingLogo(false);
    }
  };

  const deleteCompanyLogo = async (companyId) => {
    try {
      await axios.delete(`${API}/companies/${companyId}/logo`);
      toast.success("Logo supprimé avec succès !");
      
      // Rafraîchir la liste des entreprises
      await loadCompanies();
    } catch (error) {
      console.error("Erreur suppression logo:", error);
      toast.error("Erreur lors de la suppression du logo");
    }
  };

  // Fonction pour gérer l'upload de logo pour une entreprise spécifique
  const handleLogoUploadForCompany = async (event, companyId) => {
    const file = event.target.files[0];
    if (!file) return;

    // Vérifier le type de fichier
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Format de fichier non supporté. Utilisez PNG, JPG, JPEG, WEBP ou PDF");
      return;
    }

    // Vérifier la taille (2MB max pour une image, 5MB pour un PDF)
    const maxSize = file.type === 'application/pdf' ? 5 * 1024 * 1024 : 2 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("Fichier trop volumineux. Taille maximale: 2MB (5MB pour un PDF)");
      return;
    }

    setIsUploadingLogo(true);

    try {
      const formData = new FormData();
      formData.append('logo', file);

      const response = await axios.post(
        `${API}/companies/${companyId}/logo`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      toast.success("Logo uploadé avec succès !");
      
      // Rafraîchir la liste des entreprises pour afficher le nouveau logo
      await loadCompanies();
      
      // Réinitialiser l'input file
      event.target.value = '';

    } catch (error) {
      console.error("Erreur upload logo:", error);
      if (error.response?.status === 413) {
        toast.error("Fichier trop volumineux. Taille maximale: 2MB");
      } else if (error.response?.status === 400) {
        toast.error(error.response?.data?.detail || "Format de fichier non supporté");
      } else {
        toast.error("Erreur lors de l'upload du logo");
      }
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // Fonction pour supprimer le logo d'une entreprise
  const handleDeleteCompanyLogo = async (companyId) => {
    if (!confirm("Êtes-vous sûr de vouloir supprimer le logo de cette entreprise ?")) {
      return;
    }

    try {
      await axios.delete(`${API}/companies/${companyId}/logo`);
      toast.success("Logo supprimé avec succès !");
      
      // Rafraîchir la liste des entreprises
      await loadCompanies();
    } catch (error) {
      console.error("Erreur suppression logo:", error);
      toast.error(error.response?.data?.detail || "Erreur lors de la suppression du logo");
    }
  };

  const clearLogoSelection = () => {
    setSelectedLogoFile(null);
    setLogoPreview(null);
  };

  // useEffect pour charger automatiquement l'historique des bulletins
  useEffect(() => {
    if (selectedCompany && payrollSection === 'generated') {
      fetchBulletinsHistory();
    }
  }, [selectedCompany, payrollSection]);

  // Fonction pour charger l'historique des bulletins
  const fetchBulletinsHistory = async () => {
    if (!selectedCompany) {
      toast.error("Veuillez sélectionner une entreprise");
      return;
    }

    setIsLoadingBulletinsHistory(true);
    
    try {
      const response = await axios.get(`${API}/companies/${selectedCompany.id}/payroll-history`);
      setBulletinsHistory(response.data.history || []);
      
      if (response.data.history.length === 0) {
        toast.info("Aucun bulletin trouvé dans l'historique");
      } else {
        toast.success(`${response.data.total_bulletins} bulletins trouvés sur ${response.data.total_periods} périodes`);
      }
    } catch (error) {
      console.error('Erreur lors du chargement de l\'historique des bulletins:', error);
      toast.error("Erreur lors du chargement de l'historique des bulletins");
      setBulletinsHistory([]);
    } finally {
      setIsLoadingBulletinsHistory(false);
    }
  };

  // Fonction pour sauvegarder complètement le système (nouvelle version)
  const handleSystemBackup = async () => {
    setIsBackupInProgress(true);
    
    try {
      toast.info("📦 Création de la sauvegarde système complète...", { duration: 3000 });
      
      const response = await axios.get(`${BACKEND_URL}/api/system/backup`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.data.success) {
        const backupData = response.data.backup_data;
        const stats = response.data.statistics;
        
        // Créer les deux formats: JSON et ZIP
        const timestamp = new Date().toISOString().split('T')[0];
        
        // 1. Sauvegarde JSON
        const jsonBlob = new Blob([JSON.stringify(backupData, null, 2)], {
          type: 'application/json'
        });
        const jsonUrl = URL.createObjectURL(jsonBlob);
        const jsonLink = document.createElement('a');
        jsonLink.href = jsonUrl;
        jsonLink.download = `SIRH_Sauvegarde_Complete_${timestamp}.json`;
        document.body.appendChild(jsonLink);
        jsonLink.click();
        document.body.removeChild(jsonLink);
        URL.revokeObjectURL(jsonUrl);
        
        // 2. Sauvegarde ZIP (simulée - contient le JSON)
        const zipBlob = new Blob([JSON.stringify(backupData, null, 2)], {
          type: 'application/zip'
        });
        const zipUrl = URL.createObjectURL(zipBlob);
        const zipLink = document.createElement('a');
        zipLink.href = zipUrl;
        zipLink.download = `SIRH_Sauvegarde_Complete_${timestamp}.zip`;
        document.body.appendChild(zipLink);
        zipLink.click();
        document.body.removeChild(zipLink);
        URL.revokeObjectURL(zipUrl);
        
        toast.success(
          `✅ Sauvegarde système créée avec succès !
          📊 ${stats.companies_count} entreprises
          👥 ${stats.employees_count} employés  
          👤 ${stats.users_count} utilisateurs
          📄 ${stats.payroll_records_count} bulletins de paie
          📷 ${stats.photos_count} photos
          💾 Taille: ${stats.total_size_mb} MB
          📁 Formats: JSON et ZIP téléchargés`,
          { duration: 5000 }
        );
      }
    } catch (error) {
      console.error('Erreur sauvegarde système:', error);
      toast.error(`❌ Erreur lors de la sauvegarde système: ${error.response?.data?.detail || error.message}`);
    } finally {
      setIsBackupInProgress(false);
    }
  };

  // Fonction pour restaurer complètement le système (nouvelle version)
  const handleSystemRestore = async (file) => {
    setIsRestoreInProgress(true);
    
    try {
      toast.info("📥 Restauration du système en cours...", { duration: 3000 });
      
      const formData = new FormData();
      formData.append('backup_file', file);
      
      const response = await axios.post(`${BACKEND_URL}/api/system/restore`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (response.data.success) {
        const stats = response.data.statistics;
        const backupInfo = response.data.backup_info;
        
        toast.success(
          `✅ Système restauré avec succès !
          📊 ${stats.companies} entreprises restaurées
          👥 ${stats.employees} employés restaurés
          👤 ${stats.users} utilisateurs restaurés
          📄 ${stats.payroll} bulletins de paie restaurés
          📷 ${stats.photos} photos restaurées
          🗓️ Sauvegarde du: ${backupInfo.timestamp ? new Date(backupInfo.timestamp).toLocaleString('fr-FR') : 'Inconnue'}
          ⚠️ Les mots de passe des utilisateurs ont été réinitialisés`,
          { duration: 6000 }
        );
        
        // Recharger les données après restauration
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error('Erreur restauration système:', error);
      toast.error(`❌ Erreur lors de la restauration système: ${error.response?.data?.detail || error.message}`);
    } finally {
      setIsRestoreInProgress(false);
    }
  };

  // Fonction pour sauvegarder les fichiers persistants
  const handleFileBackup = async () => {
    setIsFileBackupInProgress(true);
    
    try {
      toast.info("💾 Sauvegarde des fichiers en cours...", { duration: 3000 });
      
      // Étape 1: Créer la sauvegarde
      const response = await axios.post(`${BACKEND_URL}/api/system/backup-files`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.data.success) {
        const backupInfo = response.data.backup_info;
        const files = response.data.files_backed_up;
        
        toast.success(
          `✅ Sauvegarde des fichiers créée !
          📁 Fichier: ${backupInfo.filename}
          💾 Taille: ${backupInfo.size_mb} MB
          📷 Photos: ${files.employee_photos} fichiers
          🏢 Logos: ${files.company_logos} fichiers
          📄 Documents: ${files.uploaded_files} fichiers
          🗄️ Base de données incluse`,
          { duration: 3000 }
        );
        
        // Étape 2: Télécharger automatiquement le fichier
        toast.info("📥 Téléchargement automatique en cours...", { duration: 2000 });
        
        const downloadResponse = await axios.get(`${BACKEND_URL}/api/system/backup-files/download`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          responseType: 'blob'
        });
        
        // Créer un lien de téléchargement
        const blob = new Blob([downloadResponse.data], { type: 'application/gzip' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = backupInfo.filename || `backup_${new Date().toISOString().split('T')[0]}.tar.gz`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        
        toast.success("✅ Téléchargement terminé !", { duration: 2000 });
        
        // Recharger la liste des sauvegardes
        fetchBackupsList();
      }
    } catch (error) {
      console.error('Erreur sauvegarde fichiers:', error);
      toast.error(`❌ Erreur lors de la sauvegarde: ${error.response?.data?.detail || error.message}`);
    } finally {
      setIsFileBackupInProgress(false);
    }
  };

  // Fonction pour restaurer les fichiers depuis la dernière sauvegarde
  const handleFileRestore = async () => {
    setIsFileRestoreInProgress(true);
    
    try {
      toast.info("📥 Restauration des fichiers en cours...", { duration: 3000 });
      
      const response = await axios.post(`${BACKEND_URL}/api/system/restore-files?use_latest=true`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.data.success) {
        const files = response.data.files_restored;
        
        toast.success(
          `✅ Fichiers restaurés avec succès !
          📷 Photos: ${files.employee_photos} fichiers
          🏢 Logos: ${files.company_logos} fichiers  
          📄 Documents: ${files.uploaded_files} fichiers
          🗄️ Base de données restaurée
          ⚠️ ${response.data.warning}`,
          { duration: 6000 }
        );
        
        // Recharger les données après restauration
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      console.error('Erreur restauration fichiers:', error);
      toast.error(`❌ Erreur lors de la restauration: ${error.response?.data?.detail || error.message}`);
    } finally {
      setIsFileRestoreInProgress(false);
    }
  };

  // Fonction pour restaurer les fichiers depuis un fichier uploadé par l'utilisateur
  const handleFileRestoreFromUpload = async (file) => {
    if (!file) {
      toast.error("Veuillez sélectionner un fichier de sauvegarde");
      return;
    }

    // Vérifier l'extension du fichier
    if (!file.name.endsWith('.tar.gz') && !file.name.endsWith('.gz') && !file.name.endsWith('.zip')) {
      toast.error("Le fichier doit être au format .tar.gz, .gz ou .zip");
      return;
    }

    setIsUploadRestoreInProgress(true);
    
    try {
      toast.info(`📥 Restauration depuis "${file.name}" en cours...`, { duration: 5000 });
      
      const formData = new FormData();
      formData.append('backup_file', file);

      const response = await axios.post(`${BACKEND_URL}/api/system/restore-files`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (response.data.success) {
        const files = response.data.files_restored;
        
        toast.success(
          `✅ Fichiers restaurés avec succès depuis votre sauvegarde !
          📷 Photos: ${files.employee_photos} fichiers
          🏢 Logos: ${files.company_logos} fichiers  
          📄 Documents: ${files.uploaded_files} fichiers
          🗄️ Base de données restaurée`,
          { duration: 8000 }
        );
        
        // Réinitialiser le fichier sélectionné
        setFileRestoreUpload(null);
        
        // Recharger les données après restauration
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
    } catch (error) {
      console.error('Erreur restauration fichiers depuis upload:', error);
      toast.error(`❌ Erreur lors de la restauration: ${error.response?.data?.detail || error.message}`);
    } finally {
      setIsUploadRestoreInProgress(false);
    }
  };

  // Fonction pour récupérer la liste des sauvegardes
  const fetchBackupsList = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/system/backup-files/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.data.success) {
        setBackupsList(response.data.backups);
      }
    } catch (error) {
      console.error('Erreur récupération liste sauvegardes:', error);
    }
  };

  // Charger la liste des sauvegardes au début
  useEffect(() => {
    if (manageSection === 'system' && user?.role === 'super_admin') {
      fetchBackupsList();
    }
  }, [manageSection, user]);

  // Fonction pour sauvegarder toutes les données AVEC photos employés (ancienne version)
  const handleBackupAllData = async () => {
    setIsBackupInProgress(true);
    
    try {
      toast.info("Sauvegarde en cours... Récupération des photos employés...");
      
      // Étape 1: Sauvegarder les photos d'employés en base64
      const employeesWithPhotos = [];
      let photosIncluded = 0;
      
      for (const employee of employees) {
        let employeeWithPhoto = { ...employee };
        
        if (employee.photo_url) {
          try {
            // Récupérer la photo et la convertir en base64
            const response = await fetch(employee.photo_url);
            if (response.ok) {
              const blob = await response.blob();
              const reader = new FileReader();
              
              await new Promise((resolve) => {
                reader.onloadend = () => {
                  employeeWithPhoto.photo_base64 = reader.result;
                  employeeWithPhoto.photo_filename = employee.photo_filename || 'photo.png';
                  photosIncluded++;
                  resolve();
                };
                reader.readAsDataURL(blob);
              });
            }
          } catch (photoError) {
            console.warn(`Impossible de sauvegarder la photo pour ${employee.first_name} ${employee.last_name}:`, photoError);
          }
        }
        
        employeesWithPhotos.push(employeeWithPhoto);
      }
      
      // Étape 2: Créer un objet avec toutes les données importantes
      const backupData = {
        timestamp: new Date().toISOString(),
        version: "2.0", // Version mise à jour avec photos
        companies: companies,
        employees: employeesWithPhotos, // Employés avec photos en base64
        users: users,
        systemOverview: systemOverview,
        photos: {
          included: photosIncluded,
          instructions: "Les photos sont incluses en base64 dans les données employés. Utiliser la fonction de restauration pour les rétablir."
        },
        metadata: {
          totalCompanies: companies.length,
          totalEmployees: employees.length,
          totalUsers: users.length,
          totalPhotos: photosIncluded,
          backupDate: new Date().toLocaleDateString('fr-FR'),
          backupTime: new Date().toLocaleTimeString('fr-FR'),
          hasPhotos: photosIncluded > 0
        }
      };
      
      // Convertir en JSON
      const jsonData = JSON.stringify(backupData, null, 2);
      
      // Créer le fichier de sauvegarde
      const blob = new Blob([jsonData], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      
      // Télécharger le fichier
      const link = document.createElement('a');
      link.href = url;
      link.download = `sirh_backup_complet_${new Date().toISOString().split('T')[0]}_${new Date().getHours()}h${new Date().getMinutes()}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success(`Sauvegarde complète créée avec succès ! 
        📊 ${backupData.metadata.totalCompanies} entreprises
        👥 ${backupData.metadata.totalEmployees} employés 
        📸 ${photosIncluded} photos incluses
        💾 Fichier sécurisé pour restauration post-déploiement`);
      
    } catch (error) {
      console.error("Erreur lors de la sauvegarde:", error);
      toast.error("Erreur lors de la création de la sauvegarde complète");
    } finally {
      setIsBackupInProgress(false);
    }
  };

  // Fonction pour restaurer les données et photos après un déploiement
  const handleRestoreData = async () => {
    if (!restoreFile) {
      toast.error("Veuillez sélectionner un fichier de sauvegarde");
      return;
    }

    setIsRestoreInProgress(true);

    try {
      // Lire le fichier JSON
      const fileContent = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(restoreFile);
      });

      const backupData = JSON.parse(fileContent);
      
      // Vérifier la version du backup
      const version = backupData.version || "1.0";
      const hasPhotos = version === "2.0" && backupData.photos && backupData.photos.included > 0;
      
      toast.info(`Restauration en cours... Version ${version} ${hasPhotos ? 'avec photos' : 'sans photos'}`);

      let photosRestored = 0;
      let photosSkipped = 0;

      if (hasPhotos && backupData.employees) {
        // Restaurer les photos d'employés
        for (const employeeBackup of backupData.employees) {
          if (employeeBackup.photo_base64 && employeeBackup.id) {
            try {
              // Convertir base64 en blob
              const base64Data = employeeBackup.photo_base64.split(',')[1];
              const mimeType = employeeBackup.photo_base64.split(',')[0].split(':')[1].split(';')[0];
              const byteCharacters = atob(base64Data);
              const byteNumbers = new Array(byteCharacters.length);
              
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: mimeType });

              // Créer FormData pour l'upload
              const formData = new FormData();
              formData.append('photo', blob, employeeBackup.photo_filename || 'restored_photo.png');

              // Uploader la photo via l'API
              const response = await axios.post(
                `${API}/employees/${employeeBackup.id}/photo`,
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                  }
                }
              );

              if (response.status === 200) {
                photosRestored++;
              }

            } catch (photoError) {
              console.warn(`Erreur restauration photo employé ${employeeBackup.first_name} ${employeeBackup.last_name}:`, photoError);
              photosSkipped++;
            }
          }
        }
      }

      // Recharger les données après restauration
      await loadEmployees();
      
      setIsRestoreDialogOpen(false);
      setRestoreFile(null);

      if (hasPhotos) {
        toast.success(`Restauration terminée avec succès !
          📸 ${photosRestored} photos restaurées
          ${photosSkipped > 0 ? `⚠️ ${photosSkipped} photos ignorées` : ''}
          🔄 Données employés rechargées`);
      } else {
        toast.success("Restauration terminée ! (Aucune photo dans cette sauvegarde)");
      }

    } catch (error) {
      console.error("Erreur lors de la restauration:", error);
      toast.error("Erreur lors de la restauration des données");
    } finally {
      setIsRestoreInProgress(false);
    }
  };

  // Fonction pour gérer le changement de fichier de restauration
  const handleRestoreFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/json') {
      setRestoreFile(file);
    } else {
      toast.error("Veuillez sélectionner un fichier JSON valide");
    }
  };

  // Fonction pour exporter le registre chronologique en Excel (Version Moderne XLSX)
  const handleExportRegistreExcel = async () => {
    try {
      // VÉRIFICATION : Entreprise sélectionnée
      if (!selectedCompany || !selectedCompany.id) {
        toast.error("Veuillez sélectionner une entreprise avant d'exporter le registre");
        return;
      }

      // Demander à l'utilisateur de sélectionner le mois et l'année
      const month = prompt("Entrez le mois (1-12) pour le registre chronologique:", new Date().getMonth() + 1);
      if (!month || month < 1 || month > 12) {
        toast.error("Mois invalide. Opération annulée.");
        return;
      }

      const year = prompt("Entrez l'année pour le registre chronologique:", new Date().getFullYear());
      if (!year || year < 2020) {
        toast.error("Année invalide. Opération annulée.");
        return;
      }

      setIsExportingExcel(true);
      toast.info(`Chargement des bulletins de paie pour ${month}/${year}...`, { duration: 2000 });

      // Import dynamique de xlsx pour éviter les erreurs SSR
      const XLSX = await import('xlsx');

      // RÉCUPÉRER LES BULLETINS RÉELS DU MOIS/ANNÉE SÉLECTIONNÉ
      const response = await axios.get(
        `${BACKEND_URL}/api/companies/${selectedCompany.id}/payroll/${month}/${year}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      );

      const payrollData = response.data || [];
      
      console.log(`📊 EXPORT EXCEL - Entreprise: ${selectedCompany.name}`);
      console.log(`📅 Période: ${month}/${year}`);
      console.log(`✅ Bulletins trouvés: ${payrollData.length}`);

      if (payrollData.length === 0) {
        toast.warning(`Aucun bulletin de paie trouvé pour ${month}/${year} dans l'entreprise ${selectedCompany.name}`);
        setIsExportingExcel(false);
        return;
      }
      
      // Préparer les données à partir des bulletins réels
      const employeeData = payrollData.map(item => {
        const emp = item.employee;
        const results = item.payroll;
        
        // Calculer le total des retenues salariales si non présent
        const cnps_salarie = results.cnps_salarie || 0;
        const is_salarie = results.is_salarie || results.is_total || 0;
        const cmu_salarie = results.cmu_salarie || 0;
        const avances = results.avances || 0;
        const total_ret_sal = results.retenues_salariales_total || (cnps_salarie + is_salarie + cmu_salarie + avances);
        
        // Récupérer les retenues patronales avec les bons noms de champs
        const prestations_familiales = results.prestations_familiales || 0;
        const accidents_travail = results.accidents_travail || 0;
        const is_patronal = results.is_patronal || 0;
        const cnps_employeur = results.cnps_employeur_base || 0;
        const taxe_apprentissage = results.taxe_apprentissage || 0;
        const formation_continue = results.formation_continue || 0;
        const cmu_patronal = results.cmu_employeur || 0;
        
        // Calculer le total patronal comme somme exacte des colonnes
        const total_ret_pat = Math.round(prestations_familiales + accidents_travail + is_patronal + cnps_employeur + taxe_apprentissage + formation_continue + cmu_patronal);
        
        return {
          date_paie: results.created_at ? new Date(results.created_at).toLocaleDateString('fr-FR') : `${month}/${year}`,
          nom: emp.last_name || 'N/A',
          prenoms: emp.first_name || 'N/A', 
          poste: emp.position || 'N/A',
          matricule: emp.matricule || 'N/A',
          numero_cnps: emp.numero_cnps || 'N/A',
          salaire_categoriel: results.salary_categoriel || 0,
          sursalaire: results.sursalaire || 0,
          prime_transport: results.prime_transport || 0,
          salaire_brut: results.salary_brut || 0,
          salaire_brut_imposable: results.salary_brut_imposable_is || results.salary_brut_social_imposable || 0,
          // Retenues salariales
          cnps_salarie: cnps_salarie,
          is_salarie: is_salarie,
          cmu_salarie: cmu_salarie,
          avances: avances,
          retenues_salariales_total: total_ret_sal,
          // Retenues patronales
          prestations_familiales: prestations_familiales,
          accidents_travail: accidents_travail,
          is_patronal: is_patronal,
          cnps_employeur: cnps_employeur,
          taxe_apprentissage: taxe_apprentissage,
          formation_continue: formation_continue,
          cmu_patronal: cmu_patronal,
          retenues_patronales_total: total_ret_pat,
          // Net
          salaire_net: results.salary_net || results.net_salary || 0
        };
      });
      
      // Créer un nouveau classeur
      const wb = XLSX.utils.book_new();
      
      // Préparer les données pour Excel avec headers appropriés
      const worksheetData = [
        // Titre principal
        [`REGISTRE CHRONOLOGIQUE DES PAIES - ${selectedCompany.name.toUpperCase()}`],
        [`Période: ${month}/${year} | Généré le: ${new Date().toLocaleString('fr-FR')}`],
        [], // Ligne vide
        // En-têtes de colonnes
        [
          'Date de Paie', 'Nom', 'Prénoms', 'Poste', 'Matricule', 'N° CNPS',
          'Salaire Catégoriel', 'Sursalaire', 'Prime Transport', 'Salaire Brut', 'Salaire Brut Imposable',
          'CNPS salarié', 'IS salarié', 'CMU salarié', 'Avances', 'Total Ret. Salariales',
          'Prest. familiales', 'Accidents travail', 'IS patronal', 'CNPS employeur', 
          'Taxe apprentissage', 'Formation continue', 'CMU patronal', 'Total Ret. Patronales',
          'Salaire Net à Payer'
        ]
      ];
      
      // Ajouter les données des employés
      employeeData.forEach(emp => {
        worksheetData.push([
          emp.date_paie,
          emp.nom,
          emp.prenoms,
          emp.poste,
          emp.matricule,
          emp.numero_cnps,
          emp.salaire_categoriel,
          emp.sursalaire,
          emp.prime_transport,
          emp.salaire_brut,
          emp.salaire_brut_imposable,
          emp.cnps_salarie,
          emp.is_salarie,
          emp.cmu_salarie,
          emp.avances,
          emp.retenues_salariales_total,
          emp.prestations_familiales,
          emp.accidents_travail,
          emp.is_patronal,
          emp.cnps_employeur,
          emp.taxe_apprentissage,
          emp.formation_continue,
          emp.cmu_patronal,
          emp.retenues_patronales_total,
          emp.salaire_net
        ]);
      });
      
      // Ajouter ligne de totaux
      const totals = employeeData.reduce((acc, emp) => ({
        salaire_brut: acc.salaire_brut + (emp.salaire_brut || 0),
        retenues_salariales: acc.retenues_salariales + (emp.retenues_salariales_total || 0),
        retenues_patronales: acc.retenues_patronales + (emp.retenues_patronales_total || 0),
        salaire_net: acc.salaire_net + (emp.salaire_net || 0)
      }), { salaire_brut: 0, retenues_salariales: 0, retenues_patronales: 0, salaire_net: 0 });
      
      worksheetData.push([]); // Ligne vide
      worksheetData.push([
        'TOTAUX', '', '', '', '', '',
        '', '', '', totals.salaire_brut, '',
        '', '', '', totals.retenues_salariales,
        '', '', '', '', 
        '', '', '', totals.retenues_patronales,
        totals.salaire_net
      ]);
      
      // Créer la feuille de calcul
      const ws = XLSX.utils.aoa_to_sheet(worksheetData);
      
      // Appliquer des styles de base (largeurs de colonne)
      const colWidths = [
        {wch: 12}, {wch: 15}, {wch: 15}, {wch: 20}, {wch: 12}, {wch: 15},
        {wch: 15}, {wch: 12}, {wch: 15}, {wch: 15}, {wch: 18},
        {wch: 12}, {wch: 12}, {wch: 12}, {wch: 18},
        {wch: 18}, {wch: 15}, {wch: 12}, {wch: 15},
        {wch: 15}, {wch: 18}, {wch: 12}, {wch: 18},
        {wch: 18}
      ];
      ws['!cols'] = colWidths;
      
      // Ajouter la feuille au classeur
      XLSX.utils.book_append_sheet(wb, ws, "Registre Chronologique");
      
      // Générer le fichier Excel en format moderne XLSX
      const excelBuffer = XLSX.write(wb, { 
        bookType: 'xlsx', 
        type: 'array',
        cellStyles: true
      });
      
      // Créer le blob avec le bon type MIME pour XLSX
      const excelBlob = new Blob([excelBuffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Téléchargement du fichier
      const filename = `Registre_Chronologique_Paies_${selectedCompany.name.replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
      
      const url = URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success(`📊 Registre chronologique Excel téléchargé avec succès ! 
        💼 ${employeeData.length} employés inclus
        📅 Période : ${new Date().toLocaleDateString('fr-FR')}
        📱 Format Excel moderne (.xlsx) compatible avec toutes les versions d'Excel
        💾 Fichier : ${filename}
        ✅ Données calculées en temps réel avec barèmes ivoiriens officiels`);
      
    } catch (error) {
      console.error("Erreur export Excel:", error);
      toast.error(`Erreur lors de l'export Excel du registre chronologique: ${error.message || 'Erreur inconnue'}`);
    } finally {
      setIsExportingExcel(false);
    }
  };

  // Fonction pour imprimer le registre chronologique
  const handlePrintRegistre = async () => {
    // VÉRIFICATION CRITIQUE : Entreprise sélectionnée
    if (!selectedCompany || !selectedCompany.id) {
      toast.error("Veuillez sélectionner une entreprise avant d'imprimer le registre");
      return;
    }

    // Demander à l'utilisateur de sélectionner le mois et l'année
    const month = prompt("Entrez le mois (1-12) pour le registre chronologique:", new Date().getMonth() + 1);
    if (!month || month < 1 || month > 12) {
      toast.error("Mois invalide. Opération annulée.");
      return;
    }

    const year = prompt("Entrez l'année pour le registre chronologique:", new Date().getFullYear());
    if (!year || year < 2020) {
      toast.error("Année invalide. Opération annulée.");
      return;
    }

    setIsPrintingRegistre(true);
    
    try {
      toast.info(`Chargement des bulletins de paie pour ${month}/${year}...`, { duration: 2000 });

      // RÉCUPÉRER LES BULLETINS RÉELS DU MOIS/ANNÉE SÉLECTIONNÉ
      const response = await axios.get(
        `${BACKEND_URL}/api/companies/${selectedCompany.id}/payroll/${month}/${year}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      );

      const payrollData = response.data || [];
      
      console.log(`🔍 REGISTRE CHRONOLOGIQUE - Entreprise: ${selectedCompany.name} (ID: ${selectedCompany.id})`);
      console.log(`📅 Période: ${month}/${year}`);
      console.log(`📊 Bulletins trouvés: ${payrollData.length}`);

      // VÉRIFICATION : Au moins un bulletin trouvé
      if (payrollData.length === 0) {
        toast.warning(`Aucun bulletin de paie trouvé pour ${month}/${year} dans l'entreprise ${selectedCompany.name}`);
        setIsPrintingRegistre(false);
        return;
      }
      
      toast.info("Préparation de l'impression...", { duration: 2000 });
      
      // Attendre un court délai pour le feedback
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Créer le contenu HTML pour l'impression
      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Registre Chronologique des Paies</title>
          <style>
            @page { 
              size: A4 landscape; 
              margin: 1cm; 
            }
            body { 
              font-family: Arial, sans-serif; 
              font-size: 10px; 
              margin: 0; 
              padding: 0;
            }
            .header { 
              text-align: center; 
              margin-bottom: 20px; 
              border-bottom: 2px solid #000;
              padding-bottom: 10px;
            }
            .company-info {
              text-align: left;
              margin-bottom: 15px;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              font-size: 8px;
              margin-top: 10px;
            }
            th, td { 
              border: 1px solid #000; 
              padding: 3px; 
              text-align: center; 
            }
            th { 
              background-color: #f0f0f0; 
              font-weight: bold;
            }
            .section-header {
              background-color: #e0e0e0 !important;
              font-weight: bold;
            }
            .total-row {
              background-color: #f5f5f5;
              font-weight: bold;
            }
            .salariales { background-color: #fef2f2; }
            .patronales { background-color: #fef7ed; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>REGISTRE CHRONOLOGIQUE DES PAIES</h1>
            <div class="company-info">
              <strong>Entreprise:</strong> ${selectedCompany?.name || 'Nom Entreprise'}<br>
              <strong>Adresse:</strong> ${selectedCompany?.address || 'Adresse Entreprise'}<br>
              <strong>Période:</strong> ${month}/${year}<br>
              <strong>Date d'impression:</strong> ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR')}
            </div>
          </div>
          
          <table>
            <thead>
              <tr>
                <th rowspan="2">Date Paie</th>
                <th rowspan="2">Nom</th>
                <th rowspan="2">Prénoms</th>
                <th rowspan="2">Salaire Catégoriel</th>
                <th rowspan="2">Salaire Brut</th>
                <th rowspan="2">Salaire Brut Imposable</th>
                <th colspan="5" class="section-header">Retenues Salariales</th>
                <th colspan="8" class="section-header">Retenues Patronales</th>
                <th rowspan="2">Salaire Net</th>
              </tr>
              <tr>
                <th class="salariales">CNPS salarié</th>
                <th class="salariales">IS salarié</th>
                <th class="salariales">CMU salarié</th>
                <th class="salariales">Autres</th>
                <th class="salariales">Total Salar.</th>
                <th class="patronales">Prest. familiales</th>
                <th class="patronales">Accidents</th>
                <th class="patronales">IS patronal</th>
                <th class="patronales">CNPS employeur</th>
                <th class="patronales">Taxe apprentissage</th>
                <th class="patronales">Formation continue</th>
                <th class="patronales">CMU patronal</th>
                <th class="patronales">Total Patron.</th>
              </tr>
            </thead>
            <tbody>`;
      
      let printBody = '';
      let totals = {
        salaire_categoriel: 0,
        salaire_brut: 0,
        salaire_brut_imposable: 0,
        cnps_salarie: 0,
        is_salarie: 0,
        cmu_salarie: 0,
        autres: 0,
        total_salariales: 0,
        prestations: 0,
        accidents: 0,
        is_patronal: 0,
        cnps_employeur: 0,
        taxe: 0,
        formation: 0,
        cmu_patronal: 0,
        total_patronales: 0,
        salaire_net: 0
      };
      
      // UTILISER LES BULLETINS RÉELS DÉJÀ CALCULÉS
      payrollData.forEach(item => {
        const emp = item.employee;
        const results = item.payroll;
        
        // Récupérer les valeurs avec les bons noms de champs
        const cnps_salarie = results.cnps_salarie || 0;
        const is_salarie = results.is_salarie || results.is_total || 0;
        const cmu_salarie = results.cmu_salarie || 0;
        const avances = results.avances || 0;
        const total_ret_sal = results.retenues_salariales_total || (cnps_salarie + is_salarie + cmu_salarie + avances);
        
        const prestations_familiales = results.prestations_familiales || 0;
        const accidents_travail = results.accidents_travail || 0;
        const is_patronal = results.is_patronal || 0;
        const cnps_employeur = results.cnps_employeur_base || 0;
        const taxe_apprentissage = results.taxe_apprentissage || 0;
        const formation_continue = results.formation_continue || 0;
        const cmu_employeur = results.cmu_employeur || 0;
        const total_ret_pat = Math.round(prestations_familiales + accidents_travail + is_patronal + cnps_employeur + taxe_apprentissage + formation_continue + cmu_employeur);
        
        // Ajouter aux totaux
        totals.salaire_categoriel += results.salary_categoriel || 0;
        totals.salaire_brut += results.salary_brut || 0;
        totals.salaire_brut_imposable += results.salary_brut_imposable_is || 0;
        totals.cnps_salarie += cnps_salarie;
        totals.is_salarie += is_salarie;
        totals.cmu_salarie += cmu_salarie;
        totals.autres += avances;
        totals.total_salariales += total_ret_sal;
        totals.prestations += prestations_familiales;
        totals.accidents += accidents_travail;
        totals.is_patronal += is_patronal;
        totals.cnps_employeur += cnps_employeur;
        totals.taxe += taxe_apprentissage;
        totals.formation += formation_continue;
        totals.cmu_patronal += cmu_employeur;
        totals.total_patronales += total_ret_pat;
        totals.salaire_net += results.salary_net || results.net_salary || 0;
        
        // Date de paie
        const date_paie = results.created_at ? new Date(results.created_at).toLocaleDateString('fr-FR') : `${month}/${year}`;
        
        printBody += `
          <tr>
            <td>${date_paie}</td>
            <td>${emp.last_name}</td>
            <td>${emp.first_name}</td>
            <td>${Math.round(results.salary_categoriel || 0).toLocaleString('fr-FR')}</td>
            <td>${Math.round(results.salary_brut || 0).toLocaleString('fr-FR')}</td>
            <td>${Math.round(results.salary_brut_imposable_is || 0).toLocaleString('fr-FR')}</td>
            <td class="salariales">${Math.round(cnps_salarie).toLocaleString('fr-FR')}</td>
            <td class="salariales">${Math.round(is_salarie).toLocaleString('fr-FR')}</td>
            <td class="salariales">${Math.round(cmu_salarie).toLocaleString('fr-FR')}</td>
            <td class="salariales">${Math.round(avances).toLocaleString('fr-FR')}</td>
            <td class="salariales">${Math.round(total_ret_sal).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(prestations_familiales).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(accidents_travail).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(is_patronal).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(cnps_employeur).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(taxe_apprentissage).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(formation_continue).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(cmu_employeur).toLocaleString('fr-FR')}</td>
            <td class="patronales">${Math.round(total_ret_pat).toLocaleString('fr-FR')}</td>
            <td>${Math.round(results.salary_net || results.net_salary || 0).toLocaleString('fr-FR')}</td>
          </tr>
        `;
      });
      
      const printFooter = `
            <tr class="total-row">
              <td colspan="3"><strong>TOTAUX</strong></td>
              <td><strong>${Math.round(totals.salaire_categoriel).toLocaleString('fr-FR')}</strong></td>
              <td><strong>${Math.round(totals.salaire_brut).toLocaleString('fr-FR')}</strong></td>
              <td class="salariales"><strong>${Math.round(totals.cnps_salarie).toLocaleString('fr-FR')}</strong></td>
              <td class="salariales"><strong>${Math.round(totals.is_salarie).toLocaleString('fr-FR')}</strong></td>
              <td class="salariales"><strong>${Math.round(totals.cmu_salarie).toLocaleString('fr-FR')}</strong></td>
              <td class="salariales"><strong>${Math.round(totals.autres).toLocaleString('fr-FR')}</strong></td>
              <td class="salariales"><strong>${Math.round(totals.total_salariales).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.prestations).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.accidents).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.is_patronal).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.cnps_employeur).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.taxe).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.formation).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.cmu_patronal).toLocaleString('fr-FR')}</strong></td>
              <td class="patronales"><strong>${Math.round(totals.total_patronales).toLocaleString('fr-FR')}</strong></td>
              <td><strong>${Math.round(totals.salaire_net).toLocaleString('fr-FR')}</strong></td>
            </tr>
            </tbody>
          </table>
        </body>
        </html>
      `;
      
      const fullPrintContent = printContent + printBody + printFooter;
      
      // Méthode d'impression sécurisée compatible tous navigateurs
      try {
        // Tentative 1: Fenêtre popup (navigateurs desktop)
        const printWindow = window.open('', '_blank', 'width=1200,height=800');
        
        if (printWindow) {
          printWindow.document.write(fullPrintContent);
          printWindow.document.close();
          
          // Attendre le chargement puis imprimer
          printWindow.onload = () => {
            setTimeout(() => {
              try {
                printWindow.print();
                // Ne pas fermer automatiquement pour laisser l'utilisateur contrôler
              } catch (printError) {
                console.error('Erreur impression popup:', printError);
                printWindow.close();
                throw new Error('Impression popup échouée');
              }
            }, 1000);
          };
          
        } else {
          // Tentative 2: Impression directe (mobiles/tablettes ou popup bloqué)
          throw new Error('Popup bloqué - utilisation méthode alternative');
        }
        
      } catch (popupError) {
        console.warn('Popup impression bloqué, utilisation méthode alternative:', popupError);
        
        // Méthode alternative pour mobiles/tablettes
        try {
          // Créer un iframe caché pour l'impression
          const printFrame = document.createElement('iframe');
          printFrame.style.position = 'absolute';
          printFrame.style.top = '-9999px';
          printFrame.style.left = '-9999px';
          printFrame.style.width = '1px';
          printFrame.style.height = '1px';
          
          document.body.appendChild(printFrame);
          
          const frameDoc = printFrame.contentWindow.document;
          frameDoc.write(fullPrintContent);
          frameDoc.close();
          
          // Attendre le chargement puis imprimer
          setTimeout(() => {
            try {
              printFrame.contentWindow.print();
              
              // Supprimer l'iframe après impression
              setTimeout(() => {
                if (printFrame.parentNode) {
                  document.body.removeChild(printFrame);
                }
              }, 1000);
              
            } catch (frameError) {
              console.error('Erreur impression iframe:', frameError);
              // Supprimer l'iframe en cas d'erreur
              if (printFrame.parentNode) {
                document.body.removeChild(printFrame);
              }
              throw frameError;
            }
          }, 500);
          
        } catch (iframeError) {
          console.error('Erreur impression iframe:', iframeError);
          
          // Méthode finale: Téléchargement HTML pour impression manuelle
          const htmlBlob = new Blob([fullPrintContent], { type: 'text/html;charset=utf-8' });
          const url = URL.createObjectURL(htmlBlob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `Registre_Chronologique_Impression_${new Date().toISOString().split('T')[0]}.html`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          
          toast.info(`📄 Fichier HTML téléchargé pour impression manuelle
            🖨️ Ouvrez le fichier et utilisez Ctrl+P pour imprimer
            📱 Compatible avec tous les navigateurs et appareils`);
          return;
        }
      }
      
      toast.success(`🖨️ Impression du registre chronologique lancée avec succès !
        📊 ${payrollData.length} employés inclus
        📄 Format paysage A4 optimisé pour toutes les colonnes
        🎯 Compatible PC, tablettes et mobiles`);
      
    } catch (error) {
      console.error("Erreur impression:", error);
      toast.error("Erreur lors de la préparation de l'impression");
    } finally {
      setIsPrintingRegistre(false);
    }
  };

  // Fonction pour exporter le registre chronologique en PDF
  const handleExportRegistrePDF = async () => {
    // VÉRIFICATION CRITIQUE : Entreprise sélectionnée
    if (!selectedCompany || !selectedCompany.id) {
      toast.error("Veuillez sélectionner une entreprise avant d'exporter le PDF");
      return;
    }

    const month = prompt("Entrez le mois (1-12) pour le registre chronologique:", new Date().getMonth() + 1);
    if (!month || month < 1 || month > 12) {
      toast.error("Mois invalide. Opération annulée.");
      return;
    }

    const year = prompt("Entrez l'année pour le registre chronologique:", new Date().getFullYear());
    if (!year || year < 2020) {
      toast.error("Année invalide. Opération annulée.");
      return;
    }

    setIsExportingPDF(true);
    toast.info(`Génération du PDF du registre chronologique pour ${month}/${year}...`, { duration: 3000 });

    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/companies/${selectedCompany.id}/registre-chronologique-pdf/${month}/${year}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );

      // Créer le blob et télécharger
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Registre_Chronologique_${selectedCompany.name.replace(/[^a-zA-Z0-9]/g, '_')}_${month}_${year}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(`📄 Registre chronologique PDF téléchargé avec succès !`);
    } catch (error) {
      console.error("Erreur export PDF:", error);
      toast.error(`Erreur lors de l'export PDF: ${error.response?.data?.detail || error.message || 'Erreur inconnue'}`);
    } finally {
      setIsExportingPDF(false);
    }
  };

  // Fonction pour afficher le livre de paie à l'écran
  const handleViewLivrePaie = async () => {
    // VÉRIFICATION : Entreprise sélectionnée
    if (!selectedCompany || !selectedCompany.id) {
      toast.error("Veuillez sélectionner une entreprise avant d'afficher le livre de paie");
      return;
    }

    // Demander à l'utilisateur de sélectionner le mois et l'année
    const month = prompt("Entrez le mois (1-12) pour le livre de paie:", new Date().getMonth() + 1);
    if (!month || month < 1 || month > 12) {
      toast.error("Mois invalide. Opération annulée.");
      return;
    }

    const year = prompt("Entrez l'année pour le livre de paie:", new Date().getFullYear());
    if (!year || year < 2020) {
      toast.error("Année invalide. Opération annulée.");
      return;
    }

    try {
      toast.info(`Chargement du livre de paie pour ${month}/${year}...`, { duration: 2000 });

      // RÉCUPÉRER LES BULLETINS RÉELS DU MOIS/ANNÉE SÉLECTIONNÉ
      const response = await axios.get(
        `${BACKEND_URL}/api/companies/${selectedCompany.id}/payroll/${month}/${year}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      );

      const payrollData = response.data || [];
      
      console.log(`📊 LIVRE DE PAIE - Entreprise: ${selectedCompany.name}`);
      console.log(`📅 Période: ${month}/${year}`);
      console.log(`✅ Bulletins trouvés: ${payrollData.length}`);

      if (payrollData.length === 0) {
        toast.warning(`Aucun bulletin de paie trouvé pour ${month}/${year} dans l'entreprise ${selectedCompany.name}`);
        return;
      }
      
      // Stocker les données et afficher
      setLivrePaieData(payrollData);
      setLivrePaiePeriod({ month, year });
      setIsViewingLivrePaie(true);
      toast.success(`Livre de paie chargé : ${payrollData.length} bulletin(s) pour ${month}/${year}`);
      
    } catch (error) {
      console.error("Erreur lors du chargement du livre de paie:", error);
      toast.error("Erreur lors du chargement du livre de paie");
    }
  };

  const filteredCompanies = companies.filter(company =>
    company.name.toLowerCase().includes(companyFilter.toLowerCase()) ||
    company.ville.toLowerCase().includes(companyFilter.toLowerCase()) ||
    company.secteur_activite.toLowerCase().includes(companyFilter.toLowerCase())
  );

  const loadUsers = async () => {
    try {
      const response = await axios.get(`${API}/users-with-access`);
      setUsers(response.data);
    } catch (error) {
      console.error("Erreur users:", error);
    }
  };

  // Fonction pour charger la vue d'ensemble du système
  const loadSystemOverview = async () => {
    console.log('🔍 loadSystemOverview appelée');
    console.log('👤 User:', user);
    console.log('🔐 User role:', user?.role);
    
    if (user?.role !== 'super_admin') {
      console.log('⚠️ Utilisateur n\'est pas super_admin, arrêt du chargement');
      toast.warning("Seul le super administrateur peut accéder à cette section");
      return;
    }

    console.log('📊 Chargement de la vue d\'ensemble du système...');
    setLoadingSystemOverview(true);
    try {
      const token = localStorage.getItem("token");
      console.log('🔑 Token:', token ? 'Présent' : 'Absent');
      
      const response = await axios.get(`${API}/system/overview`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('✅ Données de la vue d\'ensemble reçues:', response.data);
      setSystemOverview(response.data);
      toast.success("Vue d'ensemble chargée avec succès");
    } catch (error) {
      console.error("❌ Erreur lors du chargement de la vue d'ensemble:", error);
      console.error("Détails de l'erreur:", error.response?.data);
      console.error("Status:", error.response?.status);
      toast.error(`Erreur: ${error.response?.data?.detail || "Impossible de charger la vue d'ensemble du système"}`);
    } finally {
      setLoadingSystemOverview(false);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/users`, userForm);
      toast.success("Utilisateur créé avec succès");
      setIsCreateUserOpen(false);
      setUserForm({username: "", email: "", full_name: "", password: "", role: "admin_single", company_access: []});
      loadUsers();
    } catch (error) {
      toast.error("Erreur lors de la création de l'utilisateur");
    }
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setUserForm({
      username: user.user.username,
      email: user.user.email,
      full_name: user.user.full_name,
      password: "", // Ne pas pré-remplir le mot de passe
      role: user.user.role,
      company_access: user.company_access.map(access => access.company.id)
    });
    setIsEditUserOpen(true);
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    
    // Activer l'état de chargement
    setIsUpdatingUser(true);
    
    try {
      await axios.put(`${API}/users/${editingUser.user.id}`, userForm);
      toast.success("✅ Utilisateur mis à jour avec succès");
      
      // Fermer le modal après un court délai pour un meilleur feedback visuel
      setTimeout(() => {
        setIsEditUserOpen(false);
        setEditingUser(null);
        setUserForm({username: "", email: "", full_name: "", password: "", role: "admin_single", company_access: []});
        setIsUpdatingUser(false);
      }, 500);
      
      // Recharger la liste des utilisateurs
      loadUsers();
    } catch (error) {
      toast.error(error.response?.data?.detail || "❌ Erreur lors de la mise à jour de l'utilisateur");
      setIsUpdatingUser(false);
    }
  };

  // Fonction pour charger le diagnostic des accès d'un utilisateur
  const loadUserAccessDiagnostic = async (userId) => {
    setIsLoadingDiagnostic(true);
    try {
      const response = await axios.get(`${API}/users/${userId}/debug-access`);
      setUserAccessDiagnostic(response.data);
      setShowDiagnosticModal(true);
    } catch (error) {
      toast.error("Erreur lors du chargement du diagnostic");
      console.error("Erreur diagnostic:", error);
    } finally {
      setIsLoadingDiagnostic(false);
    }
  };

  // Fonction pour réparer automatiquement les accès d'un utilisateur
  const repairUserAccess = async (userId) => {
    if (!window.confirm("Réparer automatiquement les problèmes détectés ?\n\nLes entreprises inactives seront réactivées, les entreprises non approuvées seront approuvées, et les permissions/ID manquants seront corrigés.")) {
      return;
    }
    setIsRepairingAccess(true);
    try {
      const response = await axios.post(`${API}/users/${userId}/repair-access`);
      toast.success(response.data.message || "Réparation effectuée");
      // Recharger le diagnostic pour refléter les corrections
      const refreshed = await axios.get(`${API}/users/${userId}/debug-access`);
      setUserAccessDiagnostic(refreshed.data);
    } catch (error) {
      toast.error("Erreur lors de la réparation des accès");
      console.error("Erreur réparation:", error);
    } finally {
      setIsRepairingAccess(false);
    }
  };

  const handleToggleUserStatus = async (userId, currentStatus, userName) => {
    const action = currentStatus ? "désactiver" : "activer";
    const actionPast = currentStatus ? "désactivé" : "activé";
    
    if (window.confirm(`Êtes-vous sûr de vouloir ${action} l'utilisateur "${userName}" ?`)) {
      try {
        const response = await axios.put(`${API}/users/${userId}/toggle-status`);
        toast.success(`Utilisateur ${actionPast} avec succès`);
        loadUsers();
      } catch (error) {
        toast.error(`Erreur lors de la modification du statut`);
      }
    }
  };

  // 🚀 Optimisation réactivité - Suppression employé avec callback memoized
  const handleDeleteEmployee = useCallback(async (employee) => {
    // Vérifier d'abord si l'employé est inactif
    if (employee.is_active !== false) {
      toast.error("Impossible de supprimer un employé actif. Veuillez d'abord le désactiver.");
      return;
    }
    
    const employeeName = `${employee.prenoms || employee.first_name} ${employee.nom || employee.last_name}`;
    
    if (window.confirm(`⚠️ SUPPRESSION DÉFINITIVE\n\nÊtes-vous sûr de vouloir supprimer définitivement l'employé "${employeeName}" ?\n\nCette action supprimera également:\n- Tous ses contrats\n- Tous ses bulletins de paie\n- Tous ses prêts\n- Toutes ses sanctions disciplinaires\n\n❌ Cette action est IRRÉVERSIBLE !`)) {
      try {
        await axios.delete(`${API}/employees/${employee.id}`);
        toast.success(`Employé ${employeeName} supprimé définitivement`);
        loadEmployees();
        loadStats(selectedCompany?.id); // Mettre à jour les statistiques
      } catch (error) {
        toast.error(error.response?.data?.detail || "Erreur lors de la suppression de l'employé");
      }
    }
  }, [loadEmployees, loadStats, selectedCompany]);

  const handleGenerateMatricules = async () => {
    if (!selectedCompany) {
      toast.error("Veuillez sélectionner une entreprise");
      return;
    }

    if (window.confirm("Générer des matricules pour tous les employés qui n'en ont pas ?\n\nCette action créera des matricules uniques au format XXX-YYYY.")) {
      try {
        const response = await axios.post(`${API}/employees/generate-matricules/${selectedCompany.id}`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        toast.success(`${response.data.updated_employees} matricule(s) généré(s) avec succès`);
        loadEmployees(); // Recharger la liste des employés
      } catch (error) {
        console.error('Erreur lors de la génération des matricules:', error);
        toast.error(error.response?.data?.detail || "Erreur lors de la génération des matricules");
      }
    }
  };

  // Toggle le statut actif/inactif d'un employé
  const handleToggleEmployeeActive = async (employee) => {
    const newStatus = !employee.is_active;
    const action = newStatus ? 'activer' : 'désactiver';
    
    if (!window.confirm(`Voulez-vous ${action} l'employé "${employee.prenoms || employee.first_name} ${employee.nom || employee.last_name}" ?\n\n${newStatus ? 'L\'employé sera comptabilisé dans les statistiques.' : 'L\'employé ne sera plus comptabilisé dans les statistiques.'}`)) {
      return;
    }
    
    try {
      const response = await axios.patch(`${API}/employees/${employee.id}/toggle-active`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Mettre à jour l'état local immédiatement
      setEmployees(prev => prev.map(emp => 
        emp.id === employee.id ? { ...emp, is_active: response.data.is_active } : emp
      ));
      
      toast.success(response.data.message);
      
      // Recharger les stats pour mettre à jour le compteur d'employés actifs
      loadStats(selectedCompany?.id);
    } catch (error) {
      console.error('Erreur toggle statut employé:', error);
      toast.error(error.response?.data?.detail || "Erreur lors du changement de statut");
    }
  };

  // 🚀 Optimisation réactivité - Édition employé avec callback memoized
  const handleEditEmployee = useCallback((employee) => {
    setEditingEmployee(employee);
    // Migration : déplacer les primes spéciales exonérées de la liste primes vers les champs dédiés
    const migratedPrimes = [];
    const specialPrimeValues = {};
    (employee.primes || []).forEach(pid => {
      const comp = salaryComponents.find(c => c.id === pid);
      const field = comp ? getSpecialPrimeField(comp.name) : null;
      if (field) {
        specialPrimeValues[field] = employee[field] || comp.amount || 0;
      } else {
        migratedPrimes.push(pid);
      }
    });
    setEmployeeForm({
      first_name: employee.first_name,
      last_name: employee.last_name,
      sexe: employee.sexe || "M",
      email: employee.email,
      phone: employee.phone,
      position: employee.position,
      numero_cnps: employee.numero_cnps || "",
      secteur_activite_precis: employee.secteur_activite_precis || "",
      categorie_professionnelle: employee.categorie_professionnelle || "",
      grade: employee.grade || "",
      salary_categoriel: employee.salary_categoriel,
      sursalaire: employee.sursalaire,
      prime_transport: employee.prime_transport,
      prime_anciennete: employee.prime_anciennete,
      allocations_familiales_imposables: employee.allocations_familiales_imposables,
      avantages_nature: employee.avantages_nature || 0,
      avantages_argent: employee.avantages_argent || 0,
      remboursement_frais: employee.remboursement_frais || 0,
      indemnite_frais_emploi: employee.indemnite_frais_emploi || 0,
      prime_panier: specialPrimeValues.prime_panier ?? (employee.prime_panier || 0),
      prime_salissure: specialPrimeValues.prime_salissure ?? (employee.prime_salissure || 0),
      prime_tenue: specialPrimeValues.prime_tenue ?? (employee.prime_tenue || 0),
      prime_outillage: specialPrimeValues.prime_outillage ?? (employee.prime_outillage || 0),
      cmu_employeur: employee.cmu_employeur || 0,
      cmu_salarie: employee.cmu_salarie || 0,
      cmu_active: employee.cmu_active || false,
      formation_continue: employee.formation_continue || 0,
      taxe_apprentissage: employee.taxe_apprentissage || 0,
      is_patronal: employee.is_patronal || 0,
      is_salarie: employee.is_salarie || 0,
      // Nouveaux champs RICF
      statut_matrimonial: employee.statut_matrimonial || "celibataire",
      nombre_enfants: employee.nombre_enfants || 0,
      nombre_enfants_infirmes: employee.nombre_enfants_infirmes || 0,
      indemnites: employee.indemnites || [],
      primes: migratedPrimes,
      complement_retraite: employee.complement_retraite || [],
      frais: employee.frais || [],
      special_allowance_amounts: employee.special_allowance_amounts || {},  // Montants personnalisés
      component_amounts: employee.component_amounts || {},  // Montants personnalisés des indemnités/primes
      contract_type: employee.contract_type,
      hire_date: employee.hire_date ? employee.hire_date.split('T')[0] : "",
      date_fin_activite: employee.date_fin_activite ? employee.date_fin_activite.split('T')[0] : "",
      gratification_display_consent: employee.gratification_display_consent !== undefined ? employee.gratification_display_consent : true,
      allocations_familiales_consent: employee.allocations_familiales_consent !== undefined ? employee.allocations_familiales_consent : true,
      // Préserver la photo actuelle lors de l'édition
      photo_url: employee.photo_url || null,
      photo_filename: employee.photo_filename || null
    });
    setIsEditEmployeeOpen(true);
  }, [salaryComponents]);

  const handleUpdateEmployee = async (e) => {
    e.preventDefault();
    try {
      // PRÉSERVATION DES PHOTOS : Exclure SYSTÉMATIQUEMENT les champs photo lors des modifications
      // Les photos ne sont modifiées que par des actions explicites (upload/suppression)
      const { photo_url, photo_filename, ...employeeDataWithoutPhoto } = employeeForm;
      
      const employeeData = {
        ...employeeDataWithoutPhoto,
        company_id: selectedCompany.id,
        // Champs de classification professionnelle
        secteur_activite_precis: employeeForm.secteur_activite_precis || "",
        categorie_professionnelle: employeeForm.categorie_professionnelle || "",
        grade: employeeForm.grade || "",
        salary_categoriel: parseFloat(employeeForm.salary_categoriel),
        sursalaire: parseFloat(employeeForm.sursalaire || 0),
        prime_transport: parseFloat(employeeForm.prime_transport || 0),
        prime_anciennete: parseFloat(employeeForm.prime_anciennete || 0),
        allocations_familiales_imposables: parseFloat(employeeForm.allocations_familiales_imposables || 0),
        avantages_nature: parseFloat(employeeForm.avantages_nature || 0),
        avantages_argent: parseFloat(employeeForm.avantages_argent || 0),
        remboursement_frais: parseFloat(employeeForm.remboursement_frais || 0),
        indemnite_frais_emploi: parseFloat(employeeForm.indemnite_frais_emploi || 0),
        prime_panier: parseFloat(employeeForm.prime_panier || 0),
        prime_salissure: parseFloat(employeeForm.prime_salissure || 0),
        prime_tenue: parseFloat(employeeForm.prime_tenue || 0),
        prime_outillage: parseFloat(employeeForm.prime_outillage || 0),
        cmu_employeur: parseFloat(employeeForm.cmu_employeur || 0),
        cmu_salarie: parseFloat(employeeForm.cmu_salarie || 0),
        cmu_active: employeeForm.cmu_active || false,
        formation_continue: parseFloat(employeeForm.formation_continue || 0),
        taxe_apprentissage: parseFloat(employeeForm.taxe_apprentissage || 0),
        is_patronal: parseFloat(employeeForm.is_patronal || 0),
        is_salarie: parseFloat(employeeForm.is_salarie || 0),
        // Nouveaux champs RICF
        statut_matrimonial: employeeForm.statut_matrimonial || "celibataire",
        nombre_enfants: parseInt(employeeForm.nombre_enfants) || 0,
        nombre_enfants_infirmes: parseInt(employeeForm.nombre_enfants_infirmes) || 0,
        special_allowance_amounts: employeeForm.special_allowance_amounts || {},  // Montants personnalisés des allocations
        hire_date: new Date(employeeForm.hire_date).toISOString(),
        date_fin_activite: employeeForm.date_fin_activite ? new Date(employeeForm.date_fin_activite).toISOString() : null,
        gratification_display_consent: employeeForm.gratification_display_consent,
        allocations_familiales_consent: employeeForm.allocations_familiales_consent,
      };

      await axios.put(`${API}/employees/${editingEmployee.id}`, employeeData);
      
      toast.success("Employé modifié avec succès");
      setIsEditEmployeeOpen(false);
      setEditingEmployee(null);
      setEmployeeForm({
        first_name: "", last_name: "", sexe: "M", email: "", phone: "", position: "", 
        salary_categoriel: "", sursalaire: 0, prime_transport: 0,
        prime_anciennete: 0, allocations_familiales_imposables: 0,
        avantages_nature: 0, avantages_argent: 0, remboursement_frais: 0,
    indemnite_frais_emploi: 0, prime_panier: 0, prime_salissure: 0, prime_tenue: 0, prime_outillage: 0,
        cmu_employeur: 0, cmu_salarie: 0, cmu_active: false,
        formation_continue: 0, taxe_apprentissage: 0, is_patronal: 0, is_salarie: 0,
        indemnites: [], primes: [], complement_retraite: [], frais: [],
        special_allowance_amounts: {},  // Réinitialiser les montants personnalisés
        component_amounts: {},
        contract_type: "CDI", hire_date: "", date_fin_activite: "",
        gratification_display_consent: true,
        allocations_familiales_consent: true,
        photo_url: null, photo_filename: null
      });
      loadEmployees();
      loadStats();
    } catch (error) {
      toast.error("Erreur lors de la modification de l'employé");
    }
  };

  // Fonctions de gestion des photos d'employés
  const handlePhotoUpload = async (event, employeeId = null) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validation du fichier
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Format de fichier non supporté. Formats acceptés: PNG, JPG, JPEG, PDF');
      return;
    }

    // Validation de la taille (5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      toast.error('Fichier trop volumineux. Taille maximale: 5MB');
      return;
    }

    setUploadingPhoto(true);

    try {
      // Cas 1: Upload lors de la création d'employé (pas encore d'ID)
      if (!employeeId) {
        // Pour la création, on stocke temporairement le fichier dans le formulaire
        const reader = new FileReader();
        reader.onload = (e) => {
          setEmployeeForm({
            ...employeeForm,
            photo_url: e.target.result,
            photo_filename: file.name
          });
          toast.success('Photo ajoutée. Elle sera uploadée lors de la création de l\'employé.');
        };
        reader.readAsDataURL(file);
        return;
      }

      // Cas 2: Upload lors de la modification d'employé (ID existant)
      const formData = new FormData();
      formData.append('photo', file);

      const response = await axios.post(
        `${BACKEND_URL}/api/employees/${employeeId}/photo`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        }
      );

      toast.success('Photo uploadée avec succès');
      
      // Recharger les employés pour afficher la nouvelle photo
      await loadEmployees();
      
      // Si on modifie un employé, mettre à jour l'objet editingEmployee
      if (editingEmployee && editingEmployee.id === employeeId) {
        const updatedEmployee = { ...editingEmployee, photo_url: response.data.photo_url };
        setEditingEmployee(updatedEmployee);
      }
    } catch (error) {
      console.error('Erreur upload photo:', error);
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'upload de la photo');
    } finally {
      setUploadingPhoto(false);
      // Reset input file
      event.target.value = '';
    }
  };

  const handleDeletePhoto = async (employeeId) => {
    if (!employeeId) return;

    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette photo ?')) {
      return;
    }

    setDeletingPhoto(true);

    try {
      await axios.delete(
        `${BACKEND_URL}/api/employees/${employeeId}/photo`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      toast.success('Photo supprimée avec succès');
      
      // Recharger les employés
      await loadEmployees();
      
      // Si on modifie un employé, mettre à jour l'objet editingEmployee
      if (editingEmployee && editingEmployee.id === employeeId) {
        const updatedEmployee = { ...editingEmployee };
        delete updatedEmployee.photo_url;
        setEditingEmployee(updatedEmployee);
      }
    } catch (error) {
      console.error('Erreur suppression photo:', error);
      toast.error(error.response?.data?.detail || 'Erreur lors de la suppression de la photo');
    } finally {
      setDeletingPhoto(false);
    }
  };


  // 🚀 CALLBACKS OPTIMISÉS POUR PAIE JOURNALIÈRE
  
  // Callback pour la sélection d'employé dans daily payroll
  const handleDailyPayrollEmployeeChange = useCallback((value) => {
    try {
      setDailyPayrollForm(prev => ({ ...prev, employee_id: value }));
    } catch (error) {
      console.error('Erreur sélection employé daily payroll:', error);
    }
  }, []);

  // Callback pour le type de calcul dans daily payroll
  const handleDailyPayrollTypeCalculChange = useCallback((value) => {
    try {
      setDailyPayrollForm(prev => ({ ...prev, type_calcul: value }));
    } catch (error) {
      console.error('Erreur changement type calcul daily payroll:', error);
    }
  }, []);

  // Callback pour le mois dans daily payroll
  const handleDailyPayrollMonthChange = useCallback((value) => {
    try {
      setDailyPayrollForm(prev => ({ ...prev, month: parseInt(value) }));
    } catch (error) {
      console.error('Erreur changement mois daily payroll:', error);
    }
  }, []);

  // Callback pour l'année dans daily payroll
  const handleDailyPayrollYearChange = useCallback((value) => {
    try {
      setDailyPayrollForm(prev => ({ ...prev, year: parseInt(value) }));
    } catch (error) {
      console.error('Erreur changement année daily payroll:', error);
    }
  }, []);


  // États pour la prolongation d'accès
  const [extendAccessUserId, setExtendAccessUserId] = useState(null);
  const [extendAccessDays, setExtendAccessDays] = useState(30);
  const [isExtendingAccess, setIsExtendingAccess] = useState(false);

  // États pour la suppression d'utilisateur
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [deleteUserName, setDeleteUserName] = useState("");
  const [isDeletingUser, setIsDeletingUser] = useState(false);

  // Fonction pour supprimer un utilisateur
  const handleDeleteUser = async (userId) => {
    setIsDeletingUser(true);
    try {
      await axios.delete(`${API}/users/${userId}`);
      toast.success("Utilisateur supprimé avec succès");
      setDeleteUserId(null);
      setDeleteUserName("");
      loadUsers(); // Recharger la liste des utilisateurs
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de la suppression de l'utilisateur");
    } finally {
      setIsDeletingUser(false);
    }
  };

  // Fonction pour prolonger l'accès d'un utilisateur
  const handleExtendUserAccess = async (userId) => {
    if (!extendAccessDays || extendAccessDays <= 0) {
      toast.error("Veuillez spécifier un nombre de jours valide");
      return;
    }

    setIsExtendingAccess(true);

    try {
      await axios.put(
        `${BACKEND_URL}/api/users/${userId}/extend-access`,
        {
          additional_days: parseInt(extendAccessDays)
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      );

      toast.success(`Accès prolongé de ${extendAccessDays} jours avec succès`);
      setExtendAccessUserId(null);
      setExtendAccessDays(30);
      
      // Recharger les utilisateurs
      loadUsers();
    } catch (error) {
      console.error('Erreur prolongation accès:', error);
      toast.error(error.response?.data?.detail || "Erreur lors de la prolongation de l'accès");
    } finally {
      setIsExtendingAccess(false);
    }
  };

  // Fonction de calcul du nombre de parts familiales selon la réglementation ivoirienne 2023
  const calculatePartsFamiliales = (statut_matrimonial, nombre_enfants, nombre_enfants_infirmes) => {
    // Conforme à l'Ordonnance N° 2023-719 du 13 septembre 2023
    const enfants_normaux = Math.max(0, nombre_enfants - nombre_enfants_infirmes);
    
    let parts = 0;
    
    // Application du barème officiel 2023
    if ((statut_matrimonial === "celibataire" || statut_matrimonial === "divorce") && enfants_normaux === 0) {
      parts = 1.0;  // Célibataire, divorcé sans enfant = 1 part
    } else if (statut_matrimonial === "marie" && enfants_normaux === 0) {
      parts = 2.0;  // Marié sans enfant = 2 parts
    } else if (statut_matrimonial === "veuf" && enfants_normaux === 0) {
      parts = 1.0;  // Veuf sans enfant = 1 part
    } else if ((statut_matrimonial === "celibataire" || statut_matrimonial === "divorce") && enfants_normaux === 1) {
      parts = 2.0;  // Célibataire/divorcé avec 1 enfant = 2 parts
    } else if ((statut_matrimonial === "marie" || statut_matrimonial === "veuf") && enfants_normaux === 1) {
      parts = 2.5;  // Marié/veuf avec 1 enfant = 2.5 parts
    } else if ((statut_matrimonial === "celibataire" || statut_matrimonial === "divorce") && enfants_normaux === 2) {
      parts = 2.5;  // Célibataire/divorcé avec 2 enfants = 2.5 parts
    } else if ((statut_matrimonial === "marie" || statut_matrimonial === "veuf") && enfants_normaux === 2) {
      parts = 3.0;  // Marié/veuf avec 2 enfants = 3 parts
    } else if ((statut_matrimonial === "celibataire" || statut_matrimonial === "divorce") && enfants_normaux === 3) {
      parts = 3.0;  // Célibataire/divorcé avec 3 enfants = 3 parts
    } else if ((statut_matrimonial === "marie" || statut_matrimonial === "veuf") && enfants_normaux === 3) {
      parts = 3.5;  // Marié/veuf avec 3 enfants = 3.5 parts
    } else if ((statut_matrimonial === "celibataire" || statut_matrimonial === "divorce") && enfants_normaux === 4) {
      parts = 3.5;  // Célibataire/divorcé avec 4 enfants = 3.5 parts
    } else if ((statut_matrimonial === "marie" || statut_matrimonial === "veuf") && enfants_normaux === 4) {
      parts = 4.0;  // Marié/veuf avec 4 enfants = 4 parts
    } else {
      // Pour plus de 4 enfants : majoration d'un demi-point par enfant supplémentaire
      if (statut_matrimonial === "celibataire" || statut_matrimonial === "divorce") {
        parts = 3.5 + (enfants_normaux - 4) * 0.5;
      } else {  // marié ou veuf
        parts = 4.0 + (enfants_normaux - 4) * 0.5;
      }
    }
    
    // Ajout des enfants infirmes (1 part complète par enfant infirme)
    parts += nombre_enfants_infirmes * 1.0;
    
    // Limiter à 5 parts maximum (selon la loi)
    return Math.min(parts, 5.0);
  };

  // Fonction pour télécharger le PDF du bulletin journalier
  const handleDownloadDailyPayrollPDF = async () => {
    if (!dailyPayrollResult || !dailyPayrollForm.employee_id) {
      toast.error("Veuillez d'abord calculer la paie journalière");
      return;
    }

    try {
      setPdfDownloading(true);
      
      const ville = selectedCompany?.ville || 'abidjan';
      
      const response = await axios.post(
        `${BACKEND_URL}/api/generate-bulletin-journalier-pdf`,
        {
          employee_id: dailyPayrollForm.employee_id,
          heures_travaillees_jour: parseFloat(dailyPayrollForm.heures_travaillees_jour),
          salaire_base_periode: parseFloat(dailyPayrollForm.salaire_base_periode),
          periode_en_jours: parseInt(dailyPayrollForm.periode_en_jours),
          ville: ville,
          type_calcul: dailyPayrollForm.type_calcul,
          month: dailyPayrollForm.month,
          year: dailyPayrollForm.year
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          responseType: 'blob'
        }
      );

      // Créer le blob PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      
      // Nom du fichier
      const selectedEmployee = employees.find(emp => emp.id === dailyPayrollForm.employee_id);
      const filename = `bulletin_journalier_${selectedEmployee?.first_name}_${selectedEmployee?.last_name}_${dailyPayrollForm.month}${dailyPayrollForm.year}.pdf`;
      
      // Télécharger le PDF
      downloadPDFWithLink(pdfBlob, filename);
      
      toast.success("Bulletin journalier téléchargé avec succès");
    } catch (error) {
      console.error('Erreur téléchargement PDF journalier:', error);
      toast.error(error.response?.data?.detail || "Erreur lors du téléchargement du PDF");
    } finally {
      setPdfDownloading(false);
    }
  };

  // Fonction de calcul INVERSE de la paie journalière (du net vers le brut)
  const calculateReverseDaily = (netJournalierSouhaite, periodeEnJours, heuresJour, ville) => {
    // On part du net journalier souhaité et on calcule le brut nécessaire
    // Formules : Net = Brut - CNPS - ITS - IGR
    // CNPS = Brut * 6.3%
    // ITS et IGR dépendent du barème progressif
    
    // Seuils transport par ville
    const seuilsTransport = { 'abidjan': 30000, 'bouake': 24000, 'autres': 21000 };
    const seuilTransport = seuilsTransport[ville?.toLowerCase()] || 21000;
    const transportJournalierExonere = Math.round(seuilTransport / 30);
    
    // Calcul itératif pour trouver le brut qui donne le net souhaité
    // On commence avec une estimation : net * 1.25 (approximation)
    let brutPeriodeEstime = netJournalierSouhaite * periodeEnJours * 1.25;
    let iterations = 0;
    const maxIterations = 100;
    const tolerance = 1; // Tolérance de 1 FCFA
    
    while (iterations < maxIterations) {
      // Calculer les éléments à partir du brut estimé
      const brutJournalier = Math.round(brutPeriodeEstime / periodeEnJours);
      const brutJournalierImposable = Math.max(0, brutJournalier - transportJournalierExonere);
      
      // CNPS journalier (6.3%)
      const cnpsJournalier = Math.round(brutJournalierImposable * 0.063);
      
      // Base ITS journalière
      const baseITSJournalier = brutJournalierImposable - cnpsJournalier;
      
      // Calcul ITS sur base mensuelle reconvertie
      const baseMensuelle = baseITSJournalier * 30;
      let itsMensuel = 0;
      
      if (baseMensuelle > 75000) {
        if (baseMensuelle <= 300000) {
          itsMensuel = Math.round((baseMensuelle - 75000) * 0.10);
        } else if (baseMensuelle <= 547000) {
          itsMensuel = Math.round(22500 + (baseMensuelle - 300000) * 0.15);
        } else if (baseMensuelle <= 979000) {
          itsMensuel = Math.round(59550 + (baseMensuelle - 547000) * 0.20);
        } else if (baseMensuelle <= 1519000) {
          itsMensuel = Math.round(145950 + (baseMensuelle - 979000) * 0.25);
        } else {
          itsMensuel = Math.round(280950 + (baseMensuelle - 1519000) * 0.35);
        }
      }
      
      const itsJournalier = Math.round(itsMensuel / 30);
      const igrJournalier = Math.round(itsJournalier * 0.10);
      
      // Total retenues journalières
      const totalRetenuesJournalier = cnpsJournalier + itsJournalier + igrJournalier;
      
      // Net journalier calculé
      const netJournalierCalcule = brutJournalier - totalRetenuesJournalier;
      
      // Vérifier si on est proche du net souhaité
      const difference = netJournalierSouhaite - netJournalierCalcule;
      
      if (Math.abs(difference) <= tolerance) {
        // On a trouvé !
        return {
          brut_periode: brutPeriodeEstime,
          brut_journalier: brutJournalier,
          brut_journalier_imposable: brutJournalierImposable,
          transport_exonere_journalier: transportJournalierExonere,
          cnps_journalier: cnpsJournalier,
          its_journalier: itsJournalier,
          igr_journalier: igrJournalier,
          total_retenues_journalier: totalRetenuesJournalier,
          net_journalier: netJournalierCalcule,
          net_periode: netJournalierCalcule * periodeEnJours,
          heures_jour: heuresJour,
          salaire_horaire: Math.round(brutJournalier / heuresJour),
          iterations: iterations,
          success: true
        };
      }
      
      // Ajuster l'estimation
      // Si le net calculé est trop bas, on augmente le brut
      // Si le net calculé est trop haut, on diminue le brut
      brutPeriodeEstime = brutPeriodeEstime + (difference * periodeEnJours * 1.1);
      iterations++;
    }
    
    // Si on n'a pas convergé, retourner la meilleure estimation
    const brutJournalier = Math.round(brutPeriodeEstime / periodeEnJours);
    return {
      brut_periode: brutPeriodeEstime,
      brut_journalier: brutJournalier,
      success: false,
      message: "Calcul approximatif (convergence non atteinte)"
    };
  };

  // Fonction de calcul de la paie journalière
  const handleCalculateDailyPayroll = async (e) => {
    e.preventDefault();
    
    if (!dailyPayrollForm.employee_id) {
      toast.error("Veuillez sélectionner un employé");
      return;
    }

    if (dailyPayrollForm.heures_travaillees_jour <= 0 || dailyPayrollForm.heures_travaillees_jour > 24) {
      toast.error("Le nombre d'heures doit être entre 0 et 24");
      return;
    }

    if (!dailyPayrollForm.periode_en_jours || parseInt(dailyPayrollForm.periode_en_jours) <= 0) {
      toast.error("La période en jours est obligatoire et doit être supérieure à 0");
      return;
    }

    // Validation selon le mode de calcul
    if (dailyPayrollForm.mode_calcul === 'inverse') {
      if (!dailyPayrollForm.net_journalier_souhaite || parseFloat(dailyPayrollForm.net_journalier_souhaite) <= 0) {
        toast.error("Le net journalier souhaité est obligatoire pour le calcul inverse");
        return;
      }
    } else {
      if (!dailyPayrollForm.salaire_base_periode || parseFloat(dailyPayrollForm.salaire_base_periode) <= 0) {
        toast.error("Le salaire de base de la période est obligatoire et doit être supérieur à 0");
        return;
      }
    }

    setCalculatingDailyPayroll(true);

    try {
      // Récupérer l'employé sélectionné pour avoir la ville
      const selectedEmployee = employees.find(emp => emp.id === dailyPayrollForm.employee_id);
      if (!selectedEmployee) {
        toast.error("Employé introuvable");
        return;
      }

      // La ville vient de l'entreprise
      const ville = selectedCompany?.ville || 'abidjan';

      let resultWithPeriode;

      if (dailyPayrollForm.mode_calcul === 'inverse') {
        // Calcul inverse : du net vers le brut
        const netSouhaite = parseFloat(dailyPayrollForm.net_journalier_souhaite);
        const periodeJours = parseInt(dailyPayrollForm.periode_en_jours);
        const heuresJour = parseFloat(dailyPayrollForm.heures_travaillees_jour);
        
        const reverseResult = calculateReverseDaily(netSouhaite, periodeJours, heuresJour, ville);
        
        if (reverseResult.success) {
          // Mettre à jour automatiquement le salaire de base dans le formulaire
          setDailyPayrollForm(prev => ({
            ...prev,
            salaire_base_periode: Math.round(reverseResult.brut_periode).toString()
          }));
          
          // Construire le résultat comme si c'était un calcul normal
          resultWithPeriode = {
            salaire_brut_journalier: reverseResult.brut_journalier,
            salaire_brut_imposable_journalier: reverseResult.brut_journalier_imposable,
            prime_transport_exoneree_journalier: reverseResult.transport_exonere_journalier,
            cnps_journalier: reverseResult.cnps_journalier,
            its_journalier: reverseResult.its_journalier,
            igr_journalier: reverseResult.igr_journalier,
            total_retenues_journalier: reverseResult.total_retenues_journalier,
            salaire_net_journalier: reverseResult.net_journalier,
            salaire_net_periode: reverseResult.net_periode,
            salaire_horaire: reverseResult.salaire_horaire,
            heures_travaillees_jour: heuresJour,
            periode_en_jours: periodeJours,
            type_calcul: dailyPayrollForm.type_calcul,
            mode_calcul_inverse: true,
            net_journalier_souhaite: netSouhaite,
            employee: selectedEmployee,
            periode: {
              periode: dailyPayrollForm.periode,
              month: dailyPayrollForm.month,
              year: dailyPayrollForm.year
            }
          };
          
          // Sauvegarder dans l'historique des calculs inverse
          const historyEntry = {
            id: Date.now(),
            date: new Date().toISOString(),
            employeeName: `${selectedEmployee.first_name} ${selectedEmployee.last_name}`,
            employeeId: selectedEmployee.id,
            netSouhaite: netSouhaite,
            brutCalcule: reverseResult.brut_journalier,
            brutPeriode: Math.round(reverseResult.brut_periode),
            periodeJours: periodeJours,
            heuresJour: heuresJour,
            ville: ville,
            cnpsJournalier: reverseResult.cnps_journalier,
            itsJournalier: reverseResult.its_journalier,
            igrJournalier: reverseResult.igr_journalier,
            totalRetenues: reverseResult.total_retenues_journalier,
            netPeriode: reverseResult.net_periode,
            companyName: selectedCompany?.name || 'N/A'
          };
          
          setInverseCalculationHistory(prev => {
            const newHistory = [historyEntry, ...prev].slice(0, 50); // Garder les 50 derniers
            localStorage.setItem('inverseCalculationHistory', JSON.stringify(newHistory));
            return newHistory;
          });
          
          toast.success(`Calcul inverse réussi ! Salaire de base nécessaire: ${formatCurrency(Math.round(reverseResult.brut_periode))}`);
        } else {
          toast.warning("Calcul approximatif - " + reverseResult.message);
          resultWithPeriode = {
            ...reverseResult,
            employee: selectedEmployee,
            periode: {
              periode: dailyPayrollForm.periode,
              month: dailyPayrollForm.month,
              year: dailyPayrollForm.year
            }
          };
        }
      } else {
        // Calcul normal via l'API
        const response = await axios.post(
          `${BACKEND_URL}/api/bulletin-journalier`,
          {
            employee_id: dailyPayrollForm.employee_id,
            heures_travaillees_jour: parseFloat(dailyPayrollForm.heures_travaillees_jour),
            salaire_base_periode: parseFloat(dailyPayrollForm.salaire_base_periode),
            periode_en_jours: parseInt(dailyPayrollForm.periode_en_jours),
            ville: ville,
            type_calcul: dailyPayrollForm.type_calcul,
            month: dailyPayrollForm.month,
            year: dailyPayrollForm.year
          },
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          }
        );

        // Ajouter les informations de période au résultat pour l'affichage
        resultWithPeriode = {
          ...response.data,
          periode: {
            periode: dailyPayrollForm.periode,
            month: dailyPayrollForm.month,
            year: dailyPayrollForm.year
          }
        };
        
        toast.success("Calcul de la paie journalière effectué avec succès");
      }

      setDailyPayrollResult(resultWithPeriode);
      setShowDailyPayrollPreview(false); // Reset preview when new calculation
      
    } catch (error) {
      console.error('Erreur lors du calcul de la paie journalière:', error);
      toast.error(error.response?.data?.detail || "Erreur lors du calcul de la paie journalière");
    } finally {
      setCalculatingDailyPayroll(false);
    }
  };

  // Fonction pour gérer l'aperçu du bulletin journalier
  const handlePreviewDailyPayroll = () => {
    if (!dailyPayrollResult) {
      toast.error("Veuillez d'abord calculer la paie journalière");
      return;
    }
    setShowDailyPayrollPreview(true);
  };

  // Fonction pour imprimer l'aperçu du bulletin
  const handlePrintDailyPayrollPreview = () => {
    window.print();
  };

  // Fonction pour créer un employé journalier
  const handleCreateDailyEmployee = async (e) => {
    e.preventDefault();
    
    if (!selectedCompany) {
      toast.error("Veuillez sélectionner une entreprise");
      return;
    }

    if (!dailyEmployeeForm.first_name || !dailyEmployeeForm.last_name) {
      toast.error("Le nom et le prénom sont obligatoires");
      return;
    }

    if (!dailyEmployeeForm.salary_categoriel || parseFloat(dailyEmployeeForm.salary_categoriel) <= 0) {
      toast.error("Le salaire de base doit être supérieur à 0");
      return;
    }

    if (!dailyEmployeeForm.hire_date) {
      toast.error("La date d'embauche est obligatoire");
      return;
    }

    setCreatingDailyEmployee(true);

    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/employees`,
        {
          company_id: selectedCompany.id,
          first_name: dailyEmployeeForm.first_name,
          last_name: dailyEmployeeForm.last_name,
          position: dailyEmployeeForm.position,
          salary_categoriel: parseFloat(dailyEmployeeForm.salary_categoriel),
          phone: dailyEmployeeForm.phone || `+225 00 00 00 00`,
          email: dailyEmployeeForm.email || `${dailyEmployeeForm.first_name.toLowerCase()}.${dailyEmployeeForm.last_name.toLowerCase()}@journalier.ci`,
          numero_cnps: "",
          sursalaire: 0,
          prime_transport: 0,
          avantages_nature: 0,
          avances: 0,
          hire_date: dailyEmployeeForm.hire_date, // Utiliser la date saisie manuellement
          contract_type: "CDI",
          statut_matrimonial: "celibataire",
          nombre_enfants: 0,
          allocations_familiales_consent: false,
          gratification_display_consent: false
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      );

      toast.success(`Employé journalier ${dailyEmployeeForm.first_name} ${dailyEmployeeForm.last_name} créé avec succès`);
      
      // Rafraîchir la liste des employés
      await loadEmployees(selectedCompany.id);
      
      // Réinitialiser le formulaire et fermer le modal
      setDailyEmployeeForm({
        first_name: "",
        last_name: "",
        position: "Ouvrier journalier",
        salary_categoriel: 0,
        phone: "",
        email: "",
        hire_date: new Date().toISOString().split('T')[0]
      });
      setIsCreateDailyEmployeeOpen(false);
      
    } catch (error) {
      console.error('Erreur lors de la création de l\'employé journalier:', error);
      toast.error(error.response?.data?.detail || "Erreur lors de la création de l'employé journalier");
    } finally {
      setCreatingDailyEmployee(false);
    }
  };


  const filteredUsers = users.filter(userItem =>
    userItem.user.username.toLowerCase().includes(userFilter.toLowerCase()) ||
    userItem.user.full_name.toLowerCase().includes(userFilter.toLowerCase()) ||
    userItem.user.email.toLowerCase().includes(userFilter.toLowerCase()) ||
    userItem.user.role.toLowerCase().includes(userFilter.toLowerCase())
  );

  const getRoleLabel = (role) => {
    const roleLabels = {
      super_admin: "Super Administrateur",
      assistant_sirh: "Assistant SIRH-CI/PAIE",
      admin_multi: "Admin Multi-Entreprise",
      admin_single: "Admin Entreprise",
      rh: "Ressources Humaines",
      comptable: "Comptable"
    };
    return roleLabels[role] || role;
  };

  const getRoleBadgeColor = (role) => {
    const colors = {
      super_admin: "bg-purple-100 text-purple-800",
      admin_multi: "bg-orange-100 text-orange-800",
      admin_single: "bg-blue-100 text-blue-800",
      rh: "bg-green-100 text-green-800",
      comptable: "bg-yellow-100 text-yellow-800"
    };
    return colors[role] || "bg-gray-100 text-gray-800";
  };

  const getComponentName = (componentId) => {
    const comp = salaryComponents.find(c => c.id === componentId);
    return comp ? comp.name : '';
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 to-green-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-green-600 rounded-lg flex items-center justify-center mx-auto mb-4 animate-pulse">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">SIRH-CI/PAIE</h2>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  const handleLogout = () => {
    if (window.confirm("Êtes-vous sûr de vouloir vous déconnecter ?")) {
      logout();
    }
  };

  const handleRefresh = () => {
    // Recharger complètement la page (équivalent à Ctrl+F5)
    toast.info("Actualisation de l'application...");
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  // Fonctions pour la génération de bulletins
  const handleEmployeeSelectionForBulletin = (employeeId, isSelected) => {
    if (isSelected) {
      setSelectedEmployeesForBulletin([...selectedEmployeesForBulletin, employeeId]);
    } else {
      setSelectedEmployeesForBulletin(selectedEmployeesForBulletin.filter(id => id !== employeeId));
    }
  };

  const handleSelectAllEmployeesForBulletin = (selectAll) => {
    if (selectAll) {
      setSelectedEmployeesForBulletin(allEmployees.map(emp => emp.id));
    } else {
      setSelectedEmployeesForBulletin([]);
    }
  };

  const handleGenerateBulletins = async () => {
    if (!selectedCompany) {
      toast.error("Veuillez sélectionner une entreprise");
      return;
    }

    if (selectedEmployeesForBulletin.length === 0) {
      toast.error("Veuillez sélectionner au moins un employé");
      return;
    }

    if (!bulletinPeriod.start || !bulletinPeriod.end) {
      toast.error("Veuillez définir la période du bulletin");
      return;
    }

    try {
      const requestData = {
        employee_ids: selectedEmployeesForBulletin,
        period_start: bulletinPeriod.start,
        period_end: bulletinPeriod.end,
        company_id: selectedCompany.id,
        update_statistics: updateStatistics  // Nouveau paramètre pour contrôler la mise à jour des statistiques
      };

      const response = await axios.post(`${API}/generate-bulletins`, requestData);
      setGeneratedBulletins(response.data);
      toast.success(`Bulletins générés pour ${response.data.employees.length} employé(s)`);
    } catch (error) {
      toast.error("Erreur lors de la génération des bulletins");
      console.error("Erreur génération bulletins:", error);
    }
  };

  const handleDownloadPDF = async (employeeId) => {
    if (!generatedBulletins) return;
    
    setPdfDownloading(true);
    try {
      const response = await axios.post(`${API}/generate-bulletin-pdf`, {
        employee_ids: [employeeId],
        period_start: generatedBulletins.period_start,
        period_end: generatedBulletins.period_end,
        company_id: selectedCompany.id
      }, {
        responseType: 'blob'
      });

      // Récupérer le nom de l'employé pour le nom du fichier
      const employee = generatedBulletins.employees.find(emp => emp.id === employeeId);
      const filename = `bulletin_${employee.full_name.replace(/\s+/g, '_')}_${new Date(generatedBulletins.period_start).toLocaleDateString('fr-FR', {month: '2-digit', year: 'numeric'}).replace('/', '')}.pdf`;
      
      // Créer le blob PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      
      // Obtenir les capacités de téléchargement de l'appareil
      const capabilities = getDownloadCapabilities();
      
      if (capabilities.isMobile) {
        // Gestion spécifique mobile
        if (capabilities.isIOS) {
          // iOS - Méthode spéciale pour iOS
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
          
          // Essayer d'abord le téléchargement direct
          if (capabilities.supportsDownload) {
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = filename;
            link.click();
            
            setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 100);
            toast.success("Téléchargement initié - Vérifiez votre dossier Téléchargements");
          } else {
            // Fallback : ouvrir dans Safari
            const newWindow = window.open(pdfUrl, '_blank');
            if (newWindow) {
              setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 5000);
              toast.success("PDF ouvert - Appuyez sur l'icône Partager puis 'Enregistrer dans Fichiers'");
            } else {
              downloadPDFWithLink(pdfBlob, filename);
            }
          }
        } else if (capabilities.isAndroid) {
          // Android - Utiliser Web Share API si disponible
          if (capabilities.canShareFiles) {
            try {
              const file = new File([pdfBlob], filename, { type: 'application/pdf' });
              await navigator.share({
                title: 'Bulletin de paie',
                text: `Bulletin de paie - ${employee.full_name}`,
                files: [file]
              });
              toast.success("Bulletin partagé avec succès");
            } catch (shareError) {
              if (shareError.name !== 'AbortError') {
                // Si le partage échoue, utiliser le téléchargement classique
                downloadPDFWithLink(pdfBlob, filename);
              }
            }
          } else {
            // Téléchargement classique pour Android sans Web Share
            downloadPDFWithLink(pdfBlob, filename);
          }
        } else {
          // Autres mobiles
          downloadPDFWithLink(pdfBlob, filename);
        }
      } else {
        // Desktop - Téléchargement classique optimisé
        downloadPDFWithLink(pdfBlob, filename);
      }

    } catch (error) {
      console.error('Erreur téléchargement PDF:', error);
      toast.error("Erreur lors du téléchargement");
    } finally {
      setPdfDownloading(false);
    }
  };

  // Fonction pour télécharger tous les bulletins générés en un seul PDF consolidé
  const handleDownloadBulkPDF = async () => {
    if (!generatedBulletins || !generatedBulletins.employees || generatedBulletins.employees.length === 0) {
      toast.error("Aucun bulletin à télécharger");
      return;
    }
    
    setBulkPdfDownloading(true);
    try {
      const employeeIds = generatedBulletins.employees.map(emp => emp.id);
      
      const response = await axios.post(`${API}/generate-bulk-bulletins-pdf`, {
        employee_ids: employeeIds,
        period_start: generatedBulletins.period_start,
        period_end: generatedBulletins.period_end,
        company_id: selectedCompany.id
      }, {
        responseType: 'blob'
      });

      // Lire les headers pour vérifier si des bulletins ont été ignorés
      const bulletinsGenerated = parseInt(response.headers['x-bulletins-generated'] || employeeIds.length);
      const bulletinsSkipped = parseInt(response.headers['x-bulletins-skipped'] || 0);

      // Créer le blob PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const periodFormatted = new Date(generatedBulletins.period_start).toLocaleDateString('fr-FR', {month: '2-digit', year: 'numeric'}).replace('/', '');
      const filename = `bulletins_${selectedCompany.name.replace(/\s+/g, '_')}_${periodFormatted}_${bulletinsGenerated}_bulletins.pdf`;
      
      // Obtenir les capacités de téléchargement de l'appareil
      const capabilities = getDownloadCapabilities();
      
      if (capabilities.isMobile) {
        // Gestion spécifique mobile
        if (capabilities.isIOS) {
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
          if (capabilities.supportsDownload) {
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = filename;
            link.click();
            setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 100);
          } else {
            const newWindow = window.open(pdfUrl, '_blank');
            if (newWindow) {
              setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 5000);
              toast.success("PDF ouvert - Appuyez sur Partager puis 'Enregistrer dans Fichiers'");
            } else {
              downloadPDFWithLink(pdfBlob, filename);
            }
          }
        } else if (capabilities.isAndroid && capabilities.canShareFiles) {
          try {
            const file = new File([pdfBlob], filename, { type: 'application/pdf' });
            await navigator.share({
              title: 'Bulletins de paie',
              text: `${bulletinsGenerated} bulletins de paie`,
              files: [file]
            });
          } catch (shareError) {
            downloadPDFWithLink(pdfBlob, filename);
          }
        } else {
          downloadPDFWithLink(pdfBlob, filename);
        }
      } else {
        // Desktop: téléchargement classique
        downloadPDFWithLink(pdfBlob, filename);
      }

      // Afficher le message de succès avec avertissement si des bulletins ont été ignorés
      if (bulletinsSkipped > 0) {
        toast.warning(
          `${bulletinsGenerated} bulletin(s) téléchargé(s). ⚠️ ${bulletinsSkipped} employé(s) ignoré(s) (inactifs ou introuvables).`,
          { duration: 6000 }
        );
      } else {
        toast.success(`${bulletinsGenerated} bulletin(s) téléchargé(s) en un seul PDF`);
      }

    } catch (error) {
      console.error('Erreur téléchargement PDF en masse:', error);
      toast.error("Erreur lors du téléchargement des bulletins");
    } finally {
      setBulkPdfDownloading(false);
    }
  };

  // Fonction utilitaire pour téléchargement classique
  const downloadPDFWithLink = (pdfBlob, filename) => {
    try {
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      
      // Forcer l'attribut download pour tous les navigateurs
      link.setAttribute('download', filename);
      link.style.display = 'none';
      
      // Ajouter au DOM temporairement
      document.body.appendChild(link);
      
      // Déclencher le téléchargement avec timeout pour éviter les blocages
      setTimeout(() => {
        link.click();
        
        // Nettoyer après un court délai
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }, 50);
      
      toast.success("Bulletin téléchargé avec succès");
    } catch (error) {
      console.error('Erreur lors du téléchargement avec lien:', error);
      
      // Fallback : ouvrir le PDF dans un nouvel onglet
      try {
        const url = window.URL.createObjectURL(pdfBlob);
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
          toast.info("PDF ouvert dans un nouvel onglet - Clic droit > Enregistrer sous");
          setTimeout(() => window.URL.revokeObjectURL(url), 5000);
        } else {
          toast.error("Impossible de télécharger ou d'ouvrir le PDF");
        }
      } catch (fallbackError) {
        toast.error("Erreur lors du téléchargement");
      }
    }
  };

  // Fonction pour détecter les capacités de téléchargement
  const getDownloadCapabilities = () => {
    const userAgent = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const hasWebShare = navigator.share && navigator.canShare;
    const supportsDownload = 'download' in document.createElement('a');
    
    return {
      isIOS,
      isAndroid,
      isMobile,
      hasWebShare,
      supportsDownload,
      canShareFiles: hasWebShare && navigator.canShare({ files: [new File(['test'], 'test.txt')] })
    };
  };

  const handleDownloadPDFFromHistory = async (employeeId, periodStart, periodEnd, employeeName) => {
    try {
      const response = await axios.post(`${API}/generate-bulletin-pdf`, {
        employee_ids: [employeeId],
        period_start: periodStart,
        period_end: periodEnd,
        company_id: selectedCompany.id
      }, {
        responseType: 'blob'
      });

      // Créer le nom du fichier
      const filename = `bulletin_${employeeName.replace(/\s+/g, '_')}_${new Date(periodStart).toLocaleDateString('fr-FR', {month: '2-digit', year: 'numeric'}).replace('/', '')}.pdf`;
      
      // Créer le blob PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      
      // Obtenir les capacités de téléchargement de l'appareil
      const capabilities = getDownloadCapabilities();
      
      if (capabilities.isMobile) {
        // Gestion spécifique mobile
        if (capabilities.isIOS) {
          // iOS - Méthode spéciale pour iOS
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
          
          // Essayer d'abord le téléchargement direct
          if (capabilities.supportsDownload) {
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = filename;
            link.click();
            
            setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 100);
            toast.success("Téléchargement initié - Vérifiez votre dossier Téléchargements");
          } else {
            // Fallback : ouvrir dans Safari
            const newWindow = window.open(pdfUrl, '_blank');
            if (newWindow) {
              setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 5000);
              toast.success("PDF ouvert - Appuyez sur l'icône Partager puis 'Enregistrer dans Fichiers'");
            } else {
              downloadPDFWithLink(pdfBlob, filename);
            }
          }
        } else if (capabilities.isAndroid) {
          // Android - Utiliser Web Share API si disponible
          if (capabilities.canShareFiles) {
            try {
              const file = new File([pdfBlob], filename, { type: 'application/pdf' });
              await navigator.share({
                title: 'Bulletin de paie',
                text: `Bulletin de paie - ${employeeName}`,
                files: [file]
              });
              toast.success("Bulletin partagé avec succès");
            } catch (shareError) {
              if (shareError.name !== 'AbortError') {
                // Si le partage échoue, utiliser le téléchargement classique
                downloadPDFWithLink(pdfBlob, filename);
              }
            }
          } else {
            // Téléchargement classique pour Android sans Web Share
            downloadPDFWithLink(pdfBlob, filename);
          }
        } else {
          // Autres mobiles
          downloadPDFWithLink(pdfBlob, filename);
        }
      } else {
        // Desktop - Téléchargement classique optimisé
        downloadPDFWithLink(pdfBlob, filename);
      }

    } catch (error) {
      console.error('Erreur téléchargement PDF historique:', error);
      toast.error("Erreur lors du téléchargement");
    }
  };

  const handlePrintPDF = async (employeeId) => {
    if (!generatedBulletins) return;
    
    try {
      const response = await axios.post(`${API}/print-bulletin-pdf`, {
        employee_ids: [employeeId],
        period_start: generatedBulletins.period_start,
        period_end: generatedBulletins.period_end,
        company_id: selectedCompany.id
      }, {
        responseType: 'blob'
      });

      // Créer une URL pour le PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      
      // Ouvrir dans une nouvelle fenêtre pour impression
      const printWindow = window.open(pdfUrl, '_blank');
      
      // Attendre que le PDF se charge puis déclencher l'impression
      if (printWindow) {
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
          }, 500);
        };
        
        // Nettoyer l'URL après un délai
        setTimeout(() => {
          window.URL.revokeObjectURL(pdfUrl);
        }, 10000);
        
        toast.success("Aperçu d'impression ouvert");
      } else {
        // Si popup bloquée, créer un lien temporaire
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
        window.URL.revokeObjectURL(pdfUrl);
        toast.info("PDF ouvert dans un nouvel onglet - utilisez Ctrl+P pour imprimer");
      }

    } catch (error) {
      console.error('Erreur impression PDF:', error);
      toast.error("Erreur lors de l'ouverture pour impression");
    }
  };

  const handlePrintPDFFromHistory = async (employeeId, periodStart, periodEnd) => {
    try {
      const response = await axios.post(`${API}/print-bulletin-pdf`, {
        employee_ids: [employeeId],
        period_start: periodStart,
        period_end: periodEnd,
        company_id: selectedCompany.id
      }, {
        responseType: 'blob'
      });

      // Créer une URL pour le PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      
      // Ouvrir dans une nouvelle fenêtre pour impression
      const printWindow = window.open(pdfUrl, '_blank');
      
      // Attendre que le PDF se charge puis déclencher l'impression
      if (printWindow) {
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
          }, 500);
        };
        
        // Nettoyer l'URL après un délai
        setTimeout(() => {
          window.URL.revokeObjectURL(pdfUrl);
        }, 10000);
        
        toast.success("Aperçu d'impression ouvert");
      } else {
        // Si popup bloquée, créer un lien temporaire
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
        window.URL.revokeObjectURL(pdfUrl);
        toast.info("PDF ouvert dans un nouvel onglet - utilisez Ctrl+P pour imprimer");
      }

    } catch (error) {
      console.error('Erreur impression PDF historique:', error);
      toast.error("Erreur lors de l'ouverture pour impression");
    }
  };

  const handleSendEmailsBulk = async () => {
    if (!generatedBulletins) return;
    
    setEmailSending(true);
    try {
      const employeeIds = generatedBulletins.employees.map(emp => emp.id);
      const response = await axios.post(`${API}/send-bulletin-email`, {
        company_id: selectedCompany.id,
        employee_ids: employeeIds,
        period_start: generatedBulletins.period_start,
        period_end: generatedBulletins.period_end,
        subject: `Bulletin de paie - ${new Date(generatedBulletins.period_start).toLocaleDateString('fr-FR', {month: 'long', year: 'numeric'})}`,
        message: null // Utiliser le message par défaut
      });

      setEmailResults(response.data);
      toast.success(`${response.data.sent_count}/${response.data.total_count} bulletins envoyés sur votre email`);
    } catch (error) {
      console.error('Erreur envoi emails:', error);
      
      // Gestion des erreurs spécifiques
      if (error.response?.status === 400 && error.response?.data?.detail?.includes("Configuration SMTP invalide")) {
        toast.error("Configuration email non valide. Configurez les paramètres d'email dans Gérer > Paramètres système.");
      } else if (error.response?.status === 404 && error.response?.data?.detail?.includes("Configuration SMTP non trouvée")) {
        toast.error("Configuration email manquante. Configurez les paramètres d'email dans Gérer > Paramètres système.");
      } else if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Erreur lors de l'envoi des emails");
      }
    } finally {
      setEmailSending(false);
    }
  };

  const handleSendBulletinsEmail = async (employeeIds) => {
    if (!selectedCompany) {
      toast.error("Aucune entreprise sélectionnée");
      return;
    }

    setEmailSending(true);
    try {
      // Utiliser les données de l'historique ou les bulletins générés
      let periodStart, periodEnd;
      
      if (generatedBulletins) {
        periodStart = generatedBulletins.period_start;
        periodEnd = generatedBulletins.period_end;
      } else {
        // Utiliser le mois en cours par défaut
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() + 1;
        periodStart = `${year}-${month.toString().padStart(2, '0')}-01`;
        const lastDay = new Date(year, month, 0).getDate();
        periodEnd = `${year}-${month.toString().padStart(2, '0')}-${lastDay}`;
      }

      const response = await axios.post(`${API}/send-bulletin-email`, {
        company_id: selectedCompany.id,
        employee_ids: employeeIds,
        period_start: periodStart,
        period_end: periodEnd,
        subject: `Bulletin de paie - ${new Date(periodStart).toLocaleDateString('fr-FR', {month: 'long', year: 'numeric'})}`,
        message: null // Utiliser le message par défaut
      });

      setEmailResults(response.data);
      toast.success(`${response.data.sent_count}/${response.data.total_count} bulletins envoyés sur votre email`);
    } catch (error) {
      console.error('Erreur envoi emails:', error);
      
      // Gestion des erreurs spécifiques
      if (error.response?.status === 400 && error.response?.data?.detail?.includes("Configuration SMTP invalide")) {
        toast.error("Configuration email non valide. Configurez les paramètres d'email dans Gérer > Paramètres système.");
      } else if (error.response?.status === 404 && error.response?.data?.detail?.includes("Configuration SMTP non trouvée")) {
        toast.error("Configuration email manquante. Configurez les paramètres d'email dans Gérer > Paramètres système.");
      } else if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Erreur lors de l'envoi des emails");
      }
    } finally {
      setEmailSending(false);
    }
  };

  const fetchSmtpConfig = async () => {
    if (!selectedCompany) return;
    
    try {
      const response = await axios.get(`${API}/smtp-config/${selectedCompany.id}`);
      // Le backend peut retourner null si aucune config n'existe
      if (response.data) {
        setSmtpConfig(response.data);
        setSmtpForm({
          smtp_server: response.data.smtp_server || '',
          smtp_port: response.data.smtp_port || 587,
          sender_email: response.data.sender_email || '',
          sender_password: '', // Ne pas pré-remplir le mot de passe
          sender_name: response.data.sender_name || '',
          use_tls: response.data.use_tls !== undefined ? response.data.use_tls : true
        });
      } else {
        setSmtpConfig(null);
      }
    } catch (error) {
      // Ignorer les erreurs 404 silencieusement
      if (error.response?.status !== 404) {
        console.error('Erreur chargement config SMTP:', error);
      }
      setSmtpConfig(null);
    }
  };

  const handleCreateOrUpdateSmtpConfig = async (e) => {
    e.preventDefault();
    
    try {
      if (smtpConfig) {
        // Mise à jour
        const updateData = { ...smtpForm };
        if (!updateData.sender_password) {
          delete updateData.sender_password; // Ne pas envoyer si vide
        }
        
        await axios.put(`${API}/smtp-config/${selectedCompany.id}`, updateData);
        toast.success("Configuration SMTP mise à jour");
      } else {
        // Création
        await axios.post(`${API}/smtp-config`, {
          ...smtpForm,
          company_id: selectedCompany.id
        });
        toast.success("Configuration SMTP créée");
      }
      
      await fetchSmtpConfig();
      setIsSmtpConfigOpen(false);
    } catch (error) {
      console.error('Erreur config SMTP:', error);
      toast.error(error.response?.data?.detail || "Erreur lors de la configuration SMTP");
    }
  };

  // Fonction pour générer la déclaration ITS (rapports)
  const handleGenerateITSDeclaration = async () => {
    if (!selectedCompany) {
      toast.error("Aucune entreprise sélectionnée");
      return;
    }

    if (!token) {
      toast.error("Token d'authentification manquant");
      return;
    }

    try {
      const response = await axios.get(
        `${API}/companies/${selectedCompany.id}/declaration-its/${itsDeclarationForm.year}/${itsDeclarationForm.month}`,
        {
          responseType: 'blob',
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Declaration_ITS_${selectedCompany.name}_${itsDeclarationForm.year}_${itsDeclarationForm.month.toString().padStart(2, '0')}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Déclaration ITS générée avec succès");
      setIsITSDeclarationOpen(false);
    } catch (error) {
      console.error('Erreur lors de la génération de la déclaration ITS:', error);
      if (error.response) {
        toast.error(`Erreur génération déclaration: ${error.response.data?.detail || 'Erreur serveur'}`);
      } else {
        toast.error('Erreur de connexion lors de la génération');
      }
    }
  };

  // Fonctions de suppression des bulletins
  const handleDeleteBulletin = async (employeeId, periodStart, periodEnd, employeeName) => {
    if (!window.confirm(`Êtes-vous sûr de vouloir supprimer le bulletin de ${employeeName} pour la période du ${new Date(periodStart).toLocaleDateString('fr-FR')} au ${new Date(periodEnd).toLocaleDateString('fr-FR')} ?`)) {
      return;
    }

    try {
      await axios.delete(`${API}/bulletins/${employeeId}`, {
        params: {
          period_start: periodStart,
          period_end: periodEnd,
          company_id: selectedCompany.id
        }
      });
      
      toast.success(`Bulletin de ${employeeName} supprimé avec succès`);
      
      // Actualiser l'historique
      await fetchBulletinsHistory();
    } catch (error) {
      console.error('Erreur lors de la suppression du bulletin:', error);
      toast.error("Erreur lors de la suppression du bulletin");
    }
  };

  const handleDeletePeriod = async (periodStart, periodEnd, employeeCount) => {
    if (!window.confirm(`Êtes-vous sûr de vouloir supprimer TOUS les bulletins de la période du ${new Date(periodStart).toLocaleDateString('fr-FR')} au ${new Date(periodEnd).toLocaleDateString('fr-FR')} ?\n\nCela supprimera ${employeeCount} bulletin${employeeCount > 1 ? 's' : ''}. Cette action est irréversible.`)) {
      return;
    }

    try {
      await axios.delete(`${API}/bulletins/period`, {
        params: {
          period_start: periodStart,
          period_end: periodEnd,
          company_id: selectedCompany.id
        }
      });
      
      toast.success(`Tous les bulletins de la période ont été supprimés avec succès`);
      
      // Actualiser l'historique
      await fetchBulletinsHistory();
    } catch (error) {
      console.error('Erreur lors de la suppression de la période:', error);
      toast.error("Erreur lors de la suppression de la période");
    }
  };


  // Fonction pour uploader un fichier DFE d'une entreprise
  const uploadCompanyDFE = async (company, file) => {
    if (!company || !file) {
      toast.error("Entreprise ou fichier non sélectionné");
      return;
    }

    if (!token) {
      toast.error("Session expirée. Veuillez vous reconnecter.");
      return;
    }

    // Valider le type de fichier
    const allowedTypes = ["application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Format de fichier non supporté. Formats acceptés: PDF, Excel (.xlsx, .xls)");
      return;
    }

    // Valider la taille du fichier (10MB max)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.error("Fichier trop volumineux. Taille maximale: 10MB");
      return;
    }

    try {
      console.log('🔄 Début upload DFE:', {
        company: company.name,
        fileName: file.name,
        fileSize: file.size,
        tokenPresent: !!token
      });

      // Utiliser FormData pour l'upload
      const formData = new FormData();
      formData.append('dfe_file', file);

      const response = await fetch(
        `${API}/companies/${company.id}/upload-dfe`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
          body: formData
        }
      );

      console.log('📊 Réponse upload DFE:', {
        status: response.status,
        statusText: response.statusText,
        contentType: response.headers.get('content-type')
      });

      if (!response.ok) {
        if (response.status === 401) {
          toast.error("Session expirée. Veuillez vous reconnecter.");
          logout();
          return;
        } else if (response.status === 403) {
          toast.error("Accès refusé - Permissions insuffisantes");
          return;
        } else if (response.status === 404) {
          toast.error("Entreprise non trouvée");
          return;
        } else {
          const errorText = await response.text();
          console.error('Erreur serveur upload DFE:', errorText);
          toast.error(`Erreur serveur: ${response.status} - ${response.statusText}`);
          return;
        }
      }

      const result = await response.json();
      console.log('✅ Upload DFE réussi:', result);
      toast.success(`DFE de ${company.name} uploadée avec succès: ${result.filename}`);
      
    } catch (error) {
      console.error('Erreur lors de l\'upload de la DFE:', error);
      
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        toast.error("Erreur de connexion. Vérifiez votre connexion internet.");
      } else if (error.name === 'AbortError') {
        toast.error("L'upload a été interrompu.");
      } else {
        toast.error("Erreur lors de l'upload de la DFE");
      }
    }
  };

  const formatPeriod = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const options = { year: 'numeric', month: 'long' };
    
    if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return start.toLocaleDateString('fr-FR', options);
    } else {
      return `${start.toLocaleDateString('fr-FR', options)} - ${end.toLocaleDateString('fr-FR', options)}`;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-green-50">
      <Toaster position="top-right" />
      <HotToaster position="top-right" />
      
      {/* Header */}
      <header className="bg-white border-b border-orange-200 shadow-sm tablet-header">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="flex justify-between items-center h-12 tablet-landscape:h-14 lg:h-16">
            <div className="flex items-center space-x-2 tablet-landscape:space-x-3">
              <div className="w-8 h-8 tablet-landscape:w-9 tablet-landscape:h-9 lg:w-10 lg:h-10 bg-gradient-to-r from-orange-500 to-green-600 rounded-lg flex items-center justify-center">
                <Building2 className="w-4 h-4 tablet-landscape:w-5 tablet-landscape:h-5 lg:w-6 lg:h-6 text-white" />
              </div>
              <h1 className="text-base tablet-landscape:text-lg lg:text-2xl font-bold text-gray-900">SIRH-CI/PAIE</h1>
              <Badge variant="secondary" className="text-xs hidden tablet:inline-flex">v2.0 - Avancé</Badge>
            </div>
            
            <div className="flex items-center space-x-1 tablet-landscape:space-x-2 lg:space-x-4">
              {/* User info */}
              <div className="flex items-center space-x-1 tablet-landscape:space-x-2">
                <div className="w-6 h-6 tablet-landscape:w-7 tablet-landscape:h-7 lg:w-8 lg:h-8 bg-purple-100 rounded-full flex items-center justify-center">
                  <Users className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 text-purple-600" />
                </div>
                <div className="hidden tablet:block">
                  <p className="text-xs tablet-landscape:text-sm font-medium text-gray-900">{user?.full_name}</p>
                  <p className="text-xs text-gray-500">@{user?.username}</p>
                </div>
              </div>
            
            {companies.length > 0 && (
              <div className="flex items-center space-x-1 tablet:space-x-2 lg:space-x-3 company-selector company-selector-container">
                <SimpleNativeSelect
                  value={selectedCompany?.id}
                  onValueChange={handleCompanySelection}
                  placeholder="Sélectionner une entreprise"
                  className="w-40 tablet:w-48 tablet-landscape:w-56 lg:w-80 text-xs tablet:text-sm cursor-pointer"
                  options={companies.filter(c => c.is_active).map((company) => ({
                    value: company.id,
                    label: `${company.name} - ${company.ville === 'abidjan' ? 'Abidjan' : company.ville === 'bouake' ? 'Bouaké' : 'Autres villes'} (${companyStats[company.id]?.employees_count || 0} employés)`
                  }))}
                />
                
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    // Aller à l'onglet Entreprises
                    const companiesTab = document.querySelector('[value="companies"]');
                    if (companiesTab) companiesTab.click();
                  }}
                  className="flex items-center space-x-1 p-1 tablet:p-2 text-xs tablet:text-sm"
                >
                  <Settings className="w-3 h-3 tablet:w-4 tablet:h-4" />
                  <span className="hidden tablet:inline">Gérer</span>
                </Button>
              </div>
            )}
            
            {/* Search button */}
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsSearchOpen(true)}
              className="flex items-center justify-center space-x-1 border-purple-200 text-purple-600 hover:bg-purple-50 transition-all duration-200 p-1 tablet:p-2 text-xs tablet:text-sm min-w-[2.5rem] tablet:min-w-[7rem]"
              title="Rechercher (Ctrl+K)"
            >
              <Search className="w-3 h-3 tablet:w-4 tablet:h-4 flex-shrink-0" />
              <span className="hidden tablet:inline whitespace-nowrap">Rechercher</span>
              <kbd className="hidden lg:inline-flex ml-1 px-1.5 py-0.5 text-xs font-semibold text-gray-500 bg-gray-100 rounded">⌘K</kbd>
            </Button>
              
            {/* Refresh button */}
            <Button
              variant="outline"
              size="sm"
              onClick={handleRefresh}
              className="flex items-center justify-center space-x-1 border-blue-200 text-blue-600 hover:bg-blue-50 transition-all duration-200 p-1 tablet:p-2 text-xs tablet:text-sm min-w-[2.5rem] tablet:min-w-[6rem]"
              title="Actualiser l'application"
              disabled={false}
            >
              <RefreshCw className="w-3 h-3 tablet:w-4 tablet:h-4 flex-shrink-0" />
              <span className="hidden tablet:inline whitespace-nowrap">Actualiser</span>
            </Button>
            
            {/* Bouton de notification des contrats expirants */}
            {expiringContracts.length > 0 && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShowContractAlert(true)}
                className="relative flex items-center justify-center space-x-1 border-red-200 text-red-600 hover:bg-red-50 transition-all duration-200 p-1 tablet:p-2 text-xs tablet:text-sm min-w-[2.5rem] tablet:min-w-[7rem]"
                title={`${expiringContracts.length} contrat(s) expirant(s)`}
              >
                <Bell className="w-3 h-3 tablet:w-4 tablet:h-4 flex-shrink-0 animate-pulse" />
                <span className="hidden tablet:inline whitespace-nowrap">Alertes ({expiringContracts.length})</span>
                {/* Badge rouge */}
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-600 text-white text-xs font-bold rounded-full flex items-center justify-center">
                  {expiringContracts.length}
                </span>
              </Button>
            )}
              
            {/* Logout button */}
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="flex items-center justify-center space-x-1 border-red-200 text-red-600 hover:bg-red-50 transition-all duration-200 p-1 tablet:p-2 text-xs tablet:text-sm min-w-[2.5rem] tablet:min-w-[7rem]"
              title="Se déconnecter"
              disabled={false}
            >
              <LogOut className="w-3 h-3 tablet:w-4 tablet:h-4 flex-shrink-0" />
              <span className="hidden tablet:inline whitespace-nowrap">Déconnexion</span>
            </Button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {companies.length === 0 ? (
          <div className="text-center py-12">
            <Building2 className="w-16 h-16 text-orange-400 mx-auto mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Bienvenue dans SIRH-CI/PAIE</h2>
            <p className="text-gray-600 mb-8">Système avancé de gestion de paie pour la Côte d'Ivoire</p>
            <Dialog open={isCreateCompanyOpen} onOpenChange={setIsCreateCompanyOpen}>
              <DialogTrigger asChild>
                <Button className="bg-orange-600 hover:bg-orange-700">
                  <Plus className="w-4 h-4 mr-2" />
                  Créer une entreprise
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>Nouvelle entreprise</DialogTitle>
                  <DialogDescription>Créez une nouvelle entreprise dans le système</DialogDescription>
                </DialogHeader>
                <form onSubmit={handleCreateCompany} className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="name">Nom de l'entreprise</Label>
                      <Input required value={companyForm.name} onChange={(e) => setCompanyForm({...companyForm, name: e.target.value})} />
                    </div>
                    <div>
                      <Label htmlFor="email">Email</Label>
                      <Input type="email" required value={companyForm.email} onChange={(e) => setCompanyForm({...companyForm, email: e.target.value})} />
                    </div>
                  </div>
                  <div>
                    <Label htmlFor="address">Adresse</Label>
                    <Input required value={companyForm.address} onChange={(e) => setCompanyForm({...companyForm, address: e.target.value})} />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="phone">Téléphone</Label>
                      <Input required value={companyForm.phone} onChange={(e) => setCompanyForm({...companyForm, phone: e.target.value})} />
                    </div>
                    <div>
                      <Label htmlFor="registration_number">N° Registre de commerce (RCCM)</Label>
                      <Input required value={companyForm.registration_number} onChange={(e) => setCompanyForm({...companyForm, registration_number: e.target.value})} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="cnps_number">N° CNPS</Label>
                      <Input required value={companyForm.cnps_number} onChange={(e) => setCompanyForm({...companyForm, cnps_number: e.target.value})} />
                    </div>
                    <div>
                      <Label htmlFor="ncc_number">N°CC (Numéro de compte contribuable)</Label>
                      <Input value={companyForm.ncc_number} onChange={(e) => setCompanyForm({...companyForm, ncc_number: e.target.value})} placeholder="Optionnel" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="ville">Ville (pour calcul prime transport)</Label>
                      <SimpleNativeSelect
                                  value={companyForm.ville}
                                  onValueChange={handleCompanyVilleChange}
                                  placeholder="Sélectionner une ville"
                                  options={[
                                    {value: 'abidjan', label: 'Abidjan (30,000 FCFA non imposable)'},
                                    {value: 'bouake', label: 'Bouaké (24,000 FCFA non imposable)'},
                                    {value: 'autres', label: 'Autres villes (21,000 FCFA non imposable)'}
                                  ]}
                                />
                    </div>
                  </div>
                  <div>
                    <Label htmlFor="secteur_activite">Secteur d'activité (pour taux accidents travail)</Label>
                    <SimpleNativeSelect
                                  value={companyForm.secteur_activite}
                                  onValueChange={handleSecteurActiviteChange}
                                  placeholder="Sélectionner un secteur"
                                  options={[
                                    {value: 'bureau', label: 'Bureau/Services (2.0%)'},
                                    {value: 'commerce', label: 'Commerce/Distribution (2.5%)'},
                                    {value: 'industrie_legere', label: 'Industrie légère (3.0%)'},
                                    {value: 'industrie_lourde', label: 'Industrie lourde (4.0%)'},
                                    {value: 'btp', label: 'BTP/Construction (5.0%)'}
                                  ]}
                                />
                  </div>
                  <Button type="submit" className="w-full bg-orange-600 hover:bg-orange-700">Créer l'entreprise</Button>
                </form>
              </DialogContent>
            </Dialog>
          </div>
        ) : (
          <div className="space-y-8">
            {/* Stats Dashboard */}
            {stats && (
              <div className="stats-cards grid grid-cols-1 md:grid-cols-5 gap-4 tablet-landscape:gap-3">
                <Card className="bg-white border-orange-200">
                  <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-xs tablet-landscape:text-sm font-medium text-gray-600">Employés actifs</CardTitle>
                    <Users className="h-3 w-3 tablet-landscape:h-4 tablet-landscape:w-4 text-orange-600" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-xl tablet-landscape:text-2xl font-bold text-gray-900">{stats.employees_count || 0}</div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white border-green-200">
                  <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-xs tablet-landscape:text-sm font-medium text-gray-600">
                      {stats.payrolls_count > 0 ? 'Masse salariale brute' : 'Masse salariale (estimée)'}
                    </CardTitle>
                    <TrendingUp className="h-3 w-3 tablet-landscape:h-4 tablet-landscape:w-4 text-green-600" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-lg tablet-landscape:text-xl font-bold text-gray-900">
                      {formatCurrency(stats.total_salary_brut > 0 ? stats.total_salary_brut : (stats.total_theoretical_brut || 0))}
                    </div>
                    {stats.payrolls_count === 0 && stats.total_theoretical_brut > 0 && (
                      <p className="text-xs text-gray-500 mt-1">Basée sur {stats.employees_without_payroll || 0} employé(s)</p>
                    )}
                  </CardContent>
                </Card>
                
                <Card className="bg-white border-blue-200">
                  <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-xs tablet-landscape:text-sm font-medium text-gray-600">Total Net à Payer</CardTitle>
                    <Banknote className="h-3 w-3 tablet-landscape:h-4 tablet-landscape:w-4 text-blue-600" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-lg tablet-landscape:text-xl font-bold text-blue-700">
                      {formatCurrency(stats.total_salary_net || 0)}
                    </div>
                    {stats.payrolls_count > 0 && (
                      <p className="text-xs text-gray-500 mt-1">{stats.payrolls_count} bulletin(s)</p>
                    )}
                    {stats.payrolls_count === 0 && (
                      <p className="text-xs text-gray-500 mt-1">Aucun bulletin</p>
                    )}
                  </CardContent>
                </Card>
                
                <Card className="bg-white border-orange-200">
                  <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-xs tablet-landscape:text-sm font-medium text-gray-600">Total CNPS</CardTitle>
                    <Calculator className="h-3 w-3 tablet-landscape:h-4 tablet-landscape:w-4 text-orange-600" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-lg tablet-landscape:text-xl font-bold text-gray-900">
                      {formatCurrency(stats.total_cnps > 0 ? stats.total_cnps : (stats.total_theoretical_brut ? Math.round(stats.total_theoretical_brut * 0.224) : 0))}
                    </div>
                    {stats.payrolls_count === 0 && stats.total_theoretical_brut > 0 && (
                      <p className="text-xs text-gray-500 mt-1">Estimation (~22.4%)</p>
                    )}
                  </CardContent>
                </Card>
                
                <Card className="bg-white border-green-200">
                  <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-xs tablet-landscape:text-sm font-medium text-gray-600">Bulletins générés</CardTitle>
                    <FileText className="h-3 w-3 tablet-landscape:h-4 tablet-landscape:w-4 text-green-600" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-xl tablet-landscape:text-2xl font-bold text-gray-900">{stats.payrolls_count || 0}</div>
                    {stats.employees_count > 0 && (
                      <p className="text-xs text-gray-500 mt-1">
                        {stats.payrolls_count > 0 
                          ? `${Math.round((stats.payrolls_count / stats.employees_count) * 100)}% complété`
                          : 'Aucun bulletin ce mois'
                        }
                      </p>
                    )}
                  </CardContent>
                </Card>
              </div>
            )}

            {/* Main Tabs */}
            <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
              <TabsList className={`grid w-full ${user && user.role === 'super_admin' ? 'grid-cols-8' : 'grid-cols-7'} tablet-landscape:gap-1 no-delay`}>
                <TabsTrigger value="employees" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <Users className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Employés</span>
                  <span className="tablet:hidden">Emp.</span>
                </TabsTrigger>
                <TabsTrigger value="overtime" data-testid="overtime-tab-trigger" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <Clock className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Heures sup.</span>
                  <span className="tablet:hidden">H.S.</span>
                </TabsTrigger>
                <TabsTrigger value="payroll" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <Calculator className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Paie</span>
                  <span className="tablet:hidden">Paie</span>
                </TabsTrigger>
                <TabsTrigger value="companies" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <Building2 className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Entreprises</span>
                  <span className="tablet:hidden">Entr.</span>
                </TabsTrigger>
                <TabsTrigger value="declarations" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <FileText className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Déclarations</span>
                  <span className="tablet:hidden">Décl.</span>
                </TabsTrigger>
                <TabsTrigger value="documents" data-testid="documents-tab-trigger" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <Book className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Documents</span>
                  <span className="tablet:hidden">Docs</span>
                </TabsTrigger>
                {user && user.role === 'super_admin' && (
                  <TabsTrigger value="manage" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                    <Settings className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                    <span className="hidden tablet:inline">Gérer</span>
                    <span className="tablet:hidden">Gér.</span>
                  </TabsTrigger>
                )}
                <TabsTrigger value="reports" className="text-xs tablet-landscape:text-sm py-1 tablet-landscape:py-2 no-delay">
                  <BarChart3 className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                  <span className="hidden tablet:inline">Rapports</span>
                  <span className="tablet:hidden">Rap.</span>
                </TabsTrigger>
              </TabsList>

              {/* Employees Tab */}
              <TabsContent value="employees" className="space-y-3 tablet-landscape:space-y-4">
                <div className="flex flex-col tablet-landscape:flex-row justify-between items-start tablet-landscape:items-center space-y-2 tablet-landscape:space-y-0">
                  <h2 className="text-lg tablet-landscape:text-xl font-semibold text-gray-900">Gestion des employés</h2>
                  <div className="flex flex-wrap space-x-2 tablet-landscape:space-x-3">
                    <Button 
                      variant="outline" 
                      size="sm"
                      className="border-blue-300 text-blue-700 hover:bg-blue-50 text-xs tablet-landscape:text-sm"
                      onClick={handleGenerateMatricules}
                    >
                      <RefreshCw className="w-3 h-3 tablet-landscape:w-4 tablet-landscape:h-4 mr-1 tablet-landscape:mr-2" />
                      <span className="hidden tablet-landscape:inline">Générer matricules</span>
                      <span className="tablet-landscape:hidden">Matricules</span>
                    </Button>
                    <Button 
                      variant="outline" 
                      className="border-orange-300"
                      onClick={() => setIsManageSalaryComponentsOpen(true)}
                      style={{
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        position: 'relative',
                        zIndex: 10,
                        touchAction: 'manipulation',
                        userSelect: 'none'
                      }}
                    >
                      <Settings className="w-4 h-4 mr-2" style={{ pointerEvents: 'none' }} />
                      Éléments de salaire
                    </Button>
                  </div>
                </div>
                    
                <Button 
                  className="bg-green-600 hover:bg-green-700 no-delay"
                  onClick={() => setIsCreateEmployeeOpen(true)}
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Nouvel employé
                </Button>

                {/* Vue plein écran - Nouvel employé */}
                {isCreateEmployeeOpen && (
                      <div style={{
                        backgroundColor: '#f0fdfa',
                        minHeight: '100vh',
                        width: '100%'
                      }}>
                          {/* Header avec gradient teal */}
                          <div style={{ 
                            padding: '24px 32px',
                            background: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
                            color: 'white',
                            position: 'relative',
                            flexShrink: 0
                          }}>
                            <div style={{ 
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              width: '300px',
                              height: '100%',
                              background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                              pointerEvents: 'none'
                            }} />
                            
                            <Button
                              onClick={() => setIsCreateEmployeeOpen(false)}
                              variant="outline"
                              style={{ 
                                marginBottom: '16px',
                                backgroundColor: 'rgba(255,255,255,0.2)',
                                borderColor: 'rgba(255,255,255,0.3)',
                                color: 'white',
                                backdropFilter: 'blur(10px)'
                              }}
                            >
                              <ArrowLeft className="w-4 h-4 mr-2" />
                              Retour
                            </Button>
                            
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <div style={{ 
                                backgroundColor: 'rgba(255,255,255,0.2)',
                                borderRadius: '12px',
                                padding: '12px',
                                backdropFilter: 'blur(10px)'
                              }}>
                                <UserPlus style={{ width: '32px', height: '32px' }} />
                              </div>
                              <div>
                                <h1 style={{ 
                                  fontSize: '28px', 
                                  fontWeight: 700,
                                  marginBottom: '4px',
                                  textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                  Nouvel employé
                                </h1>
                                <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                  Ajouter un nouvel employé à l'entreprise
                                </p>
                              </div>
                            </div>
                          </div>

                          <form onSubmit={handleCreateEmployee} style={{ 
                            flex: 1, 
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden'
                          }}>
                            <div style={{ 
                              flex: 1, 
                              overflowY: 'auto', 
                              padding: '32px',
                              backgroundColor: '#f0fdfa'
                            }}>
                              {/* Formulaire */}
                              <div style={{
                                backgroundColor: 'white',
                                borderRadius: '16px',
                                padding: '32px',
                                maxWidth: '1400px',
                                margin: '0 auto',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                border: '1px solid #e5e7eb'
                              }}>
                                {/* En-tête du formulaire */}
                                <div style={{ 
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '12px',
                                  marginBottom: '24px',
                                  paddingBottom: '16px',
                                  borderBottom: '2px solid #14b8a6'
                                }}>
                                  <div style={{
                                    backgroundColor: '#ccfbf1',
                                    borderRadius: '10px',
                                    padding: '10px',
                                    color: '#0d9488'
                                  }}>
                                    <User style={{ width: '24px', height: '24px' }} />
                                  </div>
                                  <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#111827' }}>
                                    Informations de l'employé
                                  </h2>
                                </div>

                              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                    {/* Nom et prénom - Carte */}
                                    <div 
                                      style={{
                                        backgroundColor: '#fdf4ff',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        border: '2px solid #f3e8ff'
                                      }}
                                    >
                                      <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#6b21a8', marginBottom: '16px' }}>
                                        👤 Identité
                                      </h3>
                                      <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label style={{ fontWeight: 500, color: '#374151', marginBottom: '6px', display: 'block' }}>Prénom *</Label>
                              <Input 
                                required 
                                value={employeeForm.first_name} 
                                onChange={handleFirstNameChange}
                              />
                            </div>
                            <div>
                              <Label style={{ fontWeight: 500, color: '#374151', marginBottom: '6px', display: 'block' }}>Nom *</Label>
                              <Input 
                                required 
                                value={employeeForm.last_name} 
                                onChange={handleLastNameChange}
                              />
                            </div>
                            <div>
                              <Label style={{ fontWeight: 500, color: '#374151', marginBottom: '6px', display: 'block' }}>Sexe *</Label>
                              <select
                                value={employeeForm.sexe || "M"}
                                onChange={(e) => setEmployeeForm({...employeeForm, sexe: e.target.value})}
                                className="w-full p-2 border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-green-500 focus:border-green-500"
                                required
                              >
                                <option value="M">Masculin (M)</option>
                                <option value="F">Féminin (F)</option>
                              </select>
                            </div>
                          </div>
                                    </div>

                          {/* Coordonnées - Carte bleue */}
                          <div 
                            style={{
                              backgroundColor: '#eff6ff',
                              borderRadius: '12px',
                              padding: '20px',
                              border: '2px solid #bfdbfe'
                            }}
                          >
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#1e40af', marginBottom: '16px' }}>
                              📧 Coordonnées
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label style={{ fontWeight: 500, color: '#374151', marginBottom: '6px', display: 'block' }}>Email *</Label>
                                <Input 
                                  type="email" 
                                  required 
                                  value={employeeForm.email} 
                                  onChange={handleEmailChange}
                                />
                              </div>
                              <div>
                                <Label style={{ fontWeight: 500, color: '#374151', marginBottom: '6px', display: 'block' }}>Téléphone</Label>
                                <Input 
                                  value={employeeForm.phone} 
                                  onChange={handlePhoneChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Informations professionnelles - Carte orange */}
                          <div 
                            style={{
                              backgroundColor: '#fff7ed',
                              borderRadius: '12px',
                              padding: '20px',
                              border: '2px solid #fed7aa'
                            }}
                          >
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#9a3412', marginBottom: '16px' }}>
                              💼 Informations professionnelles
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Poste *</Label>
                                <Input required value={employeeForm.position} onChange={(e) => setEmployeeForm({...employeeForm, position: e.target.value})} />
                              </div>
                              <div>
                                <Label>N° CNPS</Label>
                                <Input 
                                  placeholder="Ex: 00123456789"
                                  value={employeeForm.numero_cnps} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, numero_cnps: e.target.value})} 
                                />
                              </div>
                            </div>
                            
                            {/* Classification professionnelle - Basé sur la grille salariale */}
                            <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                              <h4 className="text-sm font-semibold text-blue-800 mb-3">📋 Classification professionnelle (Grille salariale 2023)</h4>
                              
                              {/* Première ligne : Secteur précis d'activité */}
                              <div className="mb-4">
                                <Label className="text-blue-700 font-medium">🏭 Secteur précis d'activité</Label>
                                <select
                                  value={employeeForm.secteur_activite_precis || ''}
                                  onChange={(e) => {
                                    const newSecteur = e.target.value;
                                    setEmployeeForm({
                                      ...employeeForm, 
                                      secteur_activite_precis: newSecteur,
                                      categorie_professionnelle: '',
                                      grade: '',
                                      salary_categoriel: ''
                                    });
                                  }}
                                  style={{
                                    width: '100%',
                                    padding: '10px 12px',
                                    border: '2px solid #3b82f6',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    marginTop: '6px'
                                  }}
                                >
                                  <option value="">-- Sélectionner le secteur d'activité --</option>
                                  {Object.keys(GRILLE_SALAIRES_CATEGORIELS).map(secteur => (
                                    <option key={secteur} value={secteur}>{secteur}</option>
                                  ))}
                                </select>
                              </div>
                              
                              {/* Deuxième ligne : Catégorie et Grade */}
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label className="text-blue-700">Titre</Label>
                                  <select
                                    value={employeeForm.categorie_professionnelle || ''}
                                    onChange={(e) => {
                                      const newCategorie = e.target.value;
                                      setEmployeeForm({
                                        ...employeeForm, 
                                        categorie_professionnelle: newCategorie,
                                        grade: '',
                                        salary_categoriel: ''
                                      });
                                    }}
                                    disabled={!employeeForm.secteur_activite_precis}
                                    style={{
                                      width: '100%',
                                      padding: '8px 12px',
                                      border: '1px solid #93c5fd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      backgroundColor: employeeForm.secteur_activite_precis ? 'white' : '#f3f4f6',
                                      cursor: employeeForm.secteur_activite_precis ? 'pointer' : 'not-allowed',
                                      marginTop: '6px'
                                    }}
                                  >
                                    <option value="">
                                      {employeeForm.secteur_activite_precis 
                                        ? 'Sélectionner un titre' 
                                        : 'Sélectionnez d\'abord un secteur'}
                                    </option>
                                    {employeeForm.secteur_activite_precis && (() => {
                                      const secteurData = GRILLE_SALAIRES_CATEGORIELS[employeeForm.secteur_activite_precis];
                                      return secteurData ? Object.keys(secteurData).map(cat => (
                                        <option key={cat} value={cat}>{cat}</option>
                                      )) : null;
                                    })()}
                                  </select>
                                </div>
                                
                                <div>
                                  <Label className="text-blue-700">Catégorie professionnelle</Label>
                                  <select
                                    value={employeeForm.grade || ''}
                                    onChange={(e) => {
                                      const newGrade = e.target.value;
                                      // Calculer automatiquement le salaire catégoriel
                                      const salaire = getSalaireCategoriel(
                                        employeeForm.secteur_activite_precis, 
                                        employeeForm.categorie_professionnelle, 
                                        newGrade
                                      );
                                      setEmployeeForm({
                                        ...employeeForm, 
                                        grade: newGrade,
                                        salary_categoriel: salaire || employeeForm.salary_categoriel
                                      });
                                    }}
                                    disabled={!employeeForm.categorie_professionnelle}
                                    style={{
                                      width: '100%',
                                      padding: '8px 12px',
                                      border: '1px solid #93c5fd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      backgroundColor: employeeForm.categorie_professionnelle ? 'white' : '#f3f4f6',
                                      cursor: employeeForm.categorie_professionnelle ? 'pointer' : 'not-allowed',
                                      marginTop: '6px'
                                    }}
                                  >
                                    <option value="">
                                      {employeeForm.categorie_professionnelle 
                                        ? 'Sélectionner une catégorie' 
                                        : 'Sélectionnez d\'abord un titre'}
                                    </option>
                                    {employeeForm.categorie_professionnelle && employeeForm.secteur_activite_precis && (() => {
                                      const secteurData = GRILLE_SALAIRES_CATEGORIELS[employeeForm.secteur_activite_precis];
                                      const categorieData = secteurData?.[employeeForm.categorie_professionnelle];
                                      return categorieData?.grades?.map(grade => (
                                        <option key={grade} value={grade}>
                                          {grade} - {categorieData.salaires[grade]?.toLocaleString('fr-FR')} FCFA
                                        </option>
                                      ));
                                    })()}
                                  </select>
                                </div>
                              </div>
                              
                              {/* Indicateur de sélection */}
                              {employeeForm.secteur_activite_precis && (
                                <p className="text-xs text-blue-600 mt-3 flex items-center gap-1">
                                  <span>✓</span> Grille appliquée : <strong>{employeeForm.secteur_activite_precis}</strong>
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Salaire de base - Carte verte */}
                          <div style={{
                            backgroundColor: '#f0fdf4',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #bbf7d0'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#166534', marginBottom: '16px' }}>
                              💰 Salaire de base
                            </h3>
                            <div>
                              <Label>Salaire catégoriel (FCFA) * {employeeForm.grade && <span className="text-green-600 text-xs ml-2">✓ Calculé automatiquement</span>}</Label>
                              <Input 
                                type="number" 
                                required 
                                value={employeeForm.salary_categoriel} 
                                onChange={(e) => setEmployeeForm({...employeeForm, salary_categoriel: e.target.value})}
                                className={employeeForm.grade ? "border-green-300 bg-green-50" : ""}
                              />
                            </div>
                          </div>

                          {/* Éléments de salaire - Carte jaune */}
                          <div style={{
                            backgroundColor: '#fefce8',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fef08a'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#854d0e', marginBottom: '16px' }}>
                              📊 Éléments de salaire
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Sursalaire (FCFA)</Label>
                                <Input type="number" value={employeeForm.sursalaire} onChange={(e) => setEmployeeForm({...employeeForm, sursalaire: e.target.value})} />
                              </div>
                              <div>
                                <Label>Prime de transport (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_transport} onChange={(e) => setEmployeeForm({...employeeForm, prime_transport: e.target.value})} />
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Prime d'ancienneté (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_anciennete} onChange={(e) => setEmployeeForm({...employeeForm, prime_anciennete: e.target.value})} />
                              </div>
                              <div>
                                <Label>Allocations familiales imposables (FCFA)</Label>
                                <Input type="number" value={employeeForm.allocations_familiales_imposables} onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_imposables: e.target.value})} />
                              </div>
                            </div>
                            <FraisSelector salaryComponents={salaryComponents} employeeForm={employeeForm} setEmployeeForm={setEmployeeForm} />
                          </div>

                          {/* Avantages - Carte rose */}
                          <div style={{
                            backgroundColor: '#fdf2f8',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fbcfe8'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#831843', marginBottom: '16px' }}>
                              🎁 Avantages
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Avantages en nature (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_nature} onChange={(e) => setEmployeeForm({...employeeForm, avantages_nature: e.target.value})} />
                              </div>
                              <div>
                                <Label>Avantages en argent (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_argent} onChange={(e) => setEmployeeForm({...employeeForm, avantages_argent: e.target.value})} />
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Remboursement de frais (FCFA)</Label>
                                <Input type="number" value={employeeForm.remboursement_frais} onChange={(e) => setEmployeeForm({...employeeForm, remboursement_frais: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">💰 Totalement exonéré (non imposable)</p>
                              </div>
                            </div>
                          </div>

                          {/* CMU - Carte indigo */}
                          <div style={{
                            backgroundColor: '#eef2ff',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #c7d2fe'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#3730a3', marginBottom: '16px' }}>
                              🏥 CMU (Couverture Maladie Universelle)
                            </h3>
                            <div className="grid grid-cols-3 gap-4">
                              <div>
                                <Label>CMU Employeur (FCFA)</Label>
                                <Input type="number" value={employeeForm.cmu_employeur} onChange={(e) => setEmployeeForm({...employeeForm, cmu_employeur: e.target.value})} />
                              </div>
                              <div>
                                <Label>CMU Salarié (FCFA)</Label>
                                <Input type="number" value={employeeForm.cmu_salarie} onChange={(e) => setEmployeeForm({...employeeForm, cmu_salarie: e.target.value})} />
                              </div>
                              <div className="flex items-center space-x-2 pt-6">
                                <input 
                                  type="checkbox" 
                                  id="cmu_active" 
                                  checked={employeeForm.cmu_active} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, cmu_active: e.target.checked})} 
                                />
                                <Label htmlFor="cmu_active">CMU Active</Label>
                              </div>
                            </div>
                          </div>

                          {/* Taxes et contributions - Carte rouge clair */}
                          <div style={{
                            backgroundColor: '#fef2f2',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fecaca'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#991b1b', marginBottom: '16px' }}>
                              📋 Taxes et contributions
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Formation continue (FCFA)</Label>
                                <Input type="number" value={employeeForm.formation_continue} onChange={(e) => setEmployeeForm({...employeeForm, formation_continue: e.target.value})} />
                              </div>
                              <div>
                                <Label>Taxe d'apprentissage (FCFA)</Label>
                                <Input type="number" value={employeeForm.taxe_apprentissage} onChange={(e) => setEmployeeForm({...employeeForm, taxe_apprentissage: e.target.value})} />
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>IS Patronal (FCFA)</Label>
                                <Input type="number" value={employeeForm.is_patronal} onChange={(e) => setEmployeeForm({...employeeForm, is_patronal: e.target.value})} />
                              </div>
                              <div>
                                <Label>IS Salarié (FCFA)</Label>
                                <Input type="number" value={employeeForm.is_salarie} onChange={(e) => setEmployeeForm({...employeeForm, is_salarie: e.target.value})} />
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium mb-3">RICF (Réduction d'impôt pour charges de famille)</h4>
                            <div className="grid grid-cols-3 gap-4">
                              <div>
                                <Label>Statut matrimonial</Label>
                                <SimpleNativeSelect
                                  value={employeeForm.statut_matrimonial}
                                  onValueChange={handleStatutMatrimonialChange}
                                  placeholder="Statut matrimonial"
                                  options={[
                                    {value: 'celibataire', label: 'Célibataire'},
                                    {value: 'marie', label: 'Marié(e)'},
                                    {value: 'divorce', label: 'Divorcé(e)'},
                                    {value: 'veuf', label: 'Veuf/Veuve'}
                                  ]}
                                />
                              </div>
                              <div>
                                <Label>Nombre d'enfants</Label>
                                <Input type="number" min="0" value={employeeForm.nombre_enfants} onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants: e.target.value})} />
                              </div>
                              <div>
                                <Label>Enfants infirmes</Label>
                                <Input type="number" min="0" value={employeeForm.nombre_enfants_infirmes} onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants_infirmes: e.target.value})} />
                              </div>
                            </div>
                          </div>

                          {/* Consentements et autorisations - Carte vert clair */}
                          <div style={{
                            backgroundColor: '#f0fdf4',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #bbf7d0'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#15803d', marginBottom: '16px' }}>
                              ✅ Consentements et autorisations
                            </h3>
                            <div className="space-y-3">
                              <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-green-200">
                                <input
                                  type="checkbox"
                                  id="gratification_consent"
                                  checked={employeeForm.gratification_display_consent}
                                  onChange={(e) => setEmployeeForm({...employeeForm, gratification_display_consent: e.target.checked})}
                                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                                />
                                <label htmlFor="gratification_consent" className="text-sm text-gray-900">
                                  <span className="font-medium">Autoriser l'affichage des gratifications sur les bulletins de paie</span>
                                  <p className="text-xs text-gray-600 mt-1">
                                    Si cette option est décochée, les gratifications n'apparaîtront pas sur les bulletins de paie générés.
                                  </p>
                                </label>
                              </div>

                              {/* Autorisation allocations familiales */}
                              <div className="flex items-start space-x-3 p-3 bg-white rounded-lg border border-green-200">
                                <input
                                  id="allocations_familiales_consent"
                                  type="checkbox"
                                  checked={employeeForm.allocations_familiales_consent}
                                  onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_consent: e.target.checked})}
                                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                                />
                                <label htmlFor="allocations_familiales_consent" className="text-sm text-gray-900">
                                  <span className="font-medium">Autoriser les allocations familiales dans les calculs de paie</span>
                                  <p className="text-xs text-gray-600 mt-1">
                                    Si cette option est décochée, les allocations familiales (7,500 FCFA par enfant) ne seront pas incluses dans le calcul du salaire net.
                                  </p>
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Éléments configurables - Carte ambre */}
                          <div style={{
                            backgroundColor: '#fffbeb',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fde68a'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#78350f', marginBottom: '16px' }}>
                              ⚙️ Éléments configurables
                            </h3>
                            <div className="space-y-3">
                              <div>
                                <Label>Indemnités</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handleIndemniteChange}
                                  placeholder="Ajouter une indemnité"
                                  options={salaryComponents.filter(c => c.type === 'indemnite').map((comp) => ({
                                    value: comp.id,
                                    label: `${comp.name} - ${formatCurrency(comp.amount)} ${comp.is_taxable ? '(Imposable)' : '(Non-imposable)'}`
                                  }))}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {employeeForm.indemnites.map((indId) => {
                                    const comp = salaryComponents.find(c => c.id === indId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[indId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-indemnite-${indId}`} data-testid={`indemnite-card-${indId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemoveIndemnite(indId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`indemnite-amount-input-${indId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [indId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <div>
                                <Label>Primes</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handlePrimeChange}
                                  placeholder="Ajouter une prime"
                                  options={salaryComponents.filter(c => c.type === 'prime').map((comp) => {
                                    // Afficher les informations d'exonération si disponibles
                                    const exemptionInfo = comp.exemption_info ? ` - ${comp.exemption_info}` : '';
                                    const taxableInfo = comp.is_taxable ? '(Imposable)' : '(Non-imposable)';
                                    return {
                                      value: comp.id,
                                      label: `${comp.name} - ${formatCurrency(comp.amount)}${exemptionInfo || ` ${taxableInfo}`}`
                                    };
                                  })}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {SPECIAL_EXEMPT_PRIMES.filter(sp => parseFloat(employeeForm[sp.field]) > 0).map((sp) => (
                                    <div key={`form-special-prime-${sp.field}`} data-testid={`special-prime-card-${sp.field}`} style={{ backgroundColor: '#f0fdf4', border: '2px solid #86efac', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#14532d' }}>{sp.label} <span style={{ fontWeight: 400, fontSize: '11px' }}>(exonérée plafonnée)</span></span>
                                        <button type="button" onClick={() => setEmployeeForm(prev => ({ ...prev, [sp.field]: 0 }))} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <input
                                          type="number"
                                          data-testid={`special-prime-amount-${sp.field}`}
                                          value={employeeForm[sp.field]}
                                          onChange={(e) => {
                                            const newAmount = parseFloat(e.target.value) || 0;
                                            setEmployeeForm(prev => ({ ...prev, [sp.field]: newAmount }));
                                          }}
                                          placeholder="0"
                                          style={{ flex: 1, padding: '4px 8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px', fontWeight: 600, color: '#14532d' }}
                                        />
                                        <span style={{ fontSize: '12px', color: '#15803d' }}>FCFA</span>
                                      </div>
                                      {(() => {
                                        const montant = parseFloat(employeeForm[sp.field]) || 0;
                                        const imposable = Math.max(0, montant - sp.plafond);
                                        return imposable > 0 ? (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#b45309', marginTop: '4px', fontWeight: 600 }}>
                                            ⚠️ Exonéré : {formatCurrency(sp.plafond)} • Imposable : {formatCurrency(imposable)}
                                          </p>
                                        ) : (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#15803d', marginTop: '4px' }}>
                                            ✓ Totalement exonérée (plafond : {formatCurrency(sp.plafond)})
                                          </p>
                                        );
                                      })()}
                                    </div>
                                  ))}
                                  {employeeForm.primes.map((primeId) => {
                                    const comp = salaryComponents.find(c => c.id === primeId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[primeId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-prime-${primeId}`} data-testid={`prime-card-${primeId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemovePrime(primeId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`prime-amount-input-${primeId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [primeId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          {/* Allocations spéciales Art. 116-1 - Carte verte */}
                          <div style={{
                            backgroundColor: '#f0fdf4',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #86efac'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#14532d', marginBottom: '8px' }}>
                              ⚖️ Allocations spéciales pour frais d'emploi (Art. 116-1 CGI)
                            </h3>
                            <p style={{ fontSize: '13px', color: '#15803d', marginBottom: '16px', backgroundColor: '#dcfce7', padding: '8px', borderRadius: '6px' }}>
                              💡 Ces allocations bénéficient d'une exonération fiscale plafonnée à <strong>10% de la rémunération totale hors avantages</strong>. Le calcul est automatique lors de la paie.
                            </p>
                            <div className="space-y-3">
                              <div>
                                <Label style={{ color: '#14532d', fontWeight: 600 }}>
                                  Sélectionner une allocation spéciale
                                </Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handleComplementRetraiteChange}
                                  placeholder="Ajouter une allocation spéciale Art. 116-1"
                                  options={salaryComponents
                                    .filter(c => c.is_special_allowance === true)
                                    .map((comp) => ({
                                      value: comp.id,
                                      label: `${comp.name} - ${formatCurrency(comp.amount)}`
                                    }))}
                                />
                                <div className="flex flex-wrap gap-3 mt-3">
                                  {employeeForm.complement_retraite.map((compId) => {
                                    const comp = salaryComponents.find(c => c.id === compId);
                                    // Afficher uniquement les allocations spéciales dans cette section
                                    if (!comp || !comp.is_special_allowance) return null;
                                    
                                    const currentAmount = employeeForm.special_allowance_amounts?.[compId] || comp.amount || 0;
                                    
                                    return (
                                      <div 
                                        key={`form-special-${compId}`}
                                        style={{
                                          backgroundColor: '#f0fdf4',
                                          border: '2px solid #86efac',
                                          borderRadius: '8px',
                                          padding: '12px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: '8px',
                                          minWidth: '280px'
                                        }}
                                      >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                          <span style={{ fontSize: '14px', fontWeight: '600', color: '#14532d' }}>
                                            ⚖️ {comp.name}
                                          </span>
                                          <button
                                            type="button"
                                            onClick={() => handleRemoveComplementRetraite(compId)}
                                            style={{
                                              backgroundColor: '#fee2e2',
                                              color: '#991b1b',
                                              border: 'none',
                                              borderRadius: '4px',
                                              padding: '4px 8px',
                                              cursor: 'pointer',
                                              fontSize: '12px',
                                              fontWeight: '600'
                                            }}
                                          >
                                            ✕ Retirer
                                          </button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                          <label style={{ fontSize: '13px', color: '#15803d', fontWeight: '500', minWidth: '70px' }}>
                                            Montant:
                                          </label>
                                          <input
                                            type="number"
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({
                                                ...prev,
                                                special_allowance_amounts: {
                                                  ...prev.special_allowance_amounts,
                                                  [compId]: newAmount
                                                }
                                              }));
                                            }}
                                            placeholder="0"
                                            style={{
                                              flex: 1,
                                              padding: '6px 10px',
                                              border: '1px solid #86efac',
                                              borderRadius: '4px',
                                              fontSize: '13px',
                                              fontWeight: '600',
                                              color: '#14532d'
                                            }}
                                          />
                                          <span style={{ fontSize: '13px', color: '#15803d', fontWeight: '500' }}>
                                            FCFA
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Prénom</Label>
                              <Input required value={employeeForm.first_name} onChange={(e) => setEmployeeForm({...employeeForm, first_name: e.target.value})} />
                            </div>
                            <div>
                              <Label>Nom</Label>
                              <Input required value={employeeForm.last_name} onChange={(e) => setEmployeeForm({...employeeForm, last_name: e.target.value})} />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Email</Label>
                              <Input type="email" required value={employeeForm.email} onChange={(e) => setEmployeeForm({...employeeForm, email: e.target.value})} />
                            </div>
                            <div>
                              <Label>Téléphone</Label>
                              <Input required value={employeeForm.phone} onChange={(e) => setEmployeeForm({...employeeForm, phone: e.target.value})} />
                            </div>
                          </div>
                          <div>
                            <Label>Poste</Label>
                            <Input required value={employeeForm.position} onChange={(e) => setEmployeeForm({...employeeForm, position: e.target.value})} />
                          </div>
                          
                          {/* Catégorie professionnelle, Sous-catégorie et Grade */}
                          <div className="grid grid-cols-2 gap-4 mt-4">
                            <div>
                              <Label>Titre</Label>
                              <select
                                value={employeeForm.categorie_professionnelle || ''}
                                onChange={(e) => {
                                  setEmployeeForm({
                                    ...employeeForm, 
                                    categorie_professionnelle: e.target.value,
                                    grade: ''
                                  });
                                }}
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '6px',
                                  fontSize: '14px',
                                  backgroundColor: 'white'
                                }}
                              >
                                <option value="">Sélectionner un titre</option>
                                {Object.keys(CATEGORIES_PROFESSIONNELLES).map(cat => (
                                  <option key={cat} value={cat}>{cat}</option>
                                ))}
                              </select>
                            </div>
                            
                            <div>
                              <Label>Catégorie professionnelle</Label>
                              <select
                                value={employeeForm.grade || ''}
                                onChange={(e) => setEmployeeForm({...employeeForm, grade: e.target.value})}
                                disabled={!employeeForm.categorie_professionnelle}
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '6px',
                                  fontSize: '14px',
                                  backgroundColor: employeeForm.categorie_professionnelle ? 'white' : '#f3f4f6',
                                  cursor: employeeForm.categorie_professionnelle ? 'pointer' : 'not-allowed'
                                }}
                              >
                                <option value="">
                                  {employeeForm.categorie_professionnelle 
                                    ? 'Sélectionner une catégorie' 
                                    : 'Sélectionnez d\'abord un titre'}
                                </option>
                                {employeeForm.categorie_professionnelle && 
                                 CATEGORIES_PROFESSIONNELLES[employeeForm.categorie_professionnelle]?.map(grade => (
                                  <option key={grade} value={grade}>{grade}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          
                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3">Informations salariales</h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Salaire de base/catégoriel (FCFA)</Label>
                                <Input type="number" required value={employeeForm.salary_categoriel} onChange={(e) => setEmployeeForm({...employeeForm, salary_categoriel: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 1 du salaire brut social imposable</p>
                              </div>
                              <div>
                                <Label>Sursalaire (FCFA)</Label>
                                <Input type="number" value={employeeForm.sursalaire} onChange={(e) => setEmployeeForm({...employeeForm, sursalaire: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 2 du salaire brut social imposable</p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Gratification mensuelle (FCFA) - Calculée automatiquement</Label>
                                <Input 
                                  type="number" 
                                  value={Math.round((employeeForm.salary_categoriel * 0.75) / 12) || 0} 
                                  disabled
                                  className="bg-gray-100"
                                  placeholder="Calculé automatiquement"
                                />
                                <p className="text-xs text-green-600 mt-1">⚡ Élément 3 - Gratification mensuelle = (Salaire catégoriel × 0.75) ÷ 12</p>
                              </div>
                              <div>
                                <Label>Prime de transport (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_transport} onChange={(e) => setEmployeeForm({...employeeForm, prime_transport: e.target.value})} />
                                <p className="text-xs text-blue-600 mt-1">
                                  Non incluse dans salaire brut social (CNPS). Seuils : Abidjan (30k), Bouaké (24k), Autres (20k)
                                </p>
                              </div>
                              <div>
                                <Label>Ancienneté (calculée automatiquement)</Label>
                                <div className="p-3 bg-gray-50 rounded-md border">
                                  <p className="text-sm text-gray-700">📅 Calculée automatiquement selon la date d'embauche</p>
                                  <p className="text-xs text-green-600 mt-1">Prime : 2% après 2 ans 1 mois, +1% par année jusqu'à 25%</p>
                                </div>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Prime d'ancienneté (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_anciennete} onChange={(e) => setEmployeeForm({...employeeForm, prime_anciennete: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 4 - Calculée auto selon ancienneté (2% + 1%/an max 25%)</p>
                              </div>
                              <div>
                                <Label>Allocations familiales imposables (FCFA)</Label>
                                <Input type="number" value={employeeForm.allocations_familiales_imposables} onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_imposables: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 8 du salaire brut social imposable</p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Avantages en nature (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_nature} onChange={(e) => setEmployeeForm({...employeeForm, avantages_nature: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 9 - Logement, voiture, etc. (imposables)</p>
                              </div>
                              <div>
                                <Label>Avantages en argent (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_argent} onChange={(e) => setEmployeeForm({...employeeForm, avantages_argent: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 10 - Diverses allocations (imposables)</p>
                              </div>
                            </div>
                            <FraisSelector salaryComponents={salaryComponents} employeeForm={employeeForm} setEmployeeForm={setEmployeeForm} />
                          </div>
                            <div className="mt-4">
                              <Label>Remboursement de frais (FCFA)</Label>
                              <Input type="number" value={employeeForm.remboursement_frais} onChange={(e) => setEmployeeForm({...employeeForm, remboursement_frais: e.target.value})} />
                              <p className="text-xs text-green-600 mt-1">💰 Totalement exonéré d'impôts et de cotisations sociales</p>
                              <p className="text-xs text-gray-500 mt-1">Exemple : Remboursement de frais réels engagés par le salarié</p>
                            </div>

                            {/* CMU - Couverture Maladie Universelle */}
                            <div className="mt-4 border rounded-lg p-4 bg-blue-50">
                              <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                                <span className="text-blue-600 mr-2">🏥</span>
                                CMU - Couverture Maladie Universelle
                              </h4>
                              
                              <div className="grid grid-cols-2 gap-4 mb-3">
                                <div>
                                  <Label>CMU Employeur (FCFA)</Label>
                                  <Input 
                                    type="number" 
                                    value={employeeForm.cmu_employeur} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, cmu_employeur: e.target.value})} 
                                    placeholder="500"
                                  />
                                </div>
                                <div>
                                  <Label>CMU Salarié (FCFA)</Label>
                                  <Input 
                                    type="number" 
                                    value={employeeForm.cmu_salarie} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, cmu_salarie: e.target.value})} 
                                    placeholder="500"
                                  />
                                </div>
                              </div>
                              
                              <div className="flex items-center space-x-2">
                                <input
                                  type="checkbox"
                                  id="cmu_active"
                                  checked={employeeForm.cmu_active}
                                  onChange={(e) => setEmployeeForm({...employeeForm, cmu_active: e.target.checked})}
                                  className="rounded border-gray-300 focus:ring-blue-500"
                                />
                                <Label htmlFor="cmu_active" className="text-sm font-medium text-gray-900 cursor-pointer">
                                  Activer l'impact CMU sur le salaire net (+50% du montant total)
                                </Label>
                              </div>
                              
                              <p className="text-xs text-blue-600 mt-2">
                                💡 Si activé, le salaire net augmentera de 50% du montant total CMU (Employeur + Salarié)
                              </p>
                              <p className="text-xs text-gray-500 mt-1">
                                Exemple : CMU 1000F (500F employeur + 500F salarié) → +500F au salaire net
                              </p>
                            </div>

                            {/* Autres retenues spécifiques à la Côte d'Ivoire */}
                            <div className="mt-4 border rounded-lg p-4 bg-yellow-50">
                              <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                                <span className="text-yellow-600 mr-2">📋</span>
                                Autres retenues - Réglementation ivoirienne
                              </h4>
                              
                              <div className="grid grid-cols-1 gap-4 mb-3">
                                <div className="grid grid-cols-2 gap-4">
                                  <div>
                                    <Label>Formation continue (FCFA) - Calculé automatiquement</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.formation_continue} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, formation_continue: e.target.value})} 
                                      placeholder="Calculé: 0.6% × salaire brut"
                                      disabled
                                      className="bg-gray-100"
                                    />
                                    <p className="text-xs text-blue-600 mt-1">⚡ Formation continue = Salaire brut imposable × 0.6%</p>
                                  </div>
                                  <div>
                                    <Label>Taxe d'apprentissage (FCFA) - Calculé automatiquement</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.taxe_apprentissage} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, taxe_apprentissage: e.target.value})} 
                                      placeholder="Calculé: 0.4% × salaire brut"
                                      disabled
                                      className="bg-gray-100"
                                    />
                                    <p className="text-xs text-blue-600 mt-1">⚡ Taxe d'apprentissage = Salaire brut imposable × 0.4%</p>
                                  </div>
                                </div>
                                
                                <div className="grid grid-cols-2 gap-4">
                                  <div>
                                    <Label>IS Patronal (FCFA) - Calculé automatiquement</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.is_patronal} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, is_patronal: e.target.value})} 
                                      placeholder="Calculé: 1.2% × salaire brut"
                                      disabled
                                      className="bg-gray-100"
                                    />
                                    <p className="text-xs text-blue-600 mt-1">⚡ IS patronal = Salaire brut imposable × 1.2%</p>
                                  </div>
                                  <div>
                                    <Label>IS Salarial (FCFA)</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.is_salarie} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, is_salarie: e.target.value})} 
                                      placeholder="0"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">Impôt sur le traitement de salaire - Part salarié</p>
                                  </div>
                                </div>
                              </div>
                              
                              <p className="text-xs text-yellow-600 mt-2">
                                ℹ️ Ces retenues permettent de structurer les charges selon la réglementation ivoirienne
                              </p>
                            </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3">Consentements et Autorisations</h4>
                            <div className="space-y-3">
                              <div className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg">
                                <input
                                  type="checkbox"
                                  id="edit_gratification_consent"
                                  checked={employeeForm.gratification_display_consent}
                                  onChange={(e) => setEmployeeForm({...employeeForm, gratification_display_consent: e.target.checked})}
                                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                />
                                <label htmlFor="edit_gratification_consent" className="text-sm text-gray-900">
                                  <span className="font-medium">Autoriser l'affichage des gratifications sur les bulletins de paie</span>
                                  <p className="text-xs text-gray-600 mt-1">
                                    Si cette option est décochée, les gratifications n'apparaîtront pas sur les bulletins de paie générés.
                                  </p>
                                </label>
                              </div>

                              {/* Autorisation allocations familiales */}
                              <div className="flex items-start space-x-3 p-3 bg-blue-50 rounded-lg">
                                <input
                                  id="edit_allocations_familiales_consent"
                                  type="checkbox"
                                  checked={employeeForm.allocations_familiales_consent}
                                  onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_consent: e.target.checked})}
                                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                                />
                                <label htmlFor="edit_allocations_familiales_consent" className="text-sm text-gray-900">
                                  <span className="font-medium">Autoriser les allocations familiales dans les calculs de paie</span>
                                  <p className="text-xs text-gray-600 mt-1">
                                    Si cette option est décochée, les allocations familiales (7,500 FCFA par enfant) ne seront pas incluses dans le calcul du salaire net.
                                  </p>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3">Éléments configurables</h4>
                            <div className="space-y-3">
                              <div>
                                <Label>Indemnités</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handleIndemniteChange}
                                  placeholder="Ajouter une indemnité"
                                  options={salaryComponents.filter(c => c.type === 'indemnite').map((comp) => ({
                                    value: comp.id,
                                    label: `${comp.name} - ${formatCurrency(comp.amount)} ${comp.is_taxable ? '(Imposable)' : '(Non-imposable)'}`
                                  }))}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {employeeForm.indemnites.map((indId) => {
                                    const comp = salaryComponents.find(c => c.id === indId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[indId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-indemnite-${indId}`} data-testid={`indemnite-card-${indId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemoveIndemnite(indId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`indemnite-amount-input-${indId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [indId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <div>
                                <Label>Primes</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handlePrimeChange}
                                  placeholder="Ajouter une prime"
                                  options={salaryComponents.filter(c => c.type === 'prime').map((comp) => {
                                    // Afficher les informations d'exonération si disponibles
                                    const exemptionInfo = comp.exemption_info ? ` - ${comp.exemption_info}` : '';
                                    const taxableInfo = comp.is_taxable ? '(Imposable)' : '(Non-imposable)';
                                    return {
                                      value: comp.id,
                                      label: `${comp.name} - ${formatCurrency(comp.amount)}${exemptionInfo || ` ${taxableInfo}`}`
                                    };
                                  })}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {SPECIAL_EXEMPT_PRIMES.filter(sp => parseFloat(employeeForm[sp.field]) > 0).map((sp) => (
                                    <div key={`form-special-prime-${sp.field}`} data-testid={`special-prime-card-${sp.field}`} style={{ backgroundColor: '#f0fdf4', border: '2px solid #86efac', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#14532d' }}>{sp.label} <span style={{ fontWeight: 400, fontSize: '11px' }}>(exonérée plafonnée)</span></span>
                                        <button type="button" onClick={() => setEmployeeForm(prev => ({ ...prev, [sp.field]: 0 }))} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <input
                                          type="number"
                                          data-testid={`special-prime-amount-${sp.field}`}
                                          value={employeeForm[sp.field]}
                                          onChange={(e) => {
                                            const newAmount = parseFloat(e.target.value) || 0;
                                            setEmployeeForm(prev => ({ ...prev, [sp.field]: newAmount }));
                                          }}
                                          placeholder="0"
                                          style={{ flex: 1, padding: '4px 8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px', fontWeight: 600, color: '#14532d' }}
                                        />
                                        <span style={{ fontSize: '12px', color: '#15803d' }}>FCFA</span>
                                      </div>
                                      {(() => {
                                        const montant = parseFloat(employeeForm[sp.field]) || 0;
                                        const imposable = Math.max(0, montant - sp.plafond);
                                        return imposable > 0 ? (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#b45309', marginTop: '4px', fontWeight: 600 }}>
                                            ⚠️ Exonéré : {formatCurrency(sp.plafond)} • Imposable : {formatCurrency(imposable)}
                                          </p>
                                        ) : (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#15803d', marginTop: '4px' }}>
                                            ✓ Totalement exonérée (plafond : {formatCurrency(sp.plafond)})
                                          </p>
                                        );
                                      })()}
                                    </div>
                                  ))}
                                  {employeeForm.primes.map((primeId) => {
                                    const comp = salaryComponents.find(c => c.id === primeId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[primeId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-prime-${primeId}`} data-testid={`prime-card-${primeId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemovePrime(primeId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`prime-amount-input-${primeId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [primeId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

{/* Complément de retraite section removed */}

                              {/* Allocations spéciales Art. 116-1 intégrées dans Éléments configurables */}
                              <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #fde68a' }}>
                                <h4 style={{ fontSize: '15px', fontWeight: 600, color: '#78350f', marginBottom: '12px' }}>
                                  ⚖️ Allocations spéciales pour frais d'emploi (Art. 116-1 CGI)
                                </h4>
                                <p style={{ fontSize: '13px', color: '#78350f', marginBottom: '12px', backgroundColor: '#fef3c7', padding: '8px', borderRadius: '6px' }}>
                                  💡 Ces allocations bénéficient d'une exonération fiscale plafonnée à <strong>10% de la rémunération totale hors avantages</strong>. Le calcul est automatique lors de la paie.
                                </p>
                                <div>
                                  <Label style={{ color: '#78350f', fontWeight: 600 }}>
                                    Sélectionner une allocation spéciale
                                  </Label>
                                  <SimpleNativeSelect
                                    value=""
                                    onValueChange={handleComplementRetraiteChange}
                                    placeholder="Ajouter une allocation spéciale Art. 116-1"
                                    options={salaryComponents
                                      .filter(c => c.is_special_allowance === true)
                                      .map((comp) => ({
                                        value: comp.id,
                                        label: `${comp.name} - ${formatCurrency(comp.amount)}`
                                      }))}
                                  />
                                  <div className="flex flex-wrap gap-3 mt-3">
                                    {employeeForm.complement_retraite.map((compId) => {
                                      const comp = salaryComponents.find(c => c.id === compId);
                                      // Afficher uniquement les allocations spéciales dans cette section
                                      if (!comp || !comp.is_special_allowance) return null;
                                      
                                      const currentAmount = employeeForm.special_allowance_amounts?.[compId] || comp.amount || 0;
                                      
                                      return (
                                        <div 
                                          key={`edit-special-configurable-${compId}`}
                                          style={{
                                            backgroundColor: '#fffbeb',
                                            border: '2px solid #fde68a',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            minWidth: '280px'
                                          }}
                                        >
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#78350f' }}>
                                              ⚖️ {comp.name}
                                            </span>
                                            <button
                                              type="button"
                                              onClick={() => handleRemoveComplementRetraite(compId)}
                                              style={{
                                                backgroundColor: '#fee2e2',
                                                color: '#991b1b',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                              }}
                                            >
                                              ✕ Retirer
                                            </button>
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <label style={{ fontSize: '13px', color: '#78350f', fontWeight: '500', minWidth: '70px' }}>
                                              Montant:
                                            </label>
                                            <input
                                              type="number"
                                              value={currentAmount}
                                              onChange={(e) => {
                                                const newAmount = parseFloat(e.target.value) || 0;
                                                setEmployeeForm(prev => ({
                                                  ...prev,
                                                  special_allowance_amounts: {
                                                    ...prev.special_allowance_amounts,
                                                    [compId]: newAmount
                                                  }
                                                }));
                                              }}
                                              placeholder="0"
                                              style={{
                                                flex: 1,
                                                padding: '6px 10px',
                                                border: '1px solid #fde68a',
                                                borderRadius: '4px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#78350f'
                                              }}
                                            />
                                            <span style={{ fontSize: '13px', color: '#78350f', fontWeight: '500' }}>
                                              FCFA
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Type de contrat</Label>
                                <SimpleNativeSelect
                                  value={employeeForm.contract_type} 
                                  onValueChange={handleContractTypeChange}
                                  placeholder="Sélectionner un type de contrat"
                                  options={[
                                    {value: 'CDI', label: 'CDI'},
                                    {value: 'CDD', label: 'CDD'},
                                    {value: 'Contrat d\'essai', label: 'Contrat d\'essai'},
                                    {value: 'Contrat journalier', label: 'Contrat journalier'},
                                    {value: 'Stage', label: 'Stage'}
                                  ]}
                                />
                              </div>
                              <div>
                                <Label>Date d'embauche</Label>
                                <Input type="date" required value={employeeForm.hire_date} onChange={(e) => setEmployeeForm({...employeeForm, hire_date: e.target.value})} />
                              </div>
                            </div>
                            <div className="mt-4">
                              <Label>Date de fin d'activité (optionnel)</Label>
                              <Input type="date" value={employeeForm.date_fin_activite} onChange={(e) => setEmployeeForm({...employeeForm, date_fin_activite: e.target.value})} />
                              <p className="text-xs text-blue-600 mt-1">⏹️ Laisser vide si l'employé est encore actif. Utilisé pour calculer l'ancienneté finale.</p>
                            </div>

                            {/* Section RICF - Réduction d'impôt pour charges de famille */}
                            <div className="mt-4 border rounded-lg p-4 bg-green-50">
                              <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                                <span className="text-green-600 mr-2">👨‍👩‍👧‍👦</span>
                                RICF - Réduction d'impôt pour charges de famille
                              </h4>
                              
                              <div className="grid grid-cols-1 gap-4 mb-3">
                                <div>
                                  <Label>Statut matrimonial</Label>
                                  <SimpleNativeSelect
                                  value={employeeForm.statut_matrimonial}
                                  onValueChange={handleStatutMatrimonialChange}
                                  placeholder="Statut matrimonial"
                                  options={[
                                    {value: 'celibataire', label: 'Célibataire'},
                                    {value: 'marie', label: 'Marié(e)'},
                                    {value: 'divorce', label: 'Divorcé(e)'},
                                    {value: 'veuf', label: 'Veuf/Veuve'}
                                  ]}
                                />
                                </div>
                              </div>
                              
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Nombre d'enfants à charge</Label>
                                  <Input 
                                    type="number" 
                                    min="0"
                                    value={employeeForm.nombre_enfants} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants: parseInt(e.target.value) || 0})} 
                                    placeholder="0"
                                  />
                                </div>
                                <div>
                                  <Label>Nombre d'enfants infirmes à charge</Label>
                                  <Input 
                                    type="number" 
                                    min="0"
                                    value={employeeForm.nombre_enfants_infirmes} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants_infirmes: parseInt(e.target.value) || 0})} 
                                    placeholder="0"
                                  />
                                  <p className="text-xs text-green-600 mt-1">⚖️ Les enfants infirmes comptent pour 1 part complète chacun</p>
                                </div>
                              </div>
                              
                              <p className="text-xs text-blue-600 mt-2">
                                💡 Ces informations déterminent le nombre de parts familiales pour le calcul de la RICF
                              </p>
                              <p className="text-xs text-gray-500 mt-1">
                                Exemple : Marié 2 enfants = 3 parts → 22,000 FCFA de réduction d'impôt mensuelle
                              </p>
                            </div>
                          </div>

                          {/* Section Photo d'employé - Carte grise */}
                          <div style={{
                            backgroundColor: '#f9fafb',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #d1d5db'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#374151', marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }}>📷</span>
                              Photo de l'employé
                            </h3>
                            <div className="space-y-3">
                              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-500 transition-colors">
                                <input
                                  type="file"
                                  id="employee-photo"
                                  accept="image/png,image/jpeg,image/jpg,application/pdf"
                                  className="hidden"
                                  onChange={handlePhotoUpload}
                                />
                                <label 
                                  htmlFor="employee-photo" 
                                  className="cursor-pointer flex flex-col items-center space-y-2"
                                >
                                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                                    <Plus className="w-6 h-6 text-gray-400" />
                                  </div>
                                  <div>
                                    <p className="text-sm font-medium text-gray-700">Ajouter une photo</p>
                                    <p className="text-xs text-gray-500">PNG, JPG, PDF - Max 5MB</p>
                                  </div>
                                </label>
                              </div>
                              
                              {uploadingPhoto && (
                                <div className="flex items-center space-x-2 p-2 bg-blue-50 rounded-lg">
                                  <Loader2 className="w-4 h-4 animate-spin text-blue-600" />
                                  <span className="text-sm text-blue-700">Upload en cours...</span>
                                </div>
                              )}
                              
                              {employeeForm.photo_url && (
                                <div className="space-y-3">
                                  {/* Aperçu de l'image */}
                                  <div className="flex items-center justify-center p-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                                    {employeeForm.photo_url.startsWith('data:') ? (
                                      // Aperçu pour les nouvelles images (data URL)
                                      <div className="text-center">
                                        <img 
                                          src={employeeForm.photo_url}
                                          alt="Aperçu photo employé"
                                          className="w-24 h-24 object-cover rounded-lg mx-auto mb-2"
                                        />
                                        <p className="text-sm font-medium text-green-700">Aperçu de la photo</p>
                                        <p className="text-xs text-green-600">{employeeForm.photo_filename}</p>
                                      </div>
                                    ) : (
                                      // Indicateur pour les images déjà uploadées
                                      <div className="flex items-center space-x-3">
                                        <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                                          <Check className="w-5 h-5 text-green-600" />
                                        </div>
                                        <div className="flex-1">
                                          <p className="text-sm font-medium text-green-700">Photo ajoutée</p>
                                          <p className="text-xs text-green-600">{employeeForm.photo_filename}</p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  
                                  <Button
                                    type="button"
                                    variant="outline"
                                    size="sm"
                                    onClick={() => setEmployeeForm({...employeeForm, photo_url: null, photo_filename: null})}
                                    className="w-full"
                                  >
                                    <X className="w-4 h-4 mr-2" />
                                    Supprimer la photo
                                  </Button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                          
                    {/* Bouton de soumission - Footer fixe */}
                    <div style={{
                      padding: '20px 32px',
                      backgroundColor: 'white',
                      borderTop: '2px solid #e5e7eb',
                      flexShrink: 0
                    }}>
                      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                        <Button 
                          type="submit"
                          style={{
                            width: '100%',
                            padding: '16px 24px',
                            background: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
                            color: 'white',
                            fontWeight: 700,
                            borderRadius: '12px',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '16px',
                            boxShadow: '0 4px 16px rgba(20, 184, 166, 0.3)',
                            transition: 'all 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(20, 184, 166, 0.4)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(20, 184, 166, 0.3)';
                          }}
                        >
                          <Plus style={{ width: '20px', height: '20px' }} />
                          Créer l'employé
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              )}

                    {/* Dialog de modification d'employé */}
                    <Dialog open={isEditEmployeeOpen} onOpenChange={setIsEditEmployeeOpen}>
                      <DialogContent className="sm:max-w-2xl">
                        <DialogHeader>
                          <DialogTitle>Modifier l'employé</DialogTitle>
                          <DialogDescription>Modifier les informations de l'employé</DialogDescription>
                        </DialogHeader>
                        <form onSubmit={handleUpdateEmployee} className="space-y-4 max-h-[75vh] overflow-y-auto pr-2">
                          
                          {/* Section Photo et Identité - EN PREMIER */}
                          <div className="flex gap-4 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                            {/* Photo de l'employé - Colonne gauche */}
                            <div className="flex-shrink-0">
                              <div className="relative">
                                {editingEmployee?.photo_url ? (
                                  <img 
                                    src={`${BACKEND_URL}${editingEmployee.photo_url}`}
                                    alt="Photo employé"
                                    className="w-24 h-24 object-cover rounded-lg border-2 border-white shadow-md"
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                      e.target.nextSibling.style.display = 'flex';
                                    }}
                                  />
                                ) : null}
                                <div 
                                  className={`w-24 h-24 bg-gray-100 rounded-lg border-2 border-white shadow-md flex items-center justify-center ${editingEmployee?.photo_url ? 'hidden' : 'flex'}`}
                                  style={editingEmployee?.photo_url ? {display: 'none'} : {display: 'flex'}}
                                >
                                  <User className="w-12 h-12 text-gray-400" />
                                </div>
                                <label 
                                  htmlFor="employee-photo-quick"
                                  className="absolute -bottom-1 -right-1 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors shadow-md"
                                >
                                  <Plus className="w-4 h-4 text-white" />
                                </label>
                                <input
                                  type="file"
                                  id="employee-photo-quick"
                                  accept="image/png,image/jpeg,image/jpg"
                                  className="hidden"
                                  onChange={(e) => handlePhotoUpload(e, editingEmployee?.id)}
                                />
                              </div>
                              {uploadingPhoto && (
                                <div className="mt-2 flex items-center text-xs text-blue-600">
                                  <Loader2 className="w-3 h-3 mr-1 animate-spin" />
                                  Upload...
                                </div>
                              )}
                              {editingEmployee?.photo_url && (
                                <button
                                  type="button"
                                  onClick={() => handleDeletePhoto(editingEmployee.id)}
                                  className="mt-2 text-xs text-red-500 hover:text-red-700 flex items-center"
                                  disabled={deletingPhoto}
                                >
                                  {deletingPhoto ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Trash2 className="w-3 h-3 mr-1" />}
                                  Supprimer
                                </button>
                              )}
                            </div>
                            
                            {/* Infos d'identité - Colonne droite */}
                            <div className="flex-1 grid grid-cols-2 gap-3">
                              <div>
                                <Label className="text-xs text-blue-700">Prénom</Label>
                                <Input required value={employeeForm.first_name} onChange={(e) => setEmployeeForm({...employeeForm, first_name: e.target.value})} className="h-9" />
                              </div>
                              <div>
                                <Label className="text-xs text-blue-700">Nom</Label>
                                <Input required value={employeeForm.last_name} onChange={(e) => setEmployeeForm({...employeeForm, last_name: e.target.value})} className="h-9" />
                              </div>
                              <div>
                                <Label className="text-xs text-blue-700">Email</Label>
                                <Input type="email" required value={employeeForm.email} onChange={(e) => setEmployeeForm({...employeeForm, email: e.target.value})} className="h-9" />
                              </div>
                              <div>
                                <Label className="text-xs text-blue-700">Téléphone</Label>
                                <Input value={employeeForm.phone} onChange={(e) => setEmployeeForm({...employeeForm, phone: e.target.value})} className="h-9" />
                              </div>
                            </div>
                          </div>
                          
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Poste</Label>
                              <Input required value={employeeForm.position} onChange={(e) => setEmployeeForm({...employeeForm, position: e.target.value})} />
                            </div>
                            <div>
                              <Label>N° CNPS</Label>
                              <Input 
                                placeholder="Ex: 00123456789"
                                value={employeeForm.numero_cnps} 
                                onChange={(e) => setEmployeeForm({...employeeForm, numero_cnps: e.target.value})} 
                              />
                            </div>
                          </div>
                          
                          {/* Classification professionnelle - Basé sur la grille salariale */}
                          <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                            <h3 className="text-sm font-semibold text-blue-800 mb-3">📋 Classification professionnelle (Grille salariale 2023)</h3>
                            
                            {/* Première ligne : Secteur précis d'activité */}
                            <div className="mb-4">
                              <Label className="text-blue-700 font-medium">🏭 Secteur précis d'activité</Label>
                              <select
                                value={employeeForm.secteur_activite_precis || ''}
                                onChange={(e) => {
                                  const newSecteur = e.target.value;
                                  setEmployeeForm({
                                    ...employeeForm, 
                                    secteur_activite_precis: newSecteur,
                                    categorie_professionnelle: '',
                                    grade: '',
                                    salary_categoriel: ''
                                  });
                                }}
                                style={{
                                  width: '100%',
                                  padding: '10px 12px',
                                  border: '2px solid #3b82f6',
                                  borderRadius: '8px',
                                  fontSize: '14px',
                                  backgroundColor: 'white',
                                  fontWeight: '500',
                                  marginTop: '6px'
                                }}
                              >
                                <option value="">-- Sélectionner le secteur d'activité --</option>
                                {Object.keys(GRILLE_SALAIRES_CATEGORIELS).map(secteur => (
                                  <option key={secteur} value={secteur}>{secteur}</option>
                                ))}
                              </select>
                            </div>
                            
                            {/* Deuxième ligne : Catégorie et Grade */}
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label className="text-blue-700">Titre</Label>
                                <select
                                  value={employeeForm.categorie_professionnelle || ''}
                                  onChange={(e) => {
                                    const newCategorie = e.target.value;
                                    setEmployeeForm({
                                      ...employeeForm, 
                                      categorie_professionnelle: newCategorie,
                                      grade: '',
                                      salary_categoriel: ''
                                    });
                                  }}
                                  disabled={!employeeForm.secteur_activite_precis}
                                  style={{
                                    width: '100%',
                                    padding: '8px 12px',
                                    border: '1px solid #93c5fd',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    backgroundColor: employeeForm.secteur_activite_precis ? 'white' : '#f3f4f6',
                                    cursor: employeeForm.secteur_activite_precis ? 'pointer' : 'not-allowed',
                                    marginTop: '6px'
                                  }}
                                >
                                  <option value="">
                                    {employeeForm.secteur_activite_precis 
                                      ? 'Sélectionner un titre' 
                                      : 'Sélectionnez d\'abord un secteur'}
                                  </option>
                                  {employeeForm.secteur_activite_precis && (() => {
                                    const secteurData = GRILLE_SALAIRES_CATEGORIELS[employeeForm.secteur_activite_precis];
                                    return secteurData ? Object.keys(secteurData).map(cat => (
                                      <option key={cat} value={cat}>{cat}</option>
                                    )) : null;
                                  })()}
                                </select>
                              </div>
                              
                              <div>
                                <Label className="text-blue-700">Catégorie professionnelle</Label>
                                <select
                                  value={employeeForm.grade || ''}
                                  onChange={(e) => {
                                    const newGrade = e.target.value;
                                    // Calculer automatiquement le salaire catégoriel
                                    const salaire = getSalaireCategoriel(
                                      employeeForm.secteur_activite_precis, 
                                      employeeForm.categorie_professionnelle, 
                                      newGrade
                                    );
                                    setEmployeeForm({
                                      ...employeeForm, 
                                      grade: newGrade,
                                      salary_categoriel: salaire || employeeForm.salary_categoriel
                                    });
                                  }}
                                  disabled={!employeeForm.categorie_professionnelle}
                                  style={{
                                    width: '100%',
                                    padding: '8px 12px',
                                    border: '1px solid #93c5fd',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    backgroundColor: employeeForm.categorie_professionnelle ? 'white' : '#f3f4f6',
                                    cursor: employeeForm.categorie_professionnelle ? 'pointer' : 'not-allowed',
                                    marginTop: '6px'
                                  }}
                                >
                                  <option value="">
                                    {employeeForm.categorie_professionnelle 
                                      ? 'Sélectionner une catégorie' 
                                      : 'Sélectionnez d\'abord un titre'}
                                  </option>
                                  {employeeForm.categorie_professionnelle && employeeForm.secteur_activite_precis && (() => {
                                    const secteurData = GRILLE_SALAIRES_CATEGORIELS[employeeForm.secteur_activite_precis];
                                    const categorieData = secteurData?.[employeeForm.categorie_professionnelle];
                                    return categorieData?.grades?.map(grade => (
                                      <option key={grade} value={grade}>
                                        {grade} - {categorieData.salaires[grade]?.toLocaleString('fr-FR')} FCFA
                                      </option>
                                    ));
                                  })()}
                                </select>
                              </div>
                            </div>
                            
                            {/* Indicateur de sélection */}
                            {employeeForm.secteur_activite_precis && (
                              <p className="text-xs text-blue-600 mt-3 flex items-center gap-1">
                                <span>✓</span> Grille appliquée : <strong>{employeeForm.secteur_activite_precis}</strong>
                              </p>
                            )}
                          </div>
                          
                          <div className="grid grid-cols-1 gap-4">
                            <div>
                              <Label>Salaire catégoriel (FCFA) {employeeForm.grade && <span className="text-green-600 text-xs ml-2">✓ Calculé automatiquement</span>}</Label>
                              <Input 
                                type="number" 
                                required 
                                value={employeeForm.salary_categoriel} 
                                onChange={(e) => setEmployeeForm({...employeeForm, salary_categoriel: e.target.value})}
                                className={employeeForm.grade ? "border-green-300 bg-green-50" : ""}
                              />
                            </div>
                          </div>

                          {/* Éléments de salaire - Carte jaune */}
                          <div style={{
                            backgroundColor: '#fefce8',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fef08a'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#854d0e', marginBottom: '16px' }}>
                              📊 Éléments de salaire
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Sursalaire (FCFA)</Label>
                                <Input type="number" value={employeeForm.sursalaire} onChange={(e) => setEmployeeForm({...employeeForm, sursalaire: e.target.value})} />
                              </div>
                              <div>
                                <Label>Prime de transport (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_transport} onChange={(e) => setEmployeeForm({...employeeForm, prime_transport: e.target.value})} />
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Prime d'ancienneté (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_anciennete} onChange={(e) => setEmployeeForm({...employeeForm, prime_anciennete: e.target.value})} />
                              </div>
                              <div>
                                <Label>Allocations familiales imposables (FCFA)</Label>
                                <Input type="number" value={employeeForm.allocations_familiales_imposables} onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_imposables: e.target.value})} />
                              </div>
                            </div>
                            <FraisSelector salaryComponents={salaryComponents} employeeForm={employeeForm} setEmployeeForm={setEmployeeForm} />
                          </div>

                          {/* Avantages - Carte rose */}
                          <div style={{
                            backgroundColor: '#fdf2f8',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fbcfe8'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#831843', marginBottom: '16px' }}>
                              🎁 Avantages
                            </h3>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Avantages en nature (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_nature} onChange={(e) => setEmployeeForm({...employeeForm, avantages_nature: e.target.value})} />
                              </div>
                              <div>
                                <Label>Avantages en argent (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_argent} onChange={(e) => setEmployeeForm({...employeeForm, avantages_argent: e.target.value})} />
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Remboursement de frais (FCFA)</Label>
                                <Input type="number" value={employeeForm.remboursement_frais} onChange={(e) => setEmployeeForm({...employeeForm, remboursement_frais: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">💰 Totalement exonéré (non imposable)</p>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium mb-3">CMU (Couverture Maladie Universelle)</h4>
                            <div className="grid grid-cols-3 gap-4">
                              <div>
                                <Label>CMU Employeur (FCFA)</Label>
                                <Input type="number" value={employeeForm.cmu_employeur} onChange={(e) => setEmployeeForm({...employeeForm, cmu_employeur: e.target.value})} />
                              </div>
                              <div>
                                <Label>CMU Salarié (FCFA)</Label>
                                <Input type="number" value={employeeForm.cmu_salarie} onChange={(e) => setEmployeeForm({...employeeForm, cmu_salarie: e.target.value})} />
                              </div>
                              <div className="flex items-center space-x-2 pt-6">
                                <input 
                                  type="checkbox" 
                                  id="cmu_active_edit" 
                                  checked={employeeForm.cmu_active} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, cmu_active: e.target.checked})} 
                                />
                                <Label htmlFor="cmu_active_edit">CMU Active</Label>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium mb-3">Taxes et contributions</h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Formation continue (FCFA) - Calculé automatiquement</Label>
                                <Input 
                                  type="number" 
                                  value={employeeForm.formation_continue} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, formation_continue: e.target.value})} 
                                  placeholder="Calculé: 0.6% × salaire brut"
                                  disabled
                                  className="bg-gray-100"
                                />
                                <p className="text-xs text-blue-600 mt-1">⚡ Formation continue = Salaire brut imposable × 0.6%</p>
                              </div>
                              <div>
                                <Label>Taxe d'apprentissage (FCFA) - Calculé automatiquement</Label>
                                <Input 
                                  type="number" 
                                  value={employeeForm.taxe_apprentissage} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, taxe_apprentissage: e.target.value})} 
                                  placeholder="Calculé: 0.4% × salaire brut"
                                  disabled
                                  className="bg-gray-100"
                                />
                                <p className="text-xs text-blue-600 mt-1">⚡ Taxe apprentissage = Salaire brut imposable × 0.4%</p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>IS Patronal (FCFA) - Calculé automatiquement</Label>
                                <Input 
                                  type="number" 
                                  value={employeeForm.is_patronal} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, is_patronal: e.target.value})} 
                                  placeholder="Calculé: 1.2% × salaire brut"
                                  disabled
                                  className="bg-gray-100"
                                />
                                <p className="text-xs text-blue-600 mt-1">⚡ IS patronal = Salaire brut imposable × 1.2%</p>
                              </div>
                              <div>
                                <Label>IS Salarial (FCFA)</Label>
                                <Input 
                                  type="number" 
                                  value={employeeForm.is_salarie} 
                                  onChange={(e) => setEmployeeForm({...employeeForm, is_salarie: e.target.value})} 
                                  placeholder="0"
                                />
                                <p className="text-xs text-gray-500 mt-1">Impôt sur le traitement de salaire - Part salarié</p>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium mb-3">RICF (Réduction d'impôt pour charges de famille)</h4>
                            <div className="grid grid-cols-3 gap-4">
                              <div>
                                <Label>Statut matrimonial</Label>
                                <SimpleNativeSelect
                                  value={employeeForm.statut_matrimonial}
                                  onValueChange={handleStatutMatrimonialChange}
                                  placeholder="Statut matrimonial"
                                  options={[
                                    {value: 'celibataire', label: 'Célibataire'},
                                    {value: 'marie', label: 'Marié(e)'},
                                    {value: 'divorce', label: 'Divorcé(e)'},
                                    {value: 'veuf', label: 'Veuf/Veuve'}
                                  ]}
                                />
                              </div>
                              <div>
                                <Label>Nombre d'enfants</Label>
                                <Input type="number" min="0" value={employeeForm.nombre_enfants} onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants: e.target.value})} />
                              </div>
                              <div>
                                <Label>Enfants infirmes</Label>
                                <Input type="number" min="0" value={employeeForm.nombre_enfants_infirmes} onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants_infirmes: e.target.value})} />
                              </div>
                            </div>
                          </div>

                          {/* Éléments configurables - Carte ambre */}
                          <div style={{
                            backgroundColor: '#fffbeb',
                            borderRadius: '12px',
                            padding: '20px',
                            border: '2px solid #fde68a'
                          }}>
                            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#78350f', marginBottom: '16px' }}>
                              ⚙️ Éléments configurables
                            </h3>
                            <div className="space-y-3">
                              <div>
                                <Label>Indemnités</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handleIndemniteChange}
                                  placeholder="Ajouter une indemnité"
                                  options={salaryComponents.filter(c => c.type === 'indemnite').map((comp) => ({
                                    value: comp.id,
                                    label: `${comp.name} - ${formatCurrency(comp.amount)} ${comp.is_taxable ? '(Imposable)' : '(Non-imposable)'}`
                                  }))}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {employeeForm.indemnites.map((indId) => {
                                    const comp = salaryComponents.find(c => c.id === indId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[indId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-indemnite-${indId}`} data-testid={`indemnite-card-${indId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemoveIndemnite(indId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`indemnite-amount-input-${indId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [indId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <div>
                                <Label>Primes</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handlePrimeChange}
                                  placeholder="Ajouter une prime"
                                  options={salaryComponents.filter(c => c.type === 'prime').map((comp) => {
                                    // Afficher les informations d'exonération si disponibles
                                    const exemptionInfo = comp.exemption_info ? ` - ${comp.exemption_info}` : '';
                                    const taxableInfo = comp.is_taxable ? '(Imposable)' : '(Non-imposable)';
                                    return {
                                      value: comp.id,
                                      label: `${comp.name} - ${formatCurrency(comp.amount)}${exemptionInfo || ` ${taxableInfo}`}`
                                    };
                                  })}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {SPECIAL_EXEMPT_PRIMES.filter(sp => parseFloat(employeeForm[sp.field]) > 0).map((sp) => (
                                    <div key={`form-special-prime-${sp.field}`} data-testid={`special-prime-card-${sp.field}`} style={{ backgroundColor: '#f0fdf4', border: '2px solid #86efac', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#14532d' }}>{sp.label} <span style={{ fontWeight: 400, fontSize: '11px' }}>(exonérée plafonnée)</span></span>
                                        <button type="button" onClick={() => setEmployeeForm(prev => ({ ...prev, [sp.field]: 0 }))} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <input
                                          type="number"
                                          data-testid={`special-prime-amount-${sp.field}`}
                                          value={employeeForm[sp.field]}
                                          onChange={(e) => {
                                            const newAmount = parseFloat(e.target.value) || 0;
                                            setEmployeeForm(prev => ({ ...prev, [sp.field]: newAmount }));
                                          }}
                                          placeholder="0"
                                          style={{ flex: 1, padding: '4px 8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px', fontWeight: 600, color: '#14532d' }}
                                        />
                                        <span style={{ fontSize: '12px', color: '#15803d' }}>FCFA</span>
                                      </div>
                                      {(() => {
                                        const montant = parseFloat(employeeForm[sp.field]) || 0;
                                        const imposable = Math.max(0, montant - sp.plafond);
                                        return imposable > 0 ? (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#b45309', marginTop: '4px', fontWeight: 600 }}>
                                            ⚠️ Exonéré : {formatCurrency(sp.plafond)} • Imposable : {formatCurrency(imposable)}
                                          </p>
                                        ) : (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#15803d', marginTop: '4px' }}>
                                            ✓ Totalement exonérée (plafond : {formatCurrency(sp.plafond)})
                                          </p>
                                        );
                                      })()}
                                    </div>
                                  ))}
                                  {employeeForm.primes.map((primeId) => {
                                    const comp = salaryComponents.find(c => c.id === primeId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[primeId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-prime-${primeId}`} data-testid={`prime-card-${primeId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemovePrime(primeId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`prime-amount-input-${primeId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [primeId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

{/* Complément de retraite section removed */}

                              {/* Allocations spéciales Art. 116-1 intégrées dans Éléments configurables */}
                              <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #fde68a' }}>
                                <h4 style={{ fontSize: '15px', fontWeight: 600, color: '#78350f', marginBottom: '12px' }}>
                                  ⚖️ Allocations spéciales pour frais d'emploi (Art. 116-1 CGI)
                                </h4>
                                <p style={{ fontSize: '13px', color: '#78350f', marginBottom: '12px', backgroundColor: '#fef3c7', padding: '8px', borderRadius: '6px' }}>
                                  💡 Ces allocations bénéficient d'une exonération fiscale plafonnée à <strong>10% de la rémunération totale hors avantages</strong>. Le calcul est automatique lors de la paie.
                                </p>
                                <div>
                                  <Label style={{ color: '#78350f', fontWeight: 600 }}>
                                    Sélectionner une allocation spéciale
                                  </Label>
                                  <SimpleNativeSelect
                                    value=""
                                    onValueChange={handleComplementRetraiteChange}
                                    placeholder="Ajouter une allocation spéciale Art. 116-1"
                                    options={salaryComponents
                                      .filter(c => c.is_special_allowance === true)
                                      .map((comp) => ({
                                        value: comp.id,
                                        label: `${comp.name} - ${formatCurrency(comp.amount)}`
                                      }))}
                                  />
                                  <div className="flex flex-wrap gap-3 mt-3">
                                    {employeeForm.complement_retraite.map((compId) => {
                                      const comp = salaryComponents.find(c => c.id === compId);
                                      // Afficher uniquement les allocations spéciales dans cette section
                                      if (!comp || !comp.is_special_allowance) return null;
                                      
                                      const currentAmount = employeeForm.special_allowance_amounts?.[compId] || comp.amount || 0;
                                      
                                      return (
                                        <div 
                                          key={`edit-special-configurable-${compId}`}
                                          style={{
                                            backgroundColor: '#fffbeb',
                                            border: '2px solid #fde68a',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            minWidth: '280px'
                                          }}
                                        >
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#78350f' }}>
                                              ⚖️ {comp.name}
                                            </span>
                                            <button
                                              type="button"
                                              onClick={() => handleRemoveComplementRetraite(compId)}
                                              style={{
                                                backgroundColor: '#fee2e2',
                                                color: '#991b1b',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                              }}
                                            >
                                              ✕ Retirer
                                            </button>
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <label style={{ fontSize: '13px', color: '#78350f', fontWeight: '500', minWidth: '70px' }}>
                                              Montant:
                                            </label>
                                            <input
                                              type="number"
                                              value={currentAmount}
                                              onChange={(e) => {
                                                const newAmount = parseFloat(e.target.value) || 0;
                                                setEmployeeForm(prev => ({
                                                  ...prev,
                                                  special_allowance_amounts: {
                                                    ...prev.special_allowance_amounts,
                                                    [compId]: newAmount
                                                  }
                                                }));
                                              }}
                                              placeholder="0"
                                              style={{
                                                flex: 1,
                                                padding: '6px 10px',
                                                border: '1px solid #fde68a',
                                                borderRadius: '4px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#78350f'
                                              }}
                                            />
                                            <span style={{ fontSize: '13px', color: '#78350f', fontWeight: '500' }}>
                                              FCFA
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Prénom</Label>
                              <Input required value={employeeForm.first_name} onChange={(e) => setEmployeeForm({...employeeForm, first_name: e.target.value})} />
                            </div>
                            <div>
                              <Label>Nom</Label>
                              <Input required value={employeeForm.last_name} onChange={(e) => setEmployeeForm({...employeeForm, last_name: e.target.value})} />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Email</Label>
                              <Input type="email" required value={employeeForm.email} onChange={(e) => setEmployeeForm({...employeeForm, email: e.target.value})} />
                            </div>
                            <div>
                              <Label>Téléphone</Label>
                              <Input required value={employeeForm.phone} onChange={(e) => setEmployeeForm({...employeeForm, phone: e.target.value})} />
                            </div>
                          </div>
                          <div>
                            <Label>Poste</Label>
                            <Input required value={employeeForm.position} onChange={(e) => setEmployeeForm({...employeeForm, position: e.target.value})} />
                          </div>
                          
                          {/* Catégorie professionnelle, Sous-catégorie et Grade */}
                          <div className="grid grid-cols-2 gap-4 mt-4">
                            <div>
                              <Label>Titre</Label>
                              <select
                                value={employeeForm.categorie_professionnelle || ''}
                                onChange={(e) => {
                                  setEmployeeForm({
                                    ...employeeForm, 
                                    categorie_professionnelle: e.target.value,
                                    grade: ''
                                  });
                                }}
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '6px',
                                  fontSize: '14px',
                                  backgroundColor: 'white'
                                }}
                              >
                                <option value="">Sélectionner un titre</option>
                                {Object.keys(CATEGORIES_PROFESSIONNELLES).map(cat => (
                                  <option key={cat} value={cat}>{cat}</option>
                                ))}
                              </select>
                            </div>
                            
                            <div>
                              <Label>Catégorie professionnelle</Label>
                              <select
                                value={employeeForm.grade || ''}
                                onChange={(e) => setEmployeeForm({...employeeForm, grade: e.target.value})}
                                disabled={!employeeForm.categorie_professionnelle}
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '6px',
                                  fontSize: '14px',
                                  backgroundColor: employeeForm.categorie_professionnelle ? 'white' : '#f3f4f6',
                                  cursor: employeeForm.categorie_professionnelle ? 'pointer' : 'not-allowed'
                                }}
                              >
                                <option value="">
                                  {employeeForm.categorie_professionnelle 
                                    ? 'Sélectionner une catégorie' 
                                    : 'Sélectionnez d\'abord un titre'}
                                </option>
                                {employeeForm.categorie_professionnelle && 
                                 CATEGORIES_PROFESSIONNELLES[employeeForm.categorie_professionnelle]?.map(grade => (
                                  <option key={grade} value={grade}>{grade}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          
                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3">Informations salariales</h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Salaire de base/catégoriel (FCFA)</Label>
                                <Input type="number" required value={employeeForm.salary_categoriel} onChange={(e) => setEmployeeForm({...employeeForm, salary_categoriel: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 1 du salaire brut social imposable</p>
                              </div>
                              <div>
                                <Label>Sursalaire (FCFA)</Label>
                                <Input type="number" value={employeeForm.sursalaire} onChange={(e) => setEmployeeForm({...employeeForm, sursalaire: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 2 du salaire brut social imposable</p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Gratification mensuelle (FCFA) - Calculée automatiquement</Label>
                                <Input 
                                  type="number" 
                                  value={Math.round((employeeForm.salary_categoriel * 0.75) / 12) || 0} 
                                  disabled
                                  className="bg-gray-100"
                                  placeholder="Calculé automatiquement"
                                />
                                <p className="text-xs text-green-600 mt-1">⚡ Élément 3 - Gratification mensuelle = (Salaire catégoriel × 0.75) ÷ 12</p>
                              </div>
                              <div>
                                <Label>Prime de transport (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_transport} onChange={(e) => setEmployeeForm({...employeeForm, prime_transport: e.target.value})} />
                                <p className="text-xs text-blue-600 mt-1">
                                  Non incluse dans salaire brut social (CNPS). Seuils : Abidjan (30k), Bouaké (24k), Autres (20k)
                                </p>
                              </div>
                              <div>
                                <Label>Ancienneté (calculée automatiquement)</Label>
                                <div className="p-3 bg-gray-50 rounded-md border">
                                  <p className="text-sm text-gray-700">📅 Calculée automatiquement selon la date d'embauche</p>
                                  <p className="text-xs text-green-600 mt-1">Prime : 2% après 2 ans 1 mois, +1% par année jusqu'à 25%</p>
                                </div>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Prime d'ancienneté (FCFA)</Label>
                                <Input type="number" value={employeeForm.prime_anciennete} onChange={(e) => setEmployeeForm({...employeeForm, prime_anciennete: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 4 - Calculée auto selon ancienneté (2% + 1%/an max 25%)</p>
                              </div>
                              <div>
                                <Label>Allocations familiales imposables (FCFA)</Label>
                                <Input type="number" value={employeeForm.allocations_familiales_imposables} onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_imposables: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 8 du salaire brut social imposable</p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                              <div>
                                <Label>Avantages en nature (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_nature} onChange={(e) => setEmployeeForm({...employeeForm, avantages_nature: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 9 - Logement, voiture, etc. (imposables)</p>
                              </div>
                              <div>
                                <Label>Avantages en argent (FCFA)</Label>
                                <Input type="number" value={employeeForm.avantages_argent} onChange={(e) => setEmployeeForm({...employeeForm, avantages_argent: e.target.value})} />
                                <p className="text-xs text-green-600 mt-1">Élément 10 - Diverses allocations (imposables)</p>
                              </div>
                            </div>
                            <FraisSelector salaryComponents={salaryComponents} employeeForm={employeeForm} setEmployeeForm={setEmployeeForm} />
                          </div>
                            <div className="mt-4">
                              <Label>Remboursement de frais (FCFA)</Label>
                              <Input type="number" value={employeeForm.remboursement_frais} onChange={(e) => setEmployeeForm({...employeeForm, remboursement_frais: e.target.value})} />
                              <p className="text-xs text-green-600 mt-1">💰 Totalement exonéré d'impôts et de cotisations sociales</p>
                              <p className="text-xs text-gray-500 mt-1">Exemple : Remboursement de frais réels engagés par le salarié</p>
                            </div>

                            {/* CMU - Couverture Maladie Universelle */}
                            <div className="mt-4 border rounded-lg p-4 bg-blue-50">
                              <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                                <span className="text-blue-600 mr-2">🏥</span>
                                CMU - Couverture Maladie Universelle
                              </h4>
                              
                              <div className="grid grid-cols-2 gap-4 mb-3">
                                <div>
                                  <Label>CMU Employeur (FCFA)</Label>
                                  <Input 
                                    type="number" 
                                    value={employeeForm.cmu_employeur} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, cmu_employeur: e.target.value})} 
                                    placeholder="500"
                                  />
                                </div>
                                <div>
                                  <Label>CMU Salarié (FCFA)</Label>
                                  <Input 
                                    type="number" 
                                    value={employeeForm.cmu_salarie} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, cmu_salarie: e.target.value})} 
                                    placeholder="500"
                                  />
                                </div>
                              </div>
                              
                              <div className="flex items-center space-x-2">
                                <input
                                  type="checkbox"
                                  id="cmu_active_edit"
                                  checked={employeeForm.cmu_active}
                                  onChange={(e) => setEmployeeForm({...employeeForm, cmu_active: e.target.checked})}
                                  className="rounded border-gray-300 focus:ring-blue-500"
                                />
                                <Label htmlFor="cmu_active_edit" className="text-sm font-medium text-gray-900 cursor-pointer">
                                  Activer l'impact CMU sur le salaire net (+50% du montant total)
                                </Label>
                              </div>
                              
                              <p className="text-xs text-blue-600 mt-2">
                                💡 Si activé, le salaire net augmentera de 50% du montant total CMU (Employeur + Salarié)
                              </p>
                              <p className="text-xs text-gray-500 mt-1">
                                Exemple : CMU 1000F (500F employeur + 500F salarié) → +500F au salaire net
                              </p>
                            </div>

                            {/* Autres retenues spécifiques à la Côte d'Ivoire */}
                            <div className="mt-4 border rounded-lg p-4 bg-yellow-50">
                              <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                                <span className="text-yellow-600 mr-2">📋</span>
                                Autres retenues - Réglementation ivoirienne
                              </h4>
                              
                              <div className="grid grid-cols-1 gap-4 mb-3">
                                <div className="grid grid-cols-2 gap-4">
                                  <div>
                                    <Label>Formation continue (FCFA) - Calculé automatiquement</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.formation_continue} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, formation_continue: e.target.value})} 
                                      placeholder="Calculé: 0.6% × salaire brut"
                                      disabled
                                      className="bg-gray-100"
                                    />
                                    <p className="text-xs text-blue-600 mt-1">⚡ Formation continue = Salaire brut imposable × 0.6%</p>
                                  </div>
                                  <div>
                                    <Label>Taxe d'apprentissage (FCFA) - Calculé automatiquement</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.taxe_apprentissage} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, taxe_apprentissage: e.target.value})} 
                                      placeholder="Calculé: 0.4% × salaire brut"
                                      disabled
                                      className="bg-gray-100"
                                    />
                                    <p className="text-xs text-blue-600 mt-1">⚡ Taxe d'apprentissage = Salaire brut imposable × 0.4%</p>
                                  </div>
                                </div>
                                
                                <div className="grid grid-cols-2 gap-4">
                                  <div>
                                    <Label>IS Patronal (FCFA) - Calculé automatiquement</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.is_patronal} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, is_patronal: e.target.value})} 
                                      placeholder="Calculé: 1.2% × salaire brut"
                                      disabled
                                      className="bg-gray-100"
                                    />
                                    <p className="text-xs text-blue-600 mt-1">⚡ IS patronal = Salaire brut imposable × 1.2%</p>
                                  </div>
                                  <div>
                                    <Label>IS Salarial (FCFA)</Label>
                                    <Input 
                                      type="number" 
                                      value={employeeForm.is_salarie} 
                                      onChange={(e) => setEmployeeForm({...employeeForm, is_salarie: e.target.value})} 
                                      placeholder="0"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">Impôt sur le traitement de salaire - Part salarié</p>
                                  </div>
                                </div>
                              </div>
                              
                              <p className="text-xs text-yellow-600 mt-2">
                                ℹ️ Ces retenues permettent de structurer les charges selon la réglementation ivoirienne
                              </p>
                            </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3">Consentements et Autorisations</h4>
                            <div className="space-y-3">
                              <div className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg">
                                <input
                                  type="checkbox"
                                  id="edit_gratification_consent"
                                  checked={employeeForm.gratification_display_consent}
                                  onChange={(e) => setEmployeeForm({...employeeForm, gratification_display_consent: e.target.checked})}
                                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                />
                                <label htmlFor="edit_gratification_consent" className="text-sm text-gray-900">
                                  <span className="font-medium">Autoriser l'affichage des gratifications sur les bulletins de paie</span>
                                  <p className="text-xs text-gray-600 mt-1">
                                    Si cette option est décochée, les gratifications n'apparaîtront pas sur les bulletins de paie générés.
                                  </p>
                                </label>
                              </div>

                              {/* Autorisation allocations familiales - Modification employé admin_single */}
                              <div className="flex items-start space-x-3 p-3 bg-blue-50 rounded-lg">
                                <input
                                  id="edit_allocations_familiales_consent_admin"
                                  type="checkbox"
                                  checked={employeeForm.allocations_familiales_consent}
                                  onChange={(e) => setEmployeeForm({...employeeForm, allocations_familiales_consent: e.target.checked})}
                                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                                />
                                <label htmlFor="edit_allocations_familiales_consent_admin" className="text-sm text-gray-900">
                                  <span className="font-medium">Autoriser les allocations familiales dans les calculs de paie</span>
                                  <p className="text-xs text-gray-600 mt-1">
                                    Si cette option est décochée, les allocations familiales (7,500 FCFA par enfant) ne seront pas incluses dans le calcul du salaire net.
                                  </p>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3">Éléments configurables</h4>
                            <div className="space-y-3">
                              <div>
                                <Label>Indemnités</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handleIndemniteChange}
                                  placeholder="Ajouter une indemnité"
                                  options={salaryComponents.filter(c => c.type === 'indemnite').map((comp) => ({
                                    value: comp.id,
                                    label: `${comp.name} - ${formatCurrency(comp.amount)} ${comp.is_taxable ? '(Imposable)' : '(Non-imposable)'}`
                                  }))}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {employeeForm.indemnites.map((indId) => {
                                    const comp = salaryComponents.find(c => c.id === indId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[indId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-indemnite-${indId}`} data-testid={`indemnite-card-${indId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemoveIndemnite(indId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`indemnite-amount-input-${indId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [indId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <div>
                                <Label>Primes</Label>
                                <SimpleNativeSelect
                                  value=""
                                  onValueChange={handlePrimeChange}
                                  placeholder="Ajouter une prime"
                                  options={salaryComponents.filter(c => c.type === 'prime').map((comp) => {
                                    // Afficher les informations d'exonération si disponibles
                                    const exemptionInfo = comp.exemption_info ? ` - ${comp.exemption_info}` : '';
                                    const taxableInfo = comp.is_taxable ? '(Imposable)' : '(Non-imposable)';
                                    return {
                                      value: comp.id,
                                      label: `${comp.name} - ${formatCurrency(comp.amount)}${exemptionInfo || ` ${taxableInfo}`}`
                                    };
                                  })}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {SPECIAL_EXEMPT_PRIMES.filter(sp => parseFloat(employeeForm[sp.field]) > 0).map((sp) => (
                                    <div key={`form-special-prime-${sp.field}`} data-testid={`special-prime-card-${sp.field}`} style={{ backgroundColor: '#f0fdf4', border: '2px solid #86efac', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#14532d' }}>{sp.label} <span style={{ fontWeight: 400, fontSize: '11px' }}>(exonérée plafonnée)</span></span>
                                        <button type="button" onClick={() => setEmployeeForm(prev => ({ ...prev, [sp.field]: 0 }))} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <input
                                          type="number"
                                          data-testid={`special-prime-amount-${sp.field}`}
                                          value={employeeForm[sp.field]}
                                          onChange={(e) => {
                                            const newAmount = parseFloat(e.target.value) || 0;
                                            setEmployeeForm(prev => ({ ...prev, [sp.field]: newAmount }));
                                          }}
                                          placeholder="0"
                                          style={{ flex: 1, padding: '4px 8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px', fontWeight: 600, color: '#14532d' }}
                                        />
                                        <span style={{ fontSize: '12px', color: '#15803d' }}>FCFA</span>
                                      </div>
                                      {(() => {
                                        const montant = parseFloat(employeeForm[sp.field]) || 0;
                                        const imposable = Math.max(0, montant - sp.plafond);
                                        return imposable > 0 ? (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#b45309', marginTop: '4px', fontWeight: 600 }}>
                                            ⚠️ Exonéré : {formatCurrency(sp.plafond)} • Imposable : {formatCurrency(imposable)}
                                          </p>
                                        ) : (
                                          <p data-testid={`special-prime-exemption-${sp.field}`} style={{ fontSize: '11px', color: '#15803d', marginTop: '4px' }}>
                                            ✓ Totalement exonérée (plafond : {formatCurrency(sp.plafond)})
                                          </p>
                                        );
                                      })()}
                                    </div>
                                  ))}
                                  {employeeForm.primes.map((primeId) => {
                                    const comp = salaryComponents.find(c => c.id === primeId);
                                    if (!comp) return null;
                                    const currentAmount = employeeForm.component_amounts?.[primeId] ?? comp.amount ?? 0;
                                    return (
                                      <div key={`form-prime-${primeId}`} data-testid={`prime-card-${primeId}`} style={{ backgroundColor: 'white', border: '1px solid #fde68a', borderRadius: '8px', padding: '8px 10px', minWidth: '240px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{comp.name}</span>
                                          <button type="button" onClick={() => handleRemovePrime(primeId)} style={{ backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>✕</button>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                          <input
                                            type="number"
                                            data-testid={`prime-amount-input-${primeId}`}
                                            value={currentAmount}
                                            onChange={(e) => {
                                              const newAmount = parseFloat(e.target.value) || 0;
                                              setEmployeeForm(prev => ({ ...prev, component_amounts: { ...prev.component_amounts, [primeId]: newAmount } }));
                                            }}
                                            placeholder="0"
                                            style={{ flex: 1, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px', fontWeight: 600 }}
                                          />
                                          <span style={{ fontSize: '12px', color: '#6b7280' }}>FCFA</span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

{/* Complément de retraite section removed */}

                              {/* Allocations spéciales Art. 116-1 intégrées dans Éléments configurables */}
                              <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #fde68a' }}>
                                <h4 style={{ fontSize: '15px', fontWeight: 600, color: '#78350f', marginBottom: '12px' }}>
                                  ⚖️ Allocations spéciales pour frais d'emploi (Art. 116-1 CGI)
                                </h4>
                                <p style={{ fontSize: '13px', color: '#78350f', marginBottom: '12px', backgroundColor: '#fef3c7', padding: '8px', borderRadius: '6px' }}>
                                  💡 Ces allocations bénéficient d'une exonération fiscale plafonnée à <strong>10% de la rémunération totale hors avantages</strong>. Le calcul est automatique lors de la paie.
                                </p>
                                <div>
                                  <Label style={{ color: '#78350f', fontWeight: 600 }}>
                                    Sélectionner une allocation spéciale
                                  </Label>
                                  <SimpleNativeSelect
                                    value=""
                                    onValueChange={handleComplementRetraiteChange}
                                    placeholder="Ajouter une allocation spéciale Art. 116-1"
                                    options={salaryComponents
                                      .filter(c => c.is_special_allowance === true)
                                      .map((comp) => ({
                                        value: comp.id,
                                        label: `${comp.name} - ${formatCurrency(comp.amount)}`
                                      }))}
                                  />
                                  <div className="flex flex-wrap gap-3 mt-3">
                                    {employeeForm.complement_retraite.map((compId) => {
                                      const comp = salaryComponents.find(c => c.id === compId);
                                      // Afficher uniquement les allocations spéciales dans cette section
                                      if (!comp || !comp.is_special_allowance) return null;
                                      
                                      const currentAmount = employeeForm.special_allowance_amounts?.[compId] || comp.amount || 0;
                                      
                                      return (
                                        <div 
                                          key={`edit-special-configurable-${compId}`}
                                          style={{
                                            backgroundColor: '#fffbeb',
                                            border: '2px solid #fde68a',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            minWidth: '280px'
                                          }}
                                        >
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#78350f' }}>
                                              ⚖️ {comp.name}
                                            </span>
                                            <button
                                              type="button"
                                              onClick={() => handleRemoveComplementRetraite(compId)}
                                              style={{
                                                backgroundColor: '#fee2e2',
                                                color: '#991b1b',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                              }}
                                            >
                                              ✕ Retirer
                                            </button>
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <label style={{ fontSize: '13px', color: '#78350f', fontWeight: '500', minWidth: '70px' }}>
                                              Montant:
                                            </label>
                                            <input
                                              type="number"
                                              value={currentAmount}
                                              onChange={(e) => {
                                                const newAmount = parseFloat(e.target.value) || 0;
                                                setEmployeeForm(prev => ({
                                                  ...prev,
                                                  special_allowance_amounts: {
                                                    ...prev.special_allowance_amounts,
                                                    [compId]: newAmount
                                                  }
                                                }));
                                              }}
                                              placeholder="0"
                                              style={{
                                                flex: 1,
                                                padding: '6px 10px',
                                                border: '1px solid #fde68a',
                                                borderRadius: '4px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#78350f'
                                              }}
                                            />
                                            <span style={{ fontSize: '13px', color: '#78350f', fontWeight: '500' }}>
                                              FCFA
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="border-t pt-4">
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Type de contrat</Label>
                                <SimpleNativeSelect
                                  value={employeeForm.contract_type} 
                                  onValueChange={handleContractTypeChange}
                                  placeholder="Sélectionner un type de contrat"
                                  options={[
                                    {value: 'CDI', label: 'CDI'},
                                    {value: 'CDD', label: 'CDD'},
                                    {value: 'Contrat d\'essai', label: 'Contrat d\'essai'},
                                    {value: 'Contrat journalier', label: 'Contrat journalier'},
                                    {value: 'Stage', label: 'Stage'}
                                  ]}
                                />
                              </div>
                              <div>
                                <Label>Date d'embauche</Label>
                                <Input type="date" required value={employeeForm.hire_date} onChange={(e) => setEmployeeForm({...employeeForm, hire_date: e.target.value})} />
                              </div>
                            </div>
                            <div className="mt-4">
                              <Label>Date de fin d'activité (optionnel)</Label>
                              <Input type="date" value={employeeForm.date_fin_activite} onChange={(e) => setEmployeeForm({...employeeForm, date_fin_activite: e.target.value})} />
                              <p className="text-xs text-blue-600 mt-1">⏹️ Laisser vide si l'employé est encore actif. Utilisé pour calculer l'ancienneté finale.</p>
                            </div>

                            {/* Section RICF - Réduction d'impôt pour charges de famille */}
                            <div className="mt-4 border rounded-lg p-4 bg-green-50">
                              <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                                <span className="text-green-600 mr-2">👨‍👩‍👧‍👦</span>
                                RICF - Réduction d'impôt pour charges de famille
                              </h4>
                              
                              <div className="grid grid-cols-1 gap-4 mb-3">
                                <div>
                                  <Label>Statut matrimonial</Label>
                                  <SimpleNativeSelect
                                  value={employeeForm.statut_matrimonial}
                                  onValueChange={handleStatutMatrimonialChange}
                                  placeholder="Statut matrimonial"
                                  options={[
                                    {value: 'celibataire', label: 'Célibataire'},
                                    {value: 'marie', label: 'Marié(e)'},
                                    {value: 'divorce', label: 'Divorcé(e)'},
                                    {value: 'veuf', label: 'Veuf/Veuve'}
                                  ]}
                                />
                                </div>
                              </div>
                              
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Nombre d'enfants à charge</Label>
                                  <Input 
                                    type="number" 
                                    min="0"
                                    value={employeeForm.nombre_enfants} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants: parseInt(e.target.value) || 0})} 
                                    placeholder="0"
                                  />
                                </div>
                                <div>
                                  <Label>Nombre d'enfants infirmes à charge</Label>
                                  <Input 
                                    type="number" 
                                    min="0"
                                    value={employeeForm.nombre_enfants_infirmes} 
                                    onChange={(e) => setEmployeeForm({...employeeForm, nombre_enfants_infirmes: parseInt(e.target.value) || 0})} 
                                    placeholder="0"
                                  />
                                  <p className="text-xs text-green-600 mt-1">⚖️ Les enfants infirmes comptent pour 1 part complète chacun</p>
                                </div>
                              </div>
                              
                              <p className="text-xs text-blue-600 mt-2">
                                💡 Ces informations déterminent le nombre de parts familiales pour le calcul de la RICF
                              </p>
                              <p className="text-xs text-gray-500 mt-1">
                                Exemple : Marié 2 enfants = 3 parts → 22,000 FCFA de réduction d'impôt mensuelle
                              </p>
                            </div>
                          </div>

                          {/* Section Photo d'employé - Modification */}
                          <div className="border-t pt-4">
                            <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                              <span className="text-blue-600 mr-2">📷</span>
                              Photo de l'employé
                            </h4>
                            <div className="space-y-3">
                              {editingEmployee?.photo_url ? (
                                <div className="space-y-3">
                                  {/* Photo actuelle */}
                                  <div className="flex items-center justify-center p-4 bg-gray-50 rounded-lg">
                                    <div className="text-center">
                                      <img 
                                        src={`${BACKEND_URL}${editingEmployee.photo_url}`}
                                        alt="Photo employé actuelle"
                                        className="w-24 h-24 object-cover rounded-lg mx-auto mb-2 border-2 border-gray-200"
                                        onError={(e) => {
                                          console.log('Erreur chargement photo:', editingEmployee.photo_url);
                                          e.target.src = '';
                                          e.target.style.display = 'none';
                                          const placeholder = e.target.parentNode.querySelector('.photo-placeholder');
                                          if (placeholder) placeholder.style.display = 'flex';
                                        }}
                                      />
                                      <div className="photo-placeholder w-24 h-24 bg-gray-100 rounded-lg mx-auto mb-2 border-2 border-gray-200 hidden items-center justify-center">
                                        <User className="w-12 h-12 text-gray-400" />
                                      </div>
                                      <p className="text-sm font-medium text-gray-700">Photo actuelle</p>
                                    </div>
                                  </div>
                                  
                                  <div className="flex space-x-2">
                                    <Button
                                      type="button"
                                      variant="outline"
                                      size="sm"
                                      onClick={() => handleDeletePhoto(editingEmployee.id)}
                                      disabled={deletingPhoto}
                                      className="flex-1"
                                    >
                                      {deletingPhoto ? (
                                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                      ) : (
                                        <Trash2 className="w-4 h-4 mr-2" />
                                      )}
                                      Supprimer
                                    </Button>
                                    <label 
                                      htmlFor="employee-photo-edit" 
                                      className="flex-1 cursor-pointer inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
                                    >
                                      <Plus className="w-4 h-4 mr-2" />
                                      Changer
                                    </label>
                                  </div>
                                </div>
                              ) : null}
                              
                              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-500 transition-colors">
                                <input
                                  type="file"
                                  id="employee-photo-edit"
                                  accept="image/png,image/jpeg,image/jpg,application/pdf"
                                  className="hidden"
                                  onChange={(e) => handlePhotoUpload(e, editingEmployee?.id)}
                                />
                                <label 
                                  htmlFor="employee-photo-edit" 
                                  className="cursor-pointer flex flex-col items-center space-y-2"
                                >
                                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                                    <Plus className="w-6 h-6 text-gray-400" />
                                  </div>
                                  <div>
                                    <p className="text-sm font-medium text-gray-700">
                                      {editingEmployee?.photo_url ? 'Changer la photo' : 'Ajouter une photo'}
                                    </p>
                                    <p className="text-xs text-gray-500">PNG, JPG, PDF - Max 5MB</p>
                                  </div>
                                </label>
                              </div>
                              
                              {uploadingPhoto && (
                                <div className="flex items-center space-x-2 p-2 bg-blue-50 rounded-lg">
                                  <Loader2 className="w-4 h-4 animate-spin text-blue-600" />
                                  <span className="text-sm text-blue-700">Upload en cours...</span>
                                </div>
                              )}
                            </div>
                          </div>
                          
                          <Button type="submit" className="w-full bg-orange-600 hover:bg-orange-700">Modifier l'employé</Button>
                        </form>
                      </DialogContent>
                    </Dialog>

                <div className="grid gap-4">
                  {employees.map((employee) => (
                    <Card key={employee.id} id={`employee-card-${employee.id}`} className={`bg-white ${employee.is_active === false ? 'opacity-60 border-red-200 border-2' : ''} ${highlightedEmployeeId === employee.id ? 'ring-4 ring-orange-400 border-orange-400' : ''}`}>
                      <CardContent className="p-6">
                        <div className="flex justify-between items-start">
                          {/* Badge Inactif si l'employé est désactivé */}
                          {employee.is_active === false && (
                            <div className="absolute top-2 left-2">
                              <Badge variant="destructive" className="text-xs">
                                <XCircle className="w-3 h-3 mr-1" />
                                Inactif
                              </Badge>
                            </div>
                          )}
                          <div className="flex space-x-4 flex-1">
                            {/* Photo de l'employé */}
                            <div className="flex-shrink-0">
                              {employee.photo_url ? (
                                <img 
                                  src={`${BACKEND_URL}${employee.photo_url}`}
                                  alt={`Photo de ${employee.first_name} ${employee.last_name}`}
                                  className="w-16 h-16 object-cover rounded-lg border-2 border-gray-200"
                                  onError={(e) => {
                                    console.log('Erreur chargement photo:', employee.photo_url);
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                              ) : null}
                              <div 
                                className={`w-16 h-16 bg-gray-100 rounded-lg border-2 border-gray-200 flex items-center justify-center ${employee.photo_url ? 'hidden' : 'flex'}`}
                                style={employee.photo_url ? {display: 'none'} : {display: 'flex'}}
                              >
                                <User className="w-8 h-8 text-gray-400" />
                              </div>
                            </div>
                            
                            {/* Informations de l'employé */}
                            <div className="flex-1">
                              <h3 className="font-semibold text-gray-900">
                                {employee.first_name} {employee.last_name}
                                <span className="ml-2 text-xs font-normal px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">
                                  {employee.sexe === 'F' ? '♀ F' : '♂ M'}
                                </span>
                              </h3>
                              <p className="text-gray-600">{employee.position}</p>
                              <div className="flex flex-wrap gap-2 mt-1">
                                {employee.matricule && (
                                  <p className="text-sm font-medium text-blue-600">📋 Matricule: {employee.matricule}</p>
                                )}
                                {employee.numero_cnps && (
                                  <p className="text-sm font-medium text-green-600">🏛️ N° CNPS: {employee.numero_cnps}</p>
                                )}
                              </div>
                              <p className="text-sm text-gray-500">{employee.email} • {employee.phone}</p>
                              <div className="text-sm text-gray-500 mt-1">
                                Ancienneté: {employee.anciennete_years || 0} an(s)
                                {employee.hire_date && (
                                  <span className="ml-3">• Embauché le: {new Date(employee.hire_date).toLocaleDateString('fr-FR')}</span>
                                )}
                              </div>
                              
                              {/* Informations famille RICF */}
                              {(employee.statut_matrimonial !== 'celibataire' || employee.nombre_enfants > 0 || employee.nombre_enfants_infirmes > 0) && (
                                <div className="text-sm text-green-600 mt-1">
                                  👨‍👩‍👧‍👦 {employee.statut_matrimonial === 'marie' ? 'Marié(e)' : 
                                       employee.statut_matrimonial === 'divorce' ? 'Divorcé(e)' : 
                                       employee.statut_matrimonial === 'veuf' ? 'Veuf/Veuve' : 'Célibataire'}
                                  {employee.nombre_enfants > 0 && ` • ${employee.nombre_enfants} enfant${employee.nombre_enfants > 1 ? 's' : ''}`}
                                  {employee.nombre_enfants_infirmes > 0 && ` • ${employee.nombre_enfants_infirmes} infirme${employee.nombre_enfants_infirmes > 1 ? 's' : ''}`}
                                </div>
                              )}
                              {(employee.indemnites?.length > 0 || employee.primes?.length > 0 || employee.complement_retraite?.length > 0) && (
                                <div className="mt-2 space-y-1">
                                  {employee.indemnites?.map((id) => (
                                    <Badge key={`indemnite-${employee.id}-${id}`} variant="outline" className="mr-1 text-xs">
                                      {getComponentName(id)}
                                    </Badge>
                                  ))}
                                  {employee.primes?.map((id) => (
                                    <Badge key={`prime-${employee.id}-${id}`} variant="outline" className="mr-1 text-xs">
                                      {getComponentName(id)}
                                    </Badge>
                                  ))}
                                  {employee.complement_retraite?.map((id) => {
                                    const comp = salaryComponents.find(c => c.id === id);
                                    // Si c'est une allocation spéciale, ne pas l'afficher ici (sera affiché ci-dessous avec montant)
                                    if (comp?.is_special_allowance) return null;
                                    return (
                                      <Badge key={`retraite-${employee.id}-${id}`} variant="outline" className="mr-1 text-xs">
                                        {getComponentName(id)}
                                      </Badge>
                                    );
                                  })}
                                </div>
                              )}
                              
                              {/* Allocations spéciales avec montants */}
                              {employee.complement_retraite?.some(id => {
                                const comp = salaryComponents.find(c => c.id === id);
                                return comp?.is_special_allowance;
                              }) && (
                                <div className="mt-2 p-2 bg-amber-50 border border-amber-200 rounded-md">
                                  <div className="text-xs font-semibold text-amber-900 mb-1">
                                    ⚖️ Allocations spéciales (Art. 116-1)
                                  </div>
                                  <div className="space-y-1">
                                    {employee.complement_retraite?.map((id) => {
                                      const comp = salaryComponents.find(c => c.id === id);
                                      if (!comp?.is_special_allowance) return null;
                                      
                                      const amount = employee.special_allowance_amounts?.[id] || comp.amount || 0;
                                      return (
                                        <div 
                                          key={`special-${employee.id}-${id}`}
                                          className="text-xs text-amber-900 flex justify-between items-center py-0.5"
                                        >
                                          <span className="font-medium">{comp.name}</span>
                                          <span className="font-bold">{formatCurrency(amount)}</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}

                              {/* Primes spéciales exonérées avec montants */}
                              {SPECIAL_EXEMPT_PRIMES.some(p => (employee[p.field] || 0) > 0) && (
                                <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md" data-testid={`special-primes-card-${employee.id}`}>
                                  <div className="text-xs font-semibold text-green-900 mb-1">
                                    ✅ Primes spéciales exonérées
                                  </div>
                                  <div className="space-y-1">
                                    {SPECIAL_EXEMPT_PRIMES.map((p) => {
                                      const amount = employee[p.field] || 0;
                                      if (amount <= 0) return null;
                                      return (
                                        <div
                                          key={`special-prime-${employee.id}-${p.field}`}
                                          className="text-xs text-green-900 flex justify-between items-center py-0.5"
                                          data-testid={`special-prime-line-${employee.id}-${p.field}`}
                                        >
                                          <span className="font-medium">{p.label}</span>
                                          <span className="font-bold">{formatCurrency(amount)}</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="text-right">
                            <div className="text-lg font-semibold text-gray-900">{formatCurrency(employee.salary_categoriel || employee.salary_base)}</div>
                            <div className="text-sm text-gray-600">Salaire catégoriel</div>
                            {(employee.sursalaire > 0 || employee.prime_transport > 0 || employee.avantages_nature > 0 || employee.avantages_argent > 0) && (
                              <div className="text-sm text-gray-500 mt-1 space-y-0.5">
                                {employee.sursalaire > 0 && <div>Sursalaire: {formatCurrency(employee.sursalaire)}</div>}
                                {employee.prime_transport > 0 && <div>Transport: {formatCurrency(employee.prime_transport)}</div>}
                                {employee.avantages_nature > 0 && <div>Avantages nature: {formatCurrency(employee.avantages_nature)}</div>}
                                {employee.avantages_argent > 0 && <div>Avantages argent: {formatCurrency(employee.avantages_argent)}</div>}
                              </div>
                            )}
                            <div className="flex items-center justify-end space-x-2 mt-3">
                              {/* Toggle Actif/Inactif */}
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleToggleEmployeeActive(employee)}
                                className={`text-xs ${employee.is_active !== false 
                                  ? 'border-green-300 text-green-700 hover:bg-green-50' 
                                  : 'border-red-300 text-red-700 hover:bg-red-50'}`}
                                title={employee.is_active !== false ? 'Cliquer pour désactiver' : 'Cliquer pour activer'}
                              >
                                {employee.is_active !== false ? (
                                  <>
                                    <ToggleRight className="w-4 h-4 mr-1" />
                                    Actif
                                  </>
                                ) : (
                                  <>
                                    <ToggleLeft className="w-4 h-4 mr-1" />
                                    Inactif
                                  </>
                                )}
                              </Button>
                              <Badge variant={employee.contract_type === 'CDI' ? 'default' : 'secondary'}>
                                {employee.contract_type}
                              </Badge>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => openAdminFolder(employee)}
                                className="text-xs border-purple-300 text-purple-700 hover:bg-purple-50"
                              >
                                <FileText className="w-3 h-3 mr-1" />
                                Dossier administratif
                              </Button>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => openDocumentsDialog(employee)}
                                className="text-xs border-sky-300 text-sky-700 hover:bg-sky-50"
                                data-testid={`documents-btn-${employee.id}`}
                              >
                                <FileText className="w-3 h-3 mr-1" />
                                Documents
                              </Button>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleEditEmployee(employee)}
                                className="text-xs"
                              >
                                <Edit className="w-3 h-3 mr-1" />
                                Modifier
                              </Button>
                              {/* Le bouton Supprimer n'est actif que pour les employés inactifs */}
                              <Button
                                variant="destructive"
                                size="sm"
                                onClick={() => handleDeleteEmployee(employee)}
                                className="text-xs"
                                disabled={employee.is_active !== false}
                                title={employee.is_active !== false 
                                  ? "Désactivez d'abord l'employé pour pouvoir le supprimer" 
                                  : "Supprimer définitivement cet employé"
                                }
                              >
                                <Trash2 className="w-3 h-3 mr-1" />
                                Supprimer
                              </Button>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>

                {/* Dialog Documents RH (Attestation / Certificat de travail) */}
                <Dialog open={!!documentsEmployee} onOpenChange={(open) => { if (!open) setDocumentsEmployee(null); }}>
                  <DialogContent style={{ maxWidth: '96vw', width: '96vw', height: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }} className="w-[96vw] max-w-[96vw] sm:max-w-[96vw] h-[92vh] flex flex-col overflow-hidden" data-testid="hr-documents-dialog">
                    <DialogHeader>
                      <DialogTitle>
                        Documents RH — {documentsEmployee?.first_name} {documentsEmployee?.last_name}
                      </DialogTitle>
                      <DialogDescription>
                        Générez une attestation ou un certificat de travail PDF (avec logo et référence automatique), signé par le gérant.
                      </DialogDescription>
                    </DialogHeader>
                    <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-6 overflow-hidden mt-2">
                      <div className="overflow-y-auto pr-2">
                    <div className="border rounded-md p-3 bg-gray-50 mt-2">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Signataire des documents *</h4>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <Label className="text-xs">Qualité</Label>
                          <select
                            value={hrSignatoryTitle}
                            onChange={(e) => setHrSignatoryTitle(e.target.value)}
                            data-testid="hr-signatory-title-select"
                            style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '13px', backgroundColor: 'white' }}
                          >
                            <option value="Représentant légal">Représentant légal</option>
                            <option value="Responsable Administratif et Financier">Responsable Administratif et Financier</option>
                            <option value="Responsable des Ressources Humaines">Responsable des Ressources Humaines</option>
                          </select>
                        </div>
                        <div>
                          <Label className="text-xs">Nom et prénoms *</Label>
                          <Input
                            value={hrSignatoryName}
                            onChange={(e) => setHrSignatoryName(e.target.value)}
                            placeholder="Ex: KOUASSI Jean-Marc"
                            data-testid="hr-signatory-name-input"
                          />
                        </div>
                      </div>
                      <p className="text-xs text-gray-500 mt-1">Ce signataire figurera sur le document (corps et signature) et sera mémorisé pour l'entreprise.</p>
                    </div>
                    <div className="grid grid-cols-2 gap-3 mt-2">
                      <Button
                        onClick={() => generateHrDocument('attestation')}
                        disabled={generatingDocType !== null}
                        className="bg-sky-600 hover:bg-sky-700 h-auto py-3 flex flex-col items-center"
                        data-testid="generate-attestation-btn"
                      >
                        {generatingDocType === 'attestation' ? <Loader2 className="w-5 h-5 animate-spin mb-1" /> : <FileText className="w-5 h-5 mb-1" />}
                        <span className="text-sm font-semibold">Attestation de travail</span>
                        <span className="text-xs opacity-80">Employé en poste</span>
                      </Button>
                      <Button
                        onClick={() => generateHrDocument('certificat')}
                        disabled={generatingDocType !== null}
                        className="bg-emerald-600 hover:bg-emerald-700 h-auto py-3 flex flex-col items-center"
                        data-testid="generate-certificat-btn"
                      >
                        {generatingDocType === 'certificat' ? <Loader2 className="w-5 h-5 animate-spin mb-1" /> : <FileText className="w-5 h-5 mb-1" />}
                        <span className="text-sm font-semibold">Certificat de travail</span>
                        <span className="text-xs opacity-80">Fin de contrat</span>
                      </Button>
                      <div className="col-span-2 border border-teal-200 bg-teal-50 rounded-md p-3">
                        <p className="text-sm font-semibold text-teal-800 mb-2">Attestation de congés</p>
                        <div className="grid grid-cols-2 gap-3 mb-2">
                          <div>
                            <Label className="text-xs">Début des congés</Label>
                            <Input type="date" value={hrCongesDebut} onChange={(e) => setHrCongesDebut(e.target.value)} data-testid="hr-conges-debut-input" />
                          </div>
                          <div>
                            <Label className="text-xs">Fin des congés (incluse)</Label>
                            <Input type="date" value={hrCongesFin} onChange={(e) => setHrCongesFin(e.target.value)} data-testid="hr-conges-fin-input" />
                          </div>
                          <div>
                            <Label className="text-xs">Montant congés (FCFA)</Label>
                            <Input type="number" min="0" placeholder="Ex: 150000" value={hrCongesMontant} onChange={(e) => setHrCongesMontant(e.target.value)} data-testid="hr-conges-montant-input" />
                          </div>
                        </div>
                        <Button
                          onClick={() => generateHrDocument('attestation_conges')}
                          disabled={generatingDocType !== null}
                          className="bg-teal-600 hover:bg-teal-700 w-full h-auto py-3 flex flex-col items-center"
                          data-testid="generate-attestation-conges-btn"
                        >
                          {generatingDocType === 'attestation_conges' ? <Loader2 className="w-5 h-5 animate-spin mb-1" /> : <FileText className="w-5 h-5 mb-1" />}
                          <span className="text-sm font-semibold">Attestation de congés</span>
                          <span className="text-xs opacity-80">Période de congé + date de reprise</span>
                        </Button>
                      </div>
                      <div className="col-span-2 border border-purple-200 bg-purple-50 rounded-md p-3">
                        <p className="text-sm font-semibold text-purple-800 mb-2">Attestation de gratification</p>
                        <div className="grid grid-cols-2 gap-3 mb-2">
                          <div>
                            <Label className="text-xs">Année</Label>
                            <Input type="number" value={hrGratifAnnee} onChange={(e) => setHrGratifAnnee(e.target.value)} data-testid="hr-gratif-annee-input" />
                          </div>
                          <div>
                            <Label className="text-xs">Montant (FCFA) — vide = 75% du salaire catégoriel</Label>
                            <Input type="number" value={hrGratifMontant} onChange={(e) => setHrGratifMontant(e.target.value)} placeholder="Automatique" data-testid="hr-gratif-montant-input" />
                          </div>
                        </div>
                        <Button
                          onClick={() => generateHrDocument('attestation_gratification')}
                          disabled={generatingDocType !== null}
                          className="bg-purple-600 hover:bg-purple-700 w-full h-auto py-3 flex flex-col items-center"
                          data-testid="generate-attestation-gratification-btn"
                        >
                          {generatingDocType === 'attestation_gratification' ? <Loader2 className="w-5 h-5 animate-spin mb-1" /> : <FileText className="w-5 h-5 mb-1" />}
                          <span className="text-sm font-semibold">Attestation de gratification</span>
                          <span className="text-xs opacity-80">Gratification annuelle du salarié</span>
                        </Button>
                      </div>
                      <Button
                        onClick={() => generateHrDocument('solde_tout_compte')}
                        disabled={generatingDocType !== null}
                        className="bg-amber-600 hover:bg-amber-700 h-auto py-3 flex flex-col items-center"
                        data-testid="generate-solde-btn"
                      >
                        {generatingDocType === 'solde_tout_compte' ? <Loader2 className="w-5 h-5 animate-spin mb-1" /> : <FileText className="w-5 h-5 mb-1" />}
                        <span className="text-sm font-semibold">Solde de tout compte</span>
                        <span className="text-xs opacity-80">Reçu de fin de contrat</span>
                      </Button>
                    </div>
                    {documentsEmployee && !documentsEmployee.date_fin_activite && (
                      <p className="text-xs text-amber-600 mt-1">
                        ℹ️ Pas de date de fin d'activité renseignée : le certificat utilisera la date du jour comme date de fin.
                      </p>
                    )}
                      </div>
                      <div className="flex flex-col overflow-hidden mt-4 lg:mt-0">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">Historique des documents générés</h4>
                      {hrDocsHistory.length === 0 ? (
                        <p className="text-sm text-gray-500">Aucun document généré pour cet employé.</p>
                      ) : (
                        <div className="flex-1 overflow-y-auto border rounded-md divide-y" data-testid="hr-documents-history">
                          {hrDocsHistory.map((d) => (
                            <div key={d.id} className="flex items-center justify-between px-3 py-2 text-sm">
                              <div>
                                <span className="font-mono font-semibold text-sky-700">{d.reference}</span>
                                <span className="ml-2 text-gray-600">{HR_DOC_LABELS[d.doc_type] || d.doc_type}</span>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-500">
                                  {new Date(d.generated_at).toLocaleDateString('fr-FR')} • {d.generated_by}
                                </span>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-7 px-2 text-xs"
                                  onClick={() => downloadHrDocument(d)}
                                  data-testid={`download-hr-doc-${d.reference}`}
                                >
                                  <Download className="w-3 h-3" />
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>

                {/* Pagination des employés */}
                {employeesPagination.total_pages > 1 && (
                  <div className="mt-6 flex items-center justify-between border-t pt-4">
                    <div className="text-sm text-gray-600">
                      Affichage de {((employeesPagination.page - 1) * employeesPagination.limit) + 1} à{' '}
                      {Math.min(employeesPagination.page * employeesPagination.limit, employeesPagination.total_count)} sur{' '}
                      {employeesPagination.total_count} employé(s)
                    </div>
                    <div className="flex items-center space-x-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => loadEmployees(true, 1)}
                        disabled={!employeesPagination.has_prev}
                        className="text-xs"
                      >
                        <ChevronLeft className="w-4 h-4 mr-1" />
                        Première
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => loadEmployees(true, employeesPagination.page - 1)}
                        disabled={!employeesPagination.has_prev}
                        className="text-xs"
                      >
                        <ChevronLeft className="w-4 h-4" />
                        Précédent
                      </Button>
                      <span className="text-sm font-medium text-gray-700 px-3">
                        Page {employeesPagination.page} sur {employeesPagination.total_pages}
                      </span>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => loadEmployees(true, employeesPagination.page + 1)}
                        disabled={!employeesPagination.has_next}
                        className="text-xs"
                      >
                        Suivant
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => loadEmployees(true, employeesPagination.total_pages)}
                        disabled={!employeesPagination.has_next}
                        className="text-xs"
                      >
                        Dernière
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </Button>
                    </div>
                  </div>
                )}

                {/* Vue plein écran pour les dossiers administratifs - Structure simple */}
                {isAdminFolderOpen && (
                  <div style={{ 
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 9999,
                    overflowY: 'auto'
                  }} className="bg-purple-50">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-purple-600 to-purple-700 text-white py-6 px-8 shadow-lg">
                      <Button
                        variant="ghost"
                        onClick={() => setIsAdminFolderOpen(false)}
                        className="mb-4 bg-white/20 hover:bg-white/30 text-white border-white/30"
                      >
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Retour
                      </Button>
                      
                      <div className="flex items-center gap-3">
                        <div className="bg-white/20 rounded-xl p-3 backdrop-blur">
                          <FileText className="w-8 h-8" />
                        </div>
                        <div>
                          <h1 className="text-3xl font-bold mb-1 drop-shadow">
                            Dossier administratif
                          </h1>
                          <p className="text-sm opacity-95">
                            {selectedEmployeeForAdmin?.first_name || ''} {selectedEmployeeForAdmin?.last_name || ''} - Gestion des contrats, demandes d'explication et sanctions disciplinaires
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    {/* Contenu */}
                    <div className="py-8 px-8 bg-purple-50">
                      <div className="bg-white rounded-2xl p-8 max-w-7xl mx-auto shadow-lg border border-gray-200">
                        {loadingAdminData ? (
                      <div className="flex justify-center items-center h-32">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
                        <span className="ml-2">Chargement du dossier...</span>
                      </div>
                    ) : (
                      <>
                      <Tabs value={adminFolderTab} onValueChange={setAdminFolderTab} className="w-full">
                        <TabsList className="grid w-full grid-cols-5 text-xs">
                          <TabsTrigger value="contracts" className="text-xs relative">
                            <FileText className="w-3 h-3 mr-1" />
                            <span className="hidden sm:inline">Contrats</span>
                            <span className="sm:hidden">Contr.</span>
                            {/* Indicateur d'alerte pour les contrats */}
                            {(() => {
                              const alertsCount = getContractAlertsCount();
                              if (alertsCount.expired > 0 || alertsCount.critical > 0) {
                                return (
                                  <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
                                );
                              } else if (alertsCount.warning > 0) {
                                return (
                                  <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-500 rounded-full"></span>
                                );
                              } else if (alertsCount.info > 0) {
                                return (
                                  <span className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full"></span>
                                );
                              }
                              return null;
                            })()}
                          </TabsTrigger>
                          <TabsTrigger value="explanations" className="text-xs">
                            <AlertTriangle className="w-3 h-3 mr-1" />
                            <span className="hidden sm:inline">Demandes d'explication</span>
                            <span className="sm:hidden">Explic.</span>
                          </TabsTrigger>
                          <TabsTrigger value="sanctions" className="text-xs">
                            <Shield className="w-3 h-3 mr-1" />
                            <span className="hidden sm:inline">Sanctions disciplinaires</span>
                            <span className="sm:hidden">Sanct.</span>
                          </TabsTrigger>
                          <TabsTrigger value="droits-legaux" className="text-xs">
                            <CheckCircle className="w-3 h-3 mr-1" />
                            <span className="hidden sm:inline">Droits légaux</span>
                            <span className="sm:hidden">Droits</span>
                          </TabsTrigger>
                          <TabsTrigger value="documents-sortie" className="text-xs">
                            <User className="w-3 h-3 mr-1" />
                            <span className="hidden sm:inline">Documents de sortie</span>
                            <span className="sm:hidden">Sortie</span>
                          </TabsTrigger>
                        </TabsList>

                        {/* Onglet Contrats */}
                        <TabsContent value="contracts" className="space-y-4 mt-6">
                          <div className="flex justify-between items-center">
                            <div className="flex items-center space-x-4">
                              <h3 className="text-lg font-semibold">Contrats de {selectedEmployeeForAdmin?.first_name}</h3>
                              {/* Affichage du résumé des alertes */}
                              {(() => {
                                const alertsCount = getContractAlertsCount();
                                if (alertsCount.total > 0) {
                                  return (
                                    <div className="flex items-center space-x-2">
                                      {alertsCount.expired > 0 && (
                                        <Badge variant="destructive" className="animate-pulse">
                                          🚨 {alertsCount.expired} expiré(s)
                                        </Badge>
                                      )}
                                      {alertsCount.critical > 0 && (
                                        <Badge variant="destructive">
                                          ⚠️ {alertsCount.critical} critique(s)
                                        </Badge>
                                      )}
                                      {alertsCount.warning > 0 && (
                                        <Badge variant="secondary" className="bg-yellow-100 text-yellow-800">
                                          ⏰ {alertsCount.warning} attention
                                        </Badge>
                                      )}
                                      {alertsCount.info > 0 && (
                                        <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
                                          📅 {alertsCount.info} à surveiller
                                        </Badge>
                                      )}
                                    </div>
                                  );
                                }
                                return null;
                              })()}
                            </div>
                            
                            <Button 
                              className="bg-purple-600 hover:bg-purple-700 active:scale-95 transition-all duration-150 shadow-md hover:shadow-lg"
                              onClick={() => {
                                console.log('🔘 Bouton Ajouter contrat cliqué');
                                setIsAddingContract(true);
                                // Petit délai pour le feedback visuel puis ouvrir le formulaire
                                setTimeout(() => {
                                  setIsNewContractOpen(true);
                                  setIsAddingContract(false);
                                }, 100);
                              }}
                              disabled={isAddingContract}
                              style={{ position: 'relative', zIndex: 10 }}
                            >
                              {isAddingContract ? (
                                <>
                                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
                                  Chargement...
                                </>
                              ) : (
                                <>
                                  <Plus className="w-4 h-4 mr-2" />
                                  Ajouter un contrat
                                </>
                              )}
                            </Button>
                          </div>
                            
                          {/* Vue plein écran - Nouveau contrat */}
                          {isNewContractOpen && (
                              <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: '#faf5ff',
                                zIndex: 99999,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                              }}>
                                {/* Header */}
                                <div style={{
                                  background: 'linear-gradient(135deg, #9333ea 0%, #7e22ce 100%)',
                                  color: 'white',
                                  padding: '24px 32px',
                                  boxShadow: '0 4px 20px rgba(147, 51, 234, 0.3)',
                                  flexShrink: 0
                                }}>
                                  <Button
                                    variant="ghost"
                                    onClick={() => setIsNewContractOpen(false)}
                                    style={{
                                      marginBottom: '16px',
                                      backgroundColor: 'rgba(255,255,255,0.2)',
                                      borderColor: 'rgba(255,255,255,0.3)',
                                      color: 'white',
                                      backdropFilter: 'blur(10px)'
                                    }}
                                  >
                                    <ArrowLeft className="w-4 h-4 mr-2" />
                                    Retour
                                  </Button>
                                  
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ 
                                      backgroundColor: 'rgba(255,255,255,0.2)',
                                      borderRadius: '12px',
                                      padding: '12px',
                                      backdropFilter: 'blur(10px)'
                                    }}>
                                      <Plus style={{ width: '32px', height: '32px' }} />
                                    </div>
                                    <div>
                                      <h1 style={{ 
                                        fontSize: '28px', 
                                        fontWeight: 700,
                                        marginBottom: '4px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                      }}>
                                        Nouveau contrat
                                      </h1>
                                      <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                        Ajouter un nouveau contrat pour {selectedEmployeeForAdmin?.first_name} {selectedEmployeeForAdmin?.last_name}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* Contenu scrollable */}
                                <div style={{ 
                                  flex: 1, 
                                  overflowY: 'auto', 
                                  padding: '32px',
                                  backgroundColor: '#faf5ff'
                                }}>
                                  <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '16px',
                                    padding: '32px',
                                    maxWidth: '800px',
                                    margin: '0 auto',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e5e7eb'
                                  }}>
                                    <form onSubmit={async (e) => {
                                  e.preventDefault();
                                  // Capturer l'ID de l'employé AVANT toute opération async pour éviter les problèmes de closure
                                  const currentEmployeeId = selectedEmployeeForAdmin?.id;
                                  if (!currentEmployeeId) {
                                    toast.error("Erreur: Aucun employé sélectionné");
                                    return;
                                  }
                                  
                                  const formData = new FormData(e.target);
                                  formData.append('employee_id', currentEmployeeId);
                                  
                                  try {
                                    console.log('🔄 Création du contrat en cours pour employé:', currentEmployeeId);
                                    
                                    // Créer le contrat (le rechargement se fait dans createContract)
                                    await createContract(formData, currentEmployeeId);
                                    
                                    // Reset du formulaire
                                    e.target.reset();
                                    
                                    // Forcer un rechargement explicite pour garantir la mise à jour de l'UI
                                    console.log('🔄 Rechargement final de la liste des contrats...');
                                    await loadEmployeeContracts(currentEmployeeId);
                                    
                                    // Fermer le modal APRÈS le rechargement complet
                                    setIsNewContractOpen(false);
                                    
                                    toast.success("Contrat ajouté avec succès !");
                                    console.log('✅ Contrat créé et liste mise à jour');
                                    
                                  } catch (error) {
                                    console.error('❌ Erreur lors de l\'ajout du contrat:', error);
                                    toast.error("Erreur lors de l'ajout du contrat");
                                  }
                                }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="contract_title">Titre du contrat</Label>
                                        <Input 
                                          id="contract_title" 
                                          name="title" 
                                          required 
                                          placeholder="Ex: CDI - Développeur Senior" 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <div>
                                        <Label htmlFor="contract_description">Description</Label>
                                        <textarea
                                          id="contract_description"
                                          name="description"
                                          className="w-full p-2 border rounded-md"
                                          rows="3"
                                          placeholder="Description du contrat..."
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        ></textarea>
                                      </div>
                                      <div className="grid grid-cols-2 gap-4">
                                        <div>
                                          <Label htmlFor="contract_start_date">Date de début</Label>
                                          <Input 
                                            id="contract_start_date" 
                                            name="start_date" 
                                            type="date" 
                                            style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                          />
                                        </div>
                                        <div>
                                          <Label htmlFor="contract_end_date">Date de fin</Label>
                                          <Input 
                                            id="contract_end_date" 
                                            name="end_date" 
                                            type="date" 
                                            style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <Label htmlFor="contract_file">Fichier du contrat</Label>
                                        <Input 
                                          id="contract_file" 
                                          name="file" 
                                          type="file" 
                                          required 
                                          accept=".pdf,.doc,.docx" 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <Button 
                                        type="submit" 
                                        className="w-full bg-purple-600 hover:bg-purple-700"
                                        style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                      >
                                        Ajouter le contrat
                                      </Button>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            )}

                          {/* Section d'alertes globales */}
                          {(() => {
                            const alertsCount = getContractAlertsCount();
                            if (alertsCount.total > 0) {
                              return (
                                <Card className="border-orange-200 bg-orange-50">
                                  <CardContent className="p-4">
                                    <div className="flex items-center space-x-2 mb-2">
                                      <AlertTriangle className="w-5 h-5 text-orange-600" />
                                      <h4 className="font-semibold text-orange-800">Alertes de fin de contrat</h4>
                                    </div>
                                    <div className="text-sm text-orange-700">
                                      {alertsCount.expired > 0 && (
                                        <p>🚨 <strong>{alertsCount.expired}</strong> contrat(s) expiré(s) nécessitent une action immédiate</p>
                                      )}
                                      {alertsCount.critical > 0 && (
                                        <p>⚠️ <strong>{alertsCount.critical}</strong> contrat(s) expire(nt) dans les 7 prochains jours</p>
                                      )}
                                      {alertsCount.warning > 0 && (
                                        <p>⏰ <strong>{alertsCount.warning}</strong> contrat(s) expire(nt) dans les 30 prochains jours</p>
                                      )}
                                      {alertsCount.info > 0 && (
                                        <p>📅 <strong>{alertsCount.info}</strong> contrat(s) expire(nt) dans les 60 prochains jours</p>
                                      )}
                                    </div>
                                  </CardContent>
                                </Card>
                              );
                            }
                            return null;
                          })()}

                          <div className="space-y-3">
                            {contracts.length === 0 ? (
                              <Card className="p-6 text-center text-gray-500">
                                <FileText className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                <p>Aucun contrat enregistré pour cet employé</p>
                              </Card>
                            ) : (
                              getContractsWithAlerts().map((contract) => (
                                <Card key={contract.id} className={`p-4 ${contract.alert ? 'border-l-4 ' + (
                                  contract.alert.type === 'expired' ? 'border-l-red-500' :
                                  contract.alert.type === 'critical' ? 'border-l-red-400' :
                                  contract.alert.type === 'warning' ? 'border-l-yellow-400' :
                                  'border-l-blue-400'
                                ) : ''}`}>
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      <div className="flex items-center space-x-2 mb-2">
                                        <h4 className="font-semibold text-gray-900">{contract.title}</h4>
                                        {contract.alert && (
                                          <div className={`px-2 py-1 rounded-full text-xs font-medium border ${contract.alert.color}`}>
                                            {contract.alert.icon} {contract.alert.message}
                                          </div>
                                        )}
                                      </div>
                                      {contract.description && (
                                        <p className="text-sm text-gray-600 mt-1">{contract.description}</p>
                                      )}
                                      <div className="flex items-center space-x-4 mt-2 text-sm text-gray-500">
                                        <span>📎 {contract.file_name}</span>
                                        <span>📅 Créé: {new Date(contract.created_at).toLocaleDateString('fr-FR')}</span>
                                        {contract.start_date && (
                                          <span>🚀 Début: {new Date(contract.start_date).toLocaleDateString('fr-FR')}</span>
                                        )}
                                        {contract.end_date && (
                                          <span className={contract.alert?.type === 'expired' || contract.alert?.type === 'critical' ? 'text-red-600 font-medium' : ''}>
                                            🏁 Fin: {new Date(contract.end_date).toLocaleDateString('fr-FR')}
                                          </span>
                                        )}
                                      </div>
                                      
                                      {/* Alerte détaillée pour les contrats critiques */}
                                      {contract.alert && (contract.alert.type === 'expired' || contract.alert.type === 'critical') && (
                                        <div className={`mt-3 p-3 rounded-lg ${
                                          contract.alert.type === 'expired' ? 'bg-red-50 border border-red-200' : 'bg-red-50 border border-red-200'
                                        }`}>
                                          <div className="flex items-center space-x-2">
                                            <div className="text-red-600">
                                              {contract.alert.type === 'expired' ? '🚨' : '⚠️'}
                                            </div>
                                            <div>
                                              <p className="text-sm font-medium text-red-800">
                                                {contract.alert.type === 'expired' ? 'Action requise : Contrat expiré' : 'Action requise : Expiration imminente'}
                                              </p>
                                              <p className="text-xs text-red-600 mt-1">
                                                {contract.alert.type === 'expired' 
                                                  ? 'Ce contrat a expiré et nécessite un renouvellement ou une régularisation immédiate.'
                                                  : 'Ce contrat expire bientôt. Préparez le renouvellement ou les démarches de fin de contrat.'
                                                }
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="flex space-x-2">
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        disabled={viewingContractId === contract.id}
                                        onClick={async () => {
                                          try {
                                            setViewingContractId(contract.id);
                                            toast.info('Chargement du document...', { duration: 2000 });
                                            
                                            const response = await fetch(`${BACKEND_URL}/api/download/contract/${contract.id}`, {
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`
                                              }
                                            });
                                            
                                            if (!response.ok) {
                                              const errorData = await response.json().catch(() => ({}));
                                              const errorMessage = errorData.detail || 'Fichier non disponible';
                                              toast.error(errorMessage);
                                              return;
                                            }
                                            
                                            const blob = await response.blob();
                                            const url = window.URL.createObjectURL(blob);
                                            
                                            // Ouvrir dans un nouvel onglet pour visualisation
                                            window.open(url, '_blank');
                                            
                                            // Nettoyer après un délai plus long
                                            setTimeout(() => {
                                              window.URL.revokeObjectURL(url);
                                            }, 60000);
                                            
                                            toast.success('Document ouvert');
                                          } catch (error) {
                                            console.error('Erreur:', error);
                                            toast.error('Erreur lors de l\'ouverture du fichier');
                                          } finally {
                                            setViewingContractId(null);
                                          }
                                        }}
                                        className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                      >
                                        {viewingContractId === contract.id ? (
                                          <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                        ) : (
                                          <Eye className="w-4 h-4 mr-1" />
                                        )}
                                        {viewingContractId === contract.id ? 'Chargement...' : 'Voir'}
                                      </Button>
                                      
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        disabled={downloadingContractId === contract.id}
                                        onClick={async () => {
                                          try {
                                            setDownloadingContractId(contract.id);
                                            
                                            const response = await fetch(`${BACKEND_URL}/api/download/contract/${contract.id}`, {
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`
                                              }
                                            });
                                            
                                            if (!response.ok) {
                                              const errorData = await response.json().catch(() => ({}));
                                              const errorMessage = errorData.detail || 'Fichier non disponible';
                                              toast.error(errorMessage);
                                              return;
                                            }
                                            
                                            const blob = await response.blob();
                                            const url = window.URL.createObjectURL(blob);
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.download = contract.file_name;
                                            document.body.appendChild(a);
                                            a.click();
                                            window.URL.revokeObjectURL(url);
                                            document.body.removeChild(a);
                                            toast.success('Fichier téléchargé avec succès');
                                          } catch (error) {
                                            console.error('Erreur:', error);
                                            toast.error('Erreur lors du téléchargement du fichier');
                                          } finally {
                                            setDownloadingContractId(null);
                                          }
                                        }}
                                        className="border-purple-300 text-purple-700 hover:bg-purple-50"
                                      >
                                        {downloadingContractId === contract.id ? (
                                          <>
                                            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                            Téléchargement...
                                          </>
                                        ) : (
                                          <>
                                            <Download className="w-4 h-4 mr-1" />
                                            Télécharger
                                          </>
                                        )}
                                      </Button>
                                      
                                      {/* Bouton d'action pour les contrats qui arrivent à expiration */}
                                      {contract.alert && contract.alert.type !== 'info' && (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          onClick={() => {
                                            // Ouvrir le formulaire de renouvellement
                                            toast.info("Fonctionnalité de renouvellement à implémenter");
                                          }}
                                          className={`${
                                            contract.alert.type === 'expired' || contract.alert.type === 'critical'
                                              ? 'border-red-300 text-red-700 hover:bg-red-50'
                                              : 'border-yellow-300 text-yellow-700 hover:bg-yellow-50'
                                          }`}
                                        >
                                          <RefreshCw className="w-4 h-4 mr-1" />
                                          {contract.alert.type === 'expired' ? 'Régulariser' : 'Renouveler'}
                                        </Button>
                                      )}
                                      
                                      <Button
                                        variant="destructive"
                                        size="sm"
                                        onClick={async () => {
                                          if (!window.confirm(`Êtes-vous sûr de vouloir supprimer le contrat "${contract.title}" ?`)) return;
                                          
                                          // Capturer l'ID avant l'opération async
                                          const currentEmployeeId = selectedEmployeeForAdmin?.id;
                                          if (!currentEmployeeId) {
                                            toast.error("Erreur: Aucun employé sélectionné");
                                            return;
                                          }
                                          
                                          try {
                                            const response = await fetch(`${BACKEND_URL}/api/contracts/${contract.id}`, {
                                              method: 'DELETE',
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`
                                              }
                                            });
                                            
                                            if (!response.ok) {
                                              throw new Error('Erreur lors de la suppression');
                                            }
                                            
                                            await loadEmployeeContracts(currentEmployeeId);
                                            toast.success('Contrat supprimé avec succès');
                                          } catch (error) {
                                            console.error('Erreur:', error);
                                            toast.error('Erreur lors de la suppression du contrat');
                                          }
                                        }}
                                      >
                                        <Trash2 className="w-4 h-4 mr-1" />
                                        Supprimer
                                      </Button>
                                    </div>
                                  </div>
                                </Card>
                              ))
                            )}
                          </div>
                        </TabsContent>

                        {/* Onglet Demandes d'explication */}
                        <TabsContent value="explanations" className="space-y-4 mt-6">
                          <div className="flex justify-between items-center">
                            <h3 className="text-lg font-semibold">Demandes d'explication</h3>
                            
                            <Button 
                              className="bg-orange-600 hover:bg-orange-700"
                              onClick={() => setIsNewExplanationOpen(true)}
                            >
                              <Plus className="w-4 h-4 mr-2" />
                              Nouvelle demande
                            </Button>
                            
                            {/* Vue plein écran - Nouvelle demande d'explication */}
                            {isNewExplanationOpen && (
                              <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: '#fff7ed',
                                zIndex: 99999,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                              }}>
                                {/* Header */}
                                <div style={{
                                  background: 'linear-gradient(135deg, #ea580c 0%, #c2410c 100%)',
                                  color: 'white',
                                  padding: '24px 32px',
                                  boxShadow: '0 4px 20px rgba(234, 88, 12, 0.3)',
                                  flexShrink: 0
                                }}>
                                  <Button
                                    variant="ghost"
                                    onClick={() => setIsNewExplanationOpen(false)}
                                    style={{
                                      marginBottom: '16px',
                                      backgroundColor: 'rgba(255,255,255,0.2)',
                                      borderColor: 'rgba(255,255,255,0.3)',
                                      color: 'white',
                                      backdropFilter: 'blur(10px)'
                                    }}
                                  >
                                    <ArrowLeft className="w-4 h-4 mr-2" />
                                    Retour
                                  </Button>
                                  
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ 
                                      backgroundColor: 'rgba(255,255,255,0.2)',
                                      borderRadius: '12px',
                                      padding: '12px',
                                      backdropFilter: 'blur(10px)'
                                    }}>
                                      <AlertTriangle style={{ width: '32px', height: '32px' }} />
                                    </div>
                                    <div>
                                      <h1 style={{ 
                                        fontSize: '28px', 
                                        fontWeight: 700,
                                        marginBottom: '4px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                      }}>
                                        Nouvelle demande d'explication
                                      </h1>
                                      <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                        Créer une demande d'explication pour {selectedEmployeeForAdmin?.first_name} {selectedEmployeeForAdmin?.last_name}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* Contenu scrollable */}
                                <div style={{ 
                                  flex: 1, 
                                  overflowY: 'auto', 
                                  padding: '32px',
                                  backgroundColor: '#fff7ed'
                                }}>
                                  <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '16px',
                                    padding: '32px',
                                    maxWidth: '800px',
                                    margin: '0 auto',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e5e7eb'
                                  }}>
                                    <form onSubmit={async (e) => {
                                  e.preventDefault();
                                  const formData = new FormData(e.target);
                                  formData.append('employee_id', selectedEmployeeForAdmin.id);
                                  try {
                                    await createExplanationRequest(formData);
                                    e.target.reset();
                                    setIsNewExplanationOpen(false);
                                    toast.success("Demande d'explication créée avec succès");
                                  } catch (error) {
                                    toast.error("Erreur lors de la création de la demande");
                                  }
                                }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="explanation_title">Titre de la demande</Label>
                                        <Input 
                                          id="explanation_title" 
                                          name="title" 
                                          required 
                                          placeholder="Ex: Absence non justifiée" 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <div>
                                        <Label htmlFor="explanation_description">Description détaillée</Label>
                                        <textarea
                                          id="explanation_description"
                                          name="description"
                                          className="w-full p-2 border rounded-md"
                                          rows="4"
                                          required
                                          placeholder="Décrivez les faits nécessitant une explication..."
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        ></textarea>
                                      </div>
                                      <div>
                                        <Label htmlFor="explanation_date">Date de la demande</Label>
                                        <Input 
                                          id="explanation_date" 
                                          name="request_date" 
                                          type="date" 
                                          required 
                                          defaultValue={new Date().toISOString().split('T')[0]} 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <div>
                                        <Label htmlFor="explanation_file">Pièce jointe (optionnel)</Label>
                                        <Input 
                                          id="explanation_file" 
                                          name="file" 
                                          type="file" 
                                          accept=".pdf,.doc,.docx,.jpg,.png" 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <Button 
                                        type="submit" 
                                        className="w-full bg-orange-600 hover:bg-orange-700"
                                        style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                      >
                                        Créer la demande
                                      </Button>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="space-y-3">
                            {explanationRequests.length === 0 ? (
                              <Card className="p-6 text-center text-gray-500">
                                <AlertTriangle className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                <p>Aucune demande d'explication pour cet employé</p>
                              </Card>
                            ) : (
                              explanationRequests.map((request) => (
                                <Card key={request.id} className="p-4">
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      <div className="flex items-center space-x-2">
                                        <h4 className="font-semibold text-gray-900">{request.title}</h4>
                                        <Badge variant={request.status === 'pending' ? 'destructive' : request.status === 'responded' ? 'secondary' : 'default'}>
                                          {request.status === 'pending' ? 'En attente' : request.status === 'responded' ? 'Répondu' : 'Fermé'}
                                        </Badge>
                                      </div>
                                      <p className="text-sm text-gray-600 mt-1">{request.description}</p>
                                      <div className="flex items-center space-x-4 mt-2 text-sm text-gray-500">
                                        <span>📅 Demande: {new Date(request.request_date).toLocaleDateString('fr-FR')}</span>
                                        {request.response_date && (
                                          <span>✅ Réponse: {new Date(request.response_date).toLocaleDateString('fr-FR')}</span>
                                        )}
                                        {request.file_name && (
                                          <span>📎 {request.file_name}</span>
                                        )}
                                      </div>
                                      {request.employee_response && (
                                        <div className="mt-3 p-3 bg-blue-50 rounded-lg">
                                          <p className="text-sm font-medium text-blue-800">Réponse de l'employé :</p>
                                          <p className="text-sm text-blue-700 mt-1">{request.employee_response}</p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="flex space-x-2">
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        data-testid={`explanation-pdf-btn-${request.id}`}
                                        onClick={async () => {
                                          try {
                                            const response = await axios.get(`${BACKEND_URL}/api/explanation-requests/${request.id}/pdf`, {
                                              responseType: 'blob',
                                              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                            });
                                            const blobUrl = URL.createObjectURL(response.data);
                                            const link = document.createElement('a');
                                            link.href = blobUrl;
                                            link.download = `Demande_Explication_${request.title.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                            URL.revokeObjectURL(blobUrl);
                                            toast.success('PDF de la demande téléchargé');
                                          } catch (error) {
                                            console.error('Erreur PDF demande:', error);
                                            toast.error('Erreur lors de la génération du PDF');
                                          }
                                        }}
                                        className="border-orange-300 text-orange-700 hover:bg-orange-50"
                                      >
                                        <FileText className="w-4 h-4 mr-1" />
                                        PDF
                                      </Button>
                                      {!request.response_file_name ? (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          data-testid={`explanation-response-upload-btn-${request.id}`}
                                          onClick={() => {
                                            const input = document.createElement('input');
                                            input.type = 'file';
                                            input.accept = '.pdf,.jpg,.jpeg,.png,.webp';
                                            input.onchange = async (e) => {
                                              const f = e.target.files[0];
                                              if (!f) return;
                                              const fd = new FormData();
                                              fd.append('file', f);
                                              try {
                                                await axios.post(`${BACKEND_URL}/api/explanation-requests/${request.id}/response-file`, fd, {
                                                  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                                });
                                                toast.success("Réponse de l'employé(e) enregistrée");
                                                await loadEmployeeExplanationRequests(selectedEmployeeForAdmin.id);
                                              } catch (error) {
                                                console.error('Erreur upload réponse:', error);
                                                toast.error(error.response?.data?.detail || "Erreur lors de l'enregistrement de la réponse");
                                              }
                                            };
                                            input.click();
                                          }}
                                          className="border-green-300 text-green-700 hover:bg-green-50"
                                        >
                                          <Upload className="w-4 h-4 mr-1" />
                                          Réponse de l'employé(e)
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          data-testid={`explanation-response-view-btn-${request.id}`}
                                          onClick={async () => {
                                            try {
                                              const response = await axios.get(`${BACKEND_URL}/api/download/explanation-response/${request.id}`, {
                                                responseType: 'blob',
                                                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                              });
                                              const url = URL.createObjectURL(response.data);
                                              window.open(url, '_blank');
                                              setTimeout(() => URL.revokeObjectURL(url), 5000);
                                            } catch (error) {
                                              console.error('Erreur ouverture réponse:', error);
                                              toast.error("Erreur lors de l'ouverture de la réponse");
                                            }
                                          }}
                                          className="border-green-300 text-green-700 hover:bg-green-50"
                                        >
                                          <Eye className="w-4 h-4 mr-1" />
                                          Voir la réponse
                                        </Button>
                                      )}
                                      {request.file_name && (
                                        <>
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            onClick={async () => {
                                              try {
                                                const response = await fetch(`${BACKEND_URL}/api/download/explanation/${request.id}`, {
                                                  headers: {
                                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                  }
                                                });
                                                
                                                if (!response.ok) {
                                                  throw new Error('Erreur lors de l\'ouverture');
                                                }
                                                
                                                const blob = await response.blob();
                                                const url = window.URL.createObjectURL(blob);
                                                window.open(url, '_blank');
                                                setTimeout(() => {
                                                  window.URL.revokeObjectURL(url);
                                                }, 100);
                                                toast.success('Fichier ouvert dans un nouvel onglet');
                                              } catch (error) {
                                                console.error('Erreur:', error);
                                                toast.error('Erreur lors de l\'ouverture du fichier');
                                              }
                                            }}
                                            className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                          >
                                            <Eye className="w-4 h-4 mr-1" />
                                            Voir
                                          </Button>
                                          
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            disabled={downloadingExplanationId === request.id}
                                            onClick={async () => {
                                              try {
                                                setDownloadingExplanationId(request.id);
                                                const response = await fetch(`${BACKEND_URL}/api/download/explanation/${request.id}`, {
                                                  headers: {
                                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                  }
                                                });
                                                
                                                if (!response.ok) {
                                                  throw new Error('Erreur lors du téléchargement');
                                                }
                                                
                                                const blob = await response.blob();
                                                const url = window.URL.createObjectURL(blob);
                                                const a = document.createElement('a');
                                                a.href = url;
                                                a.download = request.file_name;
                                                document.body.appendChild(a);
                                                a.click();
                                                window.URL.revokeObjectURL(url);
                                                document.body.removeChild(a);
                                                toast.success('Fichier téléchargé avec succès');
                                              } catch (error) {
                                                console.error('Erreur:', error);
                                                toast.error('Erreur lors du téléchargement du fichier');
                                              } finally {
                                                setDownloadingExplanationId(null);
                                              }
                                            }}
                                            className="border-orange-300 text-orange-700 hover:bg-orange-50"
                                          >
                                            {downloadingExplanationId === request.id ? (
                                              <>
                                                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                                Téléchargement...
                                              </>
                                            ) : (
                                              <>
                                                <Download className="w-4 h-4 mr-1" />
                                                Télécharger
                                              </>
                                            )}
                                          </Button>
                                        </>
                                      )}
                                      
                                      <Button
                                        variant="destructive"
                                        size="sm"
                                        onClick={async () => {
                                          if (!window.confirm(`Êtes-vous sûr de vouloir supprimer la demande "${request.title}" ?`)) return;
                                          
                                          try {
                                            const response = await fetch(`${BACKEND_URL}/api/explanation-requests/${request.id}`, {
                                              method: 'DELETE',
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`
                                              }
                                            });
                                            
                                            if (!response.ok) {
                                              throw new Error('Erreur lors de la suppression');
                                            }
                                            
                                            await loadEmployeeExplanationRequests(selectedEmployeeForAdmin.id);
                                            toast.success('Demande d\'explication supprimée avec succès');
                                          } catch (error) {
                                            console.error('Erreur:', error);
                                            toast.error('Erreur lors de la suppression de la demande');
                                          }
                                        }}
                                      >
                                        <Trash2 className="w-4 h-4 mr-1" />
                                        Supprimer
                                      </Button>
                                    </div>
                                  </div>
                                </Card>
                              ))
                            )}
                          </div>
                        </TabsContent>

                        {/* Onglet Sanctions disciplinaires */}
                        <TabsContent value="sanctions" className="space-y-4 mt-6">
                          <div className="flex justify-between items-center">
                            <h3 className="text-lg font-semibold">Sanctions disciplinaires</h3>
                            
                            <Button 
                              className="bg-red-600 hover:bg-red-700"
                              onClick={() => setIsNewSanctionOpen(true)}
                            >
                              <Plus className="w-4 h-4 mr-2" />
                              Nouvelle sanction
                            </Button>
                            
                            {/* Vue plein écran - Nouvelle sanction disciplinaire */}
                            {isNewSanctionOpen && (
                              <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: '#fef2f2',
                                zIndex: 99999,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                              }}>
                                {/* Header */}
                                <div style={{
                                  background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                                  color: 'white',
                                  padding: '24px 32px',
                                  boxShadow: '0 4px 20px rgba(220, 38, 38, 0.3)',
                                  flexShrink: 0
                                }}>
                                  <Button
                                    variant="ghost"
                                    onClick={() => setIsNewSanctionOpen(false)}
                                    style={{
                                      marginBottom: '16px',
                                      backgroundColor: 'rgba(255,255,255,0.2)',
                                      borderColor: 'rgba(255,255,255,0.3)',
                                      color: 'white',
                                      backdropFilter: 'blur(10px)'
                                    }}
                                  >
                                    <ArrowLeft className="w-4 h-4 mr-2" />
                                    Retour
                                  </Button>
                                  
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ 
                                      backgroundColor: 'rgba(255,255,255,0.2)',
                                      borderRadius: '12px',
                                      padding: '12px',
                                      backdropFilter: 'blur(10px)'
                                    }}>
                                      <Shield style={{ width: '32px', height: '32px' }} />
                                    </div>
                                    <div>
                                      <h1 style={{ 
                                        fontSize: '28px', 
                                        fontWeight: 700,
                                        marginBottom: '4px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                      }}>
                                        Nouvelle sanction disciplinaire
                                      </h1>
                                      <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                        Créer une sanction disciplinaire pour {selectedEmployeeForAdmin?.first_name} {selectedEmployeeForAdmin?.last_name}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* Contenu scrollable */}
                                <div style={{ 
                                  flex: 1, 
                                  overflowY: 'auto', 
                                  padding: '32px',
                                  backgroundColor: '#fef2f2'
                                }}>
                                  <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '16px',
                                    padding: '32px',
                                    maxWidth: '800px',
                                    margin: '0 auto',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e5e7eb'
                                  }}>
                                    <form onSubmit={async (e) => {
                                  e.preventDefault();
                                  const formData = new FormData(e.target);
                                  const sanctionData = {
                                    employee_id: selectedEmployeeForAdmin.id,
                                    sanction_type: formData.get('sanction_type'),
                                    title: formData.get('title'),
                                    description: formData.get('description'),
                                    sanction_date: formData.get('sanction_date'),
                                    start_date: formData.get('start_date') || null,
                                    end_date: formData.get('end_date') || null,
                                    days_count: formData.get('days_count') ? parseInt(formData.get('days_count')) : null
                                  };
                                  try {
                                    await createDisciplinarySanction(sanctionData);
                                    e.target.reset();
                                    setIsNewSanctionOpen(false);
                                    toast.success("Sanction disciplinaire créée avec succès");
                                  } catch (error) {
                                    toast.error("Erreur lors de la création de la sanction");
                                  }
                                }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="sanction_type">Type de sanction</Label>
                                        <select
                                        name="sanction_type"
                                        required
                                        className="flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-white px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:cursor-not-allowed disabled:opacity-50 appearance-none cursor-pointer"
                                        style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                      >
                                        <option value="" disabled>Sélectionner le type de sanction</option>
                                        <option value="avertissement">Avertissement</option>
                                        <option value="mise_a_pied_1_3">Mise à pied de 1 à 3 jours</option>
                                        <option value="mise_a_pied_4_8">Mise à pied de 4 à 8 jours</option>
                                        <option value="licenciement">Licenciement</option>
                                      </select>
                                      </div>
                                      <div>
                                        <Label htmlFor="sanction_title">Titre</Label>
                                        <Input 
                                          id="sanction_title" 
                                          name="title" 
                                          required 
                                          placeholder="Ex: Retards répétés" 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <div>
                                        <Label htmlFor="sanction_description">Description</Label>
                                        <textarea
                                          id="sanction_description"
                                          name="description"
                                          className="w-full p-2 border rounded-md"
                                          rows="3"
                                          required
                                          placeholder="Détails de la sanction et des faits reprochés..."
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        ></textarea>
                                      </div>
                                      <div>
                                        <Label htmlFor="sanction_date">Date de la sanction</Label>
                                        <Input 
                                          id="sanction_date" 
                                          name="sanction_date" 
                                          type="date" 
                                          required 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <div className="grid grid-cols-2 gap-4">
                                        <div>
                                          <Label htmlFor="sanction_start_date">Date de début (mise à pied)</Label>
                                          <Input 
                                            id="sanction_start_date" 
                                            name="start_date" 
                                            type="date" 
                                            style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                          />
                                        </div>
                                        <div>
                                          <Label htmlFor="sanction_end_date">Date de fin (mise à pied)</Label>
                                          <Input 
                                            id="sanction_end_date" 
                                            name="end_date" 
                                            type="date" 
                                            style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <Label htmlFor="sanction_days">Nombre de jours (mise à pied)</Label>
                                        <Input 
                                          id="sanction_days" 
                                          name="days_count" 
                                          type="number" 
                                          min="1" 
                                          max="8" 
                                          style={{ pointerEvents: 'auto', userSelect: 'auto' }}
                                        />
                                      </div>
                                      <Button 
                                        type="submit" 
                                        className="w-full bg-red-600 hover:bg-red-700"
                                        style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                      >
                                        Créer la sanction
                                      </Button>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="space-y-3">
                            {disciplinarySanctions.length === 0 ? (
                              <Card className="p-6 text-center text-gray-500">
                                <Shield className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                <p>Aucune sanction disciplinaire pour cet employé</p>
                              </Card>
                            ) : (
                              disciplinarySanctions.map((sanction) => (
                                <Card key={sanction.id} className="p-4">
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      <div className="flex items-center space-x-2">
                                        <h4 className="font-semibold text-gray-900">{sanction.title}</h4>
                                        <Badge variant={
                                          sanction.sanction_type === 'avertissement' ? 'secondary' :
                                          sanction.sanction_type === 'mise_a_pied_1_3' ? 'default' :
                                          sanction.sanction_type === 'mise_a_pied_4_8' ? 'destructive' :
                                          'destructive'
                                        }>
                                          {sanction.sanction_type === 'avertissement' ? 'Avertissement' :
                                           sanction.sanction_type === 'mise_a_pied_1_3' ? 'Mise à pied 1-3j' :
                                           sanction.sanction_type === 'mise_a_pied_4_8' ? 'Mise à pied 4-8j' :
                                           'Licenciement'}
                                        </Badge>
                                        {sanction.is_executed && (
                                          <Badge variant="outline" className="text-green-600 border-green-600">
                                            Exécutée
                                          </Badge>
                                        )}
                                      </div>
                                      <p className="text-sm text-gray-600 mt-1">{sanction.description}</p>
                                      <div className="flex items-center space-x-4 mt-2 text-sm text-gray-500">
                                        <span>📅 Sanction: {new Date(sanction.sanction_date).toLocaleDateString('fr-FR')}</span>
                                        {sanction.start_date && sanction.end_date && (
                                          <span>⏰ Du {new Date(sanction.start_date).toLocaleDateString('fr-FR')} au {new Date(sanction.end_date).toLocaleDateString('fr-FR')}</span>
                                        )}
                                        {sanction.days_count && (
                                          <span>🗓️ {sanction.days_count} jour(s)</span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex space-x-2">
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        data-testid={`sanction-pdf-btn-${sanction.id}`}
                                        onClick={async () => {
                                          try {
                                            const response = await axios.get(`${BACKEND_URL}/api/disciplinary-sanctions/${sanction.id}/pdf`, {
                                              responseType: 'blob',
                                              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                            });
                                            const blobUrl = URL.createObjectURL(response.data);
                                            const link = document.createElement('a');
                                            link.href = blobUrl;
                                            link.download = `Sanction_${sanction.title.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                            URL.revokeObjectURL(blobUrl);
                                            toast.success('PDF de la sanction téléchargé');
                                          } catch (error) {
                                            console.error('Erreur PDF sanction:', error);
                                            toast.error('Erreur lors de la génération du PDF');
                                          }
                                        }}
                                        className="border-orange-300 text-orange-700 hover:bg-orange-50"
                                      >
                                        <FileText className="w-4 h-4 mr-1" />
                                        PDF
                                      </Button>
                                      {!sanction.ack_file_name ? (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          data-testid={`sanction-ack-upload-btn-${sanction.id}`}
                                          onClick={() => {
                                            const input = document.createElement('input');
                                            input.type = 'file';
                                            input.accept = '.pdf,.jpg,.jpeg,.png,.webp';
                                            input.onchange = async (e) => {
                                              const f = e.target.files[0];
                                              if (!f) return;
                                              const fd = new FormData();
                                              fd.append('file', f);
                                              try {
                                                await axios.post(`${BACKEND_URL}/api/disciplinary-sanctions/${sanction.id}/ack-file`, fd, {
                                                  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                                });
                                                toast.success('Accusé de réception enregistré');
                                                await loadEmployeeDisciplinarySanctions(selectedEmployeeForAdmin.id);
                                              } catch (error) {
                                                console.error('Erreur upload accusé:', error);
                                                toast.error(error.response?.data?.detail || "Erreur lors de l'enregistrement de l'accusé de réception");
                                              }
                                            };
                                            input.click();
                                          }}
                                          className="border-green-300 text-green-700 hover:bg-green-50"
                                        >
                                          <Upload className="w-4 h-4 mr-1" />
                                          Accusé de réception signé
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          data-testid={`sanction-ack-view-btn-${sanction.id}`}
                                          onClick={async () => {
                                            try {
                                              const response = await axios.get(`${BACKEND_URL}/api/download/sanction-ack/${sanction.id}`, {
                                                responseType: 'blob',
                                                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                              });
                                              const url = URL.createObjectURL(response.data);
                                              window.open(url, '_blank');
                                              setTimeout(() => URL.revokeObjectURL(url), 5000);
                                            } catch (error) {
                                              console.error('Erreur ouverture accusé:', error);
                                              toast.error("Erreur lors de l'ouverture de l'accusé de réception");
                                            }
                                          }}
                                          className="border-green-300 text-green-700 hover:bg-green-50"
                                        >
                                          <Eye className="w-4 h-4 mr-1" />
                                          Voir l'accusé signé
                                        </Button>
                                      )}
                                      {!sanction.is_executed && (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          onClick={async () => {
                                            try {
                                              await axios.put(`${BACKEND_URL}/api/disciplinary-sanctions/${sanction.id}/execute`, {});
                                              await loadEmployeeDisciplinarySanctions(selectedEmployeeForAdmin.id);
                                              toast.success("Sanction marquée comme exécutée");
                                            } catch (error) {
                                              toast.error("Erreur lors de l'exécution de la sanction");
                                            }
                                          }}
                                          className="border-green-300 text-green-700 hover:bg-green-50"
                                        >
                                          <CheckCircle className="w-4 h-4 mr-1" />
                                          Marquer exécutée
                                        </Button>
                                      )}
                                      
                                      <Button
                                        variant="destructive"
                                        size="sm"
                                        onClick={async () => {
                                          if (!window.confirm(`Êtes-vous sûr de vouloir supprimer la sanction "${sanction.title}" ?`)) return;
                                          
                                          try {
                                            const response = await fetch(`${BACKEND_URL}/api/disciplinary-sanctions/${sanction.id}`, {
                                              method: 'DELETE',
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`
                                              }
                                            });
                                            
                                            if (!response.ok) {
                                              throw new Error('Erreur lors de la suppression');
                                            }
                                            
                                            await loadEmployeeDisciplinarySanctions(selectedEmployeeForAdmin.id);
                                            toast.success('Sanction supprimée avec succès');
                                          } catch (error) {
                                            console.error('Erreur:', error);
                                            toast.error('Erreur lors de la suppression de la sanction');
                                          }
                                        }}
                                      >
                                        <Trash2 className="w-4 h-4 mr-1" />
                                        Supprimer
                                      </Button>
                                    </div>
                                  </div>
                                </Card>
                              ))
                            )}
                          </div>
                        </TabsContent>

                        {/* Onglet Droits légaux avec sous-sections */}
                        <TabsContent value="droits-legaux" className="space-y-4 mt-6">
                          <div className="bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-lg border-l-4 border-green-500">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                              Droits légaux de {selectedEmployeeForAdmin?.first_name}
                            </h3>
                            <p className="text-sm text-gray-600">
                              Gestion des gratifications et congés de l'employé
                            </p>
                          </div>
                          
                          <Tabs value={droitsLegauxTab} onValueChange={setDroitsLegauxTab} className="w-full">
                            <TabsList className="grid w-full grid-cols-3">
                              <TabsTrigger value="gratifications" className="text-sm">
                                <TrendingUp className="w-4 h-4 mr-2" />
                                Gratifications
                              </TabsTrigger>
                              <TabsTrigger value="conges" className="text-sm">
                                <Clock className="w-4 h-4 mr-2" />
                                Congés
                              </TabsTrigger>
                              <TabsTrigger value="bulletins-emarges" className="text-sm">
                                <FileText className="w-4 h-4 mr-2" />
                                Bulletins émargés
                              </TabsTrigger>
                            </TabsList>

                            {/* Sous-onglet Gratifications */}
                            <TabsContent value="gratifications" className="space-y-4 mt-6">
                              <div className="flex justify-between items-center">
                                <h4 className="text-md font-semibold">Gratifications</h4>
                                <Dialog open={isNewGratificationOpen} onOpenChange={setIsNewGratificationOpen}>
                                  <DialogTrigger asChild>
                                    <Button className="bg-green-600 hover:bg-green-700">
                                      <Plus className="w-4 h-4 mr-2" />
                                      Ajouter une gratification
                                    </Button>
                                  </DialogTrigger>
                                  <DialogContent>
                                    <DialogHeader>
                                      <DialogTitle>Nouvelle gratification</DialogTitle>
                                      <DialogDescription>Ajouter un document de gratification</DialogDescription>
                                    </DialogHeader>
                                    <form onSubmit={async (e) => {
                                      e.preventDefault();
                                      const formData = new FormData(e.target);
                                      formData.append('employee_id', selectedEmployeeForAdmin.id);
                                      formData.append('document_type', 'gratifications');
                                      try {
                                        await uploadDocument(formData, 'gratifications');
                                        toast.success('Gratification ajoutée avec succès');
                                        e.target.reset();
                                      } catch (error) {
                                        toast.error('Erreur lors de l\'ajout de la gratification');
                                      }
                                    }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="gratification-title">Titre</Label>
                                        <Input id="gratification-title" name="title" placeholder="Ex: Prime de performance Q1 2024" required />
                                      </div>
                                      <div>
                                        <Label htmlFor="gratification-description">Description</Label>
                                        <Input id="gratification-description" name="description" placeholder="Description de la gratification" />
                                      </div>
                                      <div>
                                        <Label htmlFor="gratification-amount">Montant (F CFA)</Label>
                                        <Input id="gratification-amount" name="amount" type="number" placeholder="100000" />
                                      </div>
                                      <div>
                                        <Label htmlFor="gratification-file">Document (PDF)</Label>
                                        <Input id="gratification-file" name="file" type="file" accept=".pdf" required />
                                      </div>
                                      <div>
                                        <Label htmlFor="gratification-date">Date de gratification</Label>
                                        <Input id="gratification-date" name="date_gratification" type="date" required />
                                      </div>
                                      <div className="flex justify-end space-x-2">
                                        <DialogTrigger asChild>
                                          <Button type="button" variant="outline">Annuler</Button>
                                        </DialogTrigger>
                                        <Button type="submit" className="bg-green-600 hover:bg-green-700">Ajouter</Button>
                                      </div>
                                    </form>
                                  </DialogContent>
                                </Dialog>
                              </div>
                              <div className="space-y-3">
                                {gratifications.length === 0 ? (
                                  <Card className="p-6 text-center text-gray-500">
                                    <TrendingUp className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                    <p>Aucune gratification enregistrée</p>
                                  </Card>
                                ) : (
                                  gratifications.map((gratification) => (
                                    <Card key={gratification.id} className="p-4">
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <h4 className="font-semibold text-green-800">{gratification.title}</h4>
                                          {gratification.description && (
                                            <p className="text-sm text-gray-600 mt-1">{gratification.description}</p>
                                          )}
                                          {gratification.amount && (
                                            <p className="text-lg font-bold text-green-600 mt-2">{parseInt(gratification.amount).toLocaleString()} F CFA</p>
                                          )}
                                          <div className="flex items-center text-sm text-gray-500 mt-2">
                                            <Clock className="w-4 h-4 mr-1" />
                                            Date: {new Date(gratification.date_gratification || gratification.created_at).toLocaleDateString('fr-FR')}
                                          </div>
                                          <div className="flex items-center flex-wrap gap-3 text-sm text-gray-400 mt-1">
                                            <span className="flex items-center">
                                              <Plus className="w-3 h-3 mr-1" />
                                              Ajouté le: {new Date(gratification.created_at).toLocaleDateString('fr-FR')}
                                            </span>
                                            {gratification.file_name && (
                                              <span className="flex items-center text-blue-600">
                                                📎 {gratification.file_name}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex space-x-2 ml-4">
                                          {gratification.file_name && (
                                            <>
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={async () => {
                                                  try {
                                                    const response = await fetch(`${BACKEND_URL}/api/admin-documents/${gratification.id}/download`, {
                                                      headers: {
                                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                      }
                                                    });
                                                    
                                                    if (!response.ok) {
                                                      throw new Error('Erreur lors de l\'ouverture');
                                                    }
                                                    
                                                    const blob = await response.blob();
                                                    const url = window.URL.createObjectURL(blob);
                                                    window.open(url, '_blank');
                                                    setTimeout(() => {
                                                      window.URL.revokeObjectURL(url);
                                                    }, 100);
                                                    toast.success('Fichier ouvert dans un nouvel onglet');
                                                  } catch (error) {
                                                    console.error('Erreur:', error);
                                                    toast.error('Erreur lors de l\'ouverture du fichier');
                                                  }
                                                }}
                                                className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                              >
                                                <Eye className="w-4 h-4 mr-1" />
                                                Voir
                                              </Button>
                                              
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={() => window.open(`${BACKEND_URL}/api/admin-documents/${gratification.id}/download`, '_blank')}
                                                className="border-green-300 text-green-700 hover:bg-green-50"
                                              >
                                                <Download className="w-4 h-4 mr-1" />
                                                Télécharger
                                              </Button>
                                            </>
                                          )}
                                          
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            onClick={() => handleEditDocument(gratification, 'gratifications')}
                                            className="border-yellow-300 text-yellow-700 hover:bg-yellow-50"
                                          >
                                            <Edit className="w-4 h-4 mr-1" />
                                            Modifier
                                          </Button>
                                          
                                          <Button
                                            variant="destructive"
                                            size="sm"
                                            onClick={async () => {
                                              if (window.confirm('Êtes-vous sûr de vouloir supprimer cette gratification ?')) {
                                                try {
                                                  await deleteDocument(gratification.id, 'gratifications');
                                                  toast.success('Gratification supprimée');
                                                } catch (error) {
                                                  toast.error('Erreur lors de la suppression');
                                                }
                                              }
                                            }}
                                          >
                                            <Trash2 className="w-4 h-4 mr-1" />
                                            Supprimer
                                          </Button>
                                        </div>
                                      </div>
                                    </Card>
                                  ))
                                )}
                              </div>
                            </TabsContent>

                            {/* Sous-onglet Congés */}
                            <TabsContent value="conges" className="space-y-4 mt-6">
                              <div className="flex justify-between items-center">
                                <h4 className="text-md font-semibold">Congés</h4>
                                <Dialog open={isNewCongeOpen} onOpenChange={setIsNewCongeOpen}>
                                  <DialogTrigger asChild>
                                    <Button className="bg-blue-600 hover:bg-blue-700">
                                      <Plus className="w-4 h-4 mr-2" />
                                      Ajouter des congés
                                    </Button>
                                  </DialogTrigger>
                                  <DialogContent>
                                    <DialogHeader>
                                      <DialogTitle>Nouveaux congés</DialogTitle>
                                      <DialogDescription>Ajouter un document de congés</DialogDescription>
                                    </DialogHeader>
                                    <form onSubmit={async (e) => {
                                      e.preventDefault();
                                      const formData = new FormData(e.target);
                                      formData.append('employee_id', selectedEmployeeForAdmin.id);
                                      formData.append('document_type', 'conges');
                                      try {
                                        await uploadDocument(formData, 'conges');
                                        toast.success('Congés ajoutés avec succès');
                                        e.target.reset();
                                      } catch (error) {
                                        toast.error('Erreur lors de l\'ajout des congés');
                                      }
                                    }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="conge-title">Titre</Label>
                                        <Input id="conge-title" name="title" placeholder="Ex: Congés annuels 2024" required />
                                      </div>
                                      <div>
                                        <Label htmlFor="conge-type">Type de congé</Label>
                                        <select
                                    name="conge_type"
                                    className="flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-white px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:cursor-not-allowed disabled:opacity-50 appearance-none cursor-pointer"
                                  >
                                    <option value="" disabled>Sélectionner le type</option>
                                    <option value="annuels">Congés annuels</option>
                                    <option value="maladie">Congé maladie</option>
                                    <option value="maternite">Congé maternité</option>
                                    <option value="paternite">Congé paternité</option>
                                    <option value="exceptionnel">Congé exceptionnel</option>
                                    <option value="sans-solde">Congé sans solde</option>
                                  </select>
                                      </div>
                                      <div className="grid grid-cols-2 gap-4">
                                        <div>
                                          <Label htmlFor="conge-start">Date de début</Label>
                                          <Input id="conge-start" name="date_debut" type="date" required />
                                        </div>
                                        <div>
                                          <Label htmlFor="conge-end">Date de fin</Label>
                                          <Input id="conge-end" name="date_fin" type="date" required />
                                        </div>
                                      </div>
                                      <div>
                                        <Label htmlFor="conge-days">Nombre de jours</Label>
                                        <Input id="conge-days" name="nb_jours" type="number" placeholder="15" />
                                      </div>
                                      <div>
                                        <Label htmlFor="conge-file">Document (PDF)</Label>
                                        <Input id="conge-file" name="file" type="file" accept=".pdf" />
                                      </div>
                                      <div className="flex justify-end space-x-2">
                                        <DialogTrigger asChild>
                                          <Button type="button" variant="outline">Annuler</Button>
                                        </DialogTrigger>
                                        <Button type="submit" className="bg-blue-600 hover:bg-blue-700">Ajouter</Button>
                                      </div>
                                    </form>
                                  </DialogContent>
                                </Dialog>
                              </div>
                              <div className="space-y-3">
                                {conges.length === 0 ? (
                                  <Card className="p-6 text-center text-gray-500">
                                    <Clock className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                    <p>Aucun congé enregistré</p>
                                  </Card>
                                ) : (
                                  conges.map((conge) => (
                                    <Card key={conge.id} className="p-4">
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <h4 className="font-semibold text-blue-800">{conge.title}</h4>
                                          {conge.conge_type && (
                                            <Badge className="mt-1 bg-blue-100 text-blue-800">
                                              {conge.conge_type.replace('_', ' ')}
                                            </Badge>
                                          )}
                                          <div className="mt-2 text-sm">
                                            <div className="flex items-center text-gray-600">
                                              <Calendar className="w-4 h-4 mr-1" />
                                              Du {new Date(conge.date_debut).toLocaleDateString('fr-FR')} au {new Date(conge.date_fin).toLocaleDateString('fr-FR')}
                                            </div>
                                            {conge.nb_jours && (
                                              <p className="text-blue-600 font-medium mt-1">{conge.nb_jours} jour(s)</p>
                                            )}
                                          </div>
                                          <div className="flex items-center flex-wrap gap-3 text-sm text-gray-400 mt-2">
                                            <span className="flex items-center">
                                              <Plus className="w-3 h-3 mr-1" />
                                              Ajouté le: {new Date(conge.created_at).toLocaleDateString('fr-FR')}
                                            </span>
                                            {conge.file_name && (
                                              <span className="flex items-center text-blue-600">
                                                📎 {conge.file_name}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex space-x-2 ml-4">
                                          {conge.file_name && (
                                            <>
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={async () => {
                                                  try {
                                                    const response = await fetch(`${BACKEND_URL}/api/admin-documents/${conge.id}/download`, {
                                                      headers: {
                                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                      }
                                                    });
                                                    
                                                    if (!response.ok) {
                                                      throw new Error('Erreur lors de l\'ouverture');
                                                    }
                                                    
                                                    const blob = await response.blob();
                                                    const url = window.URL.createObjectURL(blob);
                                                    window.open(url, '_blank');
                                                    setTimeout(() => {
                                                      window.URL.revokeObjectURL(url);
                                                    }, 100);
                                                    toast.success('Fichier ouvert dans un nouvel onglet');
                                                  } catch (error) {
                                                    console.error('Erreur:', error);
                                                    toast.error('Erreur lors de l\'ouverture du fichier');
                                                  }
                                                }}
                                                className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                              >
                                                <Eye className="w-4 h-4 mr-1" />
                                                Voir
                                              </Button>
                                              
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={() => window.open(`${BACKEND_URL}/api/admin-documents/${conge.id}/download`, '_blank')}
                                                className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                              >
                                                <Download className="w-4 h-4 mr-1" />
                                                Télécharger
                                              </Button>
                                            </>
                                          )}
                                          
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            onClick={() => handleEditDocument(conge, 'conges')}
                                            className="border-yellow-300 text-yellow-700 hover:bg-yellow-50"
                                          >
                                            <Edit className="w-4 h-4 mr-1" />
                                            Modifier
                                          </Button>
                                          
                                          <Button
                                            variant="destructive"
                                            size="sm"
                                            onClick={async () => {
                                              if (window.confirm('Êtes-vous sûr de vouloir supprimer ce congé ?')) {
                                                try {
                                                  await deleteDocument(conge.id, 'conges');
                                                  toast.success('Congé supprimé');
                                                } catch (error) {
                                                  toast.error('Erreur lors de la suppression');
                                                }
                                              }
                                            }}
                                          >
                                            <Trash2 className="w-4 h-4 mr-1" />
                                            Supprimer
                                          </Button>
                                        </div>
                                      </div>
                                    </Card>
                                  ))
                                )}
                              </div>
                            </TabsContent>
                          </Tabs>
                        </TabsContent>

                        {/* Onglet Documents de sortie avec sous-sections */}
                        <TabsContent value="documents-sortie" className="space-y-4 mt-6">
                          <div className="bg-gradient-to-r from-orange-50 to-red-50 p-4 rounded-lg border-l-4 border-orange-500">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                              Documents de sortie de {selectedEmployeeForAdmin?.first_name}
                            </h3>
                            <p className="text-sm text-gray-600">
                              Gestion des documents liés à la fin de contrat et attestations
                            </p>
                          </div>
                          
                          <Tabs value={documentsSortieTab} onValueChange={setDocumentsSortieTab} className="w-full">
                            <TabsList className="grid w-full grid-cols-2">
                              <TabsTrigger value="solde-compte" className="text-sm">
                                <Calculator className="w-4 h-4 mr-2" />
                                Solde de tout compte
                              </TabsTrigger>
                              <TabsTrigger value="certificat" className="text-sm">
                                <FileText className="w-4 h-4 mr-2" />
                                Certificat de travail
                              </TabsTrigger>
                            </TabsList>

                            {/* Sous-onglet Solde de tout compte */}
                            <TabsContent value="solde-compte" className="space-y-4 mt-6">
                              <div className="flex justify-between items-center">
                                <h4 className="text-md font-semibold">Soldes de tout compte</h4>
                                <Dialog open={isNewSoldeCompteOpen} onOpenChange={setIsNewSoldeCompteOpen}>
                                  <DialogTrigger asChild>
                                    <Button className="bg-purple-600 hover:bg-purple-700">
                                      <Plus className="w-4 h-4 mr-2" />
                                      Ajouter un solde
                                    </Button>
                                  </DialogTrigger>
                                  <DialogContent>
                                    <DialogHeader>
                                      <DialogTitle>Nouveau solde de tout compte</DialogTitle>
                                      <DialogDescription>Ajouter un document de solde de tout compte</DialogDescription>
                                    </DialogHeader>
                                    <form onSubmit={async (e) => {
                                      e.preventDefault();
                                      const formData = new FormData(e.target);
                                      formData.append('employee_id', selectedEmployeeForAdmin.id);
                                      formData.append('document_type', 'solde-compte');
                                      try {
                                        await uploadDocument(formData, 'solde-compte');
                                        toast.success('Solde de tout compte ajouté avec succès');
                                        e.target.reset();
                                      } catch (error) {
                                        toast.error('Erreur lors de l\'ajout du solde');
                                      }
                                    }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="solde-title">Titre</Label>
                                        <Input id="solde-title" name="title" placeholder="Ex: Solde de tout compte - Fin de contrat" required />
                                      </div>
                                      <div>
                                        <Label htmlFor="solde-motif">Motif de départ</Label>
                                        <select
                                    name="motif_depart"
                                    className="flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-white px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:cursor-not-allowed disabled:opacity-50 appearance-none cursor-pointer"
                                  >
                                    <option value="" disabled>Sélectionner le motif</option>
                                    <option value="demission">Démission</option>
                                    <option value="licenciement">Licenciement</option>
                                    <option value="fin-contrat">Fin de contrat</option>
                                    <option value="retraite">Départ à la retraite</option>
                                    <option value="mutation">Mutation</option>
                                    <option value="abandon-poste">Abandon de poste</option>
                                  </select>
                                      </div>
                                      <div>
                                        <Label htmlFor="solde-date-depart">Date de départ</Label>
                                        <Input id="solde-date-depart" name="date_depart" type="date" required />
                                      </div>
                                      <div>
                                        <Label htmlFor="solde-montant">Montant total (F CFA)</Label>
                                        <Input id="solde-montant" name="montant_total" type="number" placeholder="500000" />
                                      </div>
                                      <div>
                                        <Label htmlFor="solde-file">Document (PDF)</Label>
                                        <Input id="solde-file" name="file" type="file" accept=".pdf" required />
                                      </div>
                                      <div className="flex justify-end space-x-2">
                                        <DialogTrigger asChild>
                                          <Button type="button" variant="outline">Annuler</Button>
                                        </DialogTrigger>
                                        <Button type="submit" className="bg-purple-600 hover:bg-purple-700">Ajouter</Button>
                                      </div>
                                    </form>
                                  </DialogContent>
                                </Dialog>
                              </div>
                              <div className="space-y-3">
                                {soldesCompte.length === 0 ? (
                                  <Card className="p-6 text-center text-gray-500">
                                    <Calculator className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                    <p>Aucun solde de tout compte enregistré</p>
                                  </Card>
                                ) : (
                                  soldesCompte.map((solde) => (
                                    <Card key={solde.id} className="p-4">
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <h4 className="font-semibold text-purple-800">{solde.title}</h4>
                                          {solde.motif_depart && (
                                            <Badge className="mt-1 bg-purple-100 text-purple-800">
                                              {solde.motif_depart.replace('-', ' ')}
                                            </Badge>
                                          )}
                                          <div className="mt-2 text-sm">
                                            <div className="flex items-center text-gray-600">
                                              <Calendar className="w-4 h-4 mr-1" />
                                              Date de départ: {new Date(solde.date_depart).toLocaleDateString('fr-FR')}
                                            </div>
                                            {solde.montant_total && (
                                              <p className="text-lg font-bold text-purple-600 mt-2">
                                                {parseInt(solde.montant_total).toLocaleString()} F CFA
                                              </p>
                                            )}
                                          </div>
                                          <div className="flex items-center flex-wrap gap-3 text-sm text-gray-400 mt-2">
                                            <span className="flex items-center">
                                              <Plus className="w-3 h-3 mr-1" />
                                              Ajouté le: {new Date(solde.created_at).toLocaleDateString('fr-FR')}
                                            </span>
                                            {solde.file_name && (
                                              <span className="flex items-center text-purple-600">
                                                📎 {solde.file_name}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex space-x-2 ml-4">
                                          {solde.file_name && (
                                            <>
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={async () => {
                                                  try {
                                                    const response = await fetch(`${BACKEND_URL}/api/admin-documents/${solde.id}/download`, {
                                                      headers: {
                                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                      }
                                                    });
                                                    
                                                    if (!response.ok) {
                                                      throw new Error('Erreur lors de l\'ouverture');
                                                    }
                                                    
                                                    const blob = await response.blob();
                                                    const url = window.URL.createObjectURL(blob);
                                                    window.open(url, '_blank');
                                                    setTimeout(() => {
                                                      window.URL.revokeObjectURL(url);
                                                    }, 100);
                                                    toast.success('Fichier ouvert dans un nouvel onglet');
                                                  } catch (error) {
                                                    console.error('Erreur:', error);
                                                    toast.error('Erreur lors de l\'ouverture du fichier');
                                                  }
                                                }}
                                                className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                              >
                                                <Eye className="w-4 h-4 mr-1" />
                                                Voir
                                              </Button>
                                              
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={() => window.open(`${BACKEND_URL}/api/admin-documents/${solde.id}/download`, '_blank')}
                                                className="border-purple-300 text-purple-700 hover:bg-purple-50"
                                              >
                                                <Download className="w-4 h-4 mr-1" />
                                                Télécharger
                                              </Button>
                                            </>
                                          )}
                                          
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            onClick={() => handleEditDocument(solde, 'solde-compte')}
                                            className="border-yellow-300 text-yellow-700 hover:bg-yellow-50"
                                          >
                                            <Edit className="w-4 h-4 mr-1" />
                                            Modifier
                                          </Button>
                                          
                                          <Button
                                            variant="destructive"
                                            size="sm"
                                            onClick={async () => {
                                              if (window.confirm('Êtes-vous sûr de vouloir supprimer ce solde ?')) {
                                                try {
                                                  await deleteDocument(solde.id, 'solde-compte');
                                                  toast.success('Solde supprimé');
                                                } catch (error) {
                                                  toast.error('Erreur lors de la suppression');
                                                }
                                              }
                                            }}
                                          >
                                            <Trash2 className="w-4 h-4" />
                                          </Button>
                                        </div>
                                      </div>
                                    </Card>
                                  ))
                                )}
                              </div>
                            </TabsContent>

                            {/* Sous-onglet Certificat de travail */}
                            <TabsContent value="certificat" className="space-y-4 mt-6">
                              <div className="flex justify-between items-center">
                                <h4 className="text-md font-semibold">Certificats de travail</h4>
                                <Dialog open={isNewCertificatOpen} onOpenChange={setIsNewCertificatOpen}>
                                  <DialogTrigger asChild>
                                    <Button className="bg-orange-600 hover:bg-orange-700">
                                      <Plus className="w-4 h-4 mr-2" />
                                      Ajouter un certificat
                                    </Button>
                                  </DialogTrigger>
                                  <DialogContent>
                                    <DialogHeader>
                                      <DialogTitle>Nouveau certificat de travail</DialogTitle>
                                      <DialogDescription>Ajouter un certificat de travail</DialogDescription>
                                    </DialogHeader>
                                    <form onSubmit={async (e) => {
                                      e.preventDefault();
                                      const formData = new FormData(e.target);
                                      formData.append('employee_id', selectedEmployeeForAdmin.id);
                                      formData.append('document_type', 'certificat');
                                      try {
                                        await uploadDocument(formData, 'certificat');
                                        toast.success('Certificat ajouté avec succès');
                                        e.target.reset();
                                      } catch (error) {
                                        toast.error('Erreur lors de l\'ajout du certificat');
                                      }
                                    }} className="space-y-4">
                                      <div>
                                        <Label htmlFor="certificat-title">Titre</Label>
                                        <Input id="certificat-title" name="title" placeholder="Ex: Certificat de travail - 2024" required />
                                      </div>
                                      <div>
                                        <Label htmlFor="certificat-type">Type de certificat</Label>
                                        <select
                                    name="type_certificat"
                                    className="flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-white px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:cursor-not-allowed disabled:opacity-50 appearance-none cursor-pointer"
                                  >
                                    <option value="" disabled>Sélectionner le type</option>
                                    <option value="travail">Certificat de travail</option>
                                    <option value="salaire">Certificat de salaire</option>
                                    <option value="presence">Certificat de présence</option>
                                    <option value="stage">Certificat de stage</option>
                                    <option value="interim">Certificat intérimaire</option>
                                  </select>
                                      </div>
                                      <div className="grid grid-cols-2 gap-4">
                                        <div>
                                          <Label htmlFor="certificat-periode-debut">Période début</Label>
                                          <Input id="certificat-periode-debut" name="periode_debut" type="date" />
                                        </div>
                                        <div>
                                          <Label htmlFor="certificat-periode-fin">Période fin</Label>
                                          <Input id="certificat-periode-fin" name="periode_fin" type="date" />
                                        </div>
                                      </div>
                                      <div>
                                        <Label htmlFor="certificat-objet">Objet/Demandeur</Label>
                                        <Input id="certificat-objet" name="objet" placeholder="Ex: Demande de crédit bancaire, Visa, etc." />
                                      </div>
                                      <div>
                                        <Label htmlFor="certificat-file">Document (PDF)</Label>
                                        <Input id="certificat-file" name="file" type="file" accept=".pdf" required />
                                      </div>
                                      <div className="flex justify-end space-x-2">
                                        <DialogTrigger asChild>
                                          <Button type="button" variant="outline">Annuler</Button>
                                        </DialogTrigger>
                                        <Button type="submit" className="bg-orange-600 hover:bg-orange-700">Ajouter</Button>
                                      </div>
                                    </form>
                                  </DialogContent>
                                </Dialog>
                              </div>
                              <div className="space-y-3">
                                {certificatsTravail.length === 0 ? (
                                  <Card className="p-6 text-center text-gray-500">
                                    <FileText className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                    <p>Aucun certificat de travail enregistré</p>
                                  </Card>
                                ) : (
                                  certificatsTravail.map((certificat) => (
                                    <Card key={certificat.id} className="p-4">
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <h4 className="font-semibold text-orange-800">{certificat.title}</h4>
                                          {certificat.type_certificat && (
                                            <Badge className="mt-1 bg-orange-100 text-orange-800">
                                              {certificat.type_certificat.replace('_', ' ')}
                                            </Badge>
                                          )}
                                          <div className="mt-2 text-sm">
                                            {certificat.periode_debut && certificat.periode_fin && (
                                              <div className="flex items-center text-gray-600">
                                                <Calendar className="w-4 h-4 mr-1" />
                                                Période: {new Date(certificat.periode_debut).toLocaleDateString('fr-FR')} - {new Date(certificat.periode_fin).toLocaleDateString('fr-FR')}
                                              </div>
                                            )}
                                            {certificat.objet && (
                                              <p className="text-gray-600 mt-1">Objet: {certificat.objet}</p>
                                            )}
                                          </div>
                                          <div className="flex items-center flex-wrap gap-3 text-sm text-gray-400 mt-2">
                                            <span className="flex items-center">
                                              <Plus className="w-3 h-3 mr-1" />
                                              Ajouté le: {new Date(certificat.created_at).toLocaleDateString('fr-FR')}
                                            </span>
                                            {certificat.file_name && (
                                              <span className="flex items-center text-orange-600">
                                                📎 {certificat.file_name}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex space-x-2 ml-4">
                                          {certificat.file_name && (
                                            <>
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={async () => {
                                                  try {
                                                    const response = await fetch(`${BACKEND_URL}/api/admin-documents/${certificat.id}/download`, {
                                                      headers: {
                                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                      }
                                                    });
                                                    
                                                    if (!response.ok) {
                                                      throw new Error('Erreur lors de l\'ouverture');
                                                    }
                                                    
                                                    const blob = await response.blob();
                                                    const url = window.URL.createObjectURL(blob);
                                                    window.open(url, '_blank');
                                                    setTimeout(() => {
                                                      window.URL.revokeObjectURL(url);
                                                    }, 100);
                                                    toast.success('Fichier ouvert dans un nouvel onglet');
                                                  } catch (error) {
                                                    console.error('Erreur:', error);
                                                    toast.error('Erreur lors de l\'ouverture du fichier');
                                                  }
                                                }}
                                                className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                              >
                                                <Eye className="w-4 h-4 mr-1" />
                                                Voir
                                              </Button>
                                              
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={() => window.open(`${BACKEND_URL}/api/admin-documents/${certificat.id}/download`, '_blank')}
                                                className="border-orange-300 text-orange-700 hover:bg-orange-50"
                                              >
                                                <Download className="w-4 h-4 mr-1" />
                                                Télécharger
                                              </Button>
                                            </>
                                          )}
                                          
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            onClick={() => handleEditDocument(certificat, 'certificat')}
                                            className="border-yellow-300 text-yellow-700 hover:bg-yellow-50"
                                          >
                                            <Edit className="w-4 h-4 mr-1" />
                                            Modifier
                                          </Button>
                                          
                                          <Button
                                            variant="destructive"
                                            size="sm"
                                            onClick={async () => {
                                              if (window.confirm('Êtes-vous sûr de vouloir supprimer ce certificat ?')) {
                                                try {
                                                  await deleteDocument(certificat.id, 'certificat');
                                                  toast.success('Certificat supprimé');
                                                } catch (error) {
                                                  toast.error('Erreur lors de la suppression');
                                                }
                                              }
                                            }}
                                          >
                                            <Trash2 className="w-4 h-4 mr-1" />
                                            Supprimer
                                          </Button>
                                        </div>
                                      </div>
                                    </Card>
                                  ))
                                )}
                              </div>
                            </TabsContent>

                            {/* Sous-onglet Bulletins émargés */}
                            <TabsContent value="bulletins-emarges" className="space-y-4 mt-6">
                              {/* En-tête avec compteur et actions */}
                              <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-4 rounded-lg border-l-4 border-indigo-500 mb-4">
                                <div className="flex justify-between items-center flex-wrap gap-3">
                                  <div>
                                    <h4 className="text-lg font-bold text-indigo-900 flex items-center">
                                      <FileText className="w-5 h-5 mr-2 text-indigo-600" />
                                      Bulletins émargés
                                      <Badge className="ml-3 bg-indigo-100 text-indigo-800 font-semibold">
                                        {bulletinsEmarges.length} document{bulletinsEmarges.length !== 1 ? 's' : ''}
                                      </Badge>
                                    </h4>
                                    <p className="text-sm text-indigo-600 mt-1">
                                      Gestion des bulletins de paie signés par {selectedEmployeeForAdmin?.first_name}
                                    </p>
                                  </div>
                                  
                                  {/* Boutons d'action améliorés */}
                                  <div className="flex gap-3">
                                    {/* Bouton de téléchargement rapide amélioré */}
                                    <input
                                      type="file"
                                      accept=".pdf"
                                      multiple
                                      style={{ display: 'none' }}
                                      id="quick-upload-bulletins"
                                      onChange={async (e) => {
                                        const files = Array.from(e.target.files);
                                        if (files.length === 0) return;

                                        let successCount = 0;
                                        for (const file of files) {
                                          if (!file.name.toLowerCase().endsWith('.pdf')) {
                                            toast.error(`${file.name} : Seuls les fichiers PDF sont acceptés`);
                                            continue;
                                          }

                                          try {
                                            const formData = new FormData();
                                            formData.append('title', `Bulletin émargé - ${file.name.replace('.pdf', '')}`);
                                            formData.append('employee_id', selectedEmployeeForAdmin.id);
                                            formData.append('document_type', 'bulletins-emarges');
                                            formData.append('periode_paie', new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }));
                                            formData.append('statut_bulletin', 'en_attente');
                                            formData.append('file', file);

                                            await uploadDocument(formData, 'bulletins-emarges');
                                            successCount++;
                                          } catch (error) {
                                            toast.error(`Erreur lors de l'ajout de ${file.name}`);
                                          }
                                        }
                                        
                                        if (successCount > 0) {
                                          toast.success(`${successCount} bulletin${successCount > 1 ? 's' : ''} ajouté${successCount > 1 ? 's' : ''} avec succès ! 🎉`);
                                        }
                                        
                                        // Reset input
                                        e.target.value = '';
                                      }}
                                    />
                                    <label htmlFor="quick-upload-bulletins">
                                      <Button className="bg-emerald-600 hover:bg-emerald-700 shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105" asChild>
                                        <span className="cursor-pointer flex items-center">
                                          <Download className="w-4 h-4 mr-2" />
                                          <span className="hidden sm:inline">📁 Upload rapide</span>
                                          <span className="sm:hidden">📁</span>
                                        </span>
                                      </Button>
                                    </label>
                                    
                                    <Dialog open={isNewBulletinOpen} onOpenChange={setIsNewBulletinOpen}>
                                      <DialogTrigger asChild>
                                        <Button className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 text-white">
                                          <Plus className="w-4 h-4 mr-2" />
                                          <span className="hidden sm:inline">✏️ Saisie détaillée</span>
                                          <span className="sm:hidden">✏️</span>
                                        </Button>
                                      </DialogTrigger>
                                      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                                    <DialogHeader className="text-center pb-4 border-b border-gray-100">
                                      <div className="flex items-center justify-center mb-2">
                                        <div className="p-3 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full">
                                          <FileText className="w-6 h-6 text-white" />
                                        </div>
                                      </div>
                                      <DialogTitle className="text-xl font-bold text-gray-800">✏️ Nouveau bulletin émargé</DialogTitle>
                                      <DialogDescription className="text-gray-600">
                                        Enregistrement détaillé d'un bulletin de paie émargé pour <span className="font-semibold text-indigo-600">{selectedEmployeeForAdmin?.first_name} {selectedEmployeeForAdmin?.last_name}</span>
                                      </DialogDescription>
                                    </DialogHeader>
                                    <form onSubmit={async (e) => {
                                      e.preventDefault();
                                      const formData = new FormData(e.target);
                                      formData.append('employee_id', selectedEmployeeForAdmin.id);
                                      formData.append('document_type', 'bulletins-emarges');
                                      try {
                                        await uploadDocument(formData, 'bulletins-emarges');
                                        toast.success('🎉 Bulletin émargé ajouté avec succès !');
                                        e.target.reset();
                                      } catch (error) {
                                        toast.error('❌ Erreur lors de l\'ajout du bulletin émargé');
                                      }
                                    }} className="space-y-6 pt-6">
                                      {/* Section 1: Informations principales */}
                                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border-l-4 border-blue-500">
                                        <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
                                          <FileText className="w-4 h-4 mr-2" />
                                          📄 Informations du document
                                        </h4>
                                        <div className="space-y-4">
                                          <div>
                                            <Label htmlFor="bulletin-title" className="text-blue-700 font-medium">Titre du bulletin *</Label>
                                            <Input 
                                              id="bulletin-title" 
                                              name="title" 
                                              placeholder="Ex: Bulletin de paie émargé - Janvier 2024" 
                                              className="border-blue-200 focus:border-blue-400"
                                              required 
                                            />
                                          </div>
                                          <div>
                                            <Label htmlFor="bulletin-periode" className="text-blue-700 font-medium">Période de paie</Label>
                                            <Input 
                                              id="bulletin-periode" 
                                              name="periode_paie" 
                                              placeholder="Ex: Janvier 2024" 
                                              className="border-blue-200 focus:border-blue-400"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {/* Section 2: Dates importantes */}
                                      <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-lg border-l-4 border-green-500">
                                        <h4 className="text-sm font-semibold text-green-800 mb-3 flex items-center">
                                          <Calendar className="w-4 h-4 mr-2" />
                                          📅 Dates importantes
                                        </h4>
                                        <div className="grid grid-cols-2 gap-4">
                                          <div>
                                            <Label htmlFor="bulletin-date-emission" className="text-green-700 font-medium">Date d'émission</Label>
                                            <Input 
                                              id="bulletin-date-emission" 
                                              name="date_emission" 
                                              type="date" 
                                              className="border-green-200 focus:border-green-400"
                                            />
                                          </div>
                                          <div>
                                            <Label htmlFor="bulletin-date-emargement" className="text-green-700 font-medium">Date d'émargement</Label>
                                            <Input 
                                              id="bulletin-date-emargement" 
                                              name="date_emargement" 
                                              type="date" 
                                              className="border-green-200 focus:border-green-400"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {/* Section 3: Détails financiers */}
                                      <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-4 rounded-lg border-l-4 border-yellow-500">
                                        <h4 className="text-sm font-semibold text-yellow-800 mb-3 flex items-center">
                                          <Calculator className="w-4 h-4 mr-2" />
                                          💰 Informations financières
                                        </h4>
                                        <div>
                                          <Label htmlFor="bulletin-salaire-net" className="text-yellow-700 font-medium">Salaire Net (F CFA)</Label>
                                          <Input 
                                            id="bulletin-salaire-net" 
                                            name="salaire_net" 
                                            type="number" 
                                            placeholder="Ex: 500000" 
                                            className="border-yellow-200 focus:border-yellow-400"
                                          />
                                        </div>
                                      </div>
                                      {/* Section 4: Statut et suivi */}
                                      <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-lg border-l-4 border-purple-500">
                                        <h4 className="text-sm font-semibold text-purple-800 mb-3 flex items-center">
                                          <CheckCircle className="w-4 h-4 mr-2" />
                                          📋 Statut et suivi
                                        </h4>
                                        <div className="space-y-4">
                                          <div>
                                            <Label htmlFor="bulletin-statut" className="text-purple-700 font-medium">Statut du bulletin</Label>
                                            <select
                                              id="bulletin-statut"
                                              name="statut_bulletin"
                                              className="flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-purple-200 bg-white px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:border-purple-400 disabled:cursor-not-allowed disabled:opacity-50 appearance-none cursor-pointer"
                                            >
                                              <option value="" disabled>Sélectionner le statut</option>
                                              <option value="emarge">✅ Émargé (signé)</option>
                                              <option value="refuse">❌ Refusé</option>
                                              <option value="en_attente">⏳ En attente de signature</option>
                                              <option value="litige">⚠️ En litige</option>
                                            </select>
                                          </div>
                                          <div>
                                            <Label htmlFor="bulletin-observations" className="text-purple-700 font-medium">Observations / Commentaires</Label>
                                            <Input 
                                              id="bulletin-observations" 
                                              name="observations" 
                                              placeholder="Notes, remarques ou commentaires (optionnel)" 
                                              className="border-purple-200 focus:border-purple-400"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {/* Section 5: Fichier PDF */}
                                      <div className="bg-gradient-to-r from-red-50 to-pink-50 p-4 rounded-lg border-l-4 border-red-500">
                                        <h4 className="text-sm font-semibold text-red-800 mb-3 flex items-center">
                                          <FileText className="w-4 h-4 mr-2" />
                                          📎 Document PDF *
                                        </h4>
                                        <div>
                                          <Label htmlFor="bulletin-file" className="text-red-700 font-medium">Fichier PDF du bulletin</Label>
                                          <Input 
                                            id="bulletin-file" 
                                            name="file" 
                                            type="file" 
                                            accept=".pdf" 
                                            required 
                                            className="border-red-200 focus:border-red-400"
                                          />
                                          <p className="text-xs text-red-600 mt-1">* Seuls les fichiers PDF sont acceptés</p>
                                        </div>
                                      </div>

                                      {/* Boutons d'action améliorés */}
                                      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                                        <DialogTrigger asChild>
                                          <Button 
                                            type="button" 
                                            variant="outline" 
                                            className="px-6 hover:bg-gray-100 transition-colors border-gray-300"
                                          >
                                            ❌ Annuler
                                          </Button>
                                        </DialogTrigger>
                                        <Button 
                                          type="submit" 
                                          className="px-6 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
                                        >
                                          ✅ Enregistrer le bulletin
                                        </Button>
                                      </div>
                                    </form>
                                  </DialogContent>
                                </Dialog>
                                </div>
                              </div>
                              <div className="space-y-3">
                                {bulletinsEmarges.length === 0 ? (
                                  <Card 
                                    className="p-8 text-center text-gray-500 border-2 border-dashed border-gray-300 hover:border-indigo-400 transition-all duration-300 cursor-pointer transform hover:scale-102 bg-gradient-to-br from-gray-50 to-indigo-50 hover:from-indigo-50 hover:to-purple-50"
                                    onDragOver={(e) => {
                                      e.preventDefault();
                                      e.currentTarget.classList.add('border-indigo-500', 'bg-indigo-100', 'scale-105');
                                      e.currentTarget.classList.remove('border-gray-300');
                                    }}
                                    onDragLeave={(e) => {
                                      e.currentTarget.classList.remove('border-indigo-500', 'bg-indigo-100', 'scale-105');
                                      e.currentTarget.classList.add('border-gray-300');
                                    }}
                                    onDrop={async (e) => {
                                      e.preventDefault();
                                      e.currentTarget.classList.remove('border-indigo-500', 'bg-indigo-100', 'scale-105');
                                      e.currentTarget.classList.add('border-gray-300');
                                      
                                      const files = Array.from(e.dataTransfer.files);
                                      const pdfFiles = files.filter(file => file.name.toLowerCase().endsWith('.pdf'));
                                      
                                      if (pdfFiles.length === 0) {
                                        toast.error('⚠️ Veuillez déposer uniquement des fichiers PDF');
                                        return;
                                      }

                                      let successCount = 0;
                                      for (const file of pdfFiles) {
                                        try {
                                          const formData = new FormData();
                                          formData.append('title', `Bulletin émargé - ${file.name.replace('.pdf', '')}`);
                                          formData.append('employee_id', selectedEmployeeForAdmin.id);
                                          formData.append('document_type', 'bulletins-emarges');
                                          formData.append('periode_paie', new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }));
                                          formData.append('statut_bulletin', 'en_attente');
                                          formData.append('file', file);

                                          await uploadDocument(formData, 'bulletins-emarges');
                                          successCount++;
                                        } catch (error) {
                                          toast.error(`Erreur lors de l'ajout de ${file.name}`);
                                        }
                                      }
                                      
                                      if (successCount > 0) {
                                        toast.success(`🎉 ${successCount} bulletin${successCount > 1 ? 's' : ''} ajouté${successCount > 1 ? 's' : ''} avec succès !`);
                                      }
                                    }}
                                    onClick={() => document.getElementById('quick-upload-bulletins').click()}
                                  >
                                    <div className="animate-pulse">
                                      <FileText className="w-16 h-16 mx-auto mb-4 text-indigo-300" />
                                    </div>
                                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Aucun bulletin émargé</h3>
                                    <div className="space-y-2">
                                      <div className="flex items-center justify-center text-sm text-gray-500">
                                        <div className="flex items-center space-x-2">
                                          <span className="w-2 h-2 bg-indigo-400 rounded-full animate-ping"></span>
                                          <span>Cliquez ici pour sélectionner des fichiers</span>
                                        </div>
                                      </div>
                                      <div className="text-sm text-gray-400">
                                        <span className="font-medium">ou</span> glissez-déposez vos fichiers PDF
                                      </div>
                                      <div className="mt-4 flex justify-center space-x-4 text-xs text-gray-400">
                                        <div className="flex items-center">
                                          <CheckCircle className="w-3 h-3 mr-1 text-green-500" />
                                          Formats acceptés: PDF
                                        </div>
                                        <div className="flex items-center">
                                          <Download className="w-3 h-3 mr-1 text-blue-500" />
                                          Upload multiple
                                        </div>
                                      </div>
                                    </div>
                                  </Card>
                                ) : (
                                  bulletinsEmarges.map((bulletin) => (
                                    <Card key={bulletin.id} className="p-4">
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <h4 className="font-semibold text-indigo-800">{bulletin.title}</h4>
                                          {bulletin.periode_paie && (
                                            <p className="text-sm text-gray-600 mt-1">Période: {bulletin.periode_paie}</p>
                                          )}
                                          {bulletin.statut_bulletin && (
                                            <Badge className={`mt-1 ${
                                              bulletin.statut_bulletin === 'emarge' ? 'bg-green-100 text-green-800' :
                                              bulletin.statut_bulletin === 'refuse' ? 'bg-red-100 text-red-800' :
                                              bulletin.statut_bulletin === 'en-attente' ? 'bg-yellow-100 text-yellow-800' :
                                              'bg-orange-100 text-orange-800'
                                            }`}>
                                              {bulletin.statut_bulletin === 'emarge' ? 'Émargé' :
                                               bulletin.statut_bulletin === 'refuse' ? 'Refusé' :
                                               bulletin.statut_bulletin === 'en-attente' ? 'En attente' :
                                               'En litige'}
                                            </Badge>
                                          )}
                                          <div className="mt-2 text-sm">
                                            {bulletin.date_emission && (
                                              <div className="flex items-center text-gray-600">
                                                <Calendar className="w-4 h-4 mr-1" />
                                                Émis le: {new Date(bulletin.date_emission).toLocaleDateString('fr-FR')}
                                              </div>
                                            )}
                                            {bulletin.date_emargement && (
                                              <div className="flex items-center text-gray-600 mt-1">
                                                <CheckCircle className="w-4 h-4 mr-1" />
                                                Émargé le: {new Date(bulletin.date_emargement).toLocaleDateString('fr-FR')}
                                              </div>
                                            )}
                                            {bulletin.salaire_net && (
                                              <p className="text-lg font-bold text-indigo-600 mt-2">
                                                {parseInt(bulletin.salaire_net).toLocaleString()} F CFA
                                              </p>
                                            )}
                                          </div>
                                          {bulletin.observations && (
                                            <p className="text-xs text-gray-500 mt-2 italic">"{bulletin.observations}"</p>
                                          )}
                                          <div className="flex items-center flex-wrap gap-3 text-sm text-gray-400 mt-2">
                                            <span className="flex items-center">
                                              <Plus className="w-3 h-3 mr-1" />
                                              Ajouté le: {new Date(bulletin.created_at).toLocaleDateString('fr-FR')}
                                            </span>
                                            {bulletin.file_name && (
                                              <span className="flex items-center text-indigo-600">
                                                📎 {bulletin.file_name}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex space-x-2 ml-4">
                                          {bulletin.file_name && (
                                            <>
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={async () => {
                                                  try {
                                                    const response = await fetch(`${BACKEND_URL}/api/admin-documents/${bulletin.id}/download`, {
                                                      headers: {
                                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                                      }
                                                    });
                                                    
                                                    if (!response.ok) {
                                                      throw new Error('Erreur lors de l\'ouverture');
                                                    }
                                                    
                                                    const blob = await response.blob();
                                                    const url = window.URL.createObjectURL(blob);
                                                    window.open(url, '_blank');
                                                    setTimeout(() => {
                                                      window.URL.revokeObjectURL(url);
                                                    }, 100);
                                                    toast.success('Fichier ouvert dans un nouvel onglet');
                                                  } catch (error) {
                                                    console.error('Erreur:', error);
                                                    toast.error('Erreur lors de l\'ouverture du fichier');
                                                  }
                                                }}
                                                className="border-blue-300 text-blue-700 hover:bg-blue-50"
                                              >
                                                <Eye className="w-4 h-4 mr-1" />
                                                Voir
                                              </Button>
                                              
                                              <Button
                                                variant="outline"
                                                size="sm"
                                                onClick={() => window.open(`${BACKEND_URL}/api/admin-documents/${bulletin.id}/download`, '_blank')}
                                                className="border-indigo-300 text-indigo-700 hover:bg-indigo-50"
                                              >
                                                <Download className="w-4 h-4 mr-1" />
                                                Télécharger
                                              </Button>
                                            </>
                                          )}
                                          
                                          <Button
                                            variant="destructive"
                                            size="sm"
                                            onClick={async () => {
                                              if (window.confirm('Êtes-vous sûr de vouloir supprimer ce bulletin émargé ?')) {
                                                try {
                                                  await deleteDocument(bulletin.id, 'bulletins-emarges');
                                                  toast.success('Bulletin émargé supprimé');
                                                } catch (error) {
                                                  toast.error('Erreur lors de la suppression');
                                                }
                                              }
                                            }}
                                          >
                                            <Trash2 className="w-4 h-4 mr-1" />
                                            Supprimer
                                          </Button>
                                        </div>
                                      </div>
                                    </Card>
                                  ))
                                )}
                                
                                {/* Zone de drag & drop persistante améliorée */}
                                {bulletinsEmarges.length > 0 && (
                                  <Card 
                                    className="p-6 text-center text-gray-400 border-2 border-dashed border-emerald-200 hover:border-emerald-400 transition-all duration-300 cursor-pointer bg-gradient-to-r from-emerald-50 to-teal-50 hover:from-emerald-100 hover:to-teal-100 transform hover:scale-102"
                                    onDragOver={(e) => {
                                      e.preventDefault();
                                      e.currentTarget.classList.add('border-emerald-500', 'bg-emerald-200', 'scale-105');
                                    }}
                                    onDragLeave={(e) => {
                                      e.currentTarget.classList.remove('border-emerald-500', 'bg-emerald-200', 'scale-105');
                                    }}
                                    onDrop={async (e) => {
                                      e.preventDefault();
                                      e.currentTarget.classList.remove('border-emerald-500', 'bg-emerald-200', 'scale-105');
                                      
                                      const files = Array.from(e.dataTransfer.files);
                                      const pdfFiles = files.filter(file => file.name.toLowerCase().endsWith('.pdf'));
                                      
                                      if (pdfFiles.length === 0) {
                                        toast.error('⚠️ Veuillez déposer uniquement des fichiers PDF');
                                        return;
                                      }

                                      let successCount = 0;
                                      for (const file of pdfFiles) {
                                        try {
                                          const formData = new FormData();
                                          formData.append('title', `Bulletin émargé - ${file.name.replace('.pdf', '')}`);
                                          formData.append('employee_id', selectedEmployeeForAdmin.id);
                                          formData.append('document_type', 'bulletins-emarges');
                                          formData.append('periode_paie', new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }));
                                          formData.append('statut_bulletin', 'en_attente');
                                          formData.append('file', file);

                                          await uploadDocument(formData, 'bulletins-emarges');
                                          successCount++;
                                        } catch (error) {
                                          toast.error(`Erreur lors de l'ajout de ${file.name}`);
                                        }
                                      }
                                      
                                      if (successCount > 0) {
                                        toast.success(`🎉 ${successCount} nouveau${successCount > 1 ? 'x' : ''} bulletin${successCount > 1 ? 's' : ''} ajouté${successCount > 1 ? 's' : ''} !`);
                                      }
                                    }}
                                    onClick={() => document.getElementById('quick-upload-bulletins').click()}
                                  >
                                    <div className="flex items-center justify-center space-x-3">
                                      <div className="relative">
                                        <Plus className="w-6 h-6 text-emerald-500" />
                                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full animate-pulse"></div>
                                      </div>
                                      <div>
                                        <span className="text-emerald-700 font-medium">Ajouter plus de bulletins</span>
                                        <div className="text-xs text-emerald-600 mt-1">Cliquez ou glissez-déposez vos PDF</div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-xs text-emerald-500 space-x-2">
                                        <FileText className="w-4 h-4" />
                                        <span>PDF uniquement</span>
                                      </div>
                                    </div>
                                  </Card>
                                )}
                              </div>
                              </div>
                            </TabsContent>
                          </Tabs>
                        </TabsContent>
                      </Tabs>
                      
                      {/* Dialog de modification de document administratif */}
                      <Dialog open={isEditDocumentOpen} onOpenChange={setIsEditDocumentOpen}>
                        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
                          <DialogHeader>
                            <DialogTitle>Modifier le document</DialogTitle>
                            <DialogDescription>
                              Modifiez les informations du document. Vous pouvez également remplacer le fichier.
                            </DialogDescription>
                          </DialogHeader>
                          {editingDocument && (
                            <form onSubmit={async (e) => {
                              e.preventDefault();
                              const formData = new FormData(e.target);
                              try {
                                await updateDocument(editingDocument.id, formData, editingDocument.document_type);
                                toast.success('Document modifié avec succès');
                                setIsEditDocumentOpen(false);
                                setEditingDocument(null);
                              } catch (error) {
                                toast.error('Erreur lors de la modification');
                              }
                            }} className="space-y-4">
                              {/* Champs communs */}
                              <div>
                                <Label htmlFor="edit-title">Titre</Label>
                                <Input 
                                  id="edit-title" 
                                  name="title" 
                                  defaultValue={editingDocument.title}
                                  required 
                                />
                              </div>
                              <div>
                                <Label htmlFor="edit-description">Description</Label>
                                <Input 
                                  id="edit-description" 
                                  name="description" 
                                  defaultValue={editingDocument.description || ''}
                                />
                              </div>
                              
                              {/* Champs spécifiques selon le type de document */}
                              {editingDocument.document_type === 'gratifications' && (
                                <>
                                  <div>
                                    <Label htmlFor="edit-amount">Montant (F CFA)</Label>
                                    <Input 
                                      id="edit-amount" 
                                      name="amount" 
                                      type="number"
                                      defaultValue={editingDocument.amount || ''}
                                    />
                                  </div>
                                  <div>
                                    <Label htmlFor="edit-date-gratification">Date de gratification</Label>
                                    <Input 
                                      id="edit-date-gratification" 
                                      name="date_gratification" 
                                      type="date"
                                      defaultValue={editingDocument.date_gratification ? editingDocument.date_gratification.split('T')[0] : ''}
                                    />
                                  </div>
                                </>
                              )}
                              
                              {editingDocument.document_type === 'conges' && (
                                <>
                                  <div>
                                    <Label htmlFor="edit-conge-type">Type de congé</Label>
                                    <select
                                      id="edit-conge-type"
                                      name="conge_type"
                                      defaultValue={editingDocument.conge_type || ''}
                                      className="flex h-9 w-full rounded-md border border-input bg-white px-3 py-2 text-sm"
                                    >
                                      <option value="">Sélectionner le type</option>
                                      <option value="annuels">Congés annuels</option>
                                      <option value="maladie">Congé maladie</option>
                                      <option value="maternite">Congé maternité</option>
                                      <option value="paternite">Congé paternité</option>
                                      <option value="exceptionnel">Congé exceptionnel</option>
                                      <option value="sans-solde">Congé sans solde</option>
                                    </select>
                                  </div>
                                  <div className="grid grid-cols-2 gap-4">
                                    <div>
                                      <Label htmlFor="edit-date-debut">Date de début</Label>
                                      <Input 
                                        id="edit-date-debut" 
                                        name="date_debut" 
                                        type="date"
                                        defaultValue={editingDocument.date_debut ? editingDocument.date_debut.split('T')[0] : ''}
                                      />
                                    </div>
                                    <div>
                                      <Label htmlFor="edit-date-fin">Date de fin</Label>
                                      <Input 
                                        id="edit-date-fin" 
                                        name="date_fin" 
                                        type="date"
                                        defaultValue={editingDocument.date_fin ? editingDocument.date_fin.split('T')[0] : ''}
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <Label htmlFor="edit-nb-jours">Nombre de jours</Label>
                                    <Input 
                                      id="edit-nb-jours" 
                                      name="nb_jours" 
                                      type="number"
                                      defaultValue={editingDocument.nb_jours || ''}
                                    />
                                  </div>
                                </>
                              )}
                              
                              {editingDocument.document_type === 'solde-compte' && (
                                <>
                                  <div>
                                    <Label htmlFor="edit-motif-depart">Motif de départ</Label>
                                    <select
                                      id="edit-motif-depart"
                                      name="motif_depart"
                                      defaultValue={editingDocument.motif_depart || ''}
                                      className="flex h-9 w-full rounded-md border border-input bg-white px-3 py-2 text-sm"
                                    >
                                      <option value="">Sélectionner le motif</option>
                                      <option value="demission">Démission</option>
                                      <option value="licenciement">Licenciement</option>
                                      <option value="fin-contrat">Fin de contrat</option>
                                      <option value="retraite">Départ à la retraite</option>
                                      <option value="mutation">Mutation</option>
                                      <option value="abandon-poste">Abandon de poste</option>
                                    </select>
                                  </div>
                                  <div>
                                    <Label htmlFor="edit-date-depart">Date de départ</Label>
                                    <Input 
                                      id="edit-date-depart" 
                                      name="date_depart" 
                                      type="date"
                                      defaultValue={editingDocument.date_depart ? editingDocument.date_depart.split('T')[0] : ''}
                                    />
                                  </div>
                                  <div>
                                    <Label htmlFor="edit-montant-total">Montant total (F CFA)</Label>
                                    <Input 
                                      id="edit-montant-total" 
                                      name="montant_total" 
                                      type="number"
                                      defaultValue={editingDocument.montant_total || ''}
                                    />
                                  </div>
                                </>
                              )}
                              
                              {editingDocument.document_type === 'certificat' && (
                                <>
                                  <div>
                                    <Label htmlFor="edit-type-certificat">Type de certificat</Label>
                                    <select
                                      id="edit-type-certificat"
                                      name="type_certificat"
                                      defaultValue={editingDocument.type_certificat || ''}
                                      className="flex h-9 w-full rounded-md border border-input bg-white px-3 py-2 text-sm"
                                    >
                                      <option value="">Sélectionner le type</option>
                                      <option value="travail">Certificat de travail</option>
                                      <option value="salaire">Certificat de salaire</option>
                                      <option value="presence">Certificat de présence</option>
                                      <option value="stage">Certificat de stage</option>
                                      <option value="interim">Certificat intérimaire</option>
                                    </select>
                                  </div>
                                  <div className="grid grid-cols-2 gap-4">
                                    <div>
                                      <Label htmlFor="edit-periode-debut">Période début</Label>
                                      <Input 
                                        id="edit-periode-debut" 
                                        name="periode_debut" 
                                        type="date"
                                        defaultValue={editingDocument.periode_debut ? editingDocument.periode_debut.split('T')[0] : ''}
                                      />
                                    </div>
                                    <div>
                                      <Label htmlFor="edit-periode-fin">Période fin</Label>
                                      <Input 
                                        id="edit-periode-fin" 
                                        name="periode_fin" 
                                        type="date"
                                        defaultValue={editingDocument.periode_fin ? editingDocument.periode_fin.split('T')[0] : ''}
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <Label htmlFor="edit-objet">Objet/Demandeur</Label>
                                    <Input 
                                      id="edit-objet" 
                                      name="objet" 
                                      defaultValue={editingDocument.objet || ''}
                                      placeholder="Ex: Demande de crédit bancaire, Visa, etc."
                                    />
                                  </div>
                                </>
                              )}
                              
                              {/* Remplacement du fichier (optionnel) */}
                              <div>
                                <Label htmlFor="edit-file">Remplacer le fichier (optionnel)</Label>
                                <Input 
                                  id="edit-file" 
                                  name="file" 
                                  type="file" 
                                  accept=".pdf"
                                />
                                {editingDocument.file_name && (
                                  <p className="text-xs text-gray-500 mt-1">
                                    Fichier actuel: {editingDocument.file_name}
                                  </p>
                                )}
                              </div>
                              
                              <div className="flex justify-end space-x-2 pt-4">
                                <Button 
                                  type="button" 
                                  variant="outline"
                                  onClick={() => {
                                    setIsEditDocumentOpen(false);
                                    setEditingDocument(null);
                                  }}
                                >
                                  Annuler
                                </Button>
                                <Button type="submit" className="bg-yellow-600 hover:bg-yellow-700">
                                  Enregistrer les modifications
                                </Button>
                              </div>
                            </form>
                          )}
                        </DialogContent>
                      </Dialog>
                      </>
                    )}
                    </div>
                  </div>
                </div>
              )}
            </TabsContent>

              {/* Payroll Tab */}
              {/* Overtime Tab */}
              <TabsContent value="overtime" className="space-y-4">
                <OvertimeManagement company={selectedCompany} />
              </TabsContent>

              <TabsContent value="payroll" className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-900">Gestion de la paie</h2>
                
                {/* Navigation buttons for payroll features */}
                <div className="flex flex-wrap gap-1 sm:gap-2 border-b overflow-x-auto">
                  <Button
                    variant={payrollSection === 'loans' ? 'default' : 'ghost'}
                    onClick={() => setPayrollSection('loans')}
                    className="rounded-b-none transition-all duration-200 hover:scale-105 active:scale-95 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2 min-w-fit whitespace-nowrap flex-shrink-0"
                    disabled={false}
                  >
                    <TrendingUp className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden sm:inline">Prêts</span>
                    <span className="sm:hidden">Prêts</span>
                  </Button>
                  <Button
                    variant={payrollSection === 'calculation' ? 'default' : 'ghost'}
                    onClick={() => setPayrollSection('calculation')}
                    className="rounded-b-none transition-all duration-200 hover:scale-105 active:scale-95 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2 min-w-fit whitespace-nowrap flex-shrink-0"
                    disabled={false}
                  >
                    <Calculator className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden sm:inline">Calcul de paie</span>
                    <span className="sm:hidden">Calcul</span>
                  </Button>
                  <Button
                    variant={payrollSection === 'bulletin' ? 'default' : 'ghost'}
                    onClick={() => setPayrollSection('bulletin')}
                    className="rounded-b-none transition-all duration-200 hover:scale-105 active:scale-95 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2 min-w-fit whitespace-nowrap flex-shrink-0"
                    disabled={false}
                  >
                    <FileText className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden sm:inline">Édition de bulletin</span>
                    <span className="sm:hidden">Édition</span>
                  </Button>
                  <Button
                    variant={payrollSection === 'generated' ? 'default' : 'ghost'}
                    onClick={() => setPayrollSection('generated')}
                    className="rounded-b-none transition-all duration-200 hover:scale-105 active:scale-95 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2 min-w-fit whitespace-nowrap flex-shrink-0"
                    disabled={false}
                  >
                    <BarChart3 className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden sm:inline">Bulletins Générés</span>
                    <span className="sm:hidden">Générés</span>
                  </Button>
                  <Button
                    variant={payrollSection === 'paybook' ? 'default' : 'ghost'}
                    onClick={() => setPayrollSection('paybook')}
                    className="rounded-b-none transition-all duration-200 hover:scale-105 active:scale-95 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2 min-w-fit whitespace-nowrap flex-shrink-0"
                    disabled={false}
                  >
                    <Book className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden sm:inline">Livre de paie</span>
                    <span className="sm:hidden">Livre</span>
                  </Button>
                </div>

                {/* Loans Section */}
                {payrollSection === 'loans' && (
                  <div className="space-y-6">
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg border-l-4 border-blue-500">
                      <h3 className="text-xl font-bold text-blue-900 flex items-center mb-2">
                        <TrendingUp className="w-6 h-6 mr-2" />
                        Gestion des Prêts
                      </h3>
                      <p className="text-sm text-blue-700">
                        Gérez les prêts accordés aux employés et configurez les remboursements mensuels
                      </p>
                    </div>

                    {/* Formulaire d'ajout de prêt */}
                    <Card className="p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4">Accorder un nouveau prêt</h4>
                      <form onSubmit={async (e) => {
                        e.preventDefault();
                        try {
                          const response = await axios.post(`${API}/loans`, loanForm, {
                            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                          });
                          toast.success('Prêt accordé avec succès');
                          setLoanForm({
                            employee_id: '',
                            amount: '',
                            monthly_deduction: '',
                            start_date: '',
                            description: ''
                          });
                          // Recharger la liste des prêts
                          const loansResponse = await axios.get(`${API}/companies/${selectedCompany.id}/loans`, {
                            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                          });
                          setLoans(loansResponse.data);
                        } catch (error) {
                          toast.error('Erreur lors de l\'ajout du prêt');
                        }
                      }} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <Label>Employé *</Label>
                            <select
                              value={loanForm.employee_id}
                              onChange={(e) => setLoanForm({ ...loanForm, employee_id: e.target.value })}
                              className="w-full p-2 border rounded-lg"
                              required
                            >
                              <option value="">Sélectionner un employé</option>
                              {employees.map((emp) => (
                                <option key={emp.id} value={emp.id}>
                                  {emp.first_name} {emp.last_name} - {emp.position}
                                </option>
                              ))}
                            </select>
                          </div>
                          
                          <div>
                            <Label>Montant du prêt (FCFA) *</Label>
                            <input
                              type="number"
                              value={loanForm.amount}
                              onChange={(e) => setLoanForm({ ...loanForm, amount: e.target.value })}
                              className="w-full p-2 border rounded-lg"
                              placeholder="Ex: 500000"
                              required
                            />
                          </div>
                          
                          <div>
                            <Label>Remboursement mensuel (FCFA) *</Label>
                            <input
                              type="number"
                              value={loanForm.monthly_deduction}
                              onChange={(e) => setLoanForm({ ...loanForm, monthly_deduction: e.target.value })}
                              className="w-full p-2 border rounded-lg"
                              placeholder="Ex: 50000"
                              required
                            />
                          </div>
                          
                          <div>
                            <Label>Date de début *</Label>
                            <input
                              type="date"
                              value={loanForm.start_date}
                              onChange={(e) => setLoanForm({ ...loanForm, start_date: e.target.value })}
                              className="w-full p-2 border rounded-lg"
                              required
                            />
                          </div>
                        </div>
                        
                        <div>
                          <Label>Description / Motif</Label>
                          <textarea
                            value={loanForm.description}
                            onChange={(e) => setLoanForm({ ...loanForm, description: e.target.value })}
                            className="w-full p-2 border rounded-lg"
                            placeholder="Ex: Prêt pour acquisition véhicule"
                            rows="2"
                          />
                        </div>
                        
                        <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700">
                          <Plus className="w-4 h-4 mr-2" />
                          Accorder le prêt
                        </Button>
                      </form>
                    </Card>

                    {/* Liste des prêts */}
                    <Card className="p-6">
                      <div className="flex justify-between items-center mb-4">
                        <h4 className="text-lg font-semibold text-gray-800">Prêts en cours</h4>
                        <Button
                          variant="outline"
                          size="sm"
                          disabled={!selectedCompany || isLoadingLoans}
                          onClick={async () => {
                            if (!selectedCompany) {
                              toast.error('Veuillez sélectionner une entreprise');
                              return;
                            }
                            setIsLoadingLoans(true);
                            try {
                              const response = await axios.get(`${API}/companies/${selectedCompany.id}/loans`, {
                                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                              });
                              setLoans(response.data);
                              toast.success(`Liste actualisée (${response.data.length} prêt(s))`);
                            } catch (error) {
                              console.error('Erreur actualisation prêts:', error);
                              toast.error('Erreur lors du chargement des prêts');
                            } finally {
                              setIsLoadingLoans(false);
                            }
                          }}
                        >
                          <RefreshCw className={`w-4 h-4 mr-1 ${isLoadingLoans ? 'animate-spin' : ''}`} />
                          {isLoadingLoans ? 'Chargement...' : 'Actualiser'}
                        </Button>
                      </div>

                      {loans.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                          <TrendingUp className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                          <p>Aucun prêt en cours</p>
                        </div>
                      ) : (
                        <div className="space-y-4">
                          {loans.map((loan) => (
                            <Card key={loan.id} className="p-4 border-l-4 border-blue-500">
                              <div className="flex justify-between items-start">
                                <div className="flex-1">
                                  <h5 className="font-semibold text-gray-900">
                                    {loan.employee_name}
                                  </h5>
                                  <p className="text-sm text-gray-600 mt-1">{loan.description}</p>
                                  
                                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-3">
                                    <div>
                                      <p className="text-xs text-gray-500">Montant total</p>
                                      <p className="font-semibold text-blue-600">{formatCurrency(loan.amount)}</p>
                                    </div>
                                    <div>
                                      <p className="text-xs text-gray-500">Remboursement mensuel</p>
                                      <p className="font-semibold text-orange-600">{formatCurrency(loan.monthly_deduction)}</p>
                                    </div>
                                    <div>
                                      <p className="text-xs text-gray-500">Montant restant</p>
                                      <p className="font-semibold text-green-600">{formatCurrency(loan.remaining_amount)}</p>
                                    </div>
                                    <div>
                                      <p className="text-xs text-gray-500">Statut</p>
                                      <Badge variant={loan.status === 'active' ? 'default' : 'secondary'}>
                                        {loan.status === 'active' ? 'Actif' : 'Remboursé'}
                                      </Badge>
                                    </div>
                                  </div>
                                  
                                  <div className="flex items-center gap-4 mt-2 text-xs text-gray-500">
                                    <span>Début: {new Date(loan.start_date).toLocaleDateString('fr-FR')}</span>
                                    <span>•</span>
                                    <span>Durée: {Math.ceil(loan.amount / loan.monthly_deduction)} mois</span>
                                  </div>
                                </div>
                                
                                <div className="flex flex-col gap-2 ml-4">
                                  {loan.status === 'active' && (
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      onClick={async () => {
                                        if (!window.confirm('Marquer ce prêt comme remboursé ?')) return;
                                        try {
                                          await axios.put(`${API}/loans/${loan.id}/complete`, {}, {
                                            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                          });
                                          toast.success('Prêt marqué comme remboursé');
                                          // Recharger la liste
                                          const response = await axios.get(`${API}/companies/${selectedCompany.id}/loans`, {
                                            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                          });
                                          setLoans(response.data);
                                        } catch (error) {
                                          toast.error('Erreur lors de la mise à jour');
                                        }
                                      }}
                                      className="text-xs"
                                    >
                                      <CheckCircle className="w-3 h-3 mr-1" />
                                      Marquer remboursé
                                    </Button>
                                  )}
                                  <Button
                                    variant="destructive"
                                    size="sm"
                                    onClick={async () => {
                                      if (!window.confirm('Supprimer ce prêt ?')) return;
                                      try {
                                        await axios.delete(`${API}/loans/${loan.id}`, {
                                          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                        });
                                        toast.success('Prêt supprimé');
                                        // Recharger la liste
                                        const response = await axios.get(`${API}/companies/${selectedCompany.id}/loans`, {
                                          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                        });
                                        setLoans(response.data);
                                      } catch (error) {
                                        toast.error('Erreur lors de la suppression');
                                      }
                                    }}
                                    className="text-xs"
                                  >
                                    <Trash2 className="w-3 h-3 mr-1" />
                                    Supprimer
                                  </Button>
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={async () => {
                                      try {
                                        const response = await axios.get(`${API}/loans/${loan.id}/repayments`, {
                                          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                                        });
                                        setLoanRepaymentHistory(response.data);
                                        setSelectedLoanForHistory(loan);
                                      } catch (error) {
                                        toast.error('Erreur lors du chargement de l\'historique');
                                      }
                                    }}
                                    className="text-xs"
                                  >
                                    <Clock className="w-3 h-3 mr-1" />
                                    Historique
                                  </Button>
                                </div>
                              </div>
                            </Card>
                          ))}
                        </div>
                      )}

                      {/* Modal d'historique des remboursements */}
                      {loanRepaymentHistory && selectedLoanForHistory && (
                        <Dialog open={!!loanRepaymentHistory} onOpenChange={() => { setLoanRepaymentHistory(null); setSelectedLoanForHistory(null); }}>
                          <DialogContent className="max-w-2xl">
                            <DialogHeader>
                              <DialogTitle className="flex items-center gap-2">
                                <Clock className="w-5 h-5 text-blue-600" />
                                Historique des remboursements
                              </DialogTitle>
                            </DialogHeader>
                            
                            <div className="space-y-4">
                              {/* Résumé du prêt */}
                              <div className="bg-blue-50 p-4 rounded-lg">
                                <h4 className="font-semibold text-blue-800 mb-2">{loanRepaymentHistory.loan_description}</h4>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                                  <div>
                                    <span className="text-gray-500">Montant initial:</span>
                                    <p className="font-semibold text-blue-700">{formatCurrency(loanRepaymentHistory.initial_amount)}</p>
                                  </div>
                                  <div>
                                    <span className="text-gray-500">Total remboursé:</span>
                                    <p className="font-semibold text-green-600">{formatCurrency(loanRepaymentHistory.total_repaid)}</p>
                                  </div>
                                  <div>
                                    <span className="text-gray-500">Reste à payer:</span>
                                    <p className="font-semibold text-orange-600">{formatCurrency(loanRepaymentHistory.current_remaining)}</p>
                                  </div>
                                  <div>
                                    <span className="text-gray-500">Statut:</span>
                                    <Badge variant={loanRepaymentHistory.status === 'active' ? 'default' : 'secondary'}>
                                      {loanRepaymentHistory.status === 'active' ? 'En cours' : 'Remboursé'}
                                    </Badge>
                                  </div>
                                </div>
                                
                                {/* Barre de progression */}
                                <div className="mt-3">
                                  <div className="flex justify-between text-xs text-gray-600 mb-1">
                                    <span>Progression</span>
                                    <span>{Math.round((loanRepaymentHistory.total_repaid / loanRepaymentHistory.initial_amount) * 100)}%</span>
                                  </div>
                                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                    <div 
                                      className="h-full bg-green-500 transition-all"
                                      style={{ width: `${(loanRepaymentHistory.total_repaid / loanRepaymentHistory.initial_amount) * 100}%` }}
                                    />
                                  </div>
                                </div>
                              </div>
                              
                              {/* Tableau d'historique */}
                              <div className="border rounded-lg overflow-hidden">
                                <table className="w-full">
                                  <thead className="bg-gray-50">
                                    <tr>
                                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">Période</th>
                                      <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600">Montant déduit</th>
                                      <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600">Solde restant</th>
                                    </tr>
                                  </thead>
                                  <tbody className="divide-y">
                                    {loanRepaymentHistory.repayments.length === 0 ? (
                                      <tr>
                                        <td colSpan="3" className="px-4 py-8 text-center text-gray-500">
                                          <Clock className="w-8 h-8 mx-auto mb-2 text-gray-300" />
                                          <p>Aucun remboursement enregistré</p>
                                          <p className="text-xs mt-1">Les remboursements apparaîtront ici après la génération des bulletins de paie</p>
                                        </td>
                                      </tr>
                                    ) : (
                                      loanRepaymentHistory.repayments.map((rep, idx) => (
                                        <tr key={idx} className="hover:bg-gray-50">
                                          <td className="px-4 py-3">
                                            <span className="font-medium">{rep.period}</span>
                                          </td>
                                          <td className="px-4 py-3 text-right">
                                            <span className="text-red-600 font-medium">- {formatCurrency(rep.amount_deducted)}</span>
                                          </td>
                                          <td className="px-4 py-3 text-right">
                                            <span className="text-gray-700">{formatCurrency(rep.remaining_after)}</span>
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            
                            <div className="flex justify-end mt-4">
                              <Button variant="outline" onClick={() => { setLoanRepaymentHistory(null); setSelectedLoanForHistory(null); }}>
                                Fermer
                              </Button>
                            </div>
                          </DialogContent>
                        </Dialog>
                      )}
                    </Card>
                  </div>
                )}

                {/* Payroll Calculation Section */}
                {payrollSection === 'calculation' && (
                  <div className="space-y-4">
                    {!isCalculatePayrollOpen && !isMonthlyPayrollOpen && !isSalaryAdjustmentOpen && !isDailyPayrollOpen && !isCreateDailyEmployeeOpen && (
                      <>
                        <div className="flex justify-between items-center">
                          <h3 className="text-lg font-semibold text-gray-800">Calcul de paie - Détermination du salaire net</h3>
                          <div className="flex space-x-3">
                            {/* Bouton pour ouvrir la vue plein écran */}
                            <Button 
                              className="bg-orange-600 hover:bg-orange-700"
                              onClick={() => setIsCalculatePayrollOpen(true)}
                            >
                              <Calculator className="w-4 h-4 mr-2" />
                              Calculer la paie
                            </Button>

                            {/* Paie du mois en 1 clic */}
                            <Button 
                              className="bg-sky-600 hover:bg-sky-700"
                              onClick={() => setIsMonthlyPayrollOpen(true)}
                              data-testid="monthly-payroll-open-btn"
                            >
                              <Calendar className="w-4 h-4 mr-2" />
                              Paie du mois (tous)
                            </Button>

                            {/* Nouvelle fonctionnalité d'ajustement automatique du sursalaire */}
                            <Button 
                              className="bg-green-600 hover:bg-green-700"
                              onClick={() => setIsSalaryAdjustmentOpen(true)}
                            >
                              <TrendingUp className="w-4 h-4 mr-2" />
                              Ajuster sursalaire
                            </Button>

                            {/* Nouvelle fonctionnalité de paie journalière */}
                            <Button 
                              className="bg-blue-600 hover:bg-blue-700"
                              onClick={() => setIsDailyPayrollOpen(true)}
                            >
                              <Calendar className="w-4 h-4 mr-2" />
                              Paie journalière
                            </Button>

                            {/* Créer employé journalier */}
                            <Button 
                              className="bg-purple-600 hover:bg-purple-700"
                              onClick={() => setIsCreateDailyEmployeeOpen(true)}
                            >
                              <Plus className="w-4 h-4 mr-2" />
                              Créer employé journalier
                            </Button>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Vue pleine page pour calculer la paie */}
                    {isCalculatePayrollOpen && (
                      <div style={{
                        backgroundColor: '#fff7ed',
                        minHeight: '100vh',
                        width: '100%'
                      }}>
                            {/* Header avec gradient orange */}
                            <div style={{ 
                              padding: '24px 32px',
                              background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
                              color: 'white',
                              position: 'relative'
                            }}>
                              <div style={{ 
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: '300px',
                                height: '100%',
                                background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                                pointerEvents: 'none'
                              }} />
                              
                              <Button
                                onClick={() => setIsCalculatePayrollOpen(false)}
                                variant="outline"
                                style={{ 
                                  marginBottom: '16px',
                                  backgroundColor: 'rgba(255,255,255,0.2)',
                                  borderColor: 'rgba(255,255,255,0.3)',
                                  color: 'white',
                                  backdropFilter: 'blur(10px)'
                                }}
                              >
                                <ArrowLeft className="w-4 h-4 mr-2" />
                                Retour
                              </Button>
                              
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{ 
                                  backgroundColor: 'rgba(255,255,255,0.2)',
                                  borderRadius: '12px',
                                  padding: '12px',
                                  backdropFilter: 'blur(10px)'
                                }}>
                                  <Calculator style={{ width: '32px', height: '32px' }} />
                                </div>
                                <div>
                                  <h1 style={{ 
                                    fontSize: '28px', 
                                    fontWeight: 700,
                                    marginBottom: '4px',
                                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}>
                                    Calculer la paie
                                  </h1>
                                  <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                    Générer un bulletin de paie pour un employé
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div style={{ padding: '32px', backgroundColor: '#fff7ed', maxWidth: '1200px', margin: '0 auto' }}>
                              {/* Formulaire */}
                              <div style={{
                                backgroundColor: 'white',
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                                padding: '24px'
                              }}>
                                <h2 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '20px', color: '#374151' }}>
                                  Informations de paie
                                </h2>
                                <form onSubmit={handleCalculatePayroll} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {/* Sélection entreprise */}
                                    <div>
                                      <Label>Entreprise</Label>
                                      <select
                                        value={selectedCompany?.id || ''}
                                        onChange={(e) => {
                                          const companyId = e.target.value;
                                          const company = companies.find(c => c.id === companyId);
                                          setSelectedCompany(company);
                                          setPayrollForm({...payrollForm, employee_id: ''});
                                        }}
                                        style={{
                                          width: '100%',
                                          padding: '8px 12px',
                                          borderRadius: '6px',
                                          border: '1px solid #d1d5db',
                                          fontSize: '14px',
                                          backgroundColor: 'white',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        <option value="">Sélectionner une entreprise</option>
                                        {companies.map((company) => (
                                          <option key={company.id} value={company.id}>
                                            {company.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    {/* Sélection employé */}
                                    <div>
                                      <Label>Employé *</Label>
                                      <Input
                                        type="text"
                                        placeholder="🔍 Rechercher par nom ou matricule..."
                                        value={payrollEmployeeSearch}
                                        onChange={(e) => setPayrollEmployeeSearch(e.target.value)}
                                        data-testid="payroll-employee-search-input"
                                        style={{ marginBottom: '8px' }}
                                      />
                                      <select
                                        value={payrollForm.employee_id}
                                        onChange={(e) => handleEmployeeSelection(e.target.value)}
                                        required
                                        data-testid="payroll-employee-select"
                                        style={{
                                          width: '100%',
                                          padding: '8px 12px',
                                          borderRadius: '6px',
                                          border: '1px solid #d1d5db',
                                          fontSize: '14px',
                                          backgroundColor: 'white',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        <option value="">Sélectionner un employé</option>
                                        {(() => {
                                          const source = allEmployees.length > 0 ? allEmployees : employees;
                                          const q = payrollEmployeeSearch.trim().toLowerCase();
                                          const filtered = q
                                            ? source.filter(emp => `${emp.first_name} ${emp.last_name} ${emp.matricule || ''}`.toLowerCase().includes(q))
                                            : source;
                                          return filtered.length === 0 ? (
                                            <option disabled>Aucun employé trouvé</option>
                                          ) : (
                                            filtered.map((employee) => (
                                              <option key={employee.id} value={employee.id}>
                                                {employee.first_name} {employee.last_name} ({employee.position || 'N/A'})
                                              </option>
                                            ))
                                          );
                                        })()}
                                      </select>
                                      {selectedCompany && (
                                        <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                                          Entreprise: {selectedCompany.name} • {(allEmployees.length > 0 ? allEmployees : employees).length} employé(s) actif(s)
                                        </p>
                                      )}
                                    </div>
                                    
                                    <div className="grid grid-cols-2 gap-4">
                                      <div>
                                        <Label>Mois</Label>
                                        <select
                                          value={payrollForm.month}
                                          onChange={(e) => setPayrollForm({...payrollForm, month: parseInt(e.target.value)})}
                                          style={{
                                            width: '100%',
                                            padding: '8px 12px',
                                            borderRadius: '6px',
                                            border: '1px solid #d1d5db',
                                            fontSize: '14px',
                                            backgroundColor: 'white',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          {Array.from({length: 12}, (_, i) => (
                                            <option key={i+1} value={i+1}>
                                              {new Date(payrollForm.year, i).toLocaleDateString('fr-FR', { month: 'long' })}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div>
                                        <Label>Année</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.year} 
                                          onChange={(e) => setPayrollForm({...payrollForm, year: parseInt(e.target.value)})}
                                        />
                                      </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-3 gap-4">
                                      <div>
                                        <Label>Prime transport (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-prime-transport-input"
                                          value={payrollForm.prime_transport} 
                                          onChange={(e) => setPayrollForm({...payrollForm, prime_transport: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                      <div>
                                        <Label>Avantages nature (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-avantages-nature-input"
                                          value={payrollForm.avantages_nature} 
                                          onChange={(e) => setPayrollForm({...payrollForm, avantages_nature: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                      <div>
                                        <Label>Avantages en argent (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-avantages-argent-input"
                                          value={payrollForm.avantages_argent} 
                                          onChange={(e) => setPayrollForm({...payrollForm, avantages_argent: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-2 gap-4">
                                      <div>
                                        <Label>Heures supplémentaires (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.heures_sup} 
                                          onChange={(e) => setPayrollForm({...payrollForm, heures_sup: parseFloat(e.target.value) || 0})}
                                          data-testid="payroll-heures-sup-input"
                                        />
                                      </div>
                                      <div>
                                        <Label>Primes ponctuelles (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.primes} 
                                          onChange={(e) => setPayrollForm({...payrollForm, primes: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-2 gap-4">
                                      <div>
                                        <Label>Avances (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.avances} 
                                          onChange={(e) => setPayrollForm({...payrollForm, avances: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                      <div>
                                        <Label>Heures d'absence</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.absences_hours} 
                                          onChange={(e) => setPayrollForm({...payrollForm, absences_hours: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-2 gap-4">
                                      <div>
                                        <Label>Ancienneté (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.anciennete} 
                                          onChange={(e) => setPayrollForm({...payrollForm, anciennete: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                      <div>
                                        <Label>Indemnité frais d'emploi (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          value={payrollForm.indemnite_frais_emploi} 
                                          onChange={(e) => setPayrollForm({...payrollForm, indemnite_frais_emploi: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                    </div>
                                    
                                    <div>
                                      <Label>Remboursement de frais (FCFA)</Label>
                                      <Input 
                                        type="number" 
                                        value={payrollForm.remboursement_frais} 
                                        onChange={(e) => setPayrollForm({...payrollForm, remboursement_frais: parseFloat(e.target.value) || 0})}
                                      />
                                    </div>
                                    
                                    <div className="grid grid-cols-2 gap-4">
                                      <div>
                                        <Label>Prime de panier (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-prime-panier-input"
                                          value={payrollForm.prime_panier} 
                                          onChange={(e) => setPayrollForm({...payrollForm, prime_panier: parseFloat(e.target.value) || 0})}
                                        />
                                        {payrollForm.prime_panier > 0 && (
                                          <p style={{ fontSize: '11px', marginTop: '4px', color: payrollForm.prime_panier > SPECIAL_PRIME_PLAFONDS.prime_panier ? '#b45309' : '#15803d' }}>
                                            {payrollForm.prime_panier > SPECIAL_PRIME_PLAFONDS.prime_panier
                                              ? `⚠️ Exonéré : ${formatCurrency(SPECIAL_PRIME_PLAFONDS.prime_panier)} • Imposable : ${formatCurrency(payrollForm.prime_panier - SPECIAL_PRIME_PLAFONDS.prime_panier)}`
                                              : `✓ Totalement exonérée (plafond : ${formatCurrency(SPECIAL_PRIME_PLAFONDS.prime_panier)})`}
                                          </p>
                                        )}
                                      </div>
                                      <div>
                                        <Label>Prime de salissure (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-prime-salissure-input"
                                          value={payrollForm.prime_salissure} 
                                          onChange={(e) => setPayrollForm({...payrollForm, prime_salissure: parseFloat(e.target.value) || 0})}
                                        />
                                        {payrollForm.prime_salissure > 0 && (
                                          <p style={{ fontSize: '11px', marginTop: '4px', color: payrollForm.prime_salissure > SPECIAL_PRIME_PLAFONDS.prime_salissure ? '#b45309' : '#15803d' }}>
                                            {payrollForm.prime_salissure > SPECIAL_PRIME_PLAFONDS.prime_salissure
                                              ? `⚠️ Exonéré : ${formatCurrency(SPECIAL_PRIME_PLAFONDS.prime_salissure)} • Imposable : ${formatCurrency(payrollForm.prime_salissure - SPECIAL_PRIME_PLAFONDS.prime_salissure)}`
                                              : `✓ Totalement exonérée (plafond : ${formatCurrency(SPECIAL_PRIME_PLAFONDS.prime_salissure)})`}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-2 gap-4">
                                      <div>
                                        <Label>Indemnité de tenue de travail (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-prime-tenue-input"
                                          value={payrollForm.prime_tenue} 
                                          onChange={(e) => setPayrollForm({...payrollForm, prime_tenue: parseFloat(e.target.value) || 0})}
                                        />
                                      </div>
                                      <div>
                                        <Label>Prime d'outillage (FCFA)</Label>
                                        <Input 
                                          type="number" 
                                          data-testid="payroll-prime-outillage-input"
                                          value={payrollForm.prime_outillage} 
                                          onChange={(e) => setPayrollForm({...payrollForm, prime_outillage: parseFloat(e.target.value) || 0})}
                                        />
                                        {payrollForm.prime_outillage > 0 && (
                                          <p style={{ fontSize: '11px', marginTop: '4px', color: payrollForm.prime_outillage > SPECIAL_PRIME_PLAFONDS.prime_outillage ? '#b45309' : '#15803d' }}>
                                            {payrollForm.prime_outillage > SPECIAL_PRIME_PLAFONDS.prime_outillage
                                              ? `⚠️ Exonéré : ${formatCurrency(SPECIAL_PRIME_PLAFONDS.prime_outillage)} • Imposable : ${formatCurrency(payrollForm.prime_outillage - SPECIAL_PRIME_PLAFONDS.prime_outillage)}`
                                              : `✓ Totalement exonérée (plafond : ${formatCurrency(SPECIAL_PRIME_PLAFONDS.prime_outillage)})`}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    
                                    {/* Allocations spéciales Art. 116-1 */}
                                    {payrollForm.employee_id && (
                                      <div data-testid="payroll-special-allowances-section" style={{ backgroundColor: '#eff6ff', border: '2px solid #bfdbfe', borderRadius: '12px', padding: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#1e40af', marginBottom: '12px' }}>
                                          🎯 Allocations spéciales (Art. 116-1)
                                        </h3>
                                        {Object.keys(payrollForm.special_allowance_amounts || {}).length === 0 ? (
                                          <p style={{ fontSize: '13px', color: '#1e40af' }}>
                                            Aucune allocation spéciale définie sur la fiche de cet employé. Vous pouvez en ajouter depuis l'onglet Employés (fiche employé → Allocations spéciales).
                                          </p>
                                        ) : (
                                          <>
                                            <div className="grid grid-cols-3 gap-4">
                                              {Object.entries(payrollForm.special_allowance_amounts).map(([compId, amount]) => {
                                                const comp = salaryComponents.find(c => c.id === compId);
                                                return (
                                                  <div key={compId}>
                                                    <Label>{comp?.name || 'Allocation spéciale'} (FCFA)</Label>
                                                    <Input
                                                      type="number"
                                                      data-testid={`payroll-special-allowance-${compId}`}
                                                      value={amount}
                                                      onChange={(e) => setPayrollForm({
                                                        ...payrollForm,
                                                        special_allowance_amounts: {
                                                          ...payrollForm.special_allowance_amounts,
                                                          [compId]: parseFloat(e.target.value) || 0
                                                        }
                                                      })}
                                                    />
                                                  </div>
                                                );
                                              })}
                                            </div>
                                            <p style={{ fontSize: '12px', color: '#1e40af', marginTop: '12px' }}>
                                              Total : <strong data-testid="payroll-special-allowances-total">{formatCurrency(Object.values(payrollForm.special_allowance_amounts).reduce((s, v) => s + (parseFloat(v) || 0), 0))}</strong>
                                              {' '}— Exonérées à hauteur de 10% de la rémunération brute (plafond Art. 116-1 CGI), le surplus est imposable. La répartition exonérée/imposable est calculée automatiquement par le moteur de paie.
                                            </p>
                                          </>
                                        )}
                                      </div>
                                    )}
                                    

                                    {/* Aperçu du salaire net en direct */}
                                    {payrollForm.employee_id && (
                                      <div data-testid="payroll-live-preview" style={{ backgroundColor: '#ecfdf5', border: '2px solid #6ee7b7', borderRadius: '12px', padding: '16px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                          <div>
                                            <p style={{ fontSize: '13px', color: '#047857', fontWeight: 600 }}>💡 Aperçu en direct — Salaire net à payer</p>
                                            <p data-testid="payroll-live-preview-net" style={{ fontSize: '26px', fontWeight: 800, color: '#059669' }}>
                                              {payrollPreviewLoading ? '…' : (payrollLivePreview ? formatCurrency(payrollLivePreview.salary_net_a_payer ?? payrollLivePreview.salary_net) : '—')}
                                            </p>
                                          </div>
                                          {payrollLivePreview && !payrollPreviewLoading && (
                                            <div style={{ textAlign: 'right', fontSize: '12px', color: '#065f46', lineHeight: 1.8 }}>
                                              <div>Brut imposable IS : <strong>{formatCurrency(payrollLivePreview.salary_brut_imposable_is)}</strong></div>
                                              <div>Brut social imposable : <strong>{formatCurrency(payrollLivePreview.salary_brut_social_imposable)}</strong></div>
                                              <div>Retenues salariales : <strong style={{ color: '#dc2626' }}>-{formatCurrency(payrollLivePreview.retenues_salariales_total)}</strong></div>
                                              {payrollLivePreview.total_remboursement_prets > 0 && (
                                                <div>Remboursement prêts : <strong style={{ color: '#dc2626' }}>-{formatCurrency(payrollLivePreview.total_remboursement_prets)}</strong></div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                        <p style={{ fontSize: '11px', color: '#047857', marginTop: '4px' }}>Recalculé automatiquement à chaque modification — aucun bulletin n'est enregistré tant que vous ne validez pas.</p>
                                      </div>
                                    )}
                                    
                                    {/* Mode de paiement */}
                                    <div>
                                      <Label>Mode de paiement *</Label>
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '12px', border: '2px solid', borderColor: payrollForm.payment_method === 'espece' ? '#f97316' : '#e5e7eb', borderRadius: '8px', backgroundColor: payrollForm.payment_method === 'espece' ? '#fff7ed' : 'white', transition: 'all 0.2s' }}>
                                          <input
                                            type="radio"
                                            name="payment_method"
                                            value="espece"
                                            checked={payrollForm.payment_method === 'espece'}
                                            onChange={(e) => setPayrollForm({...payrollForm, payment_method: e.target.value})}
                                            required
                                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                          />
                                          <span style={{ fontSize: '14px', fontWeight: payrollForm.payment_method === 'espece' ? '600' : '400' }}>💵 Paiement en espèce</span>
                                        </label>
                                        
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '12px', border: '2px solid', borderColor: payrollForm.payment_method === 'virement' ? '#f97316' : '#e5e7eb', borderRadius: '8px', backgroundColor: payrollForm.payment_method === 'virement' ? '#fff7ed' : 'white', transition: 'all 0.2s' }}>
                                          <input
                                            type="radio"
                                            name="payment_method"
                                            value="virement"
                                            checked={payrollForm.payment_method === 'virement'}
                                            onChange={(e) => setPayrollForm({...payrollForm, payment_method: e.target.value})}
                                            required
                                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                          />
                                          <span style={{ fontSize: '14px', fontWeight: payrollForm.payment_method === 'virement' ? '600' : '400' }}>🏦 Virement bancaire</span>
                                        </label>
                                        
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '12px', border: '2px solid', borderColor: payrollForm.payment_method === 'cheque' ? '#f97316' : '#e5e7eb', borderRadius: '8px', backgroundColor: payrollForm.payment_method === 'cheque' ? '#fff7ed' : 'white', transition: 'all 0.2s' }}>
                                          <input
                                            type="radio"
                                            name="payment_method"
                                            value="cheque"
                                            checked={payrollForm.payment_method === 'cheque'}
                                            onChange={(e) => setPayrollForm({...payrollForm, payment_method: e.target.value})}
                                            required
                                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                          />
                                          <span style={{ fontSize: '14px', fontWeight: payrollForm.payment_method === 'cheque' ? '600' : '400' }}>📄 Chèque</span>
                                        </label>
                                      </div>
                                    </div>
                                    
                                    <Button type="submit" className="w-full bg-orange-600 hover:bg-orange-700">
                                      Générer le bulletin
                                    </Button>
                                  </form>
                              </div>
                            </div>
                      </div>
                    )}

                    {/* Vue pleine page pour Paie du mois en 1 clic */}
                    {isMonthlyPayrollOpen && (
                      <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', width: '100%' }} data-testid="monthly-payroll-view">
                        {/* Header avec gradient */}
                        <div style={{ padding: '24px 32px', background: 'linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)', color: 'white', position: 'relative' }}>
                          <Button
                            onClick={() => { setIsMonthlyPayrollOpen(false); setMonthlyPayrollResult(null); }}
                            variant="ghost"
                            style={{ color: 'white', marginBottom: '8px' }}
                            data-testid="monthly-payroll-back-btn"
                          >
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            Retour
                          </Button>
                          <h2 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Paie du mois en 1 clic</h2>
                          <p style={{ opacity: 0.9, fontSize: '14px', marginTop: '4px' }}>
                            Générez tous les bulletins du mois avec les montants pré-remplis depuis les profils employés
                          </p>
                        </div>

                        <div style={{ padding: '24px 32px', maxWidth: '1500px', margin: '0 auto' }}>
                          {/* Sélection de la période */}
                          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' }}>
                            <div>
                              <Label>Mois</Label>
                              <select
                                value={monthlyPayrollPeriod.month}
                                onChange={(e) => setMonthlyPayrollPeriod({ ...monthlyPayrollPeriod, month: parseInt(e.target.value) })}
                                data-testid="monthly-payroll-month-select"
                                style={{ display: 'block', padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px', backgroundColor: 'white', cursor: 'pointer', minWidth: '160px' }}
                              >
                                {Array.from({ length: 12 }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {new Date(monthlyPayrollPeriod.year, i).toLocaleDateString('fr-FR', { month: 'long' })}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div>
                              <Label>Année</Label>
                              <Input
                                type="number"
                                value={monthlyPayrollPeriod.year}
                                onChange={(e) => setMonthlyPayrollPeriod({ ...monthlyPayrollPeriod, year: parseInt(e.target.value) || new Date().getFullYear() })}
                                data-testid="monthly-payroll-year-input"
                                style={{ width: '120px' }}
                              />
                            </div>
                            <div style={{ flex: 1 }} />
                            <Button
                              onClick={handleGenerateMonthlyPayroll}
                              disabled={generatingMonthlyPayroll || monthlyPayrollSelection.length === 0}
                              className="bg-sky-600 hover:bg-sky-700"
                              data-testid="monthly-payroll-generate-btn"
                            >
                              {generatingMonthlyPayroll ? (
                                <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Génération en cours...</>
                              ) : (
                                <><Calculator className="w-4 h-4 mr-2" /> Générer les bulletins ({monthlyPayrollSelection.length})</>
                              )}
                            </Button>
                          </div>

                          {/* Résultat de la génération */}
                          {monthlyPayrollResult && (
                            <div style={{ marginBottom: '20px', padding: '16px', borderRadius: '8px', backgroundColor: monthlyPayrollResult.failed > 0 ? '#fffbeb' : '#f0fdf4', border: `2px solid ${monthlyPayrollResult.failed > 0 ? '#fde68a' : '#bbf7d0'}` }} data-testid="monthly-payroll-result">
                              <p style={{ fontWeight: 600, marginBottom: '4px' }}>
                                ✅ {monthlyPayrollResult.generated} bulletin(s) généré(s) pour {new Date(monthlyPayrollResult.year, monthlyPayrollResult.month - 1).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
                                {monthlyPayrollResult.failed > 0 && ` — ⚠️ ${monthlyPayrollResult.failed} échec(s)`}
                              </p>
                              <p style={{ fontSize: '14px', color: '#374151' }}>
                                Masse salariale nette totale : <strong>{formatCurrency(monthlyPayrollResult.total_net)}</strong>
                              </p>
                              {monthlyPayrollResult.errors?.length > 0 && (
                                <ul style={{ marginTop: '8px', fontSize: '13px', color: '#b45309' }}>
                                  {monthlyPayrollResult.errors.map((err, idx) => (
                                    <li key={idx}>• {err.name} : {err.error}</li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          )}

                          {/* Tableau des employés */}
                          <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'auto' }}>
                            <table className="w-full" style={{ fontSize: '13px' }}>
                              <thead className="bg-gray-50">
                                <tr>
                                  <th className="px-3 py-3 text-left">
                                    <input
                                      type="checkbox"
                                      checked={allEmployees.length > 0 && monthlyPayrollSelection.length === allEmployees.length}
                                      onChange={(e) => setMonthlyPayrollSelection(e.target.checked ? allEmployees.map(emp => emp.id) : [])}
                                      data-testid="monthly-payroll-select-all"
                                      style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                    />
                                  </th>
                                  <th className="px-3 py-3 text-left text-xs font-semibold text-gray-600">Employé</th>
                                  <th className="px-3 py-3 text-left text-xs font-semibold text-gray-600">Poste</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Salaire base</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Ancienneté</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Frais emploi</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Remb. frais</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Panier</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Salissure</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Tenue</th>
                                  <th className="px-3 py-3 text-right text-xs font-semibold text-gray-600">Outillage</th>
                                </tr>
                              </thead>
                              <tbody className="divide-y">
                                {allEmployees.length === 0 ? (
                                  <tr>
                                    <td colSpan="11" className="px-4 py-8 text-center text-gray-500">Aucun employé actif dans cette entreprise</td>
                                  </tr>
                                ) : (
                                  allEmployees.map((emp) => (
                                    <tr key={emp.id} className="hover:bg-sky-50" style={{ opacity: monthlyPayrollSelection.includes(emp.id) ? 1 : 0.45 }}>
                                      <td className="px-3 py-2">
                                        <input
                                          type="checkbox"
                                          checked={monthlyPayrollSelection.includes(emp.id)}
                                          onChange={(e) => setMonthlyPayrollSelection(prev => e.target.checked ? [...prev, emp.id] : prev.filter(id => id !== emp.id))}
                                          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                        />
                                      </td>
                                      <td className="px-3 py-2">
                                        <span style={{ fontWeight: 600 }}>{emp.first_name} {emp.last_name}</span>
                                        <span style={{ display: 'block', fontSize: '11px', color: '#6b7280' }}>{emp.matricule || ''}</span>
                                      </td>
                                      <td className="px-3 py-2 text-gray-600">{emp.position || 'N/A'}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.salary_categoriel || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.prime_anciennete || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.indemnite_frais_emploi || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.remboursement_frais || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.prime_panier || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.prime_salissure || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.prime_tenue || 0)}</td>
                                      <td className="px-3 py-2 text-right">{formatCurrency(emp.prime_outillage || 0)}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                          <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
                            ℹ️ Si un bulletin existe déjà pour un employé sur cette période, il sera mis à jour (pas de doublon). Les montants variables (heures sup, avances, absences) du dernier bulletin enregistré sont conservés.
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Vue pleine page pour Ajuster sursalaire */}
                    {isSalaryAdjustmentOpen && (
                      <SalaryAdjustment
                        employees={employees}
                        formatCurrency={formatCurrency}
                        onClose={() => setIsSalaryAdjustmentOpen(false)}
                      />
                    )}

                        {/* Vue pleine page Paie journalière */}
                        {isDailyPayrollOpen && (
                          <div style={{
                            backgroundColor: '#f8fafc',
                            minHeight: '100vh',
                            width: '100%'
                          }}>
                              {/* Header avec gradient bleu */}
                              <div style={{ 
                                padding: '24px 32px',
                                background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                                color: 'white',
                                position: 'relative'
                              }}>
                                <div style={{ 
                                  position: 'absolute',
                                  top: 0,
                                  right: 0,
                                  width: '300px',
                                  height: '100%',
                                  background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                                  pointerEvents: 'none'
                                }} />
                                
                                <Button
                                  onClick={() => setIsDailyPayrollOpen(false)}
                                  variant="outline"
                                  style={{ 
                                    marginBottom: '16px',
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    borderColor: 'rgba(255,255,255,0.3)',
                                    color: 'white',
                                    backdropFilter: 'blur(10px)'
                                  }}
                                >
                                  <ArrowLeft className="w-4 h-4 mr-2" />
                                  Retour
                                </Button>
                                
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                  <div style={{ 
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    padding: '12px',
                                    backdropFilter: 'blur(10px)'
                                  }}>
                                    <Calendar style={{ width: '32px', height: '32px' }} />
                                  </div>
                                  <div>
                                    <h1 style={{ 
                                      fontSize: '28px', 
                                      fontWeight: 700,
                                      marginBottom: '4px',
                                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}>
                                      Calcul de la paie journalière
                                    </h1>
                                    <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                      Calcul conforme à la réglementation ivoirienne : IS journalier = IBS/30 - RICF/30
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div style={{ padding: '32px', backgroundColor: '#f8fafc', maxWidth: '1200px', margin: '0 auto' }}>
                                {/* Formulaire */}
                                <div style={{
                                  backgroundColor: 'white',
                                  borderRadius: '16px',
                                  padding: '32px',
                                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                  border: '1px solid #e5e7eb'
                                }}>
                                  {/* En-tête du formulaire */}
                                  <div style={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginBottom: '24px',
                                    paddingBottom: '16px',
                                    borderBottom: '2px solid #2563eb'
                                  }}>
                                    <div style={{
                                      backgroundColor: '#dbeafe',
                                      borderRadius: '10px',
                                      padding: '10px',
                                      color: '#1d4ed8'
                                    }}>
                                      <Calculator style={{ width: '24px', height: '24px' }} />
                                    </div>
                                    <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#111827' }}>
                                      Calcul de paie journalière
                                    </h2>
                                  </div>

                                  {/* Info prime de transport et formules */}
                                  <div style={{
                                    backgroundColor: '#eff6ff',
                                    border: '2px solid #bfdbfe',
                                    borderRadius: '12px',
                                    padding: '16px',
                                    fontSize: '13px',
                                    marginBottom: '20px'
                                  }}>
                                    <div style={{
                                      fontWeight: 600,
                                      color: '#1e3a8a',
                                      marginBottom: '12px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px'
                                    }}>
                                      <Info className="w-4 h-4" />
                                      Informations réglementaires
                                    </div>
                                    
                                    <div style={{ color: '#1e40af', marginBottom: '12px' }}>
                                      <div style={{ fontWeight: 600, marginBottom: '8px' }}>🚗 Prime de transport exonérée par ville :</div>
                                      <div style={{ marginLeft: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        <div>• Abidjan : <span style={{ fontWeight: 600 }}>1 000 F/jour</span></div>
                                        <div>• Bouaké : <span style={{ fontWeight: 600 }}>800 F/jour</span></div>
                                        <div>• Autres villes : <span style={{ fontWeight: 600 }}>667 F/jour</span></div>
                                      </div>
                                    </div>
                                    
                                    <div style={{ color: '#1e40af', paddingTop: '12px', borderTop: '1px solid #bfdbfe' }}>
                                      <div style={{ fontWeight: 600, marginBottom: '8px' }}>📐 Formule indemnité de précarité :</div>
                                      <div style={{ marginLeft: '12px', fontSize: '12px', backgroundColor: 'white', padding: '8px', borderRadius: '6px', border: '1px solid #bfdbfe' }}>
                                        Indemnité précarité = (Salaire base jour + Gratification jour + Congé jour) × 3%
                                      </div>
                                    </div>
                                  </div>

                                  <form id="daily-payroll-form" onSubmit={handleCalculateDailyPayroll} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                              {/* Sélection employé et paramètres */}
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Employé</Label>
                                  <SimpleNativeSelect
                                    value={dailyPayrollForm.employee_id} 
                                    onValueChange={handleDailyPayrollEmployeeChange}
                                    placeholder="Sélectionner un employé"
                                    options={(allEmployees.length > 0 ? allEmployees : employees.filter((employee) => employee.is_active !== false)).map((employee) => ({
                                      value: employee.id,
                                      label: `${employee.first_name} ${employee.last_name} (${formatCurrency(employee.salary_categoriel || 0)})`
                                    }))}
                                  />
                                </div>
                                <div>
                                  <Label>Heures travaillées</Label>
                                  <Input 
                                    type="number" 
                                    step="0.5"
                                    min="0"
                                    max="24"
                                    value={dailyPayrollForm.heures_travaillees_jour} 
                                    onChange={(e) => setDailyPayrollForm({...dailyPayrollForm, heures_travaillees_jour: parseFloat(e.target.value) || 8.0})}
                                    style={{
                                      width: '100%',
                                      padding: '8px',
                                      border: '1px solid #d1d5db',
                                      borderRadius: '4px',
                                      pointerEvents: 'auto',
                                      position: 'relative',
                                      
                                      opacity: 1
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Mode de calcul - Normal ou Inverse */}
                              <div className="bg-purple-50 border-2 border-purple-300 rounded-lg p-4 mb-4">
                                <Label className="text-purple-900 font-semibold flex items-center mb-3">
                                  <Calculator className="w-4 h-4 mr-2" />
                                  Mode de calcul
                                </Label>
                                <div className="grid grid-cols-2 gap-3">
                                  <button
                                    type="button"
                                    onClick={() => setDailyPayrollForm({...dailyPayrollForm, mode_calcul: 'normal'})}
                                    className={`p-3 rounded-lg border-2 transition-all ${
                                      dailyPayrollForm.mode_calcul === 'normal' 
                                        ? 'bg-orange-100 border-orange-500 text-orange-900' 
                                        : 'bg-white border-gray-200 text-gray-600 hover:border-orange-300'
                                    }`}
                                  >
                                    <div className="font-semibold flex items-center justify-center">
                                      <TrendingUp className="w-4 h-4 mr-2" />
                                      Calcul Normal
                                    </div>
                                    <div className="text-xs mt-1 opacity-80">Brut → Net</div>
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => setDailyPayrollForm({...dailyPayrollForm, mode_calcul: 'inverse'})}
                                    className={`p-3 rounded-lg border-2 transition-all ${
                                      dailyPayrollForm.mode_calcul === 'inverse' 
                                        ? 'bg-green-100 border-green-500 text-green-900' 
                                        : 'bg-white border-gray-200 text-gray-600 hover:border-green-300'
                                    }`}
                                  >
                                    <div className="font-semibold flex items-center justify-center">
                                      <Banknote className="w-4 h-4 mr-2" />
                                      Calcul Inverse
                                    </div>
                                    <div className="text-xs mt-1 opacity-80">Net → Brut</div>
                                  </button>
                                </div>
                                <p className="text-xs text-purple-700 mt-2">
                                  {dailyPayrollForm.mode_calcul === 'inverse' 
                                    ? "🎯 Saisissez le net journalier souhaité et le système calculera automatiquement le salaire brut nécessaire"
                                    : "📊 Saisissez le salaire brut et le système calculera le net à payer"
                                  }
                                </p>
                              </div>

                              {/* Net journalier souhaité - Affiché uniquement en mode inverse */}
                              {dailyPayrollForm.mode_calcul === 'inverse' && (
                                <div className="bg-green-50 border-2 border-green-400 rounded-lg p-4 mb-4">
                                  <Label className="text-green-900 font-semibold flex items-center">
                                    <Banknote className="w-4 h-4 mr-2" />
                                    <span className="text-red-600 mr-1">*</span>
                                    Net journalier souhaité (FCFA)
                                  </Label>
                                  <Input 
                                    type="number" 
                                    step="1"
                                    min="0"
                                    placeholder="Ex: 25000"
                                    value={dailyPayrollForm.net_journalier_souhaite} 
                                    onChange={(e) => setDailyPayrollForm({...dailyPayrollForm, net_journalier_souhaite: e.target.value})}
                                    className="mt-2 border-green-400 focus:border-green-600 text-lg font-semibold"
                                    style={{
                                      pointerEvents: 'auto',
                                      position: 'relative',
                                      opacity: 1
                                    }}
                                    required
                                  />
                                  <p className="text-sm text-green-700 mt-2">
                                    💰 Saisissez le montant net que vous souhaitez verser par jour. 
                                    Le système calculera automatiquement le salaire brut et toutes les composantes.
                                  </p>
                                  {dailyPayrollForm.net_journalier_souhaite && dailyPayrollForm.periode_en_jours > 0 && (
                                    <div className="mt-2 p-2 bg-green-200 rounded text-sm text-green-900">
                                      <strong>💡 Net total estimé sur la période = </strong>
                                      {parseFloat(dailyPayrollForm.net_journalier_souhaite).toLocaleString()} F × {dailyPayrollForm.periode_en_jours} jours 
                                      = <strong>{(parseFloat(dailyPayrollForm.net_journalier_souhaite) * parseInt(dailyPayrollForm.periode_en_jours)).toLocaleString()} F</strong>
                                    </div>
                                  )}
                                </div>
                              )}

                              {/* Salaire de base de la période - OBLIGATOIRE en mode normal, auto-calculé en mode inverse */}
                              <div className={`rounded-lg p-3 ${dailyPayrollForm.mode_calcul === 'inverse' ? 'bg-gray-50 border border-gray-200' : 'bg-orange-50 border border-orange-200'}`}>
                                <Label className={`font-semibold flex items-center ${dailyPayrollForm.mode_calcul === 'inverse' ? 'text-gray-700' : 'text-orange-900'}`}>
                                  {dailyPayrollForm.mode_calcul !== 'inverse' && <span className="text-red-600 mr-1">*</span>}
                                  Salaire de base de la période
                                  {dailyPayrollForm.mode_calcul === 'inverse' && (
                                    <span className="ml-2 px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full">Auto-calculé</span>
                                  )}
                                </Label>
                                <Input 
                                  type="number" 
                                  step="0.01"
                                  min="0"
                                  placeholder={dailyPayrollForm.mode_calcul === 'inverse' ? "Calculé automatiquement" : "Ex: 75000"}
                                  value={dailyPayrollForm.salaire_base_periode} 
                                  onChange={(e) => setDailyPayrollForm({...dailyPayrollForm, salaire_base_periode: e.target.value})}
                                  className={`mt-2 ${dailyPayrollForm.mode_calcul === 'inverse' ? 'border-gray-300 bg-gray-100' : 'border-orange-300 focus:border-orange-500'}`}
                                  style={{
                                    pointerEvents: 'auto',
                                    position: 'relative',
                                    opacity: 1
                                  }}
                                  readOnly={dailyPayrollForm.mode_calcul === 'inverse'}
                                  required={dailyPayrollForm.mode_calcul !== 'inverse'}
                                />
                                <p className={`text-xs mt-1 ${dailyPayrollForm.mode_calcul === 'inverse' ? 'text-gray-600' : 'text-orange-700'}`}>
                                  {dailyPayrollForm.mode_calcul === 'inverse' 
                                    ? "🔄 Ce champ sera calculé automatiquement à partir du net souhaité"
                                    : "⚠️ Champ obligatoire - Salaire de base pour la période saisie"
                                  }
                                </p>
                              </div>

                              {/* Période en jours - OBLIGATOIRE */}
                              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                                <Label className="text-blue-900 font-semibold flex items-center">
                                  <span className="text-red-600 mr-1">*</span>
                                  Période en jours
                                </Label>
                                <Input 
                                  type="number" 
                                  step="1"
                                  min="1"
                                  max="365"
                                  placeholder="Ex: 30"
                                  value={dailyPayrollForm.periode_en_jours} 
                                  onChange={(e) => setDailyPayrollForm({...dailyPayrollForm, periode_en_jours: e.target.value})}
                                  className="mt-2 border-blue-300 focus:border-blue-500"
                                  style={{
                                    pointerEvents: 'auto',
                                    position: 'relative',
                                    opacity: 1
                                  }}
                                  required
                                />
                                <p className="text-xs text-blue-700 mt-1">
                                  📅 Nombre de jours de la période (ex: 30 pour un mois, 15 pour quinzaine)
                                </p>
                                {dailyPayrollForm.salaire_base_periode && dailyPayrollForm.periode_en_jours > 0 && (
                                  <div className="mt-2 p-2 bg-green-100 rounded text-sm text-green-800">
                                    <strong>💡 Salaire brut journalier = </strong>
                                    {parseFloat(dailyPayrollForm.salaire_base_periode).toLocaleString()} F ÷ {dailyPayrollForm.periode_en_jours} jours 
                                    = <strong>{Math.round(parseFloat(dailyPayrollForm.salaire_base_periode) / parseInt(dailyPayrollForm.periode_en_jours)).toLocaleString()} F/jour</strong>
                                  </div>
                                )}
                              </div>

                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Type de calcul</Label>
                                  <SimpleNativeSelect
                                  value={dailyPayrollForm.type_calcul}
                                  onValueChange={handleDailyPayrollTypeCalculChange}
                                  placeholder="Type de calcul"
                                  options={[
                                    {value: 'complet', label: 'Calcul complet'},
                                    {value: 'simple', label: 'IS journalier simple'}
                                  ]}
                                />
                                </div>
                                <div>
                                  <Label>Description période</Label>
                                  <Input 
                                    type="text"
                                    placeholder="Ex: Janvier 2025, Quinzaine 1, etc."
                                    value={dailyPayrollForm.periode} 
                                    onChange={(e) => setDailyPayrollForm({...dailyPayrollForm, periode: e.target.value})}
                                    style={{
                                      width: '100%',
                                      padding: '8px',
                                      border: '1px solid #d1d5db',
                                      borderRadius: '4px',
                                      pointerEvents: 'auto',
                                      position: 'relative',
                                      
                                      opacity: 1
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Mois</Label>
                                  <SimpleNativeSelect
                                    value={dailyPayrollForm.month.toString()} 
                                    onValueChange={handleDailyPayrollMonthChange}
                                    placeholder="Mois"
                                    options={Array.from({length: 12}, (_, i) => ({
                                      value: (i+1).toString(),
                                      label: new Date(2024, i).toLocaleDateString('fr-FR', { month: 'long' })
                                    }))}
                                  />
                                </div>
                                <div>
                                  <Label>Année</Label>
                                  <Input 
                                    type="number" 
                                    value={dailyPayrollForm.year} 
                                    onChange={(e) => handleDailyPayrollYearChange(e.target.value)}
                                    style={{
                                      width: '100%',
                                      padding: '8px',
                                      border: '1px solid #d1d5db',
                                      borderRadius: '4px',
                                      pointerEvents: 'auto',
                                      position: 'relative',
                                      
                                      opacity: 1
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Affichage des résultats */}
                              {dailyPayrollResult && (
                                <div className="mt-6 space-y-4">
                                  <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4">
                                    <h4 className="font-semibold text-blue-900 mb-3 flex items-center">
                                      <CheckCircle className="w-5 h-5 mr-2 text-blue-600" />
                                      Résultats du calcul journalier détaillé
                                    </h4>
                                    
                                    {/* Encadré avec la formule principale */}
                                    <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-lg p-3 mb-3">
                                      <div className="font-semibold text-green-800 mb-2 text-sm">📐 FORMULE PRINCIPALE</div>
                                      <div className="text-sm text-gray-700 space-y-1">
                                        <div className="flex items-center flex-wrap gap-2">
                                          <span className="font-medium">Salaire brut journalier =</span>
                                          <span className="bg-white px-2 py-1 rounded border">
                                            {formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_base_periode || 0)} 
                                          </span>
                                          <span>÷</span>
                                          <span className="bg-white px-2 py-1 rounded border">
                                            {dailyPayrollResult.bulletin_journalier.periode_en_jours || dailyPayrollResult.periode?.periode_en_jours || 30} jours
                                          </span>
                                          <span>=</span>
                                          <span className="bg-green-200 px-2 py-1 rounded font-bold text-green-800">
                                            {formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_base_journalier)}/jour
                                          </span>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-1">
                                          ⚡ Salaire de base période ÷ Période en jours = Salaire base journalier
                                        </p>
                                      </div>
                                    </div>
                                    
                                    {/* Composantes du salaire */}
                                    <div className="bg-white rounded-lg p-3 mb-3">
                                      <div className="font-semibold text-blue-900 mb-2 text-sm">📊 COMPOSANTES DU SALAIRE JOURNALIER (selon réglementation)</div>
                                      <div className="space-y-1.5 text-sm">
                                        <div className="flex justify-between items-center py-1 border-b border-gray-100">
                                          <span className="text-gray-700">1️⃣ Salaire de base journalier</span>
                                          <span className="font-semibold text-blue-900">{formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_base_journalier)}</span>
                                        </div>
                                        {dailyPayrollResult.type_calcul === 'complet' && (
                                          <>
                                            <div className="flex justify-between items-center py-1 border-b border-gray-100">
                                              <span className="text-gray-700">2️⃣ Gratification journalière</span>
                                              <span className="font-semibold text-blue-900">{formatCurrency(dailyPayrollResult.bulletin_journalier.gratification_journaliere)}</span>
                                            </div>
                                            <div className="flex justify-between items-center py-1 border-b border-gray-100">
                                              <span className="text-gray-700">3️⃣ Indemnité congé journalière</span>
                                              <span className="font-semibold text-blue-900">{formatCurrency(dailyPayrollResult.bulletin_journalier.conge_journalier)}</span>
                                            </div>
                                            <div className="flex justify-between items-center py-1 border-b border-gray-100">
                                              <span className="text-gray-700">4️⃣ Indemnité précarité journalière</span>
                                              <span className="font-semibold text-blue-900">{formatCurrency(dailyPayrollResult.bulletin_journalier.indemnite_precarite_journaliere)}</span>
                                            </div>
                                            <div className="flex justify-between items-center py-1 border-b border-gray-200">
                                              <span className="text-gray-700">5️⃣ Prime de transport journalière</span>
                                              <span className="font-semibold text-green-700">{formatCurrency(dailyPayrollResult.bulletin_journalier.prime_transport_journaliere)}</span>
                                            </div>
                                          </>
                                        )}
                                        <div className="flex justify-between items-center py-2 bg-blue-100 rounded px-2 mt-2">
                                          <span className="font-bold text-blue-900">💰 SALAIRE BRUT JOURNALIER</span>
                                          <span className="font-bold text-blue-900 text-lg">{formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_brut_journalier)}</span>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Retenues */}
                                    <div className="bg-white rounded-lg p-3 mb-3">
                                      <div className="font-semibold text-red-900 mb-2 text-sm">📉 RETENUES</div>
                                      <div className="space-y-1.5 text-sm">
                                        <div className="flex justify-between items-center py-1">
                                          <span className="text-gray-700">• CNPS salarié</span>
                                          <span className="font-semibold text-red-700">-{formatCurrency(dailyPayrollResult.bulletin_journalier.cnps_salarie_journalier)}</span>
                                        </div>
                                        <div className="flex justify-between items-center py-1">
                                          <span className="text-gray-700">• IS journalier</span>
                                          <span className="font-semibold text-red-700">-{formatCurrency(dailyPayrollResult.bulletin_journalier.is_journalier)}</span>
                                        </div>
                                        {dailyPayrollResult.bulletin_journalier.cmu_salarie_journalier > 0 && (
                                          <div className="flex justify-between items-center py-1">
                                            <span className="text-gray-700">• CMU salarié</span>
                                            <span className="font-semibold text-red-700">-{formatCurrency(dailyPayrollResult.bulletin_journalier.cmu_salarie_journalier)}</span>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {/* Salaire net final */}
                                    <div className="bg-green-50 border-2 border-green-400 rounded-lg p-4">
                                      <div className="flex justify-between items-center">
                                        <span className="text-lg font-bold text-green-900">💵 SALAIRE NET JOURNALIER</span>
                                        <span className="text-3xl font-bold text-green-900">{formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_net_journalier)}</span>
                                      </div>
                                    </div>

                                    {/* Boutons Aperçu et Télécharger PDF */}
                                    <div className="mt-4 grid grid-cols-2 gap-3">
                                      <Button
                                        onClick={handlePreviewDailyPayroll}
                                        className="w-full bg-green-600 hover:bg-green-700"
                                      >
                                        <Eye className="w-4 h-4 mr-2" />
                                        Aperçu
                                      </Button>
                                      <Button
                                        onClick={handleDownloadDailyPayrollPDF}
                                        disabled={pdfDownloading}
                                        className="w-full bg-blue-600 hover:bg-blue-700"
                                      >
                                        {pdfDownloading ? (
                                          <>
                                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                            Génération...
                                          </>
                                        ) : (
                                          <>
                                            <Download className="w-4 h-4 mr-2" />
                                            Télécharger PDF
                                          </>
                                        )}
                                      </Button>
                                    </div>

                                    {/* Détails IS et formules */}
                                    {dailyPayrollResult.type_calcul === 'complet' && (
                                      <div className="mt-4 text-xs text-gray-600 bg-white p-3 rounded border border-gray-200">
                                        <div className="font-semibold mb-2 text-gray-800">ℹ️ Détails du calcul :</div>
                                        <div className="grid grid-cols-2 gap-2 mb-2">
                                          <div>• <span className="font-semibold">Période :</span> {dailyPayrollResult.periode?.periode || 'Non spécifiée'}</div>
                                          <div>• <span className="font-semibold">Mois :</span> {new Date(2024, dailyPayrollResult.periode?.month - 1).toLocaleDateString('fr-FR', { month: 'long' })} {dailyPayrollResult.periode?.year}</div>
                                          <div>• IBS journalier : {formatCurrency(dailyPayrollResult.bulletin_journalier.ibs_journalier)}</div>
                                          <div>• RICF journalier : {formatCurrency(dailyPayrollResult.bulletin_journalier.ricf_journalier)}</div>
                                          <div>• Nombre de parts : {dailyPayrollResult.bulletin_journalier.nombre_parts_familiales}</div>
                                          <div>• Ville : <span className="font-semibold capitalize">{dailyPayrollResult.company_info.ville}</span></div>
                                        </div>
                                        <div className="mt-2 pt-2 border-t border-gray-200">
                                          <div className="font-semibold mb-1 text-gray-800">🚗 Prime de transport exonérée par ville :</div>
                                          <div className="grid grid-cols-3 gap-1">
                                            <div>• Abidjan : <span className={dailyPayrollResult.company_info.ville?.toLowerCase() === 'abidjan' ? 'font-bold text-green-600' : ''}>1 000 F</span></div>
                                            <div>• Bouaké : <span className={dailyPayrollResult.company_info.ville?.toLowerCase() === 'bouake' ? 'font-bold text-green-600' : ''}>800 F</span></div>
                                            <div>• Autres : <span className={!['abidjan', 'bouake'].includes(dailyPayrollResult.company_info.ville?.toLowerCase()) ? 'font-bold text-green-600' : ''}>667 F</span></div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  {/* Aperçu en ligne du bulletin journalier */}
                                  {showDailyPayrollPreview && (
                                    <div className="mt-6 print:mt-0">
                                      <div className="flex justify-between items-center mb-4 print:hidden">
                                        <h4 className="font-bold text-lg text-gray-900">📄 Aperçu du Bulletin de Paie Journalier</h4>
                                        <div className="flex gap-2">
                                          <Button
                                            onClick={handlePrintDailyPayrollPreview}
                                            className="bg-gray-600 hover:bg-gray-700"
                                            size="sm"
                                          >
                                            <Printer className="w-4 h-4 mr-2" />
                                            Imprimer
                                          </Button>
                                          <Button
                                            onClick={() => setShowDailyPayrollPreview(false)}
                                            variant="outline"
                                            size="sm"
                                          >
                                            <X className="w-4 h-4 mr-2" />
                                            Fermer
                                          </Button>
                                        </div>
                                      </div>

                                      {/* Aperçu du bulletin structuré comme un document officiel */}
                                      <div className="bg-white border-2 border-gray-300 rounded-lg p-6 shadow-lg print:shadow-none print:border-0">
                                        {/* En-tête du bulletin */}
                                        <div className="border-b-2 border-blue-500 pb-4 mb-4">
                                          <div className="grid grid-cols-2 gap-4">
                                            <div>
                                              <h3 className="font-bold text-lg text-gray-900">{selectedCompany?.name || 'Entreprise'}</h3>
                                              <p className="text-sm text-gray-600">{selectedCompany?.address || ''}</p>
                                              <p className="text-sm text-gray-600">{selectedCompany?.ville || ''}</p>
                                              <p className="text-sm text-gray-600">Tél: {selectedCompany?.phone || ''}</p>
                                            </div>
                                            <div className="text-right">
                                              <h2 className="font-bold text-xl text-blue-900 mb-2">BULLETIN DE PAIE JOURNALIER</h2>
                                              <p className="text-sm text-gray-700">
                                                <span className="font-semibold">Période:</span> {dailyPayrollResult.periode?.periode || 'Non spécifiée'}
                                              </p>
                                              <p className="text-sm text-gray-700">
                                                <span className="font-semibold">Mois:</span> {new Date(2024, dailyPayrollResult.periode?.month - 1).toLocaleDateString('fr-FR', { month: 'long' })} {dailyPayrollResult.periode?.year}
                                              </p>
                                              <p className="text-sm text-gray-700">
                                                <span className="font-semibold">Date:</span> {new Date().toLocaleDateString('fr-FR')}
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Informations employé */}
                                        <div className="bg-gray-50 border border-gray-300 rounded p-3 mb-4">
                                          <h4 className="font-semibold text-gray-900 mb-2">INFORMATIONS EMPLOYÉ</h4>
                                          <div className="grid grid-cols-2 gap-2 text-sm">
                                            <div><span className="font-semibold">Nom complet:</span> {dailyPayrollResult.employee_info.first_name} {dailyPayrollResult.employee_info.last_name}</div>
                                            <div><span className="font-semibold">Poste:</span> {dailyPayrollResult.employee_info.position}</div>
                                            <div><span className="font-semibold">Heures travaillées:</span> {dailyPayrollForm.heures_travaillees_jour}h</div>
                                            <div><span className="font-semibold">Ville:</span> <span className="capitalize">{dailyPayrollResult.company_info.ville}</span></div>
                                          </div>
                                        </div>

                                        {/* Composantes du salaire */}
                                        {dailyPayrollResult.type_calcul === 'complet' && (
                                          <div className="mb-4">
                                            <h4 className="font-semibold text-blue-900 bg-blue-50 px-3 py-2 rounded mb-2">COMPOSANTES DU SALAIRE JOURNALIER</h4>
                                            <table className="w-full text-sm border-collapse">
                                              <thead>
                                                <tr className="border-b-2 border-gray-300">
                                                  <th className="text-left py-2 px-3">Description</th>
                                                  <th className="text-right py-2 px-3">Montant (FCFA)</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr className="border-b border-gray-200">
                                                  <td className="py-2 px-3">Salaire de base journalier</td>
                                                  <td className="text-right py-2 px-3 font-medium">{formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_base_journalier)}</td>
                                                </tr>
                                                <tr className="border-b border-gray-200">
                                                  <td className="py-2 px-3">Gratification journalière</td>
                                                  <td className="text-right py-2 px-3 font-medium">{formatCurrency(dailyPayrollResult.bulletin_journalier.gratification_journaliere)}</td>
                                                </tr>
                                                <tr className="border-b border-gray-200">
                                                  <td className="py-2 px-3">Indemnité congé journalière</td>
                                                  <td className="text-right py-2 px-3 font-medium">{formatCurrency(dailyPayrollResult.bulletin_journalier.conge_journalier)}</td>
                                                </tr>
                                                <tr className="border-b border-gray-200">
                                                  <td className="py-2 px-3">Indemnité précarité journalière</td>
                                                  <td className="text-right py-2 px-3 font-medium">{formatCurrency(dailyPayrollResult.bulletin_journalier.indemnite_precarite_journaliere)}</td>
                                                </tr>
                                                <tr className="border-b border-gray-200">
                                                  <td className="py-2 px-3">Prime de transport journalière</td>
                                                  <td className="text-right py-2 px-3 font-medium text-green-700">{formatCurrency(dailyPayrollResult.bulletin_journalier.prime_transport_journaliere)}</td>
                                                </tr>
                                                <tr className="bg-blue-100 font-bold">
                                                  <td className="py-2 px-3">SALAIRE BRUT JOURNALIER</td>
                                                  <td className="text-right py-2 px-3 text-lg">{formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_brut_journalier)}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        )}

                                        {/* Retenues */}
                                        <div className="mb-4">
                                          <h4 className="font-semibold text-red-900 bg-red-50 px-3 py-2 rounded mb-2">RETENUES</h4>
                                          <table className="w-full text-sm border-collapse">
                                            <thead>
                                              <tr className="border-b-2 border-gray-300">
                                                <th className="text-left py-2 px-3">Description</th>
                                                <th className="text-right py-2 px-3">Montant (FCFA)</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr className="border-b border-gray-200">
                                                <td className="py-2 px-3">CNPS salarié</td>
                                                <td className="text-right py-2 px-3 font-medium text-red-700">-{formatCurrency(dailyPayrollResult.bulletin_journalier.cnps_salarie_journalier)}</td>
                                              </tr>
                                              <tr className="border-b border-gray-200">
                                                <td className="py-2 px-3">IS journalier</td>
                                                <td className="text-right py-2 px-3 font-medium text-red-700">-{formatCurrency(dailyPayrollResult.bulletin_journalier.is_journalier)}</td>
                                              </tr>
                                              {dailyPayrollResult.bulletin_journalier.cmu_salarie_journalier > 0 && (
                                                <tr className="border-b border-gray-200">
                                                  <td className="py-2 px-3">CMU salarié</td>
                                                  <td className="text-right py-2 px-3 font-medium text-red-700">-{formatCurrency(dailyPayrollResult.bulletin_journalier.cmu_salarie_journalier)}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>

                                        {/* Salaire net final */}
                                        <div className="bg-green-50 border-2 border-green-500 rounded-lg p-4">
                                          <div className="flex justify-between items-center">
                                            <span className="text-xl font-bold text-green-900">SALAIRE NET JOURNALIER</span>
                                            <span className="text-3xl font-bold text-green-900">{formatCurrency(dailyPayrollResult.bulletin_journalier.salaire_net_journalier)}</span>
                                          </div>
                                        </div>

                                        {/* Note légale */}
                                        <div className="mt-4 pt-4 border-t border-gray-300 text-xs text-gray-600">
                                          <p>Ce bulletin de paie journalier est établi conformément à la réglementation ivoirienne en vigueur.</p>
                                          <p className="mt-1">Calcul IS journalier: IBS/30 - RICF/30</p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </form>
                            
                            {/* Bouton de soumission en bas */}
                            <div style={{
                              marginTop: '24px',
                              paddingTop: '24px',
                              borderTop: '2px solid #e5e7eb'
                            }}>
                              <Button 
                                type="submit" 
                                form="daily-payroll-form"
                                disabled={calculatingDailyPayroll}
                                style={{
                                  width: '100%',
                                  padding: '16px 24px',
                                  background: calculatingDailyPayroll ? '#9ca3af' : 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                                  color: 'white',
                                  fontWeight: 700,
                                  borderRadius: '12px',
                                  border: 'none',
                                  cursor: calculatingDailyPayroll ? 'not-allowed' : 'pointer',
                                  fontSize: '16px',
                                  boxShadow: '0 4px 16px rgba(37, 99, 235, 0.3)',
                                  transition: 'all 0.2s',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '8px',
                                  opacity: calculatingDailyPayroll ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => {
                                  if (!calculatingDailyPayroll) {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(37, 99, 235, 0.4)';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!calculatingDailyPayroll) {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(37, 99, 235, 0.3)';
                                  }
                                }}
                              >
                                {calculatingDailyPayroll ? (
                                  <>
                                    <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                                    Calcul en cours...
                                  </>
                                ) : (
                                  <>
                                    <Calculator style={{ width: '20px', height: '20px' }} />
                                    Calculer la paie journalière
                                  </>
                                )}
                              </Button>
                              
                              {/* Bouton Historique des calculs inverse */}
                              {inverseCalculationHistory.length > 0 && (
                                <Button
                                  type="button"
                                  variant="outline"
                                  onClick={() => setShowInverseHistory(!showInverseHistory)}
                                  style={{
                                    width: '100%',
                                    marginTop: '12px',
                                    padding: '12px 24px',
                                    borderColor: '#9333ea',
                                    color: '#9333ea',
                                    fontWeight: 600,
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px'
                                  }}
                                >
                                  <History style={{ width: '18px', height: '18px' }} />
                                  {showInverseHistory ? 'Masquer' : 'Voir'} l'historique ({inverseCalculationHistory.length})
                                </Button>
                              )}
                            </div>
                            
                            {/* Section Historique des calculs inverse */}
                            {showInverseHistory && inverseCalculationHistory.length > 0 && (
                              <div style={{
                                marginTop: '24px',
                                padding: '20px',
                                backgroundColor: '#faf5ff',
                                borderRadius: '16px',
                                border: '2px solid #e9d5ff'
                              }}>
                                <div style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  marginBottom: '16px'
                                }}>
                                  <h3 style={{
                                    fontSize: '18px',
                                    fontWeight: 700,
                                    color: '#7e22ce',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                  }}>
                                    <History style={{ width: '20px', height: '20px' }} />
                                    Historique des simulations
                                  </h3>
                                  <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      onClick={async () => {
                                        try {
                                          const XLSX = await import('xlsx');
                                          
                                          // Préparer les données pour Excel
                                          const excelData = [
                                            ['Date', 'Employé', 'Entreprise', 'Net souhaité (F)', 'Brut calculé/jour (F)', 'Brut période (F)', 'Jours', 'Heures/jour', 'CNPS (F)', 'ITS (F)', 'IGR (F)', 'Total retenues (F)', 'Ville']
                                          ];
                                          
                                          inverseCalculationHistory.forEach(entry => {
                                            excelData.push([
                                              new Date(entry.date).toLocaleDateString('fr-FR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                              }),
                                              entry.employeeName,
                                              entry.companyName,
                                              entry.netSouhaite,
                                              entry.brutCalcule,
                                              entry.brutPeriode,
                                              entry.periodeJours,
                                              entry.heuresJour,
                                              entry.cnpsJournalier,
                                              entry.itsJournalier,
                                              entry.igrJournalier,
                                              entry.totalRetenues,
                                              entry.ville || 'N/A'
                                            ]);
                                          });
                                          
                                          // Créer le workbook
                                          const wb = XLSX.utils.book_new();
                                          const ws = XLSX.utils.aoa_to_sheet(excelData);
                                          
                                          // Ajuster la largeur des colonnes
                                          ws['!cols'] = [
                                            { wch: 18 }, // Date
                                            { wch: 25 }, // Employé
                                            { wch: 20 }, // Entreprise
                                            { wch: 15 }, // Net souhaité
                                            { wch: 18 }, // Brut/jour
                                            { wch: 15 }, // Brut période
                                            { wch: 8 },  // Jours
                                            { wch: 12 }, // Heures
                                            { wch: 12 }, // CNPS
                                            { wch: 12 }, // ITS
                                            { wch: 12 }, // IGR
                                            { wch: 15 }, // Total retenues
                                            { wch: 12 }  // Ville
                                          ];
                                          
                                          XLSX.utils.book_append_sheet(wb, ws, "Simulations Calcul Inverse");
                                          
                                          // Générer le fichier
                                          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                                          const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                          
                                          // Télécharger
                                          const url = URL.createObjectURL(blob);
                                          const link = document.createElement('a');
                                          link.href = url;
                                          link.download = `historique_simulations_${new Date().toISOString().split('T')[0]}.xlsx`;
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                          URL.revokeObjectURL(url);
                                          
                                          toast.success('Historique exporté en Excel !');
                                        } catch (error) {
                                          console.error('Erreur export Excel:', error);
                                          toast.error('Erreur lors de l\'export Excel');
                                        }
                                      }}
                                      style={{ color: '#16a34a', borderColor: '#16a34a', fontSize: '12px' }}
                                    >
                                      <Download style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                                      Export Excel
                                    </Button>
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      onClick={() => {
                                        if (window.confirm('Voulez-vous effacer tout l\'historique ?')) {
                                          setInverseCalculationHistory([]);
                                          localStorage.removeItem('inverseCalculationHistory');
                                          toast.success('Historique effacé');
                                        }
                                      }}
                                      style={{ color: '#dc2626', fontSize: '12px' }}
                                    >
                                      <Trash2 style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                                      Effacer tout
                                    </Button>
                                  </div>
                                </div>
                                
                                <div style={{
                                  maxHeight: '400px',
                                  overflowY: 'auto',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '12px'
                                }}>
                                  {inverseCalculationHistory.map((entry, index) => (
                                    <div
                                      key={entry.id}
                                      style={{
                                        padding: '16px',
                                        backgroundColor: 'white',
                                        borderRadius: '12px',
                                        border: '1px solid #e9d5ff',
                                        boxShadow: '0 2px 8px rgba(147, 51, 234, 0.08)'
                                      }}
                                    >
                                      <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '12px'
                                      }}>
                                        <div>
                                          <div style={{
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            color: '#1f2937'
                                          }}>
                                            {entry.employeeName}
                                          </div>
                                          <div style={{
                                            fontSize: '12px',
                                            color: '#6b7280'
                                          }}>
                                            {entry.companyName} • {new Date(entry.date).toLocaleDateString('fr-FR', {
                                              day: '2-digit',
                                              month: 'short',
                                              year: 'numeric',
                                              hour: '2-digit',
                                              minute: '2-digit'
                                            })}
                                          </div>
                                        </div>
                                        <Button
                                          variant="ghost"
                                          size="sm"
                                          onClick={() => {
                                            setInverseCalculationHistory(prev => {
                                              const newHistory = prev.filter(h => h.id !== entry.id);
                                              localStorage.setItem('inverseCalculationHistory', JSON.stringify(newHistory));
                                              return newHistory;
                                            });
                                          }}
                                          style={{ color: '#9ca3af', padding: '4px' }}
                                        >
                                          <X style={{ width: '14px', height: '14px' }} />
                                        </Button>
                                      </div>
                                      
                                      <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(3, 1fr)',
                                        gap: '12px'
                                      }}>
                                        <div style={{
                                          padding: '10px',
                                          backgroundColor: '#dcfce7',
                                          borderRadius: '8px',
                                          textAlign: 'center'
                                        }}>
                                          <div style={{ fontSize: '11px', color: '#166534', fontWeight: 500 }}>
                                            Net souhaité/jour
                                          </div>
                                          <div style={{ fontSize: '16px', fontWeight: 700, color: '#15803d' }}>
                                            {entry.netSouhaite?.toLocaleString()} F
                                          </div>
                                        </div>
                                        <div style={{
                                          padding: '10px',
                                          backgroundColor: '#dbeafe',
                                          borderRadius: '8px',
                                          textAlign: 'center'
                                        }}>
                                          <div style={{ fontSize: '11px', color: '#1e40af', fontWeight: 500 }}>
                                            Brut calculé/jour
                                          </div>
                                          <div style={{ fontSize: '16px', fontWeight: 700, color: '#1d4ed8' }}>
                                            {entry.brutCalcule?.toLocaleString()} F
                                          </div>
                                        </div>
                                        <div style={{
                                          padding: '10px',
                                          backgroundColor: '#fef3c7',
                                          borderRadius: '8px',
                                          textAlign: 'center'
                                        }}>
                                          <div style={{ fontSize: '11px', color: '#92400e', fontWeight: 500 }}>
                                            Brut période ({entry.periodeJours}j)
                                          </div>
                                          <div style={{ fontSize: '16px', fontWeight: 700, color: '#b45309' }}>
                                            {entry.brutPeriode?.toLocaleString()} F
                                          </div>
                                        </div>
                                      </div>
                                      
                                      <div style={{
                                        marginTop: '12px',
                                        padding: '10px',
                                        backgroundColor: '#f3f4f6',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        fontSize: '12px',
                                        color: '#4b5563'
                                      }}>
                                        <span>CNPS: {entry.cnpsJournalier?.toLocaleString()} F</span>
                                        <span>ITS: {entry.itsJournalier?.toLocaleString()} F</span>
                                        <span>IGR: {entry.igrJournalier?.toLocaleString()} F</span>
                                        <span style={{ fontWeight: 600, color: '#dc2626' }}>
                                          Retenues: {entry.totalRetenues?.toLocaleString()} F
                                        </span>
                                      </div>
                                      
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        onClick={() => {
                                          // Pré-remplir le formulaire avec ces valeurs
                                          const employee = employees.find(e => e.id === entry.employeeId);
                                          if (employee) {
                                            setDailyPayrollForm(prev => ({
                                              ...prev,
                                              employee_id: entry.employeeId,
                                              mode_calcul: 'inverse',
                                              net_journalier_souhaite: entry.netSouhaite.toString(),
                                              periode_en_jours: entry.periodeJours,
                                              heures_travaillees_jour: entry.heuresJour
                                            }));
                                            toast.success('Simulation chargée dans le formulaire');
                                          } else {
                                            toast.error('Employé non trouvé dans l\'entreprise actuelle');
                                          }
                                        }}
                                        style={{
                                          marginTop: '12px',
                                          width: '100%',
                                          borderColor: '#9333ea',
                                          color: '#9333ea'
                                        }}
                                      >
                                        <RefreshCw style={{ width: '14px', height: '14px', marginRight: '6px' }} />
                                        Recharger cette simulation
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                )}

                        {/* Vue pleine page - Créer employé journalier */}
                        {isCreateDailyEmployeeOpen && (
                          <div style={{
                            backgroundColor: '#faf8ff',
                            minHeight: '100vh',
                            width: '100%'
                          }}>
                              {/* Header avec gradient violet */}
                              <div style={{ 
                                padding: '24px 32px',
                                background: 'linear-gradient(135deg, #9333ea 0%, #7e22ce 100%)',
                                color: 'white',
                                position: 'relative'
                              }}>
                                <div style={{ 
                                  position: 'absolute',
                                  top: 0,
                                  right: 0,
                                  width: '250px',
                                  height: '100%',
                                  background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                                  pointerEvents: 'none'
                                }} />
                                
                                <Button
                                  onClick={() => setIsCreateDailyEmployeeOpen(false)}
                                  variant="outline"
                                  style={{ 
                                    marginBottom: '16px',
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    borderColor: 'rgba(255,255,255,0.3)',
                                    color: 'white',
                                    backdropFilter: 'blur(10px)'
                                  }}
                                >
                                  <ArrowLeft className="w-4 h-4 mr-2" />
                                  Retour
                                </Button>
                                
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                  <div style={{ 
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    padding: '12px',
                                    backdropFilter: 'blur(10px)'
                                  }}>
                                    <Plus style={{ width: '32px', height: '32px' }} />
                                  </div>
                                  <div>
                                    <h1 style={{ 
                                      fontSize: '26px', 
                                      fontWeight: 700,
                                      marginBottom: '4px',
                                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}>
                                      Créer un employé journalier
                                    </h1>
                                    <p style={{ fontSize: '14px', opacity: 0.95 }}>
                                      Ajouter rapidement un employé pour le travail journalier
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div style={{ padding: '32px', maxWidth: '900px', margin: '0 auto' }}>
                                {/* Formulaire */}
                                <div style={{
                                  backgroundColor: 'white',
                                  borderRadius: '16px',
                                  padding: '32px',
                                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                  border: '1px solid #e5e7eb'
                                }}>
                                  {/* En-tête du formulaire */}
                                  <div style={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginBottom: '24px',
                                    paddingBottom: '16px',
                                    borderBottom: '2px solid #9333ea'
                                  }}>
                                    <div style={{
                                      backgroundColor: '#f3e8ff',
                                      borderRadius: '10px',
                                      padding: '10px',
                                      color: '#7e22ce'
                                    }}>
                                      <UserPlus style={{ width: '24px', height: '24px' }} />
                                    </div>
                                    <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#111827' }}>
                                      Informations de l'employé
                                    </h2>
                                  </div>
                            
                                  <form onSubmit={handleCreateDailyEmployee} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                    {/* Nom et prénom - Carte */}
                                    <div style={{
                                      backgroundColor: '#fdf4ff',
                                      borderRadius: '12px',
                                      padding: '20px',
                                      border: '2px solid #f3e8ff'
                                    }}>
                                      <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#6b21a8', marginBottom: '16px' }}>
                                        👤 Identité
                                      </h3>
                                      <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Prénom *</Label>
                                  <Input 
                                    type="text"
                                    placeholder="Ex: Jean"
                                    value={dailyEmployeeForm.first_name} 
                                    onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, first_name: e.target.value})}
                                    required
                                  />
                                </div>
                                <div>
                                  <Label>Nom *</Label>
                                  <Input 
                                    type="text"
                                    placeholder="Ex: Kouassi"
                                    value={dailyEmployeeForm.last_name} 
                                    onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, last_name: e.target.value})}
                                    required
                                  />
                                </div>
                              </div>
                            </div>

                                    <div>
                                      <Label>Poste</Label>
                                      <Input 
                                        type="text"
                                        placeholder="Ex: Ouvrier journalier"
                                        value={dailyEmployeeForm.position} 
                                        onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, position: e.target.value})}
                                        style={{
                                          width: '100%',
                                          padding: '10px',
                                          border: '1px solid #d1d5db',
                                          borderRadius: '8px'
                                        }}
                                      />
                                    </div>

                                    {/* Catégorie professionnelle, Sous-catégorie et Grade */}
                                    <div style={{
                                      display: 'grid',
                                      gridTemplateColumns: '1fr 1fr 1fr',
                                      gap: '16px'
                                    }}>
                                      <div>
                                        <Label>Titre</Label>
                                        <select
                                          value={dailyEmployeeForm.categorie_professionnelle || ''}
                                          onChange={(e) => {
                                            setDailyEmployeeForm({
                                              ...dailyEmployeeForm, 
                                              categorie_professionnelle: e.target.value,
                                              sous_categorie_professionnelle: '',
                                              grade: ''
                                            });
                                          }}
                                          style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            backgroundColor: 'white'
                                          }}
                                        >
                                          <option value="">Sélectionner un titre</option>
                                          {Object.keys(CATEGORIES_PROFESSIONNELLES).map(cat => (
                                            <option key={cat} value={cat}>{cat}</option>
                                          ))}
                                        </select>
                                      </div>
                                      
                                      <div>
                                        <Label>Sous-catégorie professionnelle</Label>
                                        <select
                                          value={dailyEmployeeForm.sous_categorie_professionnelle || ''}
                                          onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, sous_categorie_professionnelle: e.target.value})}
                                          disabled={!dailyEmployeeForm.categorie_professionnelle}
                                          style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            backgroundColor: dailyEmployeeForm.categorie_professionnelle ? 'white' : '#f3f4f6',
                                            cursor: dailyEmployeeForm.categorie_professionnelle ? 'pointer' : 'not-allowed'
                                          }}
                                        >
                                          <option value="">
                                            {dailyEmployeeForm.categorie_professionnelle 
                                              ? 'Sélectionner une sous-catégorie' 
                                              : 'Sélectionnez d\'abord un titre'}
                                          </option>
                                          {dailyEmployeeForm.categorie_professionnelle && 
                                           CATEGORIES_PROFESSIONNELLES[dailyEmployeeForm.categorie_professionnelle]?.map(sousCat => (
                                            <option key={sousCat} value={sousCat}>{sousCat}</option>
                                          ))}
                                        </select>
                                      </div>
                                      
                                      <div>
                                        <Label>Catégorie professionnelle (ex: 3A, 2B)</Label>
                                        <Input
                                          placeholder="Saisir la catégorie"
                                          value={dailyEmployeeForm.grade || ''}
                                          onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, grade: e.target.value})}
                                          disabled={!dailyEmployeeForm.sous_categorie_professionnelle}
                                          style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            backgroundColor: dailyEmployeeForm.sous_categorie_professionnelle ? 'white' : '#f3f4f6',
                                            cursor: dailyEmployeeForm.sous_categorie_professionnelle ? 'text' : 'not-allowed'
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {/* Salaire - Carte */}
                                    <div style={{
                                      backgroundColor: '#fefce8',
                                      borderRadius: '12px',
                                      padding: '20px',
                                      border: '2px solid #fef08a'
                                    }}>
                                      <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#713f12', marginBottom: '16px' }}>
                                        💰 Rémunération
                                      </h3>
                                      <div>
                                        <Label>Salaire de base (FCFA) *</Label>
                                        <Input 
                                          type="number"
                                          step="0.01"
                                          min="0"
                                          placeholder="Ex: 75000"
                                          value={dailyEmployeeForm.salary_categoriel} 
                                          onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, salary_categoriel: parseFloat(e.target.value) || 0})}
                                          style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #fef08a',
                                            borderRadius: '8px'
                                          }}
                                          required
                                        />
                                        <p style={{ fontSize: '12px', color: '#854d0e', marginTop: '6px' }}>
                                          Montant du salaire de base mensuel
                                        </p>
                                      </div>
                                    </div>

                                    {/* Sous-section : Date d'embauche - Carte */}
                                    <div style={{
                                      backgroundColor: '#f0fdf4',
                                      borderRadius: '12px',
                                      padding: '20px',
                                      border: '2px solid #bbf7d0'
                                    }}>
                                      <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#166534', marginBottom: '16px' }}>
                                        📅 Date d'embauche
                                      </h3>
                                      <div>
                                        <Label>Date d'embauche *</Label>
                                        <Input 
                                          type="date"
                                          value={dailyEmployeeForm.hire_date} 
                                          onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, hire_date: e.target.value})}
                                          style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #bbf7d0',
                                            borderRadius: '8px'
                                          }}
                                          required
                                        />
                                        <p style={{ fontSize: '12px', color: '#166534', marginTop: '6px' }}>
                                          Date de début de contrat de l'employé
                                        </p>
                                      </div>
                                    </div>

                                    {/* Contacts - Carte */}
                                    <div style={{
                                      backgroundColor: '#f0f9ff',
                                      borderRadius: '12px',
                                      padding: '20px',
                                      border: '2px solid #bae6fd'
                                    }}>
                                      <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#075985', marginBottom: '16px' }}>
                                        📞 Coordonnées (optionnel)
                                      </h3>
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                        <div>
                                          <Label>Téléphone</Label>
                                          <Input 
                                            type="text"
                                            placeholder="+225 00 00 00 00"
                                            value={dailyEmployeeForm.phone} 
                                            onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, phone: e.target.value})}
                                            style={{
                                              width: '100%',
                                              padding: '10px',
                                              border: '1px solid #bae6fd',
                                              borderRadius: '8px'
                                            }}
                                          />
                                        </div>

                                        <div>
                                          <Label>Email</Label>
                                          <Input 
                                            type="email"
                                            placeholder="employé@journalier.ci"
                                            value={dailyEmployeeForm.email} 
                                            onChange={(e) => setDailyEmployeeForm({...dailyEmployeeForm, email: e.target.value})}
                                            style={{
                                              width: '100%',
                                              padding: '10px',
                                              border: '1px solid #bae6fd',
                                              borderRadius: '8px'
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <Button 
                                      type="submit" 
                                      disabled={creatingDailyEmployee}
                                      style={{
                                        width: '100%',
                                        padding: '16px 24px',
                                        background: creatingDailyEmployee ? '#9ca3af' : 'linear-gradient(135deg, #9333ea 0%, #7e22ce 100%)',
                                        color: 'white',
                                        fontWeight: 700,
                                        borderRadius: '12px',
                                        border: 'none',
                                        cursor: creatingDailyEmployee ? 'not-allowed' : 'pointer',
                                        fontSize: '16px',
                                        boxShadow: '0 4px 16px rgba(147, 51, 234, 0.3)',
                                        transition: 'all 0.2s',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        opacity: creatingDailyEmployee ? 0.7 : 1
                                      }}
                                      onMouseEnter={(e) => {
                                        if (!creatingDailyEmployee) {
                                          e.currentTarget.style.transform = 'translateY(-2px)';
                                          e.currentTarget.style.boxShadow = '0 8px 24px rgba(147, 51, 234, 0.4)';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (!creatingDailyEmployee) {
                                          e.currentTarget.style.transform = 'translateY(0)';
                                          e.currentTarget.style.boxShadow = '0 4px 16px rgba(147, 51, 234, 0.3)';
                                        }
                                      }}
                                    >
                                      {creatingDailyEmployee ? (
                                        <>
                                          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                          Création en cours...
                                        </>
                                      ) : (
                                        <>
                                          <Plus className="w-4 h-4 mr-2" />
                                          Créer l'employé journalier
                                        </>
                                      )}
                                    </Button>
                                  </form>
                                </div>
                              </div>
                          </div>
                        )}

                    {/* Affichage des résultats de calcul selon la formule : Salaire Net = Salaire brut imposable - Retenues + Gains */}
                    <div className="space-y-4">
                      {payrolls.map((item) => (
                        <Card key={item.payroll.id} className="bg-white">
                          <CardContent className="p-6">
                            {/* En-tête employé */}
                            <div className="flex justify-between items-start mb-6">
                              <div>
                                <h3 className="font-semibold text-gray-900 text-lg">{item.employee.first_name} {item.employee.last_name}</h3>
                                <p className="text-gray-600">{item.employee.position}</p>
                                <p className="text-sm text-gray-500">
                                  {new Date(item.payroll.year || new Date().getFullYear(), item.payroll.month - 1).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
                                </p>
                                {item.payroll.anciennete_display && (
                                  <p className="text-sm text-blue-600">Ancienneté : {item.payroll.anciennete_display}</p>
                                )}
                              </div>
                              <div className="text-right">
                                <div className="text-3xl font-bold text-green-600">{formatCurrency(item.payroll.salary_net_a_payer || item.payroll.salary_net)}</div>
                                <p className="text-sm text-gray-500">SALAIRE NET À PAYER</p>
                                {item.payroll.total_remboursement_prets > 0 && (
                                  <p className="text-xs text-orange-600 mt-1">
                                    (après déduction prêts: {formatCurrency(item.payroll.total_remboursement_prets)})
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* Formule de calcul */}
                            <div className="bg-orange-50 p-4 rounded-lg mb-6">
                              <h4 className="font-semibold text-orange-800 mb-2">📊 Formule de calcul</h4>
                              <div className="text-orange-700 font-medium">
                                Salaire Net = Salaire Brut Imposable - Retenues + Gains
                              </div>
                              <div className="text-sm text-orange-600 mt-1">
                                {formatCurrency(item.payroll.salary_net)} = {formatCurrency(item.payroll.salary_brut_imposable_is)} - {formatCurrency((item.payroll.cnps_salarie || 0) + (item.payroll.is_total || 0))} + {formatCurrency((item.payroll.prime_transport_non_imposable ?? item.payroll.prime_transport ?? 0) + (item.payroll.allocations_familiales_exonerees || 0) + (item.payroll.indemnites_frais_emploi_non_imposable || 0) + (item.payroll.remboursement_frais || 0) + (item.payroll.special_allowances_exempt || 0) + (item.payroll.primes_speciales_total_exonere || 0) + (item.payroll.frais_exempt || 0) + (item.payroll.elements_configurables_non_imposables || 0))}
                              </div>
                            </div>

                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                              {/* 1. ÉLÉMENTS DU SALAIRE BRUT IMPOSABLE */}
                              <div className="space-y-3">
                                <h4 className="font-semibold text-blue-800 bg-blue-50 p-2 rounded">
                                  💰 Éléments du Salaire Brut Imposable
                                </h4>
                                <div className="text-sm space-y-2">
                                  <div className="flex justify-between">
                                    <span>Salaire catégoriel :</span>
                                    <span className="font-medium">{formatCurrency(item.payroll.salary_categoriel)}</span>
                                  </div>
                                  {item.payroll.sursalaire > 0 && (
                                    <div className="flex justify-between">
                                      <span>Sursalaire :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.sursalaire)}</span>
                                    </div>
                                  )}
                                  {item.payroll.gratification_mensuelle > 0 && item.gratification_display_consent !== false && (
                                    <div className="flex justify-between">
                                      <span>Gratification mensuelle :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.gratification_mensuelle)}</span>
                                    </div>
                                  )}
                                  {item.payroll.prime_anciennete > 0 && (
                                    <div className="flex justify-between">
                                      <span>Prime d'ancienneté :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.prime_anciennete)}</span>
                                    </div>
                                  )}
                                  {item.payroll.heures_sup > 0 && (
                                    <div className="flex justify-between">
                                      <span>Heures supplémentaires :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.heures_sup)}</span>
                                    </div>
                                  )}
                                  {item.payroll.primes > 0 && (
                                    <div className="flex justify-between">
                                      <span>Primes ponctuelles :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.primes)}</span>
                                    </div>
                                  )}
                                  {item.payroll.avantages_nature > 0 && (
                                    <div className="flex justify-between">
                                      <span>Avantages en nature :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.avantages_nature)}</span>
                                    </div>
                                  )}
                                  {item.payroll.avantages_argent > 0 && (
                                    <div className="flex justify-between">
                                      <span>Avantages en argent :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.avantages_argent)}</span>
                                    </div>
                                  )}
                                  {item.payroll.indemnites_frais_emploi_imposable > 0 && (
                                    <div className="flex justify-between">
                                      <span>Indemnités frais emploi (imposables) :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.indemnites_frais_emploi_imposable)}</span>
                                    </div>
                                  )}
                                  {(item.payroll.configurable_elements_details || []).filter((el) => el.type !== 'frais').map((el) => (
                                    <div key={`cfg-el-${el.id || el.name}`} className="flex justify-between" data-testid="calc-configurable-element">
                                      <span>{el.type_label || 'Élément'} - {el.name} :</span>
                                      <span className="font-medium">{formatCurrency(el.amount)}</span>
                                    </div>
                                  ))}
                                  {(item.payroll.frais_details || []).filter((f) => f.taxable_amount > 0).map((f) => (
                                    <div key={`frais-tx-${f.id || f.name}`} className="flex justify-between" data-testid="calc-configurable-element">
                                      <span>Frais - {f.name} (part imposable) :</span>
                                      <span className="font-medium">{formatCurrency(f.taxable_amount)}</span>
                                    </div>
                                  ))}
                                  {item.payroll.special_allowances_total > 0 && (
                                    <div className="flex justify-between" data-testid="calc-special-allowances">
                                      <span>Allocations spéciales (Art. 116-1) :</span>
                                      <span className="font-medium">{formatCurrency(item.payroll.special_allowances_total)}</span>
                                    </div>
                                  )}
                                  <div className="border-t pt-2 mt-3">
                                    <div className="flex justify-between font-semibold text-blue-800">
                                      <span>SALAIRE BRUT IMPOSABLE :</span>
                                      <span>{formatCurrency(item.payroll.salary_brut_imposable_is)}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 2. RETENUES - Structure selon la réglementation ivoirienne */}
                              <div className="space-y-3">
                                <h4 className="font-semibold text-red-800 bg-red-50 p-2 rounded">
                                  ➖ Retenues - Réglementation Ivoirienne
                                </h4>
                                
                                {/* a) Retenues Patronales - À la charge de l'employeur */}
                                <div className="bg-orange-50 border border-orange-200 rounded p-3">
                                  <h5 className="font-medium text-orange-800 mb-2">a) Retenues Patronales (à la charge de l'employeur) :</h5>
                                  <div className="text-sm space-y-1 ml-2">
                                    <div className="flex justify-between">
                                      <span>• Prestations familiales :</span>
                                      <span className="font-medium text-orange-700">{formatCurrency(item.payroll.prestations_familiales)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span>• Accidents de travail :</span>
                                      <span className="font-medium text-orange-700">{formatCurrency(item.payroll.accidents_travail)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span>• CNPS employeur (caisse de retraite) :</span>
                                      <span className="font-medium text-orange-700">{formatCurrency(item.payroll.cnps_employeur_base)}</span>
                                    </div>
                                    {item.payroll.formation_continue > 0 && (
                                      <div className="flex justify-between">
                                        <span>• Formation continue (0.6%) :</span>
                                        <span className="font-medium text-orange-700">{formatCurrency(item.payroll.formation_continue)}</span>
                                      </div>
                                    )}
                                    {item.payroll.taxe_apprentissage > 0 && (
                                      <div className="flex justify-between">
                                        <span>• Taxe d'apprentissage (0.4%) :</span>
                                        <span className="font-medium text-orange-700">{formatCurrency(item.payroll.taxe_apprentissage)}</span>
                                      </div>
                                    )}
                                    {item.payroll.cmu_employeur > 0 && (
                                      <div className="flex justify-between">
                                        <span>• CMU patronal :</span>
                                        <span className="font-medium text-orange-700">{formatCurrency(item.payroll.cmu_employeur)}</span>
                                      </div>
                                    )}
                                    {item.payroll.is_patronal > 0 && (
                                      <div className="flex justify-between">
                                        <span>• IS patronal (impôt traitement salaire) :</span>
                                        <span className="font-medium text-orange-700">{formatCurrency(item.payroll.is_patronal)}</span>
                                      </div>
                                    )}
                                    <div className="border-t pt-1 mt-2">
                                      <div className="flex justify-between font-semibold text-orange-800">
                                        <span>Total Patronal :</span>
                                        <span>{formatCurrency(item.payroll.retenues_patronales_total || 0)}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                {/* b) Retenues Salariales - Déduites du salaire */}
                                <div className="bg-red-50 border border-red-200 rounded p-3">
                                  <h5 className="font-medium text-red-800 mb-2">b) Retenues Salariales (déduites du salaire) :</h5>
                                  <div className="text-sm space-y-1 ml-2">
                                    <div className="flex justify-between">
                                      <span>• IS salarial (impôt traitement salaire) :</span>
                                      <span className="font-medium text-red-600">-{formatCurrency(item.payroll.is_salarie || 0)}</span>
                                    </div>
                                    
                                    {/* Section RICF si des informations famille sont présentes */}
                                    {(item.payroll.ibs_brut || item.payroll.ricf_montant || item.payroll.nombre_parts_familiales > 1) && (
                                      <div className="bg-green-50 border border-green-200 rounded p-2 my-2">
                                        <h6 className="text-xs font-medium text-green-800 mb-1">
                                          👨‍👩‍👧‍👦 RICF - Réduction d'impôt pour charges de famille
                                        </h6>
                                        <div className="text-xs space-y-1">
                                          {item.payroll.statut_matrimonial && (
                                            <div className="flex justify-between">
                                              <span>Statut :</span>
                                              <span className="font-medium">{item.payroll.statut_matrimonial}</span>
                                            </div>
                                          )}
                                          {item.payroll.nombre_enfants > 0 && (
                                            <div className="flex justify-between">
                                              <span>Enfants :</span>
                                              <span className="font-medium">{item.payroll.nombre_enfants}</span>
                                            </div>
                                          )}
                                          {item.payroll.nombre_enfants_infirmes > 0 && (
                                            <div className="flex justify-between">
                                              <span>Enfants infirmes :</span>
                                              <span className="font-medium">{item.payroll.nombre_enfants_infirmes}</span>
                                            </div>
                                          )}
                                          {item.payroll.nombre_parts_familiales && (
                                            <div className="flex justify-between">
                                              <span>Parts familiales :</span>
                                              <span className="font-medium text-green-700">{item.payroll.nombre_parts_familiales}</span>
                                            </div>
                                          )}
                                          {item.payroll.ibs_brut > 0 && (
                                            <div className="flex justify-between">
                                              <span>IBS brut :</span>
                                              <span className="font-medium text-gray-600">{formatCurrency(item.payroll.ibs_brut)}</span>
                                            </div>
                                          )}
                                          {item.payroll.ricf_montant > 0 && (
                                            <div className="flex justify-between">
                                              <span>RICF réduction :</span>
                                              <span className="font-medium text-green-700">-{formatCurrency(item.payroll.ricf_montant)}</span>
                                            </div>
                                          )}
                                          <div className="border-t pt-1 mt-1">
                                            <div className="flex justify-between text-xs font-semibold">
                                              <span>IS final (IBS - RICF) :</span>
                                              <span className="text-red-600">{formatCurrency(item.payroll.is_salarie)}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="flex justify-between">
                                      <span>• CNPS employé (6.3%) :</span>
                                      <span className="font-medium text-red-600">-{formatCurrency(item.payroll.cnps_salarie)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span>• CMU employé :</span>
                                      <span className="font-medium text-red-600">-{formatCurrency(item.payroll.cmu_salarie || 0)}</span>
                                    </div>
                                    
                                    {item.payroll.avances > 0 && (
                                      <>
                                        <h6 className="font-medium text-red-700 mt-3">Autres retenues :</h6>
                                        <div className="flex justify-between ml-2">
                                          <span>• Avances :</span>
                                          <span className="font-medium text-red-600">-{formatCurrency(item.payroll.avances)}</span>
                                        </div>
                                      </>
                                    )}
                                    
                                    <div className="border-t pt-1 mt-2">
                                      <div className="flex justify-between font-semibold text-red-800">
                                        <span>Total Salariales :</span>
                                        <span>-{formatCurrency((item.payroll.retenues_salariales_total || 0) + (item.payroll.avances || 0))}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 3. GAINS (NON IMPOSABLES) */}
                              <div className="space-y-3">
                                <h4 className="font-semibold text-green-800 bg-green-50 p-2 rounded">
                                  ➕ Gains (Éléments non imposables)
                                </h4>
                                <div className="text-sm space-y-2">
                                  {item.payroll.allocations_familiales_exonerees > 0 && (
                                    <div className="flex justify-between">
                                      <span>Allocations familiales :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.allocations_familiales_exonerees)}</span>
                                    </div>
                                  )}
                                  
                                  {(item.payroll.prime_transport_non_imposable ?? item.payroll.prime_transport) > 0 && (
                                    <div className="flex justify-between">
                                      <span>Prime de transport (exonérée) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.prime_transport_non_imposable ?? item.payroll.prime_transport)}</span>
                                    </div>
                                  )}
                                  
                                  {item.payroll.indemnites_frais_emploi_non_imposable > 0 && (
                                    <div className="flex justify-between">
                                      <span>Indemnités frais emploi (non imposables) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.indemnites_frais_emploi_non_imposable)}</span>
                                    </div>
                                  )}
                                  
                                  {item.payroll.remboursement_frais > 0 && (
                                    <div className="flex justify-between">
                                      <span>Remboursement de frais :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.remboursement_frais)}</span>
                                    </div>
                                  )}
                                  
                                  {/* Primes spéciales exonérées (panier, salissure, tenue, outillage) versées comme gains */}
                                  {item.payroll.prime_panier_exonere > 0 && (
                                    <div className="flex justify-between" data-testid="calc-gain-prime-panier-exonere">
                                      <span>Prime de panier (exonérée) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.prime_panier_exonere)}</span>
                                    </div>
                                  )}
                                  {item.payroll.prime_salissure_exonere > 0 && (
                                    <div className="flex justify-between" data-testid="calc-gain-prime-salissure-exonere">
                                      <span>Prime de salissure (exonérée) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.prime_salissure_exonere)}</span>
                                    </div>
                                  )}
                                  {item.payroll.prime_tenue_exonere > 0 && (
                                    <div className="flex justify-between" data-testid="calc-gain-prime-tenue-exonere">
                                      <span>Indemnité de tenue de travail (exonérée) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.prime_tenue_exonere)}</span>
                                    </div>
                                  )}
                                  {item.payroll.prime_outillage_exonere > 0 && (
                                    <div className="flex justify-between" data-testid="calc-gain-prime-outillage-exonere">
                                      <span>Prime d'outillage (exonérée) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.prime_outillage_exonere)}</span>
                                    </div>
                                  )}
                                  
                                  {item.payroll.special_allowances_exempt > 0 && (
                                    <div className="flex justify-between" data-testid="calc-gain-special-allowances-exempt">
                                      <span>Allocations spéciales exonérées (Art. 116-1) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.special_allowances_exempt)}</span>
                                    </div>
                                  )}
                                  {item.payroll.elements_configurables_non_imposables > 0 && (
                                    <div className="flex justify-between" data-testid="calc-gain-elements-non-imposables">
                                      <span>Éléments non imposables (indemnités/primes exonérées) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(item.payroll.elements_configurables_non_imposables)}</span>
                                    </div>
                                  )}
                                  {(item.payroll.frais_details || []).filter((f) => f.exempt_amount > 0).map((f) => (
                                    <div key={`frais-ex-${f.id || f.name}`} className="flex justify-between" data-testid="calc-gain-frais-exonere">
                                      <span>{f.name} (part exonérée) :</span>
                                      <span className="font-medium text-green-600">+{formatCurrency(f.exempt_amount)}</span>
                                    </div>
                                  ))}
                                  
                                  {/* Si aucun gain */}
                                  {(!item.payroll.allocations_familiales_exonerees || item.payroll.allocations_familiales_exonerees === 0) &&
                                   (!item.payroll.prime_transport || item.payroll.prime_transport === 0) && 
                                   (!item.payroll.indemnites_frais_emploi_non_imposable || item.payroll.indemnites_frais_emploi_non_imposable === 0) && 
                                   (!item.payroll.remboursement_frais || item.payroll.remboursement_frais === 0) && 
                                   (!item.payroll.primes_speciales_total_exonere || item.payroll.primes_speciales_total_exonere === 0) && 
                                   (!item.payroll.total_indemnites_non_taxables || item.payroll.total_indemnites_non_taxables === 0) && 
                                   (!item.payroll.cmu_impact_net || item.payroll.cmu_impact_net === 0) && (
                                    <div className="text-gray-500 italic">
                                      Aucun gain ajouté au salaire net
                                    </div>
                                  )}
                                  
                                  <div className="border-t pt-2 mt-3">
                                    <div className="flex justify-between font-semibold text-green-800">
                                      <span>TOTAL GAINS :</span>
                                      <span>+{formatCurrency((item.payroll.allocations_familiales_exonerees || 0) + (item.payroll.prime_transport_non_imposable ?? item.payroll.prime_transport ?? 0) + (item.payroll.indemnites_frais_emploi_non_imposable || 0) + (item.payroll.remboursement_frais || 0) + (item.payroll.primes_speciales_total_exonere || 0) + (item.payroll.special_allowances_exempt || 0) + (item.payroll.frais_exempt || 0) + (item.payroll.elements_configurables_non_imposables || 0))}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Résumé final */}
                            <div className="bg-gray-50 p-4 rounded-lg mt-6">
                              <h4 className="font-semibold text-gray-800 mb-3">📋 Récapitulatif du calcul</h4>
                              <div className="space-y-1 text-sm">
                                <div className="flex justify-between">
                                  <span>Salaire brut imposable :</span>
                                  <span className="font-medium">{formatCurrency(item.payroll.salary_brut_imposable_is)}</span>
                                </div>
                                <div className="flex justify-between text-red-600">
                                  <span>Moins : Total retenues :</span>
                                  <span className="font-medium">-{formatCurrency((item.payroll.cnps_salarie || 0) + (item.payroll.is_salarie || 0) + (item.payroll.cmu_salarie || 0) + (item.payroll.avances || 0))}</span>
                                </div>
                                <div className="flex justify-between text-green-600">
                                  <span>Plus : Total gains :</span>
                                  <span className="font-medium">+{formatCurrency((item.payroll.allocations_familiales_exonerees || 0) + (item.payroll.prime_transport_non_imposable ?? item.payroll.prime_transport ?? 0) + (item.payroll.indemnites_frais_emploi_non_imposable || 0) + (item.payroll.remboursement_frais || 0) + (item.payroll.primes_speciales_total_exonere || 0) + (item.payroll.special_allowances_exempt || 0) + (item.payroll.frais_exempt || 0) + (item.payroll.elements_configurables_non_imposables || 0))}</span>
                                </div>
                                {/* Section remboursement des prêts */}
                                {item.payroll.prets_actifs && item.payroll.prets_actifs.length > 0 && (
                                  <>
                                    <div className="border-t pt-2 mt-2">
                                      <div className="flex justify-between font-medium text-gray-700">
                                        <span>= Salaire net :</span>
                                        <span>{formatCurrency(item.payroll.salary_net)}</span>
                                      </div>
                                    </div>
                                    <div className="flex justify-between text-orange-600">
                                      <span>Moins : Remboursement prêts :</span>
                                      <span className="font-medium">-{formatCurrency(item.payroll.total_remboursement_prets || 0)}</span>
                                    </div>
                                  </>
                                )}
                                <div className="border-t pt-2 mt-2">
                                  <div className="flex justify-between font-bold text-lg text-green-700">
                                    <span>SALAIRE NET À PAYER :</span>
                                    <span>{formatCurrency(item.payroll.salary_net_a_payer || item.payroll.salary_net)}</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Bouton pour réinitialiser ce résultat */}
                            <div className="mt-6 flex justify-end">
                              <Button 
                                onClick={() => setPayrolls([])}
                                variant="outline"
                                className="text-red-600 border-red-300 hover:bg-red-50"
                              >
                                <Trash2 className="w-4 h-4 mr-2" />
                                Réinitialiser ce résultat
                              </Button>
                            </div>
                          </CardContent>
                        </Card>
                      ))}
                    </div>
                  </div>
                )}

                {/* Bulletin Edition Section */}
                {payrollSection === 'bulletin' && (
                  <div className="space-y-6">
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-gray-800">📄 Génération de bulletins de paie</h3>
                    </div>

                    {!generatedBulletins ? (
                      <div className="space-y-6">
                        {/* Sélection de la période */}
                        <Card>
                          <CardContent className="p-6">
                            <h4 className="text-lg font-medium text-gray-900 mb-4">📅 Période du bulletin</h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label htmlFor="period-start">Date de début</Label>
                                <Input
                                  id="period-start"
                                  type="date"
                                  value={bulletinPeriod.start}
                                  onChange={(e) => setBulletinPeriod({...bulletinPeriod, start: e.target.value})}
                                />
                              </div>
                              <div>
                                <Label htmlFor="period-end">Date de fin</Label>
                                <Input
                                  id="period-end"
                                  type="date"
                                  value={bulletinPeriod.end}
                                  onChange={(e) => setBulletinPeriod({...bulletinPeriod, end: e.target.value})}
                                />
                              </div>
                            </div>
                            <p className="text-sm text-gray-600 mt-2">
                              Période sélectionnée : <strong>{formatPeriod(bulletinPeriod.start, bulletinPeriod.end)}</strong>
                            </p>
                          </CardContent>
                        </Card>

                        {/* Sélection des employés */}
                        <Card>
                          <CardContent className="p-6">
                            <div className="flex justify-between items-center mb-4">
                              <h4 className="text-lg font-medium text-gray-900">👥 Sélection des employés</h4>
                              <div className="flex space-x-2">
                                <Button 
                                  variant="outline" 
                                  size="sm"
                                  onClick={() => handleSelectAllEmployeesForBulletin(true)}
                                >
                                  Tout sélectionner
                                </Button>
                                <Button 
                                  variant="outline" 
                                  size="sm"
                                  onClick={() => handleSelectAllEmployeesForBulletin(false)}
                                >
                                  Tout désélectionner
                                </Button>
                              </div>
                            </div>

                            <Input
                              data-testid="bulletin-employee-search"
                              placeholder="🔍 Rechercher un employé (nom, poste ou matricule)..."
                              value={bulletinEmployeeSearch}
                              onChange={(e) => setBulletinEmployeeSearch(e.target.value)}
                              className="mb-3"
                            />

                            <div className="space-y-2 max-h-64 overflow-y-auto">
                              {allEmployees.filter((employee) => {
                                const q = bulletinEmployeeSearch.trim().toLowerCase();
                                if (!q) return true;
                                return `${employee.first_name} ${employee.last_name} ${employee.position || ''} ${employee.matricule || ''}`.toLowerCase().includes(q);
                              }).map((employee) => (
                                <div key={employee.id} className="flex items-center p-3 bg-gray-50 rounded-lg">
                                  <input
                                    type="checkbox"
                                    id={`employee-${employee.id}`}
                                    checked={selectedEmployeesForBulletin.includes(employee.id)}
                                    onChange={(e) => handleEmployeeSelectionForBulletin(employee.id, e.target.checked)}
                                    className="mr-3 rounded border-gray-300 focus:ring-blue-500"
                                  />
                                  <label htmlFor={`employee-${employee.id}`} className="flex-1 cursor-pointer">
                                    <div className="flex justify-between items-center">
                                      <div>
                                        <span className="font-medium text-gray-900">
                                          {employee.first_name} {employee.last_name}
                                        </span>
                                        <span className="ml-2 text-sm text-gray-600">{employee.position}</span>
                                        {employee.matricule && (
                                          <span className="ml-2 text-xs text-blue-600 font-medium">#{employee.matricule}</span>
                                        )}
                                      </div>
                                      <div className="text-sm text-gray-500">
                                        {formatCurrency(employee.salary_categoriel + (employee.sursalaire || 0))}
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              ))}
                            </div>

                            {allEmployees.length === 0 && (
                              <div className="text-center py-8 text-gray-500">
                                <Users className="w-16 h-16 mx-auto mb-4 text-gray-400" />
                                <p>Aucun employé disponible dans cette entreprise</p>
                              </div>
                            )}

                            {allEmployees.length > 0 && bulletinEmployeeSearch.trim() && allEmployees.filter((employee) => `${employee.first_name} ${employee.last_name} ${employee.position || ''} ${employee.matricule || ''}`.toLowerCase().includes(bulletinEmployeeSearch.trim().toLowerCase())).length === 0 && (
                              <div className="text-center py-4 text-gray-500" data-testid="bulletin-search-no-result">
                                <p>Aucun employé ne correspond à « {bulletinEmployeeSearch} »</p>
                              </div>
                            )}

                            <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                              <p className="text-sm text-blue-700">
                                <strong>{selectedEmployeesForBulletin.length}</strong> employé(s) sélectionné(s) sur {allEmployees.length}
                              </p>
                            </div>
                          </CardContent>
                        </Card>

                        {/* Option pour mettre à jour les statistiques */}
                        <Card className="bg-orange-50 border-orange-200">
                          <CardContent className="p-4">
                            <div className="flex items-center space-x-3">
                              <input
                                type="checkbox"
                                id="update_statistics"
                                checked={updateStatistics}
                                onChange={(e) => setUpdateStatistics(e.target.checked)}
                                className="rounded border-orange-300 focus:ring-orange-500"
                              />
                              <label htmlFor="update_statistics" className="flex-1 cursor-pointer">
                                <div>
                                  <span className="font-medium text-orange-800">
                                    Mettre à jour la masse salariale de l'entreprise
                                  </span>
                                  <p className="text-sm text-orange-600 mt-1">
                                    ⚠️ <strong>Si coché :</strong> La génération des bulletins comptera dans la masse salariale mensuelle.
                                    <br />
                                    📊 <strong>Si non coché :</strong> Les bulletins seront générés autant de fois que nécessaire sans impacter la masse salariale (recommandé pour éviter la double comptabilisation).
                                    <br />
                                    💡 <em>Chaque employé ne doit percevoir qu'un seul salaire mensuel dans les statistiques, peu importe le nombre de bulletins générés.</em>
                                  </p>
                                </div>
                              </label>
                            </div>
                          </CardContent>
                        </Card>

                        {/* Bouton de génération */}
                        <div className="flex justify-center">
                          <Button 
                            size="lg" 
                            onClick={handleGenerateBulletins}
                            disabled={selectedEmployeesForBulletin.length === 0}
                            className={`transition-all duration-200 font-semibold ${
                              selectedEmployeesForBulletin.length === 0 
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-60' 
                                : 'bg-green-600 hover:bg-green-700 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl'
                            }`}
                          >
                            <FileText className="w-5 h-5 mr-2 flex-shrink-0" />
                            <span className="whitespace-nowrap">
                              Générer les bulletins ({selectedEmployeesForBulletin.length})
                            </span>
                          </Button>
                        </div>
                      </div>
                    ) : (
                      /* Affichage des bulletins générés */
                      <div className="space-y-6">
                        {/* En-tête des bulletins générés */}
                        <div className="flex justify-between items-center">
                          <div>
                            <h4 className="text-lg font-medium text-green-800">✅ Bulletins générés avec succès</h4>
                            <p className="text-sm text-gray-600">
                              Période : {formatPeriod(generatedBulletins.period_start, generatedBulletins.period_end)} • 
                              Généré le {new Date(generatedBulletins.generation_date).toLocaleDateString('fr-FR')}
                            </p>
                            <p className="text-xs text-blue-600 mt-1">
                              💡 Les bulletins par email seront envoyés sur votre adresse : {user?.email}
                            </p>
                          </div>
                          <div className="flex space-x-3">
                            <Button 
                              variant="outline"
                              onClick={handleSendEmailsBulk}
                              disabled={emailSending}
                              className={`transition-all duration-200 border-blue-200 ${
                                emailSending 
                                  ? 'bg-blue-100 text-blue-600 cursor-wait opacity-70' 
                                  : 'bg-blue-50 hover:bg-blue-100 hover:scale-105 active:scale-95 text-blue-700'
                              }`}
                            >
                              {emailSending ? (
                                <>
                                  <Loader2 className="w-4 h-4 mr-2 animate-spin flex-shrink-0" />
                                  <span>Envoi en cours...</span>
                                </>
                              ) : (
                                <>
                                  <Mail className="w-4 h-4 mr-2 flex-shrink-0" />
                                  <span className="whitespace-nowrap">
                                    Envoyer tous par email ({generatedBulletins.employees.length})
                                  </span>
                                </>
                              )}
                            </Button>
                            <Button 
                              variant="outline"
                              onClick={handleDownloadBulkPDF}
                              disabled={bulkPdfDownloading}
                              data-testid="btn-tout-imprimer"
                              className={`transition-all duration-200 border-green-200 ${
                                bulkPdfDownloading 
                                  ? 'bg-green-100 text-green-600 cursor-wait opacity-70' 
                                  : 'bg-green-50 hover:bg-green-100 hover:scale-105 active:scale-95 text-green-700'
                              }`}
                            >
                              {bulkPdfDownloading ? (
                                <>
                                  <Loader2 className="w-4 h-4 mr-2 animate-spin flex-shrink-0" />
                                  <span>Génération en cours...</span>
                                </>
                              ) : (
                                <>
                                  <Printer className="w-4 h-4 mr-2 flex-shrink-0" />
                                  <span className="whitespace-nowrap">
                                    Tout imprimer ({generatedBulletins.employees.length})
                                  </span>
                                </>
                              )}
                            </Button>
                            <Button 
                              variant="outline" 
                              onClick={() => {
                                setGeneratedBulletins(null);
                                setSelectedEmployeesForBulletin([]);
                                setEmailResults(null);
                              }}
                            >
                              Nouvelle génération
                            </Button>
                          </div>
                        </div>

                        {/* Résultats envoi email */}
                        {emailResults && (
                          <div className={`p-4 rounded-lg border ${emailResults.failed_emails.length > 0 ? 'bg-yellow-50 border-yellow-200' : 'bg-green-50 border-green-200'}`}>
                            <div className="flex items-center space-x-2">
                              <span className="text-lg">📧</span>
                              <div>
                                <p className={`font-medium ${emailResults.failed_emails.length > 0 ? 'text-yellow-800' : 'text-green-800'}`}>
                                  Envoi d'emails terminé: {emailResults.sent_count}/{emailResults.total_count} envoyés
                                </p>
                                {emailResults.failed_emails.length > 0 && (
                                  <details className="mt-2">
                                    <summary className="cursor-pointer text-sm text-yellow-700 hover:text-yellow-900">
                                      Voir les échecs ({emailResults.failed_emails.length})
                                    </summary>
                                    <ul className="mt-2 text-sm text-yellow-700 list-disc list-inside">
                                      {emailResults.failed_emails.map((error, index) => (
                                        <li key={`email-error-${index}-${error.substring(0, 10)}`}>{error}</li>
                                      ))}
                                    </ul>
                                  </details>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Liste des bulletins générés */}
                        <div className="space-y-4">
                          {generatedBulletins.employees.map((employee) => (
                            <Card key={employee.id} className="border-green-200">
                              <CardContent className="p-6">
                                {/* En-tête : Informations entreprise et Bulletin de paie côte à côte */}
                                <div className="grid grid-cols-2 gap-6 mb-6 p-4 bg-gray-50 border border-gray-300 rounded">
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3">Informations entreprise</h4>
                                    <div className="space-y-1 text-sm">
                                      <p className="font-bold text-lg">{generatedBulletins.company_info.name}</p>
                                      <p>{generatedBulletins.company_info.address}</p>
                                      <p>Tél : {generatedBulletins.company_info.phone || '00 00 00 00 00'}</p>
                                      <p>RCCM : {generatedBulletins.company_info.rccm || 'N/A'}</p>
                                      <p>N° Compte Contribuable : {generatedBulletins.company_info.ncc_number || 'N/A'}</p>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <h3 className="text-xl font-bold text-gray-900 mb-3">BULLETIN DE PAIE</h3>
                                    <div className="space-y-1 text-sm">
                                      <p>Période : {formatPeriod(generatedBulletins.period_start, generatedBulletins.period_end)}</p>
                                      <p>Date d'édition : {new Date().toLocaleDateString('fr-FR')}</p>
                                      <p>N° Bulletin : BP-{new Date().getFullYear()}{String(new Date().getMonth() + 1).padStart(2, '0')}-{employee.matricule}</p>
                                    </div>
                                  </div>
                                </div>

                                {/* Informations employé et Situation familiale - côte à côte avec espacement tabulaire */}
                                <div className="grid grid-cols-2 gap-6 mb-6">
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">Informations sur l'employé</h4>
                                    <div className="space-y-2 text-sm">
                                      <div className="flex justify-between">
                                        <span>Nom complet :</span>
                                        <span className="font-medium">{employee.full_name}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Poste occupé :</span>
                                        <span className="font-medium">{employee.poste}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Date d'embauche :</span>
                                        <span className="font-medium">{employee.date_embauche}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Matricule :</span>
                                        <span className="font-medium">{employee.matricule}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>N° CNPS :</span>
                                        <span className="font-medium">{employee.cnps_number || 'N/A'}</span>
                                      </div>
                                      {(employee.titre || employee.categorie) && (
                                        <div className="flex justify-between" data-testid="bulletin-titre-categorie">
                                          <span>{employee.titre && employee.categorie ? 'Titre / Catégorie :' : (employee.titre ? 'Titre :' : 'Catégorie :')}</span>
                                          <span className="font-medium">{[employee.titre, employee.categorie].filter(Boolean).join(' / ')}</span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">Situation familiale</h4>
                                    <div className="space-y-2 text-sm">
                                      <div className="flex justify-between">
                                        <span>Statut matrimonial :</span>
                                        <span className="font-medium">{employee.payroll.statut_matrimonial || 'Célibataire'}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Nombre d'enfants :</span>
                                        <span className="font-medium">{employee.payroll.nombre_enfants || 0}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Enfants infirmes :</span>
                                        <span className="font-medium">{employee.payroll.nombre_enfants_infirmes || 0}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Parts familiales :</span>
                                        <span className="font-medium">{employee.payroll.nombre_parts_familiales || 1}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>RICF :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.ricf_montant || 0)}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Éléments constitutifs du salaire et Salaires bruts côte à côte */}
                                <div className="grid grid-cols-2 gap-6 mb-6">
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">Éléments constitutifs du salaire</h4>
                                    <div className="space-y-2 text-sm">
                                      <div className="flex justify-between">
                                        <span>Salaire catégoriel :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.salary_categoriel)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Prime transport :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.prime_transport || 0)}</span>
                                      </div>
                                      {employee.gratification_display_consent !== false && (
                                        <div className="flex justify-between">
                                          <span>Gratification :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.gratification_mensuelle || 0)}</span>
                                        </div>
                                      )}
                                      {employee.payroll.prime_anciennete > 0 && (
                                        <div className="flex justify-between">
                                          <span>Prime ancienneté :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.prime_anciennete)}</span>
                                        </div>
                                      )}
                                      {employee.payroll.sursalaire > 0 && (
                                        <div className="flex justify-between">
                                          <span>Sursalaire :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.sursalaire)}</span>
                                        </div>
                                      )}
                                      {employee.payroll.heures_sup > 0 && (
                                        <div className="flex justify-between">
                                          <span>Heures supplémentaires :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.heures_sup)}</span>
                                        </div>
                                      )}
                                      {employee.payroll.avantages_nature > 0 && (
                                        <div className="flex justify-between bg-yellow-50 -mx-2 px-2 py-1 rounded">
                                          <span>Avantages en nature :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.avantages_nature)}</span>
                                        </div>
                                      )}
                                      {employee.payroll.avantages_argent > 0 && (
                                        <div className="flex justify-between bg-yellow-50 -mx-2 px-2 py-1 rounded">
                                          <span>Avantages en argent :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.avantages_argent)}</span>
                                        </div>
                                      )}
                                      {/* Éléments configurables sélectionnés (indemnités / primes / compléments) */}
                                      {(employee.payroll.configurable_elements_details || [])
                                        .filter((elem) => (elem.amount || 0) > 0)
                                        .map((elem) => (
                                          <div key={`bulletin-config-${elem.id}`} className="flex justify-between bg-amber-50 -mx-2 px-2 py-1 rounded" data-testid={`bulletin-configurable-element-${elem.id}`}>
                                            <span>{elem.type_label || 'Élément'} - {elem.name} :</span>
                                            <span className="font-medium">{formatCurrency(elem.amount)}</span>
                                          </div>
                                        ))}
                                      {employee.payroll.special_allowances_taxable > 0 && (
                                        <div className="flex justify-between bg-yellow-50 -mx-2 px-2 py-1 rounded">
                                          <span>Allocations spéciales pour frais d'emploi (imposable - Art. 116-1) :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.special_allowances_taxable)}</span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">Salaires bruts</h4>
                                    <div className="space-y-2 text-sm">
                                      <div className="flex justify-between">
                                        <span>Brut imposable IS :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.salary_brut_imposable_is)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Brut social imposable :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.salary_brut_social_imposable)}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Cotisations et retenues (salariales) et Retenues patronales côte à côte */}
                                <div className="grid grid-cols-2 gap-6 mb-6">
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">Cotisations et retenues (salariales)</h4>
                                    <div className="space-y-2 text-sm">
                                      <div className="flex justify-between">
                                        <span>CNPS salarié (6,3 %) :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.cnps_salarie)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>IS salarié :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.is_salarie || 0)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>CMU salarié :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.cmu_salarie || 0)}</span>
                                      </div>
                                      {employee.payroll.avances > 0 && (
                                        <div className="flex justify-between">
                                          <span>Avances :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.avances)}</span>
                                        </div>
                                      )}
                                      <div className="pt-2 border-t border-gray-200">
                                        <div className="flex justify-between font-semibold bg-red-100 p-2 rounded">
                                          <span>Total retenues salariales :</span>
                                          <span>{formatCurrency((employee.payroll.retenues_salariales_total || 0) + (employee.payroll.avances || 0))}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">Retenues patronales</h4>
                                    <div className="space-y-2 text-sm">
                                      <div className="flex justify-between">
                                        <span>CNPS employeur :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.cnps_employeur_base || 0)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Prestations familiales (5,75%) :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.prestations_familiales || 0)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Accidents de travail :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.accidents_travail || 0)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Formation continue (0,6%) :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.formation_continue || 0)}</span>
                                      </div>
                                      <div className="flex justify-between">
                                        <span>Taxe d'apprentissage (0,4%) :</span>
                                        <span className="font-medium">{formatCurrency(employee.payroll.taxe_apprentissage || 0)}</span>
                                      </div>
                                      {employee.payroll.cmu_employeur > 0 && (
                                        <div className="flex justify-between">
                                          <span>CMU employeur :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.cmu_employeur)}</span>
                                        </div>
                                      )}
                                      {employee.payroll.is_patronal > 0 && (
                                        <div className="flex justify-between">
                                          <span>IS patronal :</span>
                                          <span className="font-medium">{formatCurrency(employee.payroll.is_patronal)}</span>
                                        </div>
                                      )}
                                      <div className="pt-2 border-t border-gray-200">
                                        <div className="flex justify-between font-semibold bg-yellow-100 p-2 rounded">
                                          <span>Total retenues patronales :</span>
                                          <span>{formatCurrency(employee.payroll.retenues_patronales_total || 0)}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Section Gains ajoutée */}
                                <div className="mb-6">
                                  <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">💰 Détail des gains (exonérés d'impôts et de cotisations)</h4>
                                  <div className="space-y-2 text-sm">
                                    {/* Prime de transport exonérée */}
                                    {employee.payroll.prime_transport_non_imposable > 0 && (
                                      <div className="flex justify-between">
                                        <span>Prime de transport (exonérée) :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.prime_transport_non_imposable)}</span>
                                      </div>
                                    )}
                                    
                                    {/* Allocations familiales */}
                                    {employee.payroll.allocations_familiales_exonerees > 0 && (
                                      <div className="flex justify-between">
                                        <span>Allocations familiales :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.allocations_familiales_exonerees)}</span>
                                      </div>
                                    )}
                                    
                                    {/* Indemnités pour frais d'emploi exonérées */}
                                    {employee.payroll.indemnites_frais_emploi_non_imposable > 0 && (
                                      <div className="flex justify-between">
                                        <span>Indemnités pour frais d'emploi/fonction (exonérées) :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.indemnites_frais_emploi_non_imposable)}</span>
                                      </div>
                                    )}
                                    
                                    {/* Allocations spéciales exonérées (Art. 116-1) */}
                                    {employee.payroll.special_allowances_exempt > 0 && (
                                      <div className="flex justify-between bg-green-50 -mx-2 px-2 py-2 rounded">
                                        <span className="font-semibold">Allocations spéciales pour frais d'emploi (exonérées - Art. 116-1) :</span>
                                        <span className="font-bold text-green-700 text-base">+{formatCurrency(employee.payroll.special_allowances_exempt)}</span>
                                      </div>
                                    )}
                                    
                                    {/* Remboursement de frais */}
                                    {employee.payroll.remboursement_frais > 0 && (
                                      <div className="flex justify-between">
                                        <span>Remboursement de frais :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.remboursement_frais)}</span>
                                      </div>
                                    )}
                                    
                                    {/* Primes spéciales exonérées (panier, salissure, tenue, outillage) versées comme gains */}
                                    {employee.payroll.prime_panier_exonere > 0 && (
                                      <div className="flex justify-between" data-testid="gain-prime-panier-exonere">
                                        <span>Prime de panier (exonérée) :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.prime_panier_exonere)}</span>
                                      </div>
                                    )}
                                    {employee.payroll.prime_salissure_exonere > 0 && (
                                      <div className="flex justify-between" data-testid="gain-prime-salissure-exonere">
                                        <span>Prime de salissure (exonérée) :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.prime_salissure_exonere)}</span>
                                      </div>
                                    )}
                                    {employee.payroll.prime_tenue_exonere > 0 && (
                                      <div className="flex justify-between" data-testid="gain-prime-tenue-exonere">
                                        <span>Indemnité de tenue de travail (exonérée) :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.prime_tenue_exonere)}</span>
                                      </div>
                                    )}
                                    {employee.payroll.prime_outillage_exonere > 0 && (
                                      <div className="flex justify-between" data-testid="gain-prime-outillage-exonere">
                                        <span>Prime d'outillage (exonérée) :</span>
                                        <span className="font-medium text-green-600">+{formatCurrency(employee.payroll.prime_outillage_exonere)}</span>
                                      </div>
                                    )}
                                    
                                    {/* Séparateur et Total */}
                                    <div className="pt-3 mt-3 border-t-2 border-green-600">
                                      <div className="flex justify-between font-bold bg-green-100 p-3 rounded border-2 border-green-600">
                                        <span className="text-base">TOTAL DES GAINS :</span>
                                        <span className="text-green-700 text-lg">+{formatCurrency((employee.payroll.prime_transport_non_imposable || 0) + (employee.payroll.allocations_familiales_exonerees || 0) + (employee.payroll.indemnites_frais_emploi_non_imposable || 0) + (employee.payroll.special_allowances_exempt || 0) + (employee.payroll.remboursement_frais || 0) + (employee.payroll.primes_speciales_total_exonere || 0) + (employee.payroll.frais_exempt || 0) + (employee.payroll.elements_configurables_non_imposables || 0))}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Formule de calcul - selon modèle avec encadré */}
                                <div className="mb-6">
                                  <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">🧮 Formule de calcul du salaire net</h4>
                                  <div className="bg-gray-100 p-4 border border-gray-300 rounded space-y-1 text-sm">
                                    <p className="font-medium">Salaire net = Salaire brut - Retenues + Gains</p>
                                    <p>Salaire net = {formatCurrency(employee.payroll.salary_brut_imposable_is)} - {formatCurrency((employee.payroll.retenues_salariales_total || 0) + (employee.payroll.avances || 0))} + {formatCurrency((employee.payroll.allocations_familiales_exonerees || 0) + (employee.payroll.prime_transport || 0) + (employee.payroll.indemnites_frais_emploi_non_imposable || 0) + (employee.payroll.remboursement_frais || 0) + (employee.payroll.special_allowances_exempt || 0) + (employee.payroll.primes_speciales_total_exonere || 0) + (employee.payroll.frais_exempt || 0) + (employee.payroll.elements_configurables_non_imposables || 0))}</p>
                                  </div>
                                </div>

                                {/* Mode de paiement */}
                                <div className="mb-6">
                                  <div className="bg-orange-50 p-4 border border-orange-500 rounded text-center">
                                    <p className="text-sm font-medium text-orange-900 mb-1">Mode de paiement</p>
                                    <p className="text-lg font-bold text-orange-900">
                                      {employee.payroll.payment_method === 'espece' && '💵 Paiement en espèce'}
                                      {employee.payroll.payment_method === 'virement' && '🏦 Virement bancaire'}
                                      {employee.payroll.payment_method === 'cheque' && '📄 Chèque'}
                                      {!employee.payroll.payment_method && '💵 Paiement en espèce'}
                                    </p>
                                  </div>
                                </div>

                                {/* Salaire net à payer - selon modèle avec encadré vert */}
                                <div className="mb-6">
                                  {/* Afficher les prêts actifs s'il y en a */}
                                  {employee.payroll.prets_actifs && employee.payroll.prets_actifs.length > 0 && (
                                    <div className="mb-4 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                                      <h5 className="font-semibold text-orange-800 mb-2">💳 Remboursement des prêts</h5>
                                      <div className="space-y-1">
                                        {employee.payroll.prets_actifs.map((pret, idx) => (
                                          <div key={idx} className="flex justify-between text-sm">
                                            <span className="text-orange-700">{pret.description || 'Prêt'}</span>
                                            <span className="font-medium text-orange-800">- {formatCurrency(pret.actual_deduction)}</span>
                                          </div>
                                        ))}
                                        <div className="border-t border-orange-300 pt-1 mt-2 flex justify-between font-semibold">
                                          <span className="text-orange-800">Total remboursement</span>
                                          <span className="text-orange-900">- {formatCurrency(employee.payroll.total_remboursement_prets || 0)}</span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  
                                  <div className="bg-green-100 p-6 border-2 border-green-600 rounded text-center">
                                    <p className="text-xl font-bold text-green-800">
                                      SALAIRE NET À PAYER : {formatCurrency(employee.payroll.salary_net_a_payer || employee.payroll.salary_net)}
                                    </p>
                                    {employee.payroll.total_remboursement_prets > 0 && (
                                      <p className="text-sm text-green-600 mt-2">
                                        (Salaire net {formatCurrency(employee.payroll.salary_net)} - Prêts {formatCurrency(employee.payroll.total_remboursement_prets)})
                                      </p>
                                    )}
                                  </div>
                                </div>

                                {/* Émargement - selon modèle */}
                                <div className="mb-6">
                                  <h4 className="font-bold text-gray-800 mb-3 border-b border-gray-300 pb-1">📋 Émargement</h4>
                                  <div className="grid grid-cols-2 gap-6 mt-4">
                                    <div className="text-center">
                                      <p className="font-medium mb-4">Signature de l'employé</p>
                                      <div className="border-b border-gray-400 h-12 mb-2"></div>
                                      <p className="text-sm">Date : ________________</p>
                                    </div>
                                    <div className="text-center">
                                      <p className="font-medium mb-4">Signature du gestionnaire de paie</p>
                                      <div className="border-b border-gray-400 h-12 mb-2"></div>
                                      <p className="text-sm">Date : {new Date().toLocaleDateString('fr-FR')}</p>
                                    </div>
                                  </div>
                                </div>

                                {/* Mention légale - selon modèle */}
                                <div className="text-center mt-8">
                                  <p className="text-xs text-gray-500 italic">
                                    Ce bulletin de paie est un document officiel et doit être conservé précieusement.
                                  </p>
                                </div>

                                {/* Actions bulletin */}
                                <div className="mt-6 flex justify-end space-x-2">
                                  <Button 
                                    variant="outline" 
                                    size="sm"
                                    onClick={() => handlePrintPDF(employee.id)}
                                    className="text-blue-600 border-blue-200 hover:bg-blue-50"
                                  >
                                    <Printer className="w-4 h-4 mr-1" />
                                    Imprimer
                                  </Button>
                                  <Button 
                                    variant="outline" 
                                    size="sm"
                                    onClick={() => handleDownloadPDF(employee.id)}
                                    disabled={pdfDownloading}
                                  >
                                    <Download className="w-4 h-4 mr-1" />
                                    {pdfDownloading ? 'Téléchargement...' : 'Télécharger PDF'}
                                  </Button>
                                  <Button 
                                    variant="destructive" 
                                    size="sm"
                                    onClick={async () => {
                                      if (!window.confirm(`Êtes-vous sûr de vouloir supprimer le bulletin de ${employee.full_name} ?`)) return;
                                      
                                      try {
                                        // Trouver le payroll_id correspondant à cet employé pour cette période
                                        const month = new Date(generatedBulletins.period_start).getMonth() + 1;
                                        const year = new Date(generatedBulletins.period_start).getFullYear();
                                        
                                        // Récupérer le bulletin de paie pour cet employé
                                        const payrollResponse = await axios.get(
                                          `${BACKEND_URL}/api/companies/${selectedCompany.id}/payroll/${month}/${year}`
                                        );
                                        
                                        const payrollItem = payrollResponse.data.payroll_data.find(
                                          p => p.employee_id === employee.id
                                        );
                                        
                                        if (!payrollItem) {
                                          toast.error('Bulletin non trouvé dans la base de données');
                                          return;
                                        }
                                        
                                        // Supprimer le bulletin
                                        await axios.delete(`${BACKEND_URL}/api/payroll/${payrollItem.id}`);
                                        
                                        // Retirer cet employé de la liste des bulletins générés
                                        const updatedEmployees = generatedBulletins.employees.filter(
                                          emp => emp.id !== employee.id
                                        );
                                        
                                        if (updatedEmployees.length === 0) {
                                          // Plus de bulletins, revenir à l'écran de génération
                                          setGeneratedBulletins(null);
                                          setSelectedEmployeesForBulletin([]);
                                        } else {
                                          // Mettre à jour la liste
                                          setGeneratedBulletins({
                                            ...generatedBulletins,
                                            employees: updatedEmployees
                                          });
                                        }
                                        
                                        toast.success('Bulletin supprimé avec succès');
                                      } catch (error) {
                                        console.error('Erreur suppression bulletin:', error);
                                        toast.error('Erreur lors de la suppression du bulletin');
                                      }
                                    }}
                                  >
                                    <Trash2 className="w-4 h-4 mr-1" />
                                    Supprimer
                                  </Button>
                                </div>
                              </CardContent>
                            </Card>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Generated Bulletins Section */}
                {payrollSection === 'generated' && (
                  <div className="space-y-6">
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-800">📋 Bulletins Générés - Historique</h3>
                        <p className="text-sm text-gray-600">Consultez et téléchargez les bulletins de paie générés précédemment</p>
                      </div>
                      <Button 
                        onClick={fetchBulletinsHistory}
                        variant="outline"
                        size="sm"
                        disabled={isLoadingBulletinsHistory}
                      >
                        {isLoadingBulletinsHistory ? (
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        ) : (
                          <RefreshCw className="w-4 h-4 mr-2" />
                        )}
                        {isLoadingBulletinsHistory ? 'Chargement...' : 'Actualiser'}
                      </Button>
                    </div>

                    {bulletinsHistory.length === 0 ? (
                      <Card className="bg-gray-50">
                        <CardContent className="p-8">
                          <div className="text-center">
                            <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
                            <h4 className="text-lg font-medium text-gray-600 mb-2">Aucun bulletin généré</h4>
                            <p className="text-gray-500 mb-4">
                              Utilisez la section "Édition de bulletin" pour générer vos premiers bulletins de paie.
                            </p>
                            <Button 
                              onClick={() => setPayrollSection('bulletin')}
                              className="bg-blue-600 hover:bg-blue-700"
                            >
                              Générer des bulletins
                            </Button>
                          </div>
                        </CardContent>
                      </Card>
                    ) : (
                      <div className="space-y-4">
                        {bulletinsHistory.map((period, index) => (
                          <Card key={`${period.year}-${period.month}`} className="border-blue-200">
                            <CardHeader>
                              <div className="flex justify-between items-start">
                                <div>
                                  <CardTitle className="text-blue-800">
                                    📅 {new Date(period.year, period.month - 1).toLocaleDateString('fr-FR', { 
                                      month: 'long', 
                                      year: 'numeric' 
                                    })}
                                  </CardTitle>
                                  <CardDescription>
                                    {period.total_employees} employé(s) • 
                                    Masse salariale nette : {formatCurrency(period.total_net)}
                                  </CardDescription>
                                </div>
                                <Badge variant="secondary">
                                  {(period.bulletins || period.employees || []).length} bulletin{(period.bulletins || period.employees || []).length > 1 ? 's' : ''}
                                </Badge>
                              </div>
                            </CardHeader>
                            <CardContent>
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {(period.bulletins || period.employees || []).map((bulletin) => (
                                  <div key={bulletin.id || bulletin.employee_id} className="border rounded-lg p-4 bg-white">
                                    <div className="flex justify-between items-start mb-3">
                                      <div>
                                        <h5 className="font-medium text-gray-900">{bulletin.employee_name || bulletin.full_name}</h5>
                                        <p className="text-sm text-gray-600">{bulletin.position}</p>
                                      </div>
                                      <Badge variant="outline" className="text-xs">
                                        {formatCurrency(bulletin.salary_net)}
                                      </Badge>
                                    </div>
                                    
                                    <div className="flex space-x-1">
                                      <Button 
                                        size="sm" 
                                        variant="outline"
                                        onClick={() => handlePrintPDFFromHistory(bulletin.employee_id || bulletin.id, period.period_start || `${period.year}-${period.month.toString().padStart(2,'0')}-01`, period.period_end || `${period.year}-${period.month.toString().padStart(2,'0')}-28`)}
                                        className="flex-1 text-xs text-blue-600 border-blue-200 hover:bg-blue-50"
                                      >
                                        <Printer className="w-3 h-3 mr-1" />
                                        Imprimer
                                      </Button>
                                      <Button 
                                        size="sm" 
                                        variant="outline"
                                        onClick={() => handleDownloadPDFFromHistory(bulletin.employee_id || bulletin.id, period.period_start || `${period.year}-${period.month.toString().padStart(2,'0')}-01`, period.period_end || `${period.year}-${period.month.toString().padStart(2,'0')}-28`, bulletin.employee_name || bulletin.full_name)}
                                        className="flex-1 text-xs"
                                      >
                                        <Download className="w-3 h-3 mr-1" />
                                        PDF
                                      </Button>
                                      <Button 
                                        size="sm" 
                                        variant="outline"
                                        onClick={() => handleSendBulletinsEmail([bulletin.employee_id || bulletin.id])}
                                        className="flex-1 text-xs"
                                      >
                                        <Mail className="w-3 h-3 mr-1" />
                                        Email
                                      </Button>
                                      <Button 
                                        size="sm" 
                                        variant="outline"
                                        onClick={() => handleDeleteBulletin(bulletin.employee_id || bulletin.id, period.period_start || `${period.year}-${period.month.toString().padStart(2,'0')}-01`, period.period_end || `${period.year}-${period.month.toString().padStart(2,'0')}-28`, bulletin.employee_name || bulletin.full_name)}
                                        className="flex-1 text-xs text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                                        disabled={false}
                                      >
                                        <Trash2 className="w-3 h-3 mr-1 flex-shrink-0" />
                                        <span className="truncate">Supprimer</span>
                                      </Button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              
                              {/* Actions groupées */}
                              <div className="mt-4 pt-4 border-t flex justify-end space-x-2">
                                <Button 
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    const employeeIds = (period.bulletins || period.employees || []).map(b => b.employee_id || b.id);
                                    handleSendBulletinsEmail(employeeIds);
                                  }}
                                >
                                  <Mail className="w-4 h-4 mr-1" />
                                  Envoyer tous par email
                                </Button>
                                <Button 
                                  variant="outline"
                                  size="sm"
                                  onClick={() => handleDeletePeriod(period.period_start || `${period.year}-${period.month.toString().padStart(2,'0')}-01`, period.period_end || `${period.year}-${period.month.toString().padStart(2,'0')}-28`, (period.bulletins || period.employees || []).length)}
                                  className="text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                                  disabled={false}
                                >
                                  <Trash2 className="w-4 h-4 mr-1 flex-shrink-0" />
                                  <span className="hidden sm:inline">Supprimer la période</span>
                                  <span className="sm:hidden">Suppr. période</span>
                                </Button>
                                <Button 
                                  size="sm"
                                  onClick={async () => {
                                    // Charger les données complètes des bulletins pour cette période
                                    try {
                                      toast.info("Chargement des détails...");
                                      const response = await axios.get(
                                        `${API}/companies/${selectedCompany.id}/payroll/${period.month}/${period.year}`,
                                        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }}
                                      );
                                      
                                      if (response.data && response.data.length > 0) {
                                        // Transformer les données pour le format attendu par generatedBulletins
                                        const bulletinsData = {
                                          period_start: `${period.year}-${period.month.toString().padStart(2,'0')}-01`,
                                          period_end: `${period.year}-${period.month.toString().padStart(2,'0')}-28`,
                                          company_info: selectedCompany,
                                          employees: response.data.map(item => ({
                                            id: item.employee?.id || item.payroll?.employee_id,
                                            first_name: item.employee?.first_name || '',
                                            last_name: item.employee?.last_name || '',
                                            full_name: `${item.employee?.first_name || ''} ${item.employee?.last_name || ''}`.trim(),
                                            position: item.employee?.position || '',
                                            matricule: item.employee?.matricule || '',
                                            numero_cnps: item.employee?.numero_cnps || '',
                                            payroll: item.payroll || {}
                                          })),
                                          generation_date: new Date().toISOString()
                                        };
                                        setGeneratedBulletins(bulletinsData);
                                        setPayrollSection('bulletin');
                                        toast.success(`${response.data.length} bulletin(s) chargé(s)`);
                                      } else {
                                        toast.error("Aucun bulletin trouvé pour cette période");
                                      }
                                    } catch (error) {
                                      console.error('Erreur lors du chargement des détails:', error);
                                      toast.error("Erreur lors du chargement des détails");
                                    }
                                  }}
                                  className="bg-blue-600 hover:bg-blue-700"
                                >
                                  <Eye className="w-4 h-4 mr-1" />
                                  Voir détails
                                </Button>
                              </div>
                            </CardContent>
                          </Card>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Paybook Section - Livre de paie */}
                {payrollSection === 'paybook' && (
                  <div className="space-y-6">
                    {/* En-tête de la section */}
                    <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-lg border border-indigo-200">
                      <div className="flex items-center justify-between">
                        <div>
                          <h3 className="text-xl font-bold text-indigo-800 flex items-center">
                            <Book className="w-6 h-6 mr-2" />
                            📚 Livre de Paie
                          </h3>
                          <p className="text-indigo-600 mt-2">
                            Journal chronologique de tous les salaires versés dans l'entreprise selon la réglementation ivoirienne
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-600">Entreprise :</p>
                          <p className="font-medium text-gray-800">{selectedCompany?.name}</p>
                        </div>
                      </div>
                    </div>

                    {/* Filtres et options */}
                    <Card className="border-indigo-200">
                      <CardHeader className="bg-indigo-50">
                        <CardTitle className="text-indigo-800 flex items-center">
                          <Filter className="w-5 h-5 mr-2" />
                          Filtres et Options
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="p-4">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          {/* Période */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              📅 Période
                            </label>
                            <select className="w-full p-2 border border-gray-300 rounded-md bg-white">
                              <option value="current">Mois actuel</option>
                              <option value="last3">3 derniers mois</option>
                              <option value="last6">6 derniers mois</option>
                              <option value="year">Année complète</option>
                              <option value="custom">Période personnalisée</option>
                            </select>
                          </div>

                          {/* Département */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              🏢 Département
                            </label>
                            <select className="w-full p-2 border border-gray-300 rounded-md bg-white">
                              <option value="">Tous les départements</option>
                              <option value="administration">Administration</option>
                              <option value="production">Production</option>
                              <option value="commercial">Commercial</option>
                              <option value="rh">Ressources Humaines</option>
                            </select>
                          </div>

                          {/* Actions */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              ⚡ Actions
                            </label>
                            <div className="space-y-2">
                              <Button 
                              className="w-full bg-indigo-600 hover:bg-indigo-700 hover:scale-105 active:scale-95 transition-all duration-200 font-medium shadow-md hover:shadow-lg" 
                              size="sm"
                              disabled={false}
                            >
                              <Search className="w-4 h-4 mr-2 flex-shrink-0" />
                              <span>Rechercher</span>
                            </Button>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Résumé des totaux */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <Card className="border-blue-200 bg-blue-50">
                        <CardContent className="p-4 text-center">
                          <div className="text-2xl font-bold text-blue-800">{livrePaieStats.employeeCount}</div>
                          <div className="text-sm text-blue-600">Employés payés</div>
                        </CardContent>
                      </Card>
                      
                      <Card className="border-green-200 bg-green-50">
                        <CardContent className="p-4 text-center">
                          <div className="text-2xl font-bold text-green-800">{formatCurrency(livrePaieStats.totalBrut)}</div>
                          <div className="text-sm text-green-600">Salaires bruts</div>
                        </CardContent>
                      </Card>
                      
                      <Card className="border-orange-200 bg-orange-50">
                        <CardContent className="p-4 text-center">
                          <div className="text-2xl font-bold text-orange-800">{formatCurrency(livrePaieStats.totalRetenues)}</div>
                          <div className="text-sm text-orange-600">Total retenues</div>
                        </CardContent>
                      </Card>
                      
                      <Card className="border-purple-200 bg-purple-50">
                        <CardContent className="p-4 text-center">
                          <div className="text-2xl font-bold text-purple-800">{formatCurrency(livrePaieStats.totalNet)}</div>
                          <div className="text-sm text-purple-600">Salaires nets</div>
                        </CardContent>
                      </Card>
                    </div>

                    {/* Tableau du livre de paie */}
                    <Card className="border-gray-200">
                      <CardHeader className="bg-gray-50">
                        <div className="flex justify-between items-center">
                          <CardTitle className="text-gray-800 flex items-center">
                            <FileText className="w-5 h-5 mr-2" />
                            Registre Chronologique des Paies
                          </CardTitle>
                          <div className="flex flex-wrap gap-2">
                            <Button 
                              variant="outline" 
                              size="sm"
                              onClick={handleExportRegistreExcel}
                              disabled={isExportingExcel || payrolls.length === 0}
                              className="border-green-200 text-green-600 hover:bg-green-50 hover:border-green-300 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              {isExportingExcel ? (
                                <Loader2 className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0 animate-spin" />
                              ) : (
                                <Download className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0" />
                              )}
                              <span className="hidden sm:inline">
                                {isExportingExcel ? 'Génération...' : 'Exporter Excel'}
                              </span>
                              <span className="sm:hidden">
                                {isExportingExcel ? 'Gen...' : 'Excel'}
                              </span>
                            </Button>
                            
                            <Button 
                              variant="outline" 
                              size="sm"
                              onClick={handleViewLivrePaie}
                              disabled={payrolls.length === 0}
                              className="border-purple-200 text-purple-600 hover:bg-purple-50 hover:border-purple-300 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              <Eye className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0" />
                              <span className="hidden sm:inline">
                                Afficher le livre
                              </span>
                              <span className="sm:hidden">
                                Livre
                              </span>
                            </Button>
                            
                            <Button 
                              variant="outline" 
                              size="sm"
                              onClick={handlePrintRegistre}
                              disabled={isPrintingRegistre || payrolls.length === 0}
                              className="border-blue-200 text-blue-600 hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              {isPrintingRegistre ? (
                                <Loader2 className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0 animate-spin" />
                              ) : (
                                <Printer className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0" />
                              )}
                              <span className="hidden sm:inline">
                                {isPrintingRegistre ? 'Préparation...' : 'Imprimer'}
                              </span>
                              <span className="sm:hidden">
                                {isPrintingRegistre ? 'Prep...' : 'Print'}
                              </span>
                            </Button>
                            
                            <Button 
                              variant="outline" 
                              size="sm"
                              onClick={handleExportRegistrePDF}
                              disabled={isExportingPDF || payrolls.length === 0}
                              className="border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300 transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              {isExportingPDF ? (
                                <Loader2 className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0 animate-spin" />
                              ) : (
                                <FileText className="w-4 h-4 mr-1 sm:mr-2 flex-shrink-0" />
                              )}
                              <span className="hidden sm:inline">
                                {isExportingPDF ? 'Génération...' : 'Export PDF'}
                              </span>
                              <span className="sm:hidden">
                                {isExportingPDF ? 'Gen...' : 'PDF'}
                              </span>
                            </Button>
                          </div>
                        </div>
                      </CardHeader>
                      <CardContent className="p-0">
                        <div className="overflow-x-auto">
                          <table className="w-full text-xs border-collapse border border-gray-300">
                            <thead className="bg-gray-100">
                              {/* Première ligne d'en-tête pour les colonnes principales */}
                              <tr className="border-b-2 border-gray-300">
                                <th rowSpan="2" className="border border-gray-300 p-2 font-medium text-gray-700 text-center">Date de Paie</th>
                                <th rowSpan="2" className="border border-gray-300 p-2 font-medium text-gray-700 text-center">Employés</th>
                                <th rowSpan="2" className="border border-gray-300 p-2 font-medium text-gray-700 text-center">Matricules</th>
                                <th rowSpan="2" className="border border-gray-300 p-2 font-medium text-gray-700 text-center">Salaire Brut</th>
                                <th rowSpan="2" className="border border-gray-300 p-2 font-medium text-gray-700 text-center">Salaire Brut Imposable</th>
                                <th colSpan="5" className="border border-gray-300 p-2 font-medium text-gray-700 text-center bg-red-50">Retenues Salariales</th>
                                <th colSpan="8" className="border border-gray-300 p-2 font-medium text-gray-700 text-center bg-orange-50">Retenues Patronales</th>
                                <th rowSpan="2" className="border border-gray-300 p-2 font-medium text-gray-700 text-center">Net à Payer</th>
                              </tr>
                              {/* Deuxième ligne d'en-tête pour les sous-colonnes */}
                              <tr className="border-b border-gray-300">
                                {/* Sous-colonnes Retenues Salariales - Conformes aux bulletins */}
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-red-50">CNPS salarié (6,3%)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-red-50">IS salarié</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-red-50">CMU salarié</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-red-50">Avances</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-red-50">Total Retenues</th>
                                {/* Sous-colonnes Retenues Patronales - NOUVELLES COLONNES AJOUTÉES */}
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">Prestations familiales (5,75%)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">Accidents de travail</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">IS patronal (1,2%)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">CNPS employeur (16,75%)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">Taxe d'apprentissage (0,4%)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">Formation continue (0,6%)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">CMU patronal (500F)</th>
                                <th className="border border-gray-300 p-1 font-medium text-gray-600 text-center bg-orange-50">Total Patronal</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Affichage dynamique des bulletins de paie générés */}
                              {payrolls && payrolls.length > 0 ? (
                                payrolls.map((item, index) => {
                                  const payroll = item.payroll || item;
                                  const employee = item.employee || {};
                                  
                                  // Utiliser les vraies valeurs du bulletin de paie
                                  const salaire_base = payroll.salary_brut || 0;
                                  const salaire_brut_imposable = payroll.salary_brut_imposable_is || salaire_base;
                                  const cnps_sal = payroll.cnps_salarie || 0;
                                  const is_sal = payroll.is_salarie || 0;
                                  const cmu_sal = payroll.cmu_salarie || 0;
                                  const avances = payroll.avances || 0;
                                  const total_sal = payroll.retenues_salariales_total || (cnps_sal + is_sal + cmu_sal + avances);
                                  
                                  const prestations = payroll.prestations_familiales || 0;
                                  const accidents = payroll.accidents_travail || 0;
                                  const is_pat = payroll.is_patronal || 0;
                                  const cnps_emp = payroll.cnps_employeur_base || 0;
                                  const taxe = payroll.taxe_apprentissage || 0;
                                  const formation = payroll.formation_continue || 0;
                                  const cmu_pat = payroll.cmu_employeur || 0;
                                  // Calculer le total comme la somme exacte des colonnes affichées
                                  const total_pat = Math.round(prestations + accidents + is_pat + cnps_emp + taxe + formation + cmu_pat);
                                  
                                  const salaire_net = payroll.salary_net || 0;
                                  
                                  // Date de paie (utiliser la date de création du bulletin ou le dernier jour du mois)
                                  const datePaie = payroll.created_at 
                                    ? new Date(payroll.created_at).toLocaleDateString('fr-FR')
                                    : `${new Date(payroll.year, payroll.month, 0).getDate()}/${String(payroll.month).padStart(2, '0')}/${payroll.year}`;
                                  
                                  return (
                                    <tr key={payroll.id || index} className="border-b hover:bg-gray-50">
                                      <td className="border border-gray-300 p-2 text-center">{datePaie}</td>
                                      <td className="border border-gray-300 p-2 font-medium">{employee.first_name || ''} {employee.last_name || ''}</td>
                                      <td className="border border-gray-300 p-2 text-center">{employee.matricule || 'N/A'}</td>
                                      <td className="border border-gray-300 p-2 text-right font-medium">{salaire_base.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right font-medium">{salaire_brut_imposable.toLocaleString('fr-FR')}</td>
                                      {/* Retenues Salariales */}
                                      <td className="border border-gray-300 p-2 text-right bg-red-25">{cnps_sal.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-red-25">{is_sal.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-red-25">{cmu_sal.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-red-25">{avances.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-red-100 font-semibold">{total_sal.toLocaleString('fr-FR')}</td>
                                      {/* Retenues Patronales */}
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{prestations.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{accidents.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{is_pat.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{cnps_emp.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{taxe.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{formation.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-25">{cmu_pat.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right bg-orange-100 font-semibold">{total_pat.toLocaleString('fr-FR')}</td>
                                      <td className="border border-gray-300 p-2 text-right font-bold text-green-600">{salaire_net.toLocaleString('fr-FR')}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="19" className="border border-gray-300 p-4 text-center text-gray-500">
                                    Aucun bulletin de paie généré pour cette période. 
                                    Veuillez d'abord générer des bulletins dans la section "Édition de bulletin".
                                  </td>
                                </tr>
                              )}
                            </tbody>
                            
                            {/* Ligne de totaux */}
                            <tfoot className="bg-gray-100 font-bold border-t-2">
                              <tr>
                                <td colSpan="3" className="border border-gray-300 p-2 text-right">TOTAUX ({payrolls.length} bulletin{payrolls.length > 1 ? 's' : ''}) :</td>
                                <td className="border border-gray-300 p-2 text-right text-blue-600">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).salary_brut || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-blue-600">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).salary_brut_imposable_is || (item.payroll || item).salary_brut || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                {/* Totaux Retenues Salariales */}
                                <td className="border border-gray-300 p-2 text-right text-red-600 bg-red-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).cnps_salarie || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-red-600 bg-red-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).is_salarie || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-red-600 bg-red-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).cmu_salarie || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-red-600 bg-red-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).avances || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-red-600 bg-red-100">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).retenues_salariales_total || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                {/* Totaux Retenues Patronales */}
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).prestations_familiales || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).accidents_travail || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).is_patronal || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).cnps_employeur_base || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).taxe_apprentissage || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).formation_continue || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-50">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).cmu_employeur || 0), 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-orange-600 bg-orange-100">
                                  {/* Calculer le total patronal comme la somme exacte des colonnes */}
                                  {payrolls.reduce((sum, item) => {
                                    const p = item.payroll || item;
                                    return sum + Math.round(
                                      (p.prestations_familiales || 0) + 
                                      (p.accidents_travail || 0) + 
                                      (p.is_patronal || 0) + 
                                      (p.cnps_employeur_base || 0) + 
                                      (p.taxe_apprentissage || 0) + 
                                      (p.formation_continue || 0) + 
                                      (p.cmu_employeur || 0)
                                    );
                                  }, 0).toLocaleString('fr-FR')}
                                </td>
                                <td className="border border-gray-300 p-2 text-right text-green-600">
                                  {payrolls.reduce((sum, item) => sum + ((item.payroll || item).salary_net || 0), 0).toLocaleString('fr-FR')}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Note de cohérence avec les bulletins */}
                    <Card className="border-blue-200 bg-blue-50 mb-4">
                      <CardContent className="p-4">
                        <div className="flex items-start space-x-3">
                          <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                          <div>
                            <h4 className="font-medium text-blue-800 mb-1">Cohérence avec les Bulletins</h4>
                            <p className="text-sm text-blue-700">
                              <strong>Important :</strong> Les colonnes et montants de ce livre de paie correspondent exactement aux champs 
                              des bulletins individuels : cnps_salarie (6,3%), is_salarie, ricf_montant (RICF calculé selon les parts familiales), 
                              prestations_familiales (5,75%), accident_travail, etc. Les données sont automatiquement synchronisées avec les bulletins générés.
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Note réglementaire */}
                    <Card className="border-yellow-200 bg-yellow-50">
                      <CardContent className="p-4">
                        <div className="flex items-start space-x-3">
                          <AlertCircle className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                          <div>
                            <h4 className="font-medium text-yellow-800 mb-1">Note Réglementaire</h4>
                            <p className="text-sm text-yellow-700">
                              Conformément à l'article 32 du Code du Travail ivoirien, ce livre de paie doit être tenu 
                              de façon chronologique et conservé pendant une durée minimale de 5 ans. 
                              Il peut être présenté à tout moment aux agents de contrôle de l'Inspection du Travail.
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                )}

              </TabsContent>

              {/* Companies Tab */}
              <TabsContent value="companies" className="space-y-4">
                {/* Message spécial pour les nouveaux utilisateurs sans entreprise */}
                {user?.role !== 'super_admin' && companies.length === 0 && (
                  <Card className="border-orange-200 bg-orange-50">
                    <CardHeader>
                      <CardTitle className="text-orange-800 flex items-center">
                        <Building2 className="w-5 h-5 mr-2" />
                        Bienvenue sur SIRH-CI/PAIE !
                      </CardTitle>
                      <CardDescription className="text-orange-700">
                        Pour commencer à utiliser l'application, vous devez d'abord créer votre entreprise.
                        Cette entreprise sera uniquement accessible par vous et vous pourrez y gérer vos employés et leur paie.
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <div className="bg-white p-4 rounded-lg border border-orange-200">
                        <h4 className="font-medium text-orange-800 mb-2">Prochaines étapes :</h4>
                        <ol className="list-decimal list-inside space-y-1 text-orange-700 text-sm">
                          <li>Cliquez sur "Nouvelle entreprise" ci-dessous</li>
                          <li>Remplissez les informations de votre entreprise</li>
                          <li>Commencez à ajouter vos employés</li>
                          <li>Générez vos premiers bulletins de paie</li>
                        </ol>
                      </div>
                    </CardContent>
                  </Card>
                )}
                
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-gray-900">Gestion des entreprises</h2>
                  <div className="flex space-x-3">
                    {companies.length > 0 && (
                      <Input
                        placeholder="Rechercher une entreprise..."
                        value={companyFilter}
                        onChange={(e) => setCompanyFilter(e.target.value)}
                        className="w-64"
                      />
                    )}
                    
                    
                    <Button 
                      onClick={() => setIsCreateCompanyOpen(true)}
                      className="bg-indigo-600 hover:bg-indigo-700 text-white"
                      style={{ pointerEvents: 'auto', cursor: 'pointer', position: 'relative' }}
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Nouvelle entreprise
                    </Button>
                  </div>
                </div>

                {/* Formulaire pleine page pour créer une nouvelle entreprise */}
                {isCreateCompanyOpen && (
                  <div style={{ minHeight: '100vh' }} className="bg-gray-50 py-8 px-4">
                    <div className="max-w-4xl mx-auto">
                      <div className="bg-white rounded-lg shadow-lg p-6">
                        {/* En-tête avec bouton retour */}
                        <div className="flex items-center justify-between mb-6">
                          <div>
                            <h2 className="text-2xl font-bold text-gray-900">Nouvelle entreprise</h2>
                            <p className="text-sm text-gray-600 mt-1">Créez une nouvelle entreprise dans le système</p>
                          </div>
                          <Button
                            onClick={() => setIsCreateCompanyOpen(false)}
                            variant="outline"
                            className="flex items-center"
                          >
                            <X className="w-4 h-4 mr-2" />
                            Fermer
                          </Button>
                        </div>

                        <form onSubmit={handleCreateCompany} className="space-y-6">
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label htmlFor="name">Nom de l'entreprise</Label>
                              <Input required value={companyForm.name} onChange={(e) => setCompanyForm({...companyForm, name: e.target.value})} />
                            </div>
                            <div>
                              <Label htmlFor="email">Email</Label>
                              <Input type="email" required value={companyForm.email} onChange={(e) => setCompanyForm({...companyForm, email: e.target.value})} />
                            </div>
                          </div>
                          <div>
                            <Label htmlFor="address">Adresse</Label>
                            <Input required value={companyForm.address} onChange={(e) => setCompanyForm({...companyForm, address: e.target.value})} />
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label htmlFor="phone">Téléphone</Label>
                              <Input required value={companyForm.phone} onChange={(e) => setCompanyForm({...companyForm, phone: e.target.value})} />
                            </div>
                            <div>
                              <Label htmlFor="registration_number">N° Registre de commerce (RCCM)</Label>
                              <Input required value={companyForm.registration_number} onChange={(e) => setCompanyForm({...companyForm, registration_number: e.target.value})} />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label htmlFor="cnps_number">N° CNPS</Label>
                              <Input required value={companyForm.cnps_number} onChange={(e) => setCompanyForm({...companyForm, cnps_number: e.target.value})} />
                            </div>
                            <div>
                              <Label htmlFor="ncc_number">N°CC (Numéro de compte contribuable)</Label>
                              <Input value={companyForm.ncc_number} onChange={(e) => setCompanyForm({...companyForm, ncc_number: e.target.value})} placeholder="Optionnel" />
                            </div>
                          </div>
                          <div>
                            <Label htmlFor="gerant">Nom du gérant</Label>
                            <Input value={companyForm.gerant || ''} onChange={(e) => setCompanyForm({...companyForm, gerant: e.target.value})} placeholder="Nom complet du gérant" />
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label htmlFor="ville">Ville (pour calcul prime transport)</Label>
                              <SimpleNativeSelect
                                  value={companyForm.ville}
                                  onValueChange={handleCompanyVilleChange}
                                  placeholder="Sélectionner une ville"
                                  options={[
                                    {value: 'abidjan', label: 'Abidjan (30,000 FCFA non imposable)'},
                                    {value: 'bouake', label: 'Bouaké (24,000 FCFA non imposable)'},
                                    {value: 'autres', label: 'Autres villes (21,000 FCFA non imposable)'}
                                  ]}
                                />
                            </div>
                          </div>
                          <div>
                            <Label htmlFor="secteur_activite">Secteur d'activité (pour taux accidents travail)</Label>
                            <SimpleNativeSelect
                                  value={companyForm.secteur_activite}
                                  onValueChange={handleSecteurActiviteChange}
                                  placeholder="Sélectionner un secteur"
                                  options={[
                                    {value: 'bureau', label: 'Bureau/Services (2.0%)'},
                                    {value: 'commerce', label: 'Commerce/Distribution (2.5%)'},
                                    {value: 'industrie_legere', label: 'Industrie légère (3.0%)'},
                                    {value: 'industrie_lourde', label: 'Industrie lourde (4.0%)'},
                                    {value: 'btp', label: 'BTP/Construction (5.0%)'}
                                  ]}
                                />
                          </div>
                          <div className="flex gap-4 pt-6 border-t">
                            <Button
                              type="button"
                              onClick={() => setIsCreateCompanyOpen(false)}
                              variant="outline"
                              className="flex-1"
                            >
                              Annuler
                            </Button>
                            <Button
                              type="submit"
                              className="flex-1 bg-orange-600 hover:bg-orange-700 text-white"
                            >
                              <Plus className="w-4 h-4 mr-2" />
                              Créer l'entreprise
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}

                {/* Dialog d'édition d'entreprise */}
                <Dialog open={isEditCompanyOpen} onOpenChange={setIsEditCompanyOpen}>
                  <DialogContent className="sm:max-w-md">
                    <DialogHeader>
                      <DialogTitle>Modifier l'entreprise</DialogTitle>
                      <DialogDescription>Modifier les informations de l'entreprise</DialogDescription>
                    </DialogHeader>
                    <form onSubmit={handleUpdateCompany} className="space-y-4 max-h-96 overflow-y-auto">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label htmlFor="name">Nom de l'entreprise</Label>
                          <Input required value={companyForm.name} onChange={(e) => setCompanyForm({...companyForm, name: e.target.value})} />
                        </div>
                        <div>
                          <Label htmlFor="email">Email</Label>
                          <Input type="email" required value={companyForm.email} onChange={(e) => setCompanyForm({...companyForm, email: e.target.value})} />
                        </div>
                      </div>
                      <div>
                        <Label htmlFor="address">Adresse</Label>
                        <Input required value={companyForm.address} onChange={(e) => setCompanyForm({...companyForm, address: e.target.value})} />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label htmlFor="phone">Téléphone</Label>
                          <Input required value={companyForm.phone} onChange={(e) => setCompanyForm({...companyForm, phone: e.target.value})} />
                        </div>
                        <div>
                          <Label htmlFor="registration_number">N° Registre de commerce (RCCM)</Label>
                          <Input required value={companyForm.registration_number} onChange={(e) => setCompanyForm({...companyForm, registration_number: e.target.value})} />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label htmlFor="cnps_number">N° CNPS</Label>
                          <Input required value={companyForm.cnps_number} onChange={(e) => setCompanyForm({...companyForm, cnps_number: e.target.value})} />
                        </div>
                        <div>
                          <Label htmlFor="ncc_number">N°CC (Numéro de compte contribuable)</Label>
                          <Input value={companyForm.ncc_number} onChange={(e) => setCompanyForm({...companyForm, ncc_number: e.target.value})} placeholder="Optionnel" />
                        </div>
                      </div>
                      <div>
                        <Label htmlFor="gerant">Nom du gérant</Label>
                        <Input value={companyForm.gerant || ''} onChange={(e) => setCompanyForm({...companyForm, gerant: e.target.value})} placeholder="Nom complet du gérant" />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label htmlFor="ville">Ville</Label>
                          <SimpleNativeSelect
                                  value={companyForm.ville}
                                  onValueChange={handleCompanyVilleChange}
                                  placeholder="Sélectionner une ville"
                                  options={[
                                    {value: 'abidjan', label: 'Abidjan (30,000 FCFA non imposable)'},
                                    {value: 'bouake', label: 'Bouaké (24,000 FCFA non imposable)'},
                                    {value: 'autres', label: 'Autres villes (21,000 FCFA non imposable)'}
                                  ]}
                                />
                        </div>
                      </div>
                      <div>
                        <Label htmlFor="secteur_activite">Secteur d'activité</Label>
                        <SimpleNativeSelect
                                  value={companyForm.secteur_activite}
                                  onValueChange={handleSecteurActiviteChange}
                                  placeholder="Sélectionner un secteur"
                                  options={[
                                    {value: 'bureau', label: 'Bureau/Services (2.0%)'},
                                    {value: 'commerce', label: 'Commerce/Distribution (2.5%)'},
                                    {value: 'industrie_legere', label: 'Industrie légère (3.0%)'},
                                    {value: 'industrie_lourde', label: 'Industrie lourde (4.0%)'},
                                    {value: 'btp', label: 'BTP/Construction (5.0%)'}
                                  ]}
                                />
                      </div>
                      <Button 
                        type="submit" 
                        className="w-full bg-green-600 hover:bg-green-700"
                        style={{ 
                          pointerEvents: 'auto',
                          cursor: 'pointer',
                          position: 'relative',
                          zIndex: 1
                        }}
                      >
                        Mettre à jour
                      </Button>
                    </form>
                  </DialogContent>
                </Dialog>

                {/* CustomModal de confirmation de suppression d'entreprise */}
                <CustomModal
                  isOpen={isDeleteCompanyDialogOpen}
                  onClose={() => setIsDeleteCompanyDialogOpen(false)}
                  title={
                    <div className="flex items-center text-red-600">
                      <AlertTriangle className="w-5 h-5 mr-2" />
                      Supprimer l'entreprise
                    </div>
                  }
                  maxHeight="80vh"
                >
                  <div className="space-y-4">
                    <p className="text-gray-600 text-sm">
                      Cette action est irréversible et supprimera définitivement l'entreprise et toutes ses données.
                    </p>
                    
                    {companyToDelete && (
                      <>
                        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                          <h4 className="font-medium text-red-800 mb-2">Entreprise à supprimer :</h4>
                          <div className="space-y-1 text-sm text-red-700">
                            <p><strong>Nom :</strong> {companyToDelete.name}</p>
                            <p><strong>Adresse :</strong> {companyToDelete.address}</p>
                            <p><strong>Email :</strong> {companyToDelete.email}</p>
                            <p><strong>Téléphone :</strong> {companyToDelete.phone}</p>
                          </div>
                        </div>
                        
                        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                          <h4 className="font-medium text-yellow-800 mb-2 flex items-center">
                            <AlertCircle className="w-4 h-4 mr-1" />
                            Avertissement
                          </h4>
                          <ul className="text-sm text-yellow-700 space-y-1">
                            <li>• Tous les employés de cette entreprise seront supprimés</li>
                            <li>• Tous les bulletins de paie seront perdus</li>
                            <li>• Toutes les données financières seront effacées</li>
                            <li>• Cette action ne peut pas être annulée</li>
                          </ul>
                        </div>
                        
                        <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
                          <p className="text-sm text-blue-700">
                            <strong>💡 Conseil :</strong> Utilisez la fonction "Sauvegarder" avant de supprimer pour créer une sauvegarde de vos données.
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                  
                  {/* Footer avec boutons */}
                  <div className="flex space-x-3 pt-4 mt-4 border-t border-gray-200">
                    <button
                      onClick={() => {
                        console.log('Bouton Annuler cliqué');
                        setIsDeleteCompanyDialogOpen(false);
                      }}
                      className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 font-medium transition-colors"
                      style={{ 
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        touchAction: 'manipulation',
                        userSelect: 'none'
                      }}
                      type="button"
                    >
                      Annuler
                    </button>
                    <button
                      onClick={() => {
                        console.log('Bouton Supprimer cliqué');
                        handleDeleteCompany();
                      }}
                      className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md font-medium transition-colors flex items-center justify-center"
                      style={{ 
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        touchAction: 'manipulation',
                        userSelect: 'none'
                      }}
                      type="button"
                    >
                      <Trash2 className="w-4 h-4 mr-2" />
                      Supprimer définitivement
                    </button>
                  </div>
                </CustomModal>

                {/* CustomModal de confirmation de changement de statut */}
                <CustomModal
                  isOpen={isToggleCompanyStatusOpen}
                  onClose={() => setIsToggleCompanyStatusOpen(false)}
                  title={
                    <div className="flex items-center text-orange-600">
                      <AlertCircle className="w-5 h-5 mr-2" />
                      {companyToToggle?.is_active ? "Désactiver l'entreprise" : "Activer l'entreprise"}
                    </div>
                  }
                  maxHeight="70vh"
                >
                  <div className="space-y-4">
                    {companyToToggle && (
                      <>
                        <p className="text-gray-600 text-sm">
                          {companyToToggle.is_active 
                            ? "Êtes-vous sûr de vouloir désactiver cette entreprise ?" 
                            : "Êtes-vous sûr de vouloir activer cette entreprise ?"}
                        </p>
                        
                        <div className={`p-4 border rounded-lg ${companyToToggle.is_active ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`}>
                          <h4 className={`font-medium mb-2 ${companyToToggle.is_active ? 'text-orange-800' : 'text-green-800'}`}>
                            Entreprise concernée :
                          </h4>
                          <div className={`space-y-1 text-sm ${companyToToggle.is_active ? 'text-orange-700' : 'text-green-700'}`}>
                            <p><strong>Nom :</strong> {companyToToggle.name}</p>
                            <p><strong>Adresse :</strong> {companyToToggle.address}</p>
                            <p><strong>Email :</strong> {companyToToggle.email}</p>
                            <p><strong>Téléphone :</strong> {companyToToggle.phone}</p>
                          </div>
                        </div>
                        
                        {companyToToggle.is_active && (
                          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                            <h4 className="font-medium text-yellow-800 mb-2 flex items-center">
                              <AlertCircle className="w-4 h-4 mr-1" />
                              Impact de la désactivation
                            </h4>
                            <ul className="text-sm text-yellow-700 space-y-1">
                              <li>• L'entreprise ne sera plus accessible pour la gestion de paie</li>
                              <li>• Les employés de cette entreprise seront temporairement inaccessibles</li>
                              <li>• Vous pourrez réactiver l'entreprise à tout moment</li>
                              <li>• Les données seront conservées</li>
                            </ul>
                          </div>
                        )}
                        
                        {!companyToToggle.is_active && (
                          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                            <h4 className="font-medium text-blue-800 mb-2 flex items-center">
                              <AlertCircle className="w-4 h-4 mr-1" />
                              Après activation
                            </h4>
                            <ul className="text-sm text-blue-700 space-y-1">
                              <li>• L'entreprise sera à nouveau accessible</li>
                              <li>• Vous pourrez gérer les employés et la paie</li>
                              <li>• Toutes les données seront restaurées</li>
                            </ul>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  
                  {/* Footer avec boutons */}
                  <div className="flex space-x-3 pt-4 mt-4 border-t border-gray-200">
                    <button
                      onClick={() => {
                        console.log('Bouton Annuler cliqué');
                        setIsToggleCompanyStatusOpen(false);
                        setCompanyToToggle(null);
                      }}
                      className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 font-medium transition-colors"
                      style={{ 
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        touchAction: 'manipulation',
                        userSelect: 'none'
                      }}
                      type="button"
                    >
                      Annuler
                    </button>
                    <button
                      onClick={() => {
                        console.log('Bouton Confirmer cliqué');
                        handleToggleCompanyStatus();
                      }}
                      className={`flex-1 px-4 py-2 rounded-md text-white font-medium transition-colors flex items-center justify-center ${
                        companyToToggle?.is_active 
                          ? 'bg-orange-600 hover:bg-orange-700' 
                          : 'bg-green-600 hover:bg-green-700'
                      }`}
                      style={{ 
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        touchAction: 'manipulation',
                        userSelect: 'none'
                      }}
                      type="button"
                    >
                      {companyToToggle?.is_active ? "Désactiver" : "Activer"}
                    </button>
                  </div>
                </CustomModal>

                {/* Liste des entreprises */}
                <div className="grid gap-4">
                  {filteredCompanies.map((company) => {
                    const stats = companyStats[company.id];
                    const isCurrentCompany = selectedCompany?.id === company.id;
                    
                    return (
                      <Card 
                        key={company.id}
                        data-company-card
                        className={`bg-white transition-all duration-200 ${
                          isCurrentCompany 
                            ? 'ring-2 ring-orange-500 border-orange-300 shadow-lg' 
                            : 'hover:shadow-md'
                        } ${!company.is_active ? 'opacity-60' : ''}`}
                      >
                        <CardContent className="p-6">
                          <div className="flex justify-between items-start">
                            <div className="flex-1">
                              <div className="flex items-center space-x-3">
                                {/* Logo de l'entreprise */}
                                {company.logo_url ? (
                                  <img 
                                    src={`${BACKEND_URL}${company.logo_url}`} 
                                    alt={`Logo ${company.name}`}
                                    className="w-12 h-12 object-contain rounded-lg border border-gray-200 bg-white"
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                ) : (
                                  <div className="w-12 h-12 bg-gray-100 border border-gray-200 rounded-lg flex items-center justify-center">
                                    <Building2 className="w-6 h-6 text-gray-400" />
                                  </div>
                                )}
                                <h3 className="text-lg font-semibold text-gray-900">{company.name}</h3>
                                {isCurrentCompany && (
                                  <Badge className="bg-orange-100 text-orange-800 border-orange-300">
                                    Entreprise active
                                  </Badge>
                                )}
                                <Badge variant={company.is_active ? "default" : "secondary"}>
                                  {company.is_active ? "Active" : "Inactive"}
                                </Badge>
                              </div>
                              
                              <div className="mt-2 space-y-1">
                                <p className="text-gray-600">{company.address}</p>
                                <p className="text-sm text-gray-500">
                                  {company.email} • {company.phone}
                                </p>
                                <p className="text-sm text-gray-500">
                                  N° Registre de commerce (RCCM): {company.registration_number} • CNPS: {company.cnps_number}
                                  {company.ncc_number && <span> • N°CC: {company.ncc_number}</span>}
                                </p>
                                {company.gerant && (
                                  <p className="text-sm text-gray-700 font-medium">
                                    👤 Gérant : {company.gerant}
                                  </p>
                                )}
                                <div className="flex space-x-4 text-sm">
                                  <span className="text-blue-600 font-medium">
                                    📍 {company.ville === 'abidjan' ? 'Abidjan' : 
                                        company.ville === 'bouake' ? 'Bouaké' : 'Autres villes'}
                                  </span>
                                  <span className="text-green-600 font-medium">
                                    🏭 {company.secteur_activite === 'bureau' ? 'Bureau/Services' :
                                        company.secteur_activite === 'commerce' ? 'Commerce' :
                                        company.secteur_activite === 'industrie_legere' ? 'Industrie légère' :
                                        company.secteur_activite === 'industrie_lourde' ? 'Industrie lourde' :
                                        'BTP/Construction'}
                                  </span>
                                </div>
                              </div>

                              {/* Statistiques */}
                              {stats && (
                                <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4 p-4 bg-gray-50 rounded-lg">
                                  <div className="text-center">
                                    <div className="text-2xl font-bold text-gray-900">{stats.employees_count}</div>
                                    <div className="text-xs text-gray-600">Employés</div>
                                  </div>
                                  <div className="text-center">
                                    <div className="text-lg font-bold text-green-600">{formatCurrency(stats.total_salary_brut)}</div>
                                    <div className="text-xs text-gray-600">Masse salariale</div>
                                  </div>
                                  <div className="text-center">
                                    <div className="text-lg font-bold text-orange-600">{formatCurrency(stats.total_cnps)}</div>
                                    <div className="text-xs text-gray-600">Total CNPS</div>
                                  </div>
                                  <div className="text-center">
                                    <div className="text-2xl font-bold text-blue-600">{stats.payrolls_count}</div>
                                    <div className="text-xs text-gray-600">Bulletins</div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Actions */}
                            <div className="flex flex-col space-y-2 ml-4 company-actions" style={{ pointerEvents: 'auto', position: 'relative' }}>
                              {!isCurrentCompany && company.is_active && (
                                <Button
                                  onClick={() => switchToCompany(company)}
                                  className="bg-orange-600 hover:bg-orange-700 text-sm"
                                  size="sm"
                                  style={{ pointerEvents: 'auto !important', cursor: 'pointer', position: 'relative' }}
                                >
                                  Basculer
                                </Button>
                              )}
                              
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleEditCompany(company)}
                                className="text-sm"
                                style={{ pointerEvents: 'auto !important', cursor: 'pointer', position: 'relative' }}
                              >
                                Modifier
                              </Button>
                              
                              {/* Upload de logo */}
                              <input
                                type="file"
                                id={`logo-upload-${company.id}`}
                                accept="image/png,image/jpeg,image/jpg,image/webp,application/pdf"
                                className="hidden"
                                onChange={(e) => handleLogoUploadForCompany(e, company.id)}
                              />
                              <label 
                                htmlFor={`logo-upload-${company.id}`}
                                className="cursor-pointer inline-flex items-center justify-center px-3 py-1 text-sm bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-300 rounded"
                                style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                              >
                                <Upload className="w-3 h-3 mr-1" />
                                Logo
                              </label>
                              
                              {/* Bouton supprimer le logo si il existe */}
                              {company.logo_url && (
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => handleDeleteCompanyLogo(company.id)}
                                  className="text-sm text-red-600 hover:text-red-700 border-red-200 hover:border-red-300"
                                  style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                >
                                  <X className="w-3 h-3 mr-1" />
                                  Logo
                                </Button>
                              )}
                              
                              <input
                                type="file"
                                id={`dfe-upload-${company.id}`}
                                accept=".pdf,.xlsx,.xls"
                                className="hidden"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    uploadCompanyDFE(company, file);
                                    e.target.value = ''; // Reset input
                                  }
                                }}
                              />
                              <label 
                                htmlFor={`dfe-upload-${company.id}`}
                                className="cursor-pointer inline-flex items-center justify-center px-3 py-1 text-sm bg-green-50 text-green-700 hover:bg-green-100 border border-green-300 rounded"
                                style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                              >
                                <Upload className="w-3 h-3 mr-1" />
                                DFE
                              </label>
                              
                              <Button
                                variant={company.is_active ? "destructive" : "default"}
                                size="sm"
                                onClick={() => {
                                  if (companyBeingToggled?.id === company.id) {
                                    setCompanyBeingToggled(null); // Fermer le formulaire
                                  } else {
                                    setCompanyBeingToggled(company); // Ouvrir le formulaire
                                    setCompanyBeingDeleted(null); // Fermer l'autre formulaire
                                  }
                                }}
                                className="text-sm"
                                style={{ pointerEvents: 'auto !important', cursor: 'pointer', position: 'relative', opacity: 1 }}
                              >
                                {companyBeingToggled?.id === company.id ? "Annuler" : (company.is_active ? "Désactiver" : "Activer")}
                              </Button>
                              
                              {/* Bouton Supprimer avec confirmation améliorée */}
                              <Button
                                variant="destructive"
                                size="sm"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (companyBeingDeleted?.id === company.id) {
                                    setCompanyBeingDeleted(null); // Fermer le formulaire
                                  } else {
                                    setCompanyBeingDeleted(company); // Ouvrir le formulaire
                                    setCompanyBeingToggled(null); // Fermer l'autre formulaire
                                  }
                                }}
                                className="text-sm bg-red-600 hover:bg-red-700 active:bg-red-800 transition-all duration-150"
                                style={{ 
                                  pointerEvents: 'auto',
                                  cursor: 'pointer',
                                  position: 'relative',
                                  opacity: 1,
                                  zIndex: 10,
                                  touchAction: 'manipulation',
                                  userSelect: 'none'
                                }}
                                onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
                                onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              >
                                <Trash2 className="w-3 h-3 mr-1" />
                                {companyBeingDeleted?.id === company.id ? "Annuler" : "Supprimer"}
                              </Button>
                            </div>
                          </div>

                          {/* Formulaire inline de désactivation/activation */}
                          {companyBeingToggled?.id === company.id && (
                            <div className="mt-4 p-4 border-t-2 border-orange-200 bg-orange-50">
                              <h4 className="font-semibold text-orange-800 mb-3 flex items-center">
                                <AlertCircle className="w-5 h-5 mr-2" />
                                {company.is_active ? "Désactiver l'entreprise" : "Activer l'entreprise"}
                              </h4>
                              
                              <div className="mb-4 p-3 bg-white border border-orange-200 rounded">
                                <p className="text-sm text-gray-700 mb-2">
                                  {company.is_active 
                                    ? "Êtes-vous sûr de vouloir désactiver cette entreprise ?" 
                                    : "Êtes-vous sûr de vouloir activer cette entreprise ?"}
                                </p>
                                <div className="text-sm text-gray-600">
                                  <strong>Entreprise :</strong> {company.name}
                                </div>
                              </div>

                              {company.is_active ? (
                                <div className="mb-4 p-3 bg-yellow-50 border border-yellow-300 rounded">
                                  <h5 className="font-medium text-yellow-800 mb-2 text-sm">Impact de la désactivation :</h5>
                                  <ul className="text-xs text-yellow-700 space-y-1">
                                    <li>• L'entreprise ne sera plus accessible pour la gestion de paie</li>
                                    <li>• Les employés seront temporairement inaccessibles</li>
                                    <li>• Vous pourrez réactiver l'entreprise à tout moment</li>
                                    <li>• Les données seront conservées</li>
                                  </ul>
                                </div>
                              ) : (
                                <div className="mb-4 p-3 bg-green-50 border border-green-300 rounded">
                                  <h5 className="font-medium text-green-800 mb-2 text-sm">Après activation :</h5>
                                  <ul className="text-xs text-green-700 space-y-1">
                                    <li>• L'entreprise sera à nouveau accessible</li>
                                    <li>• Vous pourrez gérer les employés et la paie</li>
                                    <li>• Toutes les données seront restaurées</li>
                                  </ul>
                                </div>
                              )}

                              <div className="flex space-x-3">
                                <button
                                  onClick={() => setCompanyBeingToggled(null)}
                                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 font-medium transition-colors text-sm"
                                >
                                  Annuler
                                </button>
                                <button
                                  onClick={() => {
                                    handleToggleCompanyStatus();
                                    setCompanyBeingToggled(null);
                                  }}
                                  className={`flex-1 px-4 py-2 rounded-md font-medium transition-colors text-sm ${
                                    company.is_active 
                                      ? 'bg-orange-600 hover:bg-orange-700 text-white'
                                      : 'bg-green-600 hover:bg-green-700 text-white'
                                  }`}
                                >
                                  {company.is_active ? "Désactiver" : "Activer"}
                                </button>
                              </div>
                            </div>
                          )}

                          {/* Formulaire inline de suppression avec réactivité améliorée */}
                          {companyBeingDeleted?.id === company.id && (
                            <div className="mt-4 p-4 border-t-2 border-red-200 bg-red-50 animate-in slide-in-from-top duration-200">
                              <h4 className="font-semibold text-red-800 mb-3 flex items-center">
                                <AlertTriangle className="w-5 h-5 mr-2" />
                                Confirmer la suppression
                              </h4>
                              
                              <div className="mb-4 p-3 bg-white border border-red-200 rounded">
                                <p className="text-sm text-gray-700 mb-2">
                                  ⚠️ Voulez-vous vraiment supprimer cette entreprise ?
                                </p>
                                <div className="text-sm text-gray-900 font-semibold">
                                  Entreprise : {company.name}
                                </div>
                              </div>

                              <div className="mb-4 p-3 bg-yellow-50 border border-yellow-300 rounded">
                                <h5 className="font-medium text-yellow-800 mb-2 text-sm flex items-center">
                                  <AlertCircle className="w-4 h-4 mr-1" />
                                  Attention
                                </h5>
                                <ul className="text-xs text-yellow-700 space-y-1">
                                  <li>• Cette action est irréversible</li>
                                  <li>• Tous les employés de cette entreprise seront supprimés</li>
                                  <li>• Toutes les données financières seront effacées</li>
                                </ul>
                              </div>

                              <div className="flex space-x-3">
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setCompanyBeingDeleted(null);
                                  }}
                                  className="flex-1 px-4 py-2 border-2 border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-100 active:bg-gray-200 font-medium transition-all duration-150 text-sm"
                                  style={{ 
                                    cursor: 'pointer',
                                    touchAction: 'manipulation',
                                    userSelect: 'none'
                                  }}
                                  onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
                                  onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                >
                                  Annuler
                                </button>
                                <button
                                  type="button"
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    
                                    try {
                                      await axios.delete(`${API}/companies/${company.id}`);
                                      toast.success(`Entreprise "${company.name}" supprimée avec succès`);
                                      
                                      // Si l'entreprise supprimée était sélectionnée, on déselectionne
                                      if (selectedCompany?.id === company.id) {
                                        setSelectedCompany(null);
                                        setEmployees([]);
                                        localStorage.removeItem('selectedCompanyId');
                                      }
                                      
                                      setCompanyBeingDeleted(null);
                                      loadCompanies();
                                    } catch (error) {
                                      console.error("Erreur lors de la suppression:", error);
                                      if (error.response?.status === 400) {
                                        toast.error("Impossible de supprimer cette entreprise car elle contient des employés.");
                                      } else {
                                        toast.error("Erreur lors de la suppression de l'entreprise");
                                      }
                                    }
                                  }}
                                  className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 active:bg-red-800 text-white rounded-md font-medium transition-all duration-150 text-sm flex items-center justify-center"
                                  style={{ 
                                    cursor: 'pointer',
                                    touchAction: 'manipulation',
                                    userSelect: 'none'
                                  }}
                                  onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
                                  onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                >
                                  <Trash2 className="w-4 h-4 mr-2" />
                                  Confirmer la suppression
                                </button>
                              </div>
                            </div>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })}
                </div>

                {filteredCompanies.length === 0 && (
                  <div className="text-center py-12">
                    <Building2 className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Aucune entreprise trouvée</h3>
                    <p className="text-gray-600 mb-4">
                      {companyFilter ? "Aucune entreprise ne correspond à votre recherche." : "Commencez par créer votre première entreprise."}
                    </p>
                    {!companyFilter && (
                      <Button 
                        onClick={() => setIsCreateCompanyOpen(true)}
                        className="bg-orange-600 hover:bg-orange-700"
                        style={{ pointerEvents: 'auto', cursor: 'pointer', position: 'relative' }}
                      >
                        <Plus className="w-4 h-4 mr-2" />
                        Créer une entreprise
                      </Button>
                    )}
                  </div>
                )}
              </TabsContent>

              {/* Manage Tab */}
              <TabsContent value="manage" className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-900">Gestion du système</h2>
                
                {/* Navigation buttons for management features */}
                <div className="flex space-x-2 border-b">
                  <Button
                    variant={manageSection === 'users' ? 'default' : 'ghost'}
                    onClick={() => setManageSection('users')}
                    className="rounded-b-none"
                  >
                    👥 Utilisateurs
                  </Button>
                  {/* DEBUG: Affichage des infos utilisateur (à retirer en production) */}
                  {console.log('🔍 Render check - User:', user ? {username: user.username, role: user.role} : 'null', 'Should show super_admin buttons:', user && user.role === 'super_admin')}
                  {/* Bouton pour la vue d'ensemble système - visible uniquement pour super_admin */}
                  {user && user.role === 'super_admin' && (
                    <Button
                      variant={manageSection === 'system-overview' ? 'default' : 'ghost'}
                      onClick={() => setManageSection('system-overview')}
                      className="rounded-b-none relative"
                    >
                      📊 Vue d'ensemble
                      <Badge className="ml-2 bg-blue-500 text-white text-xs">
                        Système
                      </Badge>
                    </Button>
                  )}
                  {/* Bouton pour les demandes d'approbation - visible uniquement pour les super_admin */}
                  {user && user.role === 'super_admin' && (
                    <Button
                      variant={manageSection === 'pending-approvals' ? 'default' : 'ghost'}
                      onClick={() => setManageSection('pending-approvals')}
                      className="rounded-b-none relative bg-white hover:bg-gray-50 border border-gray-200"
                      style={{display: 'block', visibility: 'visible'}}
                    >
                      ⏳ Demandes d'approbation
                      <Badge className="ml-2 bg-red-500 text-white text-xs">
                        Super Admin
                      </Badge>
                    </Button>
                  )}

                  <Button
                    variant={manageSection === 'salary-components' ? 'default' : 'ghost'}
                    onClick={() => setManageSection('salary-components')}
                    className="rounded-b-none"
                  >
                    💰 Éléments de salaire
                  </Button>
                  {/* Bouton pour les paramètres système - visible uniquement pour super_admin */}
                  {user && user.role === 'super_admin' && (
                    <Button
                      variant={manageSection === 'system' ? 'default' : 'ghost'}
                      onClick={() => setManageSection('system')}
                      className="rounded-b-none"
                    >
                      ⚙️ Paramètres système
                    </Button>
                  )}
                  <Button
                    variant={manageSection === 'pdf-documents' ? 'default' : 'ghost'}
                    onClick={() => setManageSection('pdf-documents')}
                    className="rounded-b-none"
                  >
                    📄 Documents PDF
                  </Button>
                </div>

                {/* Users Management Section */}
                {manageSection === 'users' && (
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-gray-800">Gestion des utilisateurs</h3>
                      <div className="flex space-x-3">
                        <Input
                          placeholder="Rechercher un utilisateur..."
                          value={userFilter}
                          onChange={(e) => setUserFilter(e.target.value)}
                          className="w-64"
                        />
                        {/* Seuls les super_admin peuvent créer de nouveaux utilisateurs */}
                        {user && user.role === 'super_admin' && (
                      <Dialog open={isCreateUserOpen} onOpenChange={setIsCreateUserOpen}>
                        <DialogTrigger asChild>
                          <Button className="bg-purple-600 hover:bg-purple-700">
                            <Plus className="w-4 h-4 mr-2" />
                            Nouvel utilisateur
                          </Button>
                        </DialogTrigger>
                      <DialogContent className="sm:max-w-2xl">
                        <DialogHeader>
                          <DialogTitle>Nouvel utilisateur</DialogTitle>
                          <DialogDescription>Créer un nouvel utilisateur avec accès aux entreprises</DialogDescription>
                        </DialogHeader>
                        <form onSubmit={handleCreateUser} className="space-y-4 max-h-96 overflow-y-auto">
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Nom d'utilisateur</Label>
                              <Input required value={userForm.username} onChange={(e) => setUserForm({...userForm, username: e.target.value})} />
                            </div>
                            <div>
                              <Label>Nom complet</Label>
                              <Input required value={userForm.full_name} onChange={(e) => setUserForm({...userForm, full_name: e.target.value})} />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Email</Label>
                              <Input type="email" required value={userForm.email} onChange={(e) => setUserForm({...userForm, email: e.target.value})} />
                            </div>
                            <div>
                              <Label>Mot de passe</Label>
                              <Input type="password" required value={userForm.password} onChange={(e) => setUserForm({...userForm, password: e.target.value})} />
                            </div>
                          </div>
                          <div>
                            <Label>Rôle</Label>
                            <SimpleNativeSelect
                              value={userForm.role}
                              onValueChange={handleUserRoleChange}
                              placeholder="Sélectionner un rôle"
                              options={[
                                {value: 'super_admin', label: 'Super Administrateur (toutes entreprises)'},
                                {value: 'assistant_sirh', label: 'Assistant SIRH-CI/PAIE (toutes entreprises, sauf gestion)'},
                                {value: 'admin_multi', label: 'Admin Multi-Entreprise (plusieurs entreprises)'},
                                {value: 'admin_single', label: 'Admin Entreprise (une entreprise)'},
                                {value: 'rh', label: 'Ressources Humaines (une entreprise)'},
                                {value: 'comptable', label: 'Comptable (une entreprise)'}
                              ]}
                            />
                          </div>
                          {userForm.role !== 'super_admin' && (
                            <div>
                              <Label>Accès aux entreprises</Label>
                              <SimpleNativeSelect
                                value=""
                                onValueChange={handleUserAddCompanyAccess}
                                placeholder="Ajouter une entreprise"
                                options={companies.map((company) => ({
                                  value: company.id,
                                  label: `${company.name} (${company.ville})`
                                }))}
                              />
                              <div className="flex flex-wrap gap-2 mt-2">
                                {userForm.company_access.map((companyId) => {
                                  const company = companies.find(c => c.id === companyId);
                                  return company ? (
                                    <Badge key={companyId} variant="secondary" className="cursor-pointer no-delay" onClick={() => 
                                      setUserForm({...userForm, company_access: userForm.company_access.filter(id => id !== companyId)})
                                    }>
                                      {company.name} ✕
                                    </Badge>
                                  ) : null;
                                })}
                              </div>
                            </div>
                          )}
                            <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700">Créer l'utilisateur</Button>
                          </form>
                        </DialogContent>
                      </Dialog>
                        )}
                      </div>
                    </div>

                {/* Vue plein écran - Modifier l'utilisateur */}
                {isEditUserOpen && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 10000,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    backdropFilter: 'blur(4px)'
                  }}>
                    <form onSubmit={handleUpdateUser} style={{
                      backgroundColor: '#fef3c7',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden'
                    }}>
                      {/* Header avec gradient orange */}
                      <div style={{ 
                        padding: '24px 32px',
                        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                        color: 'white',
                        position: 'relative',
                        flexShrink: 0
                      }}>
                        <div style={{ 
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          width: '300px',
                          height: '100%',
                          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                          pointerEvents: 'none'
                        }} />
                        
                        <Button
                          type="button"
                          onClick={() => setIsEditUserOpen(false)}
                          variant="outline"
                          style={{ 
                            marginBottom: '16px',
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            borderColor: 'rgba(255,255,255,0.3)',
                            color: 'white',
                            backdropFilter: 'blur(10px)'
                          }}
                        >
                          <ArrowLeft className="w-4 h-4 mr-2" />
                          Retour
                        </Button>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{ 
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            borderRadius: '12px',
                            padding: '12px',
                            backdropFilter: 'blur(10px)'
                          }}>
                            <Edit style={{ width: '32px', height: '32px' }} />
                          </div>
                          <div>
                            <h1 style={{ 
                              fontSize: '28px', 
                              fontWeight: 700,
                              marginBottom: '4px',
                              textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                              Modifier l'utilisateur
                            </h1>
                            <p style={{ fontSize: '14px', opacity: 0.95 }}>
                              Mettre à jour les informations de l'utilisateur
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Formulaire scrollable */}
                      <div style={{ 
                        flex: 1, 
                        overflowY: 'auto', 
                        padding: '32px',
                        backgroundColor: '#fef3c7'
                      }}>
                        <div style={{
                          backgroundColor: 'white',
                          borderRadius: '16px',
                          padding: '32px',
                          maxWidth: '1000px',
                          margin: '0 auto',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                          border: '1px solid #e5e7eb'
                        }}>
                          <div className="space-y-6">
                            {/* Identité */}
                            <div style={{
                              backgroundColor: '#fffbeb',
                              borderRadius: '12px',
                              padding: '20px',
                              border: '2px solid #fef3c7'
                            }}>
                              <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#92400e', marginBottom: '16px' }}>
                                👤 Informations d'identité
                              </h3>
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Nom d'utilisateur</Label>
                                  <Input required value={userForm.username} onChange={(e) => setUserForm({...userForm, username: e.target.value})} />
                                </div>
                                <div>
                                  <Label>Nom complet</Label>
                                  <Input required value={userForm.full_name} onChange={(e) => setUserForm({...userForm, full_name: e.target.value})} />
                                </div>
                              </div>
                            </div>

                            {/* Authentification */}
                            <div style={{
                              backgroundColor: '#f0f9ff',
                              borderRadius: '12px',
                              padding: '20px',
                              border: '2px solid #bae6fd'
                            }}>
                              <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#075985', marginBottom: '16px' }}>
                                🔒 Authentification
                              </h3>
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label>Email</Label>
                                  <Input type="email" required value={userForm.email} onChange={(e) => setUserForm({...userForm, email: e.target.value})} />
                                </div>
                                <div>
                                  <Label>Nouveau mot de passe (optionnel)</Label>
                                  <Input type="password" placeholder="Laisser vide pour ne pas modifier" value={userForm.password} onChange={(e) => setUserForm({...userForm, password: e.target.value})} />
                                </div>
                              </div>
                            </div>

                            {/* Rôle et accès */}
                            <div style={{
                              backgroundColor: '#f3e8ff',
                              borderRadius: '12px',
                              padding: '20px',
                              border: '2px solid #ddd6fe'
                            }}>
                              <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#5b21b6', marginBottom: '16px' }}>
                                🎯 Rôle et accès
                              </h3>
                              <div className="space-y-4">
                                <div>
                                  <Label>Rôle</Label>
                                  <SimpleNativeSelect
                                    value={userForm.role}
                                    onValueChange={handleUserRoleChange}
                                    placeholder="Sélectionner un rôle"
                                    options={[
                                      {value: 'super_admin', label: 'Super Administrateur (toutes entreprises)'},
                                      {value: 'assistant_sirh', label: 'Assistant SIRH-CI/PAIE (toutes entreprises, sauf gestion)'},
                                      {value: 'admin_multi', label: 'Admin Multi-Entreprise (plusieurs entreprises)'},
                                      {value: 'admin_single', label: 'Admin Entreprise (une entreprise)'},
                                      {value: 'rh', label: 'Ressources Humaines (une entreprise)'},
                                      {value: 'comptable', label: 'Comptable (une entreprise)'}
                                    ]}
                                  />
                                </div>
                                {userForm.role !== 'super_admin' && (
                                  <div>
                                    <Label>Accès aux entreprises</Label>
                                    <SimpleNativeSelect
                                      value=""
                                      onValueChange={handleUserAddCompanyAccess}
                                      placeholder="Ajouter une entreprise"
                                      options={companies.map((company) => ({
                                        value: company.id,
                                        label: `${company.name} (${company.ville})`
                                      }))}
                                    />
                                    <div className="flex flex-wrap gap-2 mt-2">
                                      {userForm.company_access.map((companyId) => {
                                        const company = companies.find(c => c.id === companyId);
                                        return company ? (
                                          <Badge key={companyId} variant="secondary" className="cursor-pointer no-delay" onClick={() => 
                                            setUserForm({...userForm, company_access: userForm.company_access.filter(id => id !== companyId)})
                                          }>
                                            {company.name} ✕
                                          </Badge>
                                        ) : null;
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer avec boutons */}
                      <div style={{
                        padding: '20px 32px',
                        backgroundColor: 'white',
                        borderTop: '2px solid #e5e7eb',
                        flexShrink: 0
                      }}>
                        <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                          <Button 
                            type="button"
                            variant="outline"
                            onClick={() => setIsEditUserOpen(false)}
                            style={{
                              padding: '12px 24px'
                            }}
                          >
                            Annuler
                          </Button>
                          <Button 
                            type="submit"
                            disabled={isUpdatingUser}
                            style={{
                              padding: '12px 24px',
                              background: isUpdatingUser ? '#d1d5db' : 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                              color: 'white',
                              fontWeight: 700,
                              borderRadius: '8px',
                              border: 'none',
                              cursor: isUpdatingUser ? 'not-allowed' : 'pointer',
                              boxShadow: isUpdatingUser ? 'none' : '0 4px 16px rgba(245, 158, 11, 0.3)',
                              opacity: isUpdatingUser ? 0.6 : 1,
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}
                          >
                            {isUpdatingUser ? (
                              <>
                                <Loader2 className="w-4 h-4 animate-spin" />
                                Mise à jour en cours...
                              </>
                            ) : (
                              <>
                                <Edit className="w-4 h-4" />
                                Mettre à jour
                              </>
                            )}
                          </Button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}

                {/* Liste des utilisateurs */}
                <div className="grid gap-4">
                  {filteredUsers.map((userItem) => (
                    <Card key={userItem.user.id} className="bg-white">
                      <CardContent className="p-6">
                        <div className="flex justify-between items-start">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-3">
                              <h3 className="text-lg font-semibold text-gray-900">{userItem.user.full_name}</h3>
                              <Badge className={getRoleBadgeColor(userItem.user.role)}>
                                {getRoleLabel(userItem.user.role)}
                              </Badge>
                              <Badge variant={userItem.user.is_active ? "default" : "secondary"} className={userItem.user.is_active ? "bg-green-600" : "bg-gray-500"}>
                                {userItem.user.is_active ? "✅ Actif" : "❌ Inactif"}
                              </Badge>
                            </div>
                            
                            <div className="space-y-2">
                              <p className="text-gray-600">@{userItem.user.username}</p>
                              <p className="text-sm text-gray-500">{userItem.user.email}</p>
                              
                              <div className="mt-4">
                                <div className="flex items-center justify-between mb-2">
                                  <span className="text-sm font-medium text-gray-700">
                                    Accès aux entreprises ({userItem.access_count})
                                  </span>
                                  {userItem.user.role === 'super_admin' && (
                                    <Badge variant="outline" className="text-xs">
                                      Accès total
                                    </Badge>
                                  )}
                                </div>
                                
                                {userItem.user.role === 'super_admin' ? (
                                  <div className="text-sm text-purple-600 font-medium">
                                    🌟 Accès à toutes les entreprises
                                  </div>
                                ) : userItem.company_access.length > 0 ? (
                                  <div className="flex flex-wrap gap-2">
                                    {userItem.company_access.map((access) => (
                                      <Badge key={`user-${userItem.user.id}-company-${access.company.id}`} variant="outline" className="text-xs">
                                        {access.company.name}
                                        <span className="ml-1 text-gray-500">
                                          ({access.company.ville})
                                        </span>
                                      </Badge>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="text-sm text-red-600">
                                    ⚠️ Aucun accès configuré
                                  </div>
                                )}
                              </div>

                              {/* Date d'expiration de l'accès */}
                              {userItem.user.access_end_date && (
                                <div className="mt-3 p-2 bg-orange-50 border border-orange-200 rounded">
                                  <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-orange-800">
                                      ⏰ Accès expire le : {new Date(userItem.user.access_end_date).toLocaleDateString('fr-FR')}
                                    </span>
                                    {user && user.role === 'super_admin' && (
                                      <Dialog open={extendAccessUserId === userItem.user.id} onOpenChange={(open) => {
                                        if (!open) {
                                          setExtendAccessUserId(null);
                                          setExtendAccessDays(30);
                                        }
                                      }}>
                                        <DialogTrigger asChild>
                                          <Button
                                            size="sm"
                                            variant="outline"
                                            className="text-orange-700 border-orange-300 hover:bg-orange-100"
                                            onClick={() => setExtendAccessUserId(userItem.user.id)}
                                          >
                                            <Clock className="w-4 h-4 mr-1" />
                                            Prolonger
                                          </Button>
                                        </DialogTrigger>
                                        <DialogContent>
                                          <DialogHeader>
                                            <DialogTitle>Prolonger l'accès de {userItem.user.full_name}</DialogTitle>
                                            <DialogDescription>
                                              Définir une prolongation en nombre de jours à partir de la date d'expiration actuelle
                                            </DialogDescription>
                                          </DialogHeader>
                                          <div className="space-y-4 py-4">
                                            <div>
                                              <Label>Date d'expiration actuelle</Label>
                                              <Input
                                                value={new Date(userItem.user.access_end_date).toLocaleDateString('fr-FR')}
                                                disabled
                                                className="bg-gray-100"
                                              />
                                            </div>
                                            <div>
                                              <Label>Nombre de jours à ajouter</Label>
                                              <Input
                                                type="number"
                                                min="1"
                                                value={extendAccessDays}
                                                onChange={(e) => setExtendAccessDays(parseInt(e.target.value))}
                                                placeholder="Ex: 30"
                                              />
                                            </div>
                                            <div className="bg-blue-50 p-3 rounded">
                                              <p className="text-sm text-blue-800">
                                                <strong>Nouvelle date d'expiration :</strong> {
                                                  new Date(
                                                    new Date(userItem.user.access_end_date).getTime() + 
                                                    (extendAccessDays * 24 * 60 * 60 * 1000)
                                                  ).toLocaleDateString('fr-FR')
                                                }
                                              </p>
                                            </div>
                                          </div>
                                          <div className="flex justify-end space-x-2">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setExtendAccessUserId(null);
                                                setExtendAccessDays(30);
                                              }}
                                            >
                                              Annuler
                                            </Button>
                                            <Button
                                              onClick={() => handleExtendUserAccess(userItem.user.id)}
                                              disabled={isExtendingAccess || !extendAccessDays || extendAccessDays <= 0}
                                              className="bg-orange-600 hover:bg-orange-700"
                                            >
                                              {isExtendingAccess ? (
                                                <>
                                                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                                  Prolongation...
                                                </>
                                              ) : (
                                                <>
                                                  <Clock className="w-4 h-4 mr-2" />
                                                  Prolonger l'accès
                                                </>
                                              )}
                                            </Button>
                                          </div>
                                        </DialogContent>
                                      </Dialog>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Actions - Seuls les super_admin peuvent modifier les autres utilisateurs */}
                          {user && user.role === 'super_admin' && (
                            <div className="flex flex-col space-y-2 ml-4">
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleEditUser(userItem)}
                                className="text-sm hover:bg-blue-50"
                              >
                                <Edit className="w-4 h-4 mr-1" />
                                Modifier
                              </Button>
                              
                              <Button
                                variant={userItem.user.is_active ? "destructive" : "default"}
                                size="sm"
                                onClick={() => handleToggleUserStatus(userItem.user.id, userItem.user.is_active, userItem.user.full_name)}
                                className="text-sm"
                              >
                                {userItem.user.is_active ? "Désactiver" : "Activer"}
                              </Button>

                              <Button
                                variant="destructive"
                                size="sm"
                                onClick={() => {
                                  setDeleteUserId(userItem.user.id);
                                  setDeleteUserName(userItem.user.full_name);
                                }}
                                className="text-sm bg-red-600 hover:bg-red-700"
                              >
                                <Trash2 className="w-4 h-4 mr-1" />
                                Supprimer
                              </Button>
                              
                              {/* Bouton diagnostic des accès */}
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => loadUserAccessDiagnostic(userItem.user.id)}
                                disabled={isLoadingDiagnostic}
                                className="text-sm text-purple-600 border-purple-300 hover:bg-purple-50"
                              >
                                {isLoadingDiagnostic ? (
                                  <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                ) : (
                                  <Search className="w-4 h-4 mr-1" />
                                )}
                                Diagnostic
                              </Button>
                            </div>
                          )}
                          
                          {/* Message pour les non-super_admin */}
                          {user?.role !== 'super_admin' && (
                            <div className="flex flex-col space-y-2 ml-4">
                              <Badge variant="outline" className="text-xs text-gray-500">
                                🔒 Accès administrateur requis
                              </Badge>
                            </div>
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>

                {/* Vue plein écran - Confirmation de suppression */}
                {deleteUserId !== null && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(6px)'
                  }}>
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '20px',
                      width: '90%',
                      maxWidth: '600px',
                      boxShadow: '0 25px 80px rgba(0,0,0,0.5)',
                      overflow: 'hidden',
                      border: '3px solid #dc2626'
                    }}>
                      {/* Header rouge avec icône warning */}
                      <div style={{ 
                        padding: '32px',
                        background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                        color: 'white',
                        textAlign: 'center'
                      }}>
                        <div style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <AlertTriangle style={{ width: '48px', height: '48px' }} />
                        </div>
                        <h2 style={{ 
                          fontSize: '28px', 
                          fontWeight: 700,
                          marginBottom: '8px',
                          textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}>
                          ⚠️ Confirmer la suppression
                        </h2>
                        <p style={{ fontSize: '16px', opacity: 0.95 }}>
                          Cette action est irréversible !
                        </p>
                      </div>

                      {/* Contenu */}
                      <div style={{ padding: '32px' }}>
                        <div style={{
                          backgroundColor: '#fee2e2',
                          border: '2px solid #fecaca',
                          borderRadius: '12px',
                          padding: '20px',
                          marginBottom: '24px'
                        }}>
                          <p style={{ fontSize: '14px', color: '#991b1b', marginBottom: '12px' }}>
                            Vous êtes sur le point de supprimer l'utilisateur :
                          </p>
                          <p style={{ fontSize: '20px', fontWeight: 700, color: '#7f1d1d' }}>
                            {deleteUserName}
                          </p>
                        </div>

                        <div style={{
                          backgroundColor: '#fef2f2',
                          borderRadius: '8px',
                          padding: '16px',
                          fontSize: '14px',
                          color: '#7f1d1d'
                        }}>
                          <p style={{ fontWeight: 600, marginBottom: '12px' }}>
                            Conséquences de cette action :
                          </p>
                          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={{ padding: '6px 0', display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }}>🗑️</span>
                              Tous les accès aux entreprises seront supprimés
                            </li>
                            <li style={{ padding: '6px 0', display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }}>📊</span>
                              Les données de l'utilisateur seront définitivement perdues
                            </li>
                            <li style={{ padding: '6px 0', display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }}>⚠️</span>
                              Cette action ne peut pas être annulée
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* Footer avec boutons */}
                      <div style={{
                        padding: '24px 32px',
                        backgroundColor: '#f9fafb',
                        borderTop: '2px solid #e5e7eb',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px'
                      }}>
                        <Button
                          variant="outline"
                          onClick={() => {
                            setDeleteUserId(null);
                            setDeleteUserName("");
                          }}
                          disabled={isDeletingUser}
                          style={{
                            padding: '14px 32px',
                            fontSize: '16px',
                            fontWeight: 600
                          }}
                        >
                          Annuler
                        </Button>
                        <Button
                          variant="destructive"
                          onClick={() => handleDeleteUser(deleteUserId)}
                          disabled={isDeletingUser}
                          style={{
                            padding: '14px 32px',
                            background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                            color: 'white',
                            fontWeight: 700,
                            fontSize: '16px',
                            border: 'none',
                            cursor: isDeletingUser ? 'not-allowed' : 'pointer',
                            boxShadow: '0 4px 16px rgba(220, 38, 38, 0.4)',
                            opacity: isDeletingUser ? 0.7 : 1
                          }}
                        >
                          {isDeletingUser ? (
                            <>
                              <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                              Suppression...
                            </>
                          ) : (
                            <>
                              <Trash2 className="w-5 h-5 mr-2" />
                              Supprimer définitivement
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Modale de diagnostic des accès utilisateur */}
                {showDiagnosticModal && userAccessDiagnostic && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(6px)'
                  }}>
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '20px',
                      width: '95%',
                      maxWidth: '800px',
                      maxHeight: '90vh',
                      overflow: 'hidden',
                      boxShadow: '0 25px 80px rgba(0,0,0,0.5)',
                      border: '3px solid #9333ea',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Header violet */}
                      <div style={{ 
                        padding: '24px 32px',
                        background: 'linear-gradient(135deg, #9333ea 0%, #7e22ce 100%)',
                        color: 'white',
                        flexShrink: 0
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div>
                            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '4px' }}>
                              🔍 Diagnostic des accès
                            </h2>
                            <p style={{ fontSize: '14px', opacity: 0.9 }}>
                              Utilisateur : {userAccessDiagnostic.user.full_name || userAccessDiagnostic.user.username}
                            </p>
                          </div>
                          <Button
                            variant="ghost"
                            onClick={() => {
                              setShowDiagnosticModal(false);
                              setUserAccessDiagnostic(null);
                            }}
                            style={{ color: 'white', padding: '8px' }}
                          >
                            <X style={{ width: '24px', height: '24px' }} />
                          </Button>
                        </div>
                      </div>

                      {/* Contenu scrollable */}
                      <div style={{ 
                        padding: '24px 32px',
                        overflowY: 'auto',
                        flex: 1
                      }}>
                        {/* Infos utilisateur */}
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(3, 1fr)',
                          gap: '16px',
                          marginBottom: '24px'
                        }}>
                          <div style={{ padding: '16px', backgroundColor: '#f3f4f6', borderRadius: '12px' }}>
                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: 500 }}>Rôle</div>
                            <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                              {userAccessDiagnostic.user.role}
                            </div>
                          </div>
                          <div style={{ padding: '16px', backgroundColor: userAccessDiagnostic.user.is_active ? '#dcfce7' : '#fee2e2', borderRadius: '12px' }}>
                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: 500 }}>Statut</div>
                            <div style={{ fontSize: '16px', fontWeight: 600, color: userAccessDiagnostic.user.is_active ? '#15803d' : '#dc2626' }}>
                              {userAccessDiagnostic.user.is_active ? '✅ Actif' : '❌ Inactif'}
                            </div>
                          </div>
                          <div style={{ padding: '16px', backgroundColor: '#dbeafe', borderRadius: '12px' }}>
                            <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: 500 }}>Accès en base</div>
                            <div style={{ fontSize: '16px', fontWeight: 600, color: '#1d4ed8' }}>
                              {userAccessDiagnostic.total_accesses_in_db} entreprise(s)
                            </div>
                          </div>
                        </div>

                        {/* Liste des accès */}
                        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px', color: '#374151' }}>
                          📋 Détail des accès aux entreprises
                        </h3>
                        
                        {userAccessDiagnostic.access_analysis.length === 0 ? (
                          <div style={{
                            padding: '32px',
                            textAlign: 'center',
                            backgroundColor: '#fef2f2',
                            borderRadius: '12px',
                            border: '2px dashed #fca5a5'
                          }}>
                            <AlertTriangle style={{ width: '48px', height: '48px', color: '#dc2626', margin: '0 auto 16px' }} />
                            <p style={{ fontSize: '16px', fontWeight: 600, color: '#dc2626' }}>
                              ⚠️ Aucun accès configuré dans la base de données
                            </p>
                            <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '8px' }}>
                              Cet utilisateur n'a accès à aucune entreprise. Utilisez le bouton "Modifier" pour lui attribuer des entreprises.
                            </p>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {userAccessDiagnostic.access_analysis.map((access, index) => (
                              <div
                                key={index}
                                style={{
                                  padding: '16px',
                                  backgroundColor: access.issues.length > 0 ? '#fef2f2' : '#f0fdf4',
                                  borderRadius: '12px',
                                  border: `2px solid ${access.issues.length > 0 ? '#fca5a5' : '#86efac'}`
                                }}
                              >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                  <div>
                                    <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                                      {access.company_name}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                                      ID: {access.company_id}
                                    </div>
                                  </div>
                                  <div style={{
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    backgroundColor: access.issues.length > 0 ? '#dc2626' : '#16a34a',
                                    color: 'white'
                                  }}>
                                    {access.issues.length > 0 ? `${access.issues.length} problème(s)` : '✓ OK'}
                                  </div>
                                </div>
                                
                                <div style={{ 
                                  display: 'grid', 
                                  gridTemplateColumns: 'repeat(3, 1fr)', 
                                  gap: '12px',
                                  marginTop: '12px',
                                  fontSize: '13px'
                                }}>
                                  <div>
                                    <span style={{ color: '#6b7280' }}>Statut entreprise: </span>
                                    <span style={{ fontWeight: 500, color: access.company_is_active ? '#16a34a' : '#dc2626' }}>
                                      {access.company_is_active ? 'Active' : 'Inactive'}
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6b7280' }}>Approbation: </span>
                                    <span style={{ fontWeight: 500 }}>
                                      {access.company_approval_status || 'N/A'}
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6b7280' }}>Permissions: </span>
                                    <span style={{ fontWeight: 500 }}>
                                      {access.permissions.join(', ') || 'Aucune'}
                                    </span>
                                  </div>
                                </div>

                                {access.issues.length > 0 && (
                                  <div style={{
                                    marginTop: '12px',
                                    padding: '12px',
                                    backgroundColor: '#fee2e2',
                                    borderRadius: '8px'
                                  }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#dc2626', marginBottom: '8px' }}>
                                      ⚠️ Problèmes détectés :
                                    </div>
                                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#991b1b' }}>
                                      {access.issues.map((issue, i) => (
                                        <li key={i}>{issue}</li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Recommandation */}
                        <div style={{
                          marginTop: '24px',
                          padding: '16px',
                          backgroundColor: '#eff6ff',
                          borderRadius: '12px',
                          border: '1px solid #bfdbfe'
                        }}>
                          <div style={{ fontSize: '14px', fontWeight: 600, color: '#1e40af', marginBottom: '8px' }}>
                            💡 Recommandation
                          </div>
                          <p style={{ fontSize: '13px', color: '#1e40af' }}>
                            {userAccessDiagnostic.recommendation}
                          </p>
                        </div>
                      </div>

                      {/* Footer */}
                      <div style={{
                        padding: '16px 32px',
                        borderTop: '1px solid #e5e7eb',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        flexShrink: 0
                      }}>
                        <Button
                          variant="outline"
                          onClick={() => {
                            setShowDiagnosticModal(false);
                            setUserAccessDiagnostic(null);
                          }}
                        >
                          Fermer
                        </Button>
                        {userAccessDiagnostic.access_analysis &&
                          userAccessDiagnostic.access_analysis.some(a => a.issues && a.issues.length > 0) && (
                          <Button
                            data-testid="repair-access-btn"
                            onClick={() => repairUserAccess(userAccessDiagnostic.user.id)}
                            disabled={isRepairingAccess}
                            style={{
                              background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
                              color: 'white'
                            }}
                          >
                            {isRepairingAccess ? (
                              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                            ) : (
                              <Wrench className="w-4 h-4 mr-2" />
                            )}
                            Réparer automatiquement
                          </Button>
                        )}
                        <Button
                          onClick={() => {
                            // Trouver l'utilisateur et ouvrir l'édition
                            const userToEdit = users.find(u => u.user.id === userAccessDiagnostic.user.id);
                            if (userToEdit) {
                              setShowDiagnosticModal(false);
                              setUserAccessDiagnostic(null);
                              handleEditUser(userToEdit);
                            }
                          }}
                          style={{
                            background: 'linear-gradient(135deg, #9333ea 0%, #7e22ce 100%)',
                            color: 'white'
                          }}
                        >
                          <Edit className="w-4 h-4 mr-2" />
                          Modifier les accès
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

                {filteredUsers.length === 0 && (
                  <div className="text-center py-12">
                    <Users className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Aucun utilisateur trouvé</h3>
                    <p className="text-gray-600 mb-4">
                      {userFilter ? "Aucun utilisateur ne correspond à votre recherche." : "Commencez par créer le premier utilisateur."}
                    </p>
                    {!userFilter && (
                      <Button 
                        onClick={() => setIsCreateUserOpen(true)}
                        className="bg-purple-600 hover:bg-purple-700"
                      >
                        <Plus className="w-4 h-4 mr-2" />
                        Créer un utilisateur
                      </Button>
                    )}
                  </div>
                )}
                  </div>
                )}

                {/* Pending Approvals Management Section */}

                {/* Section d'approbation des entreprises */}
                {manageSection === 'pending-approvals' && (
                  <div className="space-y-4">
                    <div className="bg-gradient-to-r from-orange-50 to-red-50 p-4 rounded-lg border-l-4 border-orange-500 mb-6">
                      <div className="flex justify-between items-center">
                        <div>
                          <h3 className="text-lg font-bold text-orange-900 flex items-center">
                            <AlertTriangle className="w-5 h-5 mr-2 text-orange-600" />
                            ⏳ Demandes d'approbation
                          </h3>
                          <p className="text-sm text-orange-700 mt-1">
                            Réservé à l'administrateur système - Gérez les demandes d'approbation des utilisateurs et des entreprises
                          </p>
                        </div>
                        <Badge className="bg-red-100 text-red-800 font-semibold">
                          Super Admin Uniquement
                        </Badge>
                      </div>
                    </div>
                    
                    {/* Sous-onglets pour Utilisateurs et Entreprises */}
                    <Tabs value={approvalSubSection} onValueChange={setApprovalSubSection} className="w-full">
                      <TabsList className="grid w-full grid-cols-2 mb-6">
                        <TabsTrigger value="users" className="flex items-center gap-2">
                          <User className="w-4 h-4" />
                          Utilisateurs
                        </TabsTrigger>
                        <TabsTrigger value="companies" className="flex items-center gap-2">
                          <Building2 className="w-4 h-4" />
                          Entreprises
                          {pendingCompanies.length > 0 && (
                            <Badge className="ml-2 bg-blue-500 text-white text-xs">
                              {pendingCompanies.length}
                            </Badge>
                          )}
                        </TabsTrigger>
                      </TabsList>

                      <TabsContent value="users" className="space-y-4">
                        <PendingUsersManagement />
                      </TabsContent>

                      <TabsContent value="companies" className="space-y-4">
                        {loadingPendingCompanies ? (
                          <div className="text-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                            <p className="text-gray-600">Chargement des entreprises en attente...</p>
                          </div>
                        ) : pendingCompanies.length === 0 ? (
                          <Card className="p-8">
                            <div className="text-center">
                              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <CheckCircle className="w-8 h-8 text-green-600" />
                              </div>
                              <h4 className="text-lg font-semibold text-gray-800 mb-2">
                                Aucune demande en attente
                              </h4>
                              <p className="text-gray-600">
                                Toutes les entreprises ont été traitées
                              </p>
                            </div>
                          </Card>
                        ) : (
                          <div className="space-y-4">
                            <div className="flex justify-between items-center mb-4">
                              <h4 className="text-md font-semibold text-gray-700">
                                {pendingCompanies.length} entreprise(s) en attente
                              </h4>
                              <Button
                                onClick={loadPendingCompanies}
                                variant="outline"
                                size="sm"
                              >
                                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                Actualiser
                              </Button>
                            </div>

                            {pendingCompanies.map((company) => (
                              <Card key={company.id} className="p-6 hover:shadow-lg transition-shadow">
                                <div className="flex justify-between items-start">
                                  <div className="flex-1">
                                    <div className="flex items-center gap-3 mb-3">
                                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                                        <Building2 className="w-6 h-6 text-blue-600" />
                                      </div>
                                      <div>
                                        <h5 className="text-lg font-bold text-gray-900">{company.name}</h5>
                                        <Badge variant="outline" className="mt-1">
                                          En attente d'approbation
                                        </Badge>
                                      </div>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4 mt-4">
                                      <div>
                                        <p className="text-sm text-gray-500">Type</p>
                                        <p className="font-medium">{company.company_type || 'N/A'}</p>
                                      </div>
                                      <div>
                                        <p className="text-sm text-gray-500">Ville</p>
                                        <p className="font-medium">{company.city || 'N/A'}</p>
                                      </div>
                                      <div>
                                        <p className="text-sm text-gray-500">Email</p>
                                        <p className="font-medium text-blue-600">{company.email || 'N/A'}</p>
                                      </div>
                                      <div>
                                        <p className="text-sm text-gray-500">Téléphone</p>
                                        <p className="font-medium">{company.phone || 'N/A'}</p>
                                      </div>
                                    </div>

                                    {company.creator_info && (
                                      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                                        <p className="text-sm text-gray-500 mb-1">Créé par</p>
                                        <p className="font-medium text-gray-900">
                                          {company.creator_info.full_name} ({company.creator_info.username})
                                        </p>
                                        <p className="text-sm text-gray-600">{company.creator_info.email}</p>
                                      </div>
                                    )}

                                    {company.created_at && (
                                      <div className="mt-3">
                                        <p className="text-xs text-gray-500">
                                          Créée le {new Date(company.created_at).toLocaleDateString('fr-FR', {
                                            day: 'numeric',
                                            month: 'long',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                          })}
                                        </p>
                                      </div>
                                    )}
                                  </div>

                                  <div className="flex flex-col gap-2 ml-4">
                                    <Button
                                      onClick={async () => {
                                        if (!window.confirm(`Approuver l'entreprise "${company.name}" ?`)) return;
                                        
                                        try {
                                          const response = await fetch(
                                            `${process.env.REACT_APP_BACKEND_URL}/companies/${company.id}/approve`,
                                            {
                                              method: 'POST',
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                                                'Content-Type': 'application/json'
                                              }
                                            }
                                          );

                                          if (!response.ok) {
                                            const error = await response.json();
                                            throw new Error(error.detail || 'Erreur lors de l\'approbation');
                                          }

                                          const result = await response.json();
                                          toast.success(result.message || 'Entreprise approuvée avec succès');
                                          
                                          // Recharger la liste
                                          await loadPendingCompanies();
                                        } catch (error) {
                                          console.error('Erreur approbation:', error);
                                          toast.error(error.message);
                                        }
                                      }}
                                      className="bg-green-600 hover:bg-green-700 text-white"
                                    >
                                      <CheckCircle className="w-4 h-4 mr-2" />
                                      Approuver
                                    </Button>

                                    <Button
                                      onClick={async () => {
                                        const reason = window.prompt('Raison du rejet (optionnel):');
                                        if (reason === null) return; // Annulé
                                        
                                        if (!window.confirm(`Rejeter l'entreprise "${company.name}" ?`)) return;
                                        
                                        try {
                                          const response = await fetch(
                                            `${process.env.REACT_APP_BACKEND_URL}/companies/${company.id}/reject`,
                                            {
                                              method: 'POST',
                                              headers: {
                                                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                                                'Content-Type': 'application/json'
                                              },
                                              body: JSON.stringify({ reason: reason || '' })
                                            }
                                          );

                                          if (!response.ok) {
                                            const error = await response.json();
                                            throw new Error(error.detail || 'Erreur lors du rejet');
                                          }

                                          const result = await response.json();
                                          toast.success(result.message || 'Entreprise rejetée');
                                          
                                          // Recharger la liste
                                          await loadPendingCompanies();
                                        } catch (error) {
                                          console.error('Erreur rejet:', error);
                                          toast.error(error.message);
                                        }
                                      }}
                                      variant="destructive"
                                    >
                                      <XCircle className="w-4 h-4 mr-2" />
                                      Rejeter
                                    </Button>
                                  </div>
                                </div>
                              </Card>
                            ))}
                          </div>
                        )}
                      </TabsContent>
                    </Tabs>
                  </div>
                )}

                {/* System Overview Management Section */}
                {manageSection === 'system-overview' && (
                  <div className="space-y-6">
                    {/* En-tête */}
                    <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg border-l-4 border-blue-500">
                      <div className="flex justify-between items-center">
                        <div>
                          <h3 className="text-xl font-bold text-blue-900 flex items-center">
                            <BarChart2 className="w-6 h-6 mr-3 text-blue-600" />
                            📊 Vue d'ensemble du système
                          </h3>
                          <p className="text-sm text-blue-700 mt-2">
                            Supervision globale - Tous les utilisateurs et entreprises du système
                          </p>
                        </div>
                        <Badge className="bg-blue-100 text-blue-800 font-semibold px-4 py-2">
                          Administration Système
                        </Badge>
                      </div>
                    </div>

                    {loadingSystemOverview ? (
                      <div className="text-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                        <p className="text-gray-600">Chargement des données système...</p>
                      </div>
                    ) : systemOverview ? (
                      <>
                        {/* Statistiques générales */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                          <Card className="p-6 bg-gradient-to-br from-green-50 to-emerald-100 border-green-200">
                            <div className="flex items-center justify-between">
                              <div>
                                <h4 className="text-2xl font-bold text-green-800">{systemOverview.total_users}</h4>
                                <p className="text-green-600 font-medium">Utilisateurs Total</p>
                              </div>
                              <User className="w-8 h-8 text-green-600" />
                            </div>
                            <div className="mt-3 text-sm text-green-700">
                              <span className="font-semibold">{systemOverview.active_users}</span> actifs
                            </div>
                          </Card>

                          <Card className="p-6 bg-gradient-to-br from-blue-50 to-cyan-100 border-blue-200">
                            <div className="flex items-center justify-between">
                              <div>
                                <h4 className="text-2xl font-bold text-blue-800">{systemOverview.total_companies}</h4>
                                <p className="text-blue-600 font-medium">Entreprises</p>
                              </div>
                              <Building2 className="w-8 h-8 text-blue-600" />
                            </div>
                          </Card>

                          <Card className="p-6 bg-gradient-to-br from-orange-50 to-yellow-100 border-orange-200">
                            <div className="flex items-center justify-between">
                              <div>
                                <h4 className="text-2xl font-bold text-orange-800">{systemOverview.pending_approvals}</h4>
                                <p className="text-orange-600 font-medium">En Attente</p>
                              </div>
                              <Clock className="w-8 h-8 text-orange-600" />
                            </div>
                            {systemOverview.pending_approvals > 0 && (
                              <div className="mt-3">
                                <Button 
                                  size="sm" 
                                  variant="outline" 
                                  className="text-orange-700 border-orange-300 hover:bg-orange-100"
                                  onClick={() => setManageSection('pending-approvals')}
                                >
                                  Gérer les demandes
                                </Button>
                              </div>
                            )}
                          </Card>

                          <Card className="p-6 bg-gradient-to-br from-purple-50 to-pink-100 border-purple-200">
                            <div className="flex items-center justify-between">
                              <div>
                                <h4 className="text-2xl font-bold text-purple-800">{systemOverview.recent_registrations}</h4>
                                <p className="text-purple-600 font-medium">Nouveaux (7j)</p>
                              </div>
                              <Calendar className="w-8 h-8 text-purple-600" />
                            </div>
                          </Card>
                        </div>

                        {/* Carte de Synchronisation des Utilisateurs de Production */}
                        <Card className="p-6 bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-300">
                          <div className="space-y-4">
                            <div className="flex items-center justify-between">
                              <h4 className="text-lg font-semibold text-orange-800 flex items-center">
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                Synchronisation Utilisateurs Production
                              </h4>
                              <Badge className="bg-orange-600 text-white font-semibold px-3 py-1">
                                Super Admin
                              </Badge>
                            </div>
                            
                            <p className="text-sm text-orange-700">
                              Créer ou mettre à jour les utilisateurs clés dans l'environnement de production après le déploiement
                            </p>
                            
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                              <div className="flex items-center space-x-2 bg-white p-2 rounded border border-orange-200">
                                <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                                <span className="text-xs font-medium">admin</span>
                              </div>
                              <div className="flex items-center space-x-2 bg-white p-2 rounded border border-orange-200">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span className="text-xs font-medium">DIVINE</span>
                              </div>
                              <div className="flex items-center space-x-2 bg-white p-2 rounded border border-orange-200">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span className="text-xs font-medium">KORBAN</span>
                              </div>
                              <div className="flex items-center space-x-2 bg-white p-2 rounded border border-orange-200">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span className="text-xs font-medium">FREIJ</span>
                              </div>
                            </div>
                            
                            <Button 
                              onClick={async () => {
                                if (!window.confirm('Synchroniser les 4 utilisateurs de production (admin, DIVINE, KORBAN CONSULTING, FREIJ ISAAC) ?')) {
                                  return;
                                }
                                
                                try {
                                  toast.info('Synchronisation en cours...');
                                  
                                  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/sync-production-users`, {
                                    method: 'POST',
                                    headers: {
                                      'Content-Type': 'application/json',
                                      'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }
                                  });
                                  
                                  if (!response.ok) {
                                    const error = await response.json();
                                    throw new Error(error.detail || 'Erreur de synchronisation');
                                  }
                                  
                                  const result = await response.json();
                                  const created = result.results.filter(r => r.action === 'created');
                                  const updated = result.results.filter(r => r.action === 'updated');
                                  
                                  let msg = `✅ Synchronisation réussie (${result.environment})\n`;
                                  if (created.length > 0) msg += `Créés: ${created.map(u => u.username).join(', ')}\n`;
                                  if (updated.length > 0) msg += `Mis à jour: ${updated.map(u => u.username).join(', ')}`;
                                  
                                  toast.success(msg);
                                  
                                } catch (error) {
                                  toast.error(`Erreur: ${error.message}`);
                                }
                              }}
                              className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold py-3"
                            >
                              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                              </svg>
                              Synchroniser Maintenant
                            </Button>
                          </div>
                        </Card>


                        {/* Répartition par rôles */}
                        <Card className="p-6">
                          <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                            <Users className="w-5 h-5 mr-2 text-gray-600" />
                            Répartition par rôles
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            {Object.entries(systemOverview.users_by_role).map(([role, count]) => (
                              <div key={role} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                <span className="text-gray-700 capitalize">
                                  {role === 'super_admin' && '🔑 Super Admin'}
                                  {role === 'admin_multi' && '👑 Admin Multi'}
                                  {role === 'admin_single' && '🛡️ Admin Single'}
                                  {role === 'user' && '👤 Utilisateur'}
                                  {!['super_admin', 'admin_multi', 'admin_single', 'user'].includes(role) && `📝 ${role}`}
                                </span>
                                <Badge className="bg-gray-200 text-gray-800 font-semibold">
                                  {count}
                                </Badge>
                              </div>
                            ))}
                          </div>
                        </Card>

                        {/* Filtres et recherche */}
                        <Card className="p-6">
                          <div className="flex flex-wrap gap-4 items-center justify-between mb-6">
                            <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                              <Search className="w-5 h-5 mr-2 text-gray-600" />
                              Liste complète des utilisateurs
                            </h4>
                            <div className="flex flex-wrap gap-3">
                              <Input
                                placeholder="Rechercher par nom, email..."
                                value={userFilter}
                                onChange={(e) => setUserFilter(e.target.value)}
                                className="w-64"
                              />
                              <SimpleNativeSelect
                                  value={overviewRoleFilter}
                                  onValueChange={setOverviewRoleFilter}
                                  placeholder="Filtrer par rôle"
                                  options={[
                                    {value: 'all', label: 'Tous les rôles'},
                                    {value: 'super_admin', label: 'Super Admin'},
                                    {value: 'admin_multi', label: 'Admin Multi'},
                                    {value: 'admin_single', label: 'Admin Single'},
                                    {value: 'user', label: 'Utilisateur'}
                                  ]}
                                />
                              <SimpleNativeSelect
                                  value={overviewStatusFilter}
                                  onValueChange={setOverviewStatusFilter}
                                  placeholder="Filtrer par statut"
                                  options={[
                                    {value: 'all', label: 'Tous les statuts'},
                                    {value: 'active', label: 'Actifs'},
                                    {value: 'inactive', label: 'Inactifs'},
                                    {value: 'pending', label: 'En attente'}
                                  ]}
                                />
                            </div>
                          </div>

                          {/* Liste des utilisateurs */}
                          <div className="space-y-4 max-h-96 overflow-y-auto">
                            {systemOverview.users_list
                              .filter(u => {
                                const matchesSearch = !userFilter || 
                                  u.full_name.toLowerCase().includes(userFilter.toLowerCase()) ||
                                  u.email.toLowerCase().includes(userFilter.toLowerCase()) ||
                                  u.username.toLowerCase().includes(userFilter.toLowerCase());
                                
                                const matchesRole = overviewRoleFilter === 'all' || u.role === overviewRoleFilter;
                                
                                const matchesStatus = overviewStatusFilter === 'all' ||
                                  (overviewStatusFilter === 'active' && u.is_active) ||
                                  (overviewStatusFilter === 'inactive' && !u.is_active) ||
                                  (overviewStatusFilter === 'pending' && u.approval_status === 'pending');
                                
                                return matchesSearch && matchesRole && matchesStatus;
                              })
                              .map((user) => (
                                <Card key={user.id} className="p-4 hover:shadow-md transition-shadow">
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      <div className="flex items-center space-x-3 mb-2">
                                        <h5 className="font-semibold text-gray-900">{user.full_name}</h5>
                                        <Badge className={
                                          user.role === 'super_admin' ? 'bg-red-100 text-red-800' :
                                          user.role === 'admin_multi' ? 'bg-purple-100 text-purple-800' :
                                          user.role === 'admin_single' ? 'bg-blue-100 text-blue-800' :
                                          'bg-gray-100 text-gray-800'
                                        }>
                                          {user.role === 'super_admin' && '🔑 Super Admin'}
                                          {user.role === 'admin_multi' && '👑 Admin Multi'}
                                          {user.role === 'admin_single' && '🛡️ Admin Single'}
                                          {user.role === 'user' && '👤 Utilisateur'}
                                        </Badge>
                                        <Badge variant={user.is_active ? "default" : "secondary"} className={user.is_active ? "bg-green-600" : "bg-gray-500"}>
                                          {user.is_active ? "✅ Actif" : "❌ Inactif"}
                                        </Badge>
                                        {user.approval_status === 'pending' && (
                                          <Badge className="bg-orange-100 text-orange-800">
                                            ⏳ En attente
                                          </Badge>
                                        )}
                                      </div>
                                      <div className="space-y-1 text-sm">
                                        <p className="text-gray-600">@{user.username} • {user.email}</p>
                                        <p className="text-gray-500">
                                          Créé le {new Date(user.created_at).toLocaleDateString('fr-FR')}
                                          {user.last_login && (
                                            <span> • Dernière connexion: {new Date(user.last_login).toLocaleDateString('fr-FR')}</span>
                                          )}
                                        </p>
                                        {user.company_names.length > 0 ? (
                                          <div className="flex flex-wrap gap-1 mt-2">
                                            <span className="text-xs text-gray-500 mr-2">Entreprises:</span>
                                            {user.company_names.map((companyName, idx) => (
                                              <Badge key={idx} variant="outline" className="text-xs">
                                                🏢 {companyName}
                                              </Badge>
                                            ))}
                                          </div>
                                        ) : user.role === 'super_admin' ? (
                                          <Badge variant="outline" className="text-xs bg-purple-50 text-purple-700">
                                            🌟 Accès à toutes les entreprises
                                          </Badge>
                                        ) : (
                                          <Badge variant="outline" className="text-xs bg-gray-50 text-gray-500">
                                            Aucune entreprise assignée
                                          </Badge>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </Card>
                              ))
                            }
                          </div>
                        </Card>
                      </>
                    ) : (
                      <Card className="p-12 text-center">
                        <AlertTriangle className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-semibold text-gray-700 mb-2">Aucune donnée disponible</h3>
                        <p className="text-gray-500 mb-4">Impossible de charger les données système</p>
                        <Button onClick={loadSystemOverview} className="bg-blue-600 hover:bg-blue-700">
                          <RefreshCw className="w-4 h-4 mr-2" />
                          Réessayer
                        </Button>
                      </Card>
                    )}
                  </div>
                )}

                {/* Salary Components Management Section */}
                {manageSection === 'salary-components' && (
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg font-semibold text-gray-800">Gestion des éléments de salaire</h3>
                      <Button
                        onClick={() => setIsManageSalaryComponentsOpen(true)}
                        className="bg-orange-600 hover:bg-orange-700"
                        style={{
                          pointerEvents: 'auto',
                          cursor: 'pointer',
                          position: 'relative',
                          zIndex: 10,
                          touchAction: 'manipulation',
                          userSelect: 'none'
                        }}
                      >
                        <Settings className="w-4 h-4 mr-2" style={{ pointerEvents: 'none' }} />
                        Gérer les éléments
                      </Button>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <Card className="bg-blue-50">
                        <CardHeader>
                          <CardTitle className="text-blue-800">Indemnités</CardTitle>
                          <CardDescription>Indemnités diverses (imposables/non-imposables)</CardDescription>
                        </CardHeader>
                        <CardContent>
                          <p className="text-2xl font-bold text-blue-900">
                            {salaryComponents.filter(c => c.type === 'indemnite').length}
                          </p>
                          <p className="text-sm text-blue-600">éléments configurés</p>
                        </CardContent>
                      </Card>

                      <Card className="bg-green-50">
                        <CardHeader>
                          <CardTitle className="text-green-800">Primes</CardTitle>
                          <CardDescription>Primes diverses (imposables/non-imposables)</CardDescription>
                        </CardHeader>
                        <CardContent>
                          <p className="text-2xl font-bold text-green-900">
                            {salaryComponents.filter(c => c.type === 'prime').length}
                          </p>
                          <p className="text-sm text-green-600">éléments configurés</p>
                        </CardContent>
                      </Card>

                      <Card className="bg-purple-50">
                        <CardHeader>
                          <CardTitle className="text-purple-800">Compléments retraite</CardTitle>
                          <CardDescription>Compléments de retraite (imposables/non-imposables)</CardDescription>
                        </CardHeader>
                        <CardContent>
                          <p className="text-2xl font-bold text-purple-900">
                            {salaryComponents.filter(c => c.type === 'complement_retraite').length}
                          </p>
                          <p className="text-sm text-purple-600">éléments configurés</p>
                        </CardContent>
                      </Card>
                    </div>

                    <Card className="bg-white">
                      <CardHeader>
                        <CardTitle>Éléments de salaire configurés</CardTitle>
                        <CardDescription>Liste des indemnités, primes et compléments disponibles</CardDescription>
                      </CardHeader>
                      <CardContent>
                        {salaryComponents.length > 0 ? (
                          <div className="space-y-2">
                            {salaryComponents.map((component) => (
                              <div key={component.id} className="flex items-center justify-between p-3 border rounded-lg">
                                <div>
                                  <h4 className="font-medium">{component.name}</h4>
                                  <div className="flex items-center space-x-2 mt-1">
                                    <Badge variant={component.type === 'indemnite' ? 'default' : component.type === 'prime' ? 'secondary' : component.type === 'frais' ? 'warning' : 'outline'}>
                                      {component.type === 'indemnite' ? 'Indemnité' : 
                                       component.type === 'prime' ? 'Prime' : 
                                       component.type === 'frais' ? 'Frais' : 'Complément retraite'}
                                    </Badge>
                                    {component.taxable_calculation_type === 'rate' && component.taxable_rate != null && component.taxable_rate < 1.0 && (
                                      <Badge variant="warning">
                                        🧮 {component.taxable_rate === 0.66667 ? '66,667' : component.taxable_rate === 0.33333 ? '33,333' : Math.round(component.taxable_rate * 100)}% imposable
                                      </Badge>
                                    )}
                                    {component.taxable_calculation_type === 'fixed' && component.fixed_taxable_amount > 0 && (
                                      <Badge variant="secondary">
                                        💰 {component.fixed_taxable_amount.toLocaleString()} F imposables
                                      </Badge>
                                    )}
                                    <Badge variant={component.is_taxable ? 'destructive' : 'secondary'}>
                                      {component.is_taxable ? 'Imposable' : 'Non imposable'}
                                    </Badge>
                                  </div>
                                </div>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="border-red-300 text-red-600 hover:bg-red-50"
                                  onClick={() => { if (window.confirm(`Supprimer l'élément "${component.name}" ? Il ne sera plus disponible pour les employés.`)) handleDeleteSalaryComponent(component.id); }}
                                  data-testid={`delete-salary-component-${component.id}`}
                                >
                                  <Trash2 className="w-4 h-4 mr-1" />
                                  Supprimer
                                </Button>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center py-8">
                            <Settings className="w-12 h-12 text-gray-400 mx-auto mb-3" style={{ pointerEvents: 'none' }} />
                            <p className="text-gray-500">Aucun élément de salaire configuré</p>
                            <Button
                              onClick={() => setIsManageSalaryComponentsOpen(true)}
                              className="mt-3 bg-orange-600 hover:bg-orange-700"
                              style={{
                                pointerEvents: 'auto',
                                cursor: 'pointer',
                                position: 'relative',
                                zIndex: 10,
                                touchAction: 'manipulation',
                                userSelect: 'none'
                              }}
                            >
                              Configurer les éléments
                            </Button>
                          </div>
                        )}
                      </CardContent>
                    </Card>
                  </div>
                )}

                {/* System Settings Section */}
                {manageSection === 'system' && (
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800">Paramètres système</h3>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <Card className="bg-white">
                        <CardHeader>
                          <CardTitle>Informations système</CardTitle>
                          <CardDescription>Détails sur la configuration actuelle</CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-3">
                          <div className="flex justify-between">
                            <span>Version du système :</span>
                            <Badge variant="outline">SIRH-CI v2.0</Badge>
                          </div>
                          <div className="flex justify-between">
                            <span>Entreprises actives :</span>
                            <Badge variant="secondary">{companies.filter(c => c.is_active).length}</Badge>
                          </div>
                          <div className="flex justify-between">
                            <span>Utilisateurs actifs :</span>
                            <Badge variant="secondary">{users.filter(u => u.is_active).length}</Badge>
                          </div>
                          <div className="flex justify-between">
                            <span>Conformité réglementaire :</span>
                            <Badge variant="default" className="bg-green-600">🇨🇮 Côte d'Ivoire 2025</Badge>
                          </div>
                          <div className="border-t pt-3 mt-3">
                            <h4 className="font-medium text-gray-900 mb-2">Créateur de l'application</h4>
                            <div className="bg-orange-50 p-3 rounded-lg">
                              <p className="font-semibold text-orange-800">Elouho Ettien Ane Martial</p>
                              <p className="text-sm text-orange-700">Consultant Juriste-Fiscaliste</p>
                              <p className="text-sm text-orange-700">Gestionnaire RH & Paie</p>
                              <div className="flex items-center mt-2">
                                <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                                <span className="text-xs text-orange-600">Expert en réglementation sociale ivoirienne</span>
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      <Card className="bg-white">
                        <CardHeader>
                          <CardTitle>Réglementations appliquées</CardTitle>
                          <CardDescription>Règles fiscales et sociales en vigueur</CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-2">
                          <div className="flex items-center space-x-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm">CNPS : 6.3% salarié, ~16% employeur</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm">IS : Impôt sur le traitement des salaires (Barème progressif 0-35%)</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm">Transport : Seuils non imposables par ville</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm">Ancienneté : 2% après 2 ans 1 mois</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm">Frais d'emploi : 10% non imposable</span>
                          </div>
                        </CardContent>
                      </Card>

                      <Card className="bg-white">
                        <CardHeader>
                          <CardTitle>Configuration Email</CardTitle>
                          <CardDescription>Paramètres SMTP pour l'envoi des bulletins</CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-4">
                          {smtpConfig ? (
                            <div className="space-y-3">
                              <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span className="text-sm">Serveur : {smtpConfig.smtp_server}:{smtpConfig.smtp_port}</span>
                              </div>
                              <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span className="text-sm">Email : {smtpConfig.sender_email}</span>
                              </div>
                              <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span className="text-sm">TLS : {smtpConfig.use_tls ? 'Activé' : 'Désactivé'}</span>
                              </div>
                              <Badge variant="default" className="bg-green-600 text-white">✅ Configuré</Badge>
                            </div>
                          ) : (
                            <div className="text-center py-4">
                              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="text-red-600 text-xl">📧</span>
                              </div>
                              <p className="text-sm text-gray-600 mb-3">Aucune configuration SMTP</p>
                              <Badge variant="destructive">❌ Non configuré</Badge>
                            </div>
                          )}
                          
                          <Button
                            onClick={() => {
                              fetchSmtpConfig();
                              setIsSmtpConfigOpen(true);
                            }}
                            className="w-full bg-blue-600 hover:bg-blue-700"
                          >
                            📧 {smtpConfig ? 'Modifier' : 'Configurer'} SMTP
                          </Button>
                        </CardContent>
                      </Card>
                    </div>
                    

                    {/* Nouvelle carte pour la synchronisation des utilisateurs de production */}
                    <div className="md:col-span-3 mt-6">
                      <Card className="bg-white border-2 border-orange-200">
                        <CardHeader className="bg-orange-50">
                          <CardTitle className="text-orange-800 flex items-center">
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                            </svg>
                            Synchronisation Utilisateurs de Production
                          </CardTitle>
                          <CardDescription className="text-orange-700">
                            Créer ou mettre à jour les utilisateurs clés dans l'environnement de production
                          </CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-4 pt-6">
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <h4 className="font-medium text-blue-800 mb-2 flex items-center">
                              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              Utilisateurs qui seront synchronisés
                            </h4>
                            <div className="grid grid-cols-2 gap-3 text-sm text-blue-700 mt-3">
                              <div className="flex items-center space-x-2 bg-white p-2 rounded">
                                <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                                <span><strong>admin</strong> (Super Admin)</span>
                              </div>
                              <div className="flex items-center space-x-2 bg-white p-2 rounded">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span><strong>DIVINE</strong> (Admin Multi)</span>
                              </div>
                              <div className="flex items-center space-x-2 bg-white p-2 rounded">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span><strong>KORBAN CONSULTING</strong> (Admin Multi)</span>
                              </div>
                              <div className="flex items-center space-x-2 bg-white p-2 rounded">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <span><strong>FREIJ ISAAC</strong> (Admin Multi)</span>
                              </div>
                            </div>
                          </div>
                          
                          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                            <h4 className="font-medium text-yellow-800 mb-2 flex items-center">
                              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                              </svg>
                              Important
                            </h4>
                            <ul className="text-sm text-yellow-700 space-y-1 list-disc list-inside">
                              <li>Cette fonctionnalité crée ou met à jour automatiquement les utilisateurs</li>
                              <li>Les mots de passe seront réinitialisés aux valeurs par défaut</li>
                              <li>Utilisez cette fonction APRÈS chaque déploiement en production</li>
                              <li>Tous les utilisateurs seront actifs et approuvés</li>
                            </ul>
                          </div>
                          
                          <Button 
                            onClick={async () => {
                              if (!window.confirm('Voulez-vous vraiment synchroniser les utilisateurs de production ? Cette opération créera ou mettra à jour 4 utilisateurs clés.')) {
                                return;
                              }
                              
                              try {
                                toast.info('Synchronisation des utilisateurs en cours...');
                                
                                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/sync-production-users`, {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                  }
                                });
                                
                                if (!response.ok) {
                                  const error = await response.json();
                                  throw new Error(error.detail || 'Erreur lors de la synchronisation');
                                }
                                
                                const result = await response.json();
                                
                                // Afficher les résultats détaillés
                                const createdUsers = result.results.filter(r => r.action === 'created');
                                const updatedUsers = result.results.filter(r => r.action === 'updated');
                                
                                let message = `✅ Synchronisation réussie dans l'environnement: ${result.environment}\n\n`;
                                if (createdUsers.length > 0) {
                                  message += `Utilisateurs créés: ${createdUsers.map(u => u.username).join(', ')}\n`;
                                }
                                if (updatedUsers.length > 0) {
                                  message += `Utilisateurs mis à jour: ${updatedUsers.map(u => u.username).join(', ')}`;
                                }
                                
                                toast.success(message);
                                console.log('Résultats détaillés:', result);
                                
                              } catch (error) {
                                console.error('Erreur de synchronisation:', error);
                                toast.error(`Erreur: ${error.message}`);
                              }
                            }}
                            className="w-full bg-orange-600 hover:bg-orange-700 text-white h-14 text-base font-semibold"
                          >
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                            Synchroniser les Utilisateurs de Production
                          </Button>
                          
                          <div className="text-xs text-gray-500 text-center pt-2 border-t">
                            💡 Astuce : Exécutez cette synchronisation après chaque déploiement majeur pour vous assurer que tous les utilisateurs clés peuvent se connecter
                          </div>
                        </CardContent>
                      </Card>
                    </div>

                    {/* Nouvelle carte pour Sauvegarde/Restauration Système */}
                    <div className="md:col-span-3">
                      <Card className="bg-white border-2 border-indigo-200">
                        <CardHeader className="bg-indigo-50">
                          <CardTitle className="text-indigo-800 flex items-center">
                            <Save className="w-5 h-5 mr-2" />
                            Sauvegarde & Restauration Système
                          </CardTitle>
                          <CardDescription className="text-indigo-700">
                            Sauvegarde complète et restauration de toutes les données du système
                          </CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-4 pt-6">
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <h4 className="font-medium text-blue-800 mb-2 flex items-center">
                              <Info className="w-4 h-4 mr-2" />
                              Contenu de la sauvegarde système
                            </h4>
                            <div className="grid grid-cols-2 gap-2 text-sm text-blue-700">
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Toutes les entreprises</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Tous les employés</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Tous les utilisateurs</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Historique des bulletins</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Photos d'employés</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Configuration système</span>
                              </div>
                            </div>
                          </div>
                          
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {/* Bouton Sauvegarde Système */}
                            <Button 
                              onClick={handleSystemBackup}
                              disabled={isBackupInProgress || companies.length === 0}
                              className="bg-blue-600 hover:bg-blue-700 text-white h-12"
                            >
                              {isBackupInProgress ? (
                                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                              ) : (
                                <Download className="w-5 h-5 mr-2" />
                              )}
                              <div className="flex flex-col items-start">
                                <span className="text-sm font-medium">
                                  {isBackupInProgress ? 'Sauvegarde...' : 'Sauvegarder Système'}
                                </span>
                                <span className="text-xs opacity-90">JSON + ZIP</span>
                              </div>
                            </Button>

                            {/* Bouton Restauration Système */}
                            <Button 
                              onClick={() => setIsSystemRestoreDialogOpen(true)}
                              disabled={isRestoreInProgress}
                              className="bg-green-600 hover:bg-green-700 text-white h-12"
                              style={{ pointerEvents: 'auto', cursor: 'pointer', position: 'relative' }}
                            >
                              <Upload className="w-5 h-5 mr-2" />
                              <div className="flex flex-col items-start">
                                <span className="text-sm font-medium">Restaurer Système</span>
                                <span className="text-xs opacity-90">JSON ou ZIP</span>
                              </div>
                            </Button>

                            {/* CustomModal Restauration Système */}
                            <CustomModal
                              isOpen={isSystemRestoreDialogOpen}
                              onClose={() => {
                                setIsSystemRestoreDialogOpen(false);
                                setSystemRestoreFile(null);
                              }}
                              title={
                                <div className="flex items-center text-green-600">
                                  <Upload className="w-5 h-5 mr-2" />
                                  Restaurer Système Complet
                                </div>
                              }
                              maxHeight="80vh"
                            >
                              <div className="space-y-4">
                                <p className="text-gray-600 text-sm">
                                  ⚠️ Cette opération remplacera TOUTES les données actuelles du système
                                </p>
                                <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                                    <h4 className="font-medium text-red-800 mb-2 flex items-center">
                                      <AlertTriangle className="w-4 h-4 mr-2" />
                                      Attention - Action Irréversible
                                    </h4>
                                    <ul className="text-sm text-red-700 space-y-1">
                                      <li>• Remplace toutes les entreprises existantes</li>
                                      <li>• Remplace tous les employés existants</li>
                                      <li>• Remplace tous les utilisateurs (sauf le compte actuel)</li>
                                      <li>• Remplace tout l'historique des bulletins</li>
                                      <li>• Remplace toutes les photos d'employés</li>
                                    </ul>
                                  </div>
                                  
                                  <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                      Sélectionner le fichier de sauvegarde système (.json ou .zip)
                                    </label>
                                    <input
                                      type="file"
                                      accept=".json,.zip"
                                      onChange={(e) => setSystemRestoreFile(e.target.files[0])}
                                      className="block w-full text-sm text-gray-500
                                               file:mr-4 file:py-2 file:px-4
                                               file:rounded-full file:border-0
                                               file:text-sm file:font-semibold
                                               file:bg-green-50 file:text-green-700
                                               hover:file:bg-green-100
                                               border border-gray-300 rounded-lg"
                                    />
                                  </div>
                                  
                                  {systemRestoreFile && (
                                    <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                                      <p className="text-sm text-green-700">
                                        <strong>Fichier sélectionné :</strong> {systemRestoreFile.name}
                                      </p>
                                      <p className="text-xs text-green-600 mt-1">
                                        Taille : {(systemRestoreFile.size / 1024 / 1024).toFixed(2)} MB
                                      </p>
                                    </div>
                                  )}
                                  
                              </div>
                              
                              {/* Footer avec boutons natifs */}
                              <div className="flex flex-col sm:flex-row gap-3 pt-4 mt-4 border-t border-gray-200">
                                <button
                                  onClick={() => {
                                    console.log('Annuler restauration système cliqué');
                                    setIsSystemRestoreDialogOpen(false);
                                    setSystemRestoreFile(null);
                                  }}
                                  disabled={isRestoreInProgress}
                                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                  style={{ 
                                    pointerEvents: isRestoreInProgress ? 'none' : 'auto',
                                    cursor: isRestoreInProgress ? 'not-allowed' : 'pointer',
                                    touchAction: 'manipulation',
                                    userSelect: 'none'
                                  }}
                                  type="button"
                                >
                                  Annuler
                                </button>
                                <button
                                  onClick={() => {
                                    console.log('Restaurer système cliqué');
                                    handleSystemRestore(systemRestoreFile);
                                  }}
                                  disabled={!systemRestoreFile || isRestoreInProgress}
                                  className="flex-1 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                  style={{ 
                                    pointerEvents: (!systemRestoreFile || isRestoreInProgress) ? 'none' : 'auto',
                                    cursor: (!systemRestoreFile || isRestoreInProgress) ? 'not-allowed' : 'pointer',
                                    touchAction: 'manipulation',
                                    userSelect: 'none'
                                  }}
                                  type="button"
                                >
                                  {isRestoreInProgress ? (
                                    <>
                                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                      Restauration...
                                    </>
                                  ) : (
                                    <>
                                      <Upload className="w-4 h-4 mr-2" />
                                      Restaurer Système
                                    </>
                                  )}
                                </button>
                              </div>
                            </CustomModal>
                          </div>
                          
                          <div className="text-xs text-gray-500 border-t pt-3">
                            <div className="flex items-center justify-between">
                              <span>💾 Sauvegarde complète du système SIRH-CI</span>
                              <span>🔒 Accès super_admin requis</span>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                    
                    {/* Nouvelle carte pour Gestion des Fichiers Persistants */}
                    <div className="md:col-span-3">
                      <Card className="bg-white border-2 border-green-200">
                        <CardHeader className="bg-green-50">
                          <CardTitle className="text-green-800 flex items-center">
                            <HardDrive className="w-5 h-5 mr-2" />
                            Gestion des Fichiers Persistants
                          </CardTitle>
                          <CardDescription className="text-green-700">
                            Protection contre la perte de fichiers lors des déploiements
                          </CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-4 pt-6">
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <h4 className="font-medium text-blue-800 mb-2 flex items-center">
                              <Info className="w-4 h-4 mr-2" />
                              Fichiers protégés
                            </h4>
                            <div className="grid grid-cols-2 gap-2 text-sm text-blue-700">
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Photos d'employés</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Logos d'entreprises</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Documents uploadés</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Fichiers administratifs</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Base de données MongoDB</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <span>Fichiers de configuration</span>
                              </div>
                            </div>
                          </div>
                          
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {/* Bouton Sauvegarde Fichiers */}
                            <Button 
                              onClick={handleFileBackup}
                              disabled={isFileBackupInProgress}
                              className="bg-blue-600 hover:bg-blue-700 text-white h-12"
                              style={{
                                pointerEvents: isFileBackupInProgress ? 'none' : 'auto',
                                cursor: isFileBackupInProgress ? 'not-allowed' : 'pointer',
                                position: 'relative',
                                
                                opacity: isFileBackupInProgress ? 0.7 : 1
                              }}
                            >
                              {isFileBackupInProgress ? (
                                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                              ) : (
                                <Download className="w-5 h-5 mr-2" />
                              )}
                              <div className="flex flex-col items-start">
                                <span className="text-sm font-medium">
                                  {isFileBackupInProgress ? 'Sauvegarde...' : 'Sauvegarder Fichiers'}
                                </span>
                                <span className="text-xs opacity-90">Photos + Documents</span>
                              </div>
                            </Button>

                            {/* Bouton Restauration Fichiers */}
                            <Button 
                              onClick={handleFileRestore}
                              disabled={isFileRestoreInProgress}
                              className="bg-green-600 hover:bg-green-700 text-white h-12"
                              style={{
                                pointerEvents: isFileRestoreInProgress ? 'none' : 'auto !important',
                                cursor: isFileRestoreInProgress ? 'not-allowed' : 'pointer',
                                position: 'relative',
                                
                                opacity: isFileRestoreInProgress ? 0.7 : 1
                              }}
                            >
                              {isFileRestoreInProgress ? (
                                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                              ) : (
                                <Upload className="w-5 h-5 mr-2" />
                              )}
                              <div className="flex flex-col items-start">
                                <span className="text-sm font-medium">
                                  {isFileRestoreInProgress ? 'Restauration...' : 'Restaurer Fichiers'}
                                </span>
                                <span className="text-xs opacity-90">Dernière sauvegarde</span>
                              </div>
                            </Button>
                          </div>

                          {/* Section Upload fichier de sauvegarde */}
                          <div className="bg-orange-50 border-2 border-dashed border-orange-300 rounded-lg p-4">
                            <h4 className="font-medium text-orange-800 mb-3 flex items-center">
                              <Upload className="w-4 h-4 mr-2" />
                              Restaurer depuis un fichier téléchargé
                            </h4>
                            <p className="text-xs text-orange-700 mb-3">
                              Utilisez cette option après un déploiement pour restaurer vos photos et documents depuis votre fichier de sauvegarde.
                            </p>
                            
                            <div className="space-y-3">
                              <div className="flex items-center space-x-2">
                                <input
                                  type="file"
                                  id="backup-file-upload"
                                  accept=".tar.gz,.gz,.zip"
                                  onChange={(e) => setFileRestoreUpload(e.target.files[0])}
                                  className="hidden"
                                />
                                <label
                                  htmlFor="backup-file-upload"
                                  className="flex-1 cursor-pointer bg-white border border-orange-300 rounded-lg px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 transition-colors flex items-center justify-center"
                                >
                                  <FileText className="w-4 h-4 mr-2 text-orange-600" />
                                  {fileRestoreUpload ? fileRestoreUpload.name : 'Sélectionner un fichier .tar.gz'}
                                </label>
                              </div>
                              
                              {fileRestoreUpload && (
                                <div className="flex items-center justify-between bg-white rounded-lg px-3 py-2 border border-orange-200">
                                  <div className="flex items-center space-x-2">
                                    <FileText className="w-4 h-4 text-orange-600" />
                                    <span className="text-sm font-medium text-gray-700 truncate max-w-[200px]">
                                      {fileRestoreUpload.name}
                                    </span>
                                    <span className="text-xs text-gray-500">
                                      ({(fileRestoreUpload.size / 1024 / 1024).toFixed(2)} MB)
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => setFileRestoreUpload(null)}
                                    className="text-red-500 hover:text-red-700"
                                  >
                                    <X className="w-4 h-4" />
                                  </button>
                                </div>
                              )}
                              
                              <Button
                                onClick={() => handleFileRestoreFromUpload(fileRestoreUpload)}
                                disabled={!fileRestoreUpload || isUploadRestoreInProgress}
                                className="w-full bg-orange-600 hover:bg-orange-700 text-white"
                              >
                                {isUploadRestoreInProgress ? (
                                  <>
                                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                    Restauration en cours...
                                  </>
                                ) : (
                                  <>
                                    <Upload className="w-4 h-4 mr-2" />
                                    Restaurer depuis ce fichier
                                  </>
                                )}
                              </Button>
                            </div>
                          </div>
                          
                          {/* Liste des sauvegardes disponibles */}
                          <div className="border-t pt-4">
                            <h4 className="text-sm font-medium text-gray-700 mb-2">
                              Sauvegardes disponibles ({backupsList.length})
                            </h4>
                            {backupsList.length > 0 ? (
                              <div className="space-y-2 max-h-32 overflow-y-auto">
                                {backupsList.slice(0, 3).map((backup, index) => (
                                  <div key={index} className="flex items-center justify-between text-xs bg-gray-50 p-2 rounded">
                                    <span className="font-mono">{backup.filename}</span>
                                    <div className="flex items-center space-x-2">
                                      <span className="text-gray-500">{backup.size_mb} MB</span>
                                      <span className="text-blue-600">{backup.age_days}j</span>
                                    </div>
                                  </div>
                                ))}
                                {backupsList.length > 3 && (
                                  <div className="text-xs text-gray-500 text-center">
                                    ... et {backupsList.length - 3} autre(s)
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="text-xs text-gray-500 italic">
                                Aucune sauvegarde disponible
                              </div>
                            )}
                          </div>
                          
                          <div className="text-xs text-gray-500 border-t pt-3">
                            <div className="flex items-center justify-between">
                              <span>🛡️ Protection contre perte de données</span>
                              <span>🔒 Accès super_admin requis</span>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                )}

                {/* PDF Documents Management Section */}
                {manageSection === 'pdf-documents' && (
                  <div className="space-y-4">
                    <PDFManagement selectedCompany={selectedCompany} onViewEmployee={handleViewEmployeeFromDoc} />
                  </div>
                )}
              </TabsContent>

              <TabsContent value="documents" className="space-y-4">
                <PDFManagement selectedCompany={selectedCompany} onViewEmployee={handleViewEmployeeFromDoc} />
              </TabsContent>

              {/* ITS Declarations Tab */}
              <TabsContent value="declarations" className="space-y-6">
                <DeclarationsTab selectedCompany={selectedCompany} token={token} formatCurrency={formatCurrency} employees={employees} />
              </TabsContent>

              {/* Reports Tab */}
              <TabsContent value="reports" className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-900">Rapports et statistiques</h2>
                <AnnualDashboard company={selectedCompany} token={token} />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Card className="bg-white">
                    <CardHeader>
                      <CardTitle>Résumé mensuel</CardTitle>
                      <CardDescription>Statistiques du mois en cours</CardDescription>
                    </CardHeader>
                    <CardContent>
                      {stats && (
                        <div className="space-y-6">
                          {/* Graphique des masses salariales */}
                          <div className="h-80">
                            <SafeResponsiveContainer width="100%" height="100%">
                              <BarChart
                                data={[
                                  {
                                    name: 'Masse Salariale Brute',
                                    value: stats.total_salary_brut || 0
                                  },
                                  {
                                    name: 'Salaire brut imposable IS (impôt traitement salaire)', 
                                    value: stats.total_salary_brut_imposable_is || 0
                                  },
                                  {
                                    name: 'Salaire Brut Social Imposable (CNPS)',
                                    value: stats.total_salary_brut_social_imposable || 0
                                  },
                                  {
                                    name: 'Salaires Nets Payés',
                                    value: stats.total_salary_net || 0
                                  }
                                ]}
                                margin={{
                                  top: 20,
                                  right: 30,
                                  left: 20,
                                  bottom: 60
                                }}
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis 
                                  dataKey="name" 
                                  angle={-45}
                                  textAnchor="end"
                                  height={100}
                                  fontSize={11}
                                />
                                <YAxis 
                                  tickFormatter={(value) => `${(value / 1000000).toFixed(1)}M`}
                                  fontSize={11}
                                />
                                <Tooltip 
                                  formatter={(value) => [formatCurrency(value), '']}
                                  labelStyle={{ color: '#374151' }}
                                />
                                <Bar 
                                  dataKey="value" 
                                  radius={[4, 4, 0, 0]}
                                >
                                  <Cell fill="#F97316" />
                                  <Cell fill="#EAB308" />
                                  <Cell fill="#22C55E" />
                                  <Cell fill="#3B82F6" />
                                </Bar>
                              </BarChart>
                            </SafeResponsiveContainer>
                          </div>

                          {/* Tableau détaillé */}
                          <div className="space-y-2">
                            <h4 className="font-medium text-gray-900 mb-3">Détail des montants</h4>
                            <div className="flex justify-between">
                              <span>Employés actifs:</span>
                              <span className="font-semibold">{stats.employees_count}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-orange-600">Masse salariale brute:</span>
                              <span className="font-semibold text-orange-600">{formatCurrency(stats.total_salary_brut)}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-yellow-600">Salaire brut imposable IS:</span>
                              <span className="font-semibold text-yellow-600">{formatCurrency(stats.total_salary_brut_imposable_is || 0)}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-green-600">Salaire brut social imposable (CNPS):</span>
                              <span className="font-semibold text-green-600">{formatCurrency(stats.total_salary_brut_social_imposable || 0)}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-blue-600">Salaires nets payés:</span>
                              <span className="font-semibold text-blue-600">{formatCurrency(stats.total_salary_net)}</span>
                            </div>
                            <div className="border-t mt-3 pt-3">
                              <div className="flex justify-between">
                                <span>Total CNPS (salarié + employeur):</span>
                                <span className="font-semibold">{formatCurrency(stats.total_cnps)}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>Total IRPP:</span>
                                <span className="font-semibold">{formatCurrency(stats.total_irpp)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                  
                  <Card className="bg-white">
                    <CardHeader>
                      <CardTitle>Actions rapides</CardTitle>
                      <CardDescription>Export et générations</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-3">
                      <Button variant="outline" className="w-full justify-start">
                        <FileText className="w-4 h-4 mr-2" />
                        Exporter les bulletins (PDF)
                      </Button>
                      <Button variant="outline" className="w-full justify-start">
                        <FileText className="w-4 h-4 mr-2" />
                        Déclaration CNPS
                      </Button>
                      <Button 
                        variant="outline" 
                        className="w-full justify-start"
                        onClick={() => setIsITSDeclarationOpen(true)}
                      >
                        <FileText className="w-4 h-4 mr-2" />
                        Déclaration ITS (État 301)
                      </Button>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>
            </Tabs>
          </div>
        )}
      </main>
      
      {/* Footer with creator information */}
      <footer className="bg-gray-50 border-t mt-8">
        <div className="max-w-7xl mx-auto px-4 py-6">
          {/* Informations créateur et contacts */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-4">
            {/* Créateur */}
            <div className="text-center md:text-left">
              <div className="text-sm text-gray-700">
                <span className="font-medium">Créé par : </span>
                <span className="font-semibold text-orange-600">Elouho Ettien Ane Martial</span>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Consultant Juriste-Fiscaliste/Gestionnaire RH & Paie
              </div>
            </div>
            
            {/* Centre d'assistance général */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <Phone className="w-4 h-4 text-green-600" />
                <svg className="w-4 h-4 text-green-500" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="text-sm font-semibold text-gray-800">01 04 29 40 40</span>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Centre d'assistance
              </div>
            </div>
            
            {/* Centre d'assistance RH */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <Phone className="w-4 h-4 text-blue-600" />
                <svg className="w-4 h-4 text-green-500" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="text-sm font-semibold text-gray-800">01 04 29 41 41</span>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Centre d'assistance RH et questions de droit social
              </div>
            </div>
            
            {/* Centre d'assistance Paie */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <Phone className="w-4 h-4 text-purple-600" />
                <svg className="w-4 h-4 text-green-500" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="text-sm font-semibold text-gray-800">01 04 29 42 42</span>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Centre d'assistance Gestion de paie
              </div>
            </div>
            
            {/* Consultation juridique-fiscale */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <Phone className="w-4 h-4 text-orange-600" />
                <svg className="w-4 h-4 text-green-500" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="text-sm font-semibold text-gray-800">07 69 54 54 69</span>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Consultation juridique-fiscale/gestion RH & Paie
              </div>
            </div>
          </div>
          
          {/* Copyright */}
          <div className="border-t pt-4">
            <div className="text-center text-sm text-gray-600">
              © 2025 SIRH-CI/PAIE - Système conforme à la réglementation ivoirienne
            </div>
          </div>
        </div>
      </footer>

      {/* SMTP Configuration Dialog */}
      <Dialog open={isSmtpConfigOpen} onOpenChange={setIsSmtpConfigOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Configuration SMTP</DialogTitle>
            <DialogDescription>
              Configurez les paramètres d'envoi d'emails pour les bulletins de paie
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={handleCreateOrUpdateSmtpConfig} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="smtp_server">Serveur SMTP</Label>
                <Input
                  id="smtp_server"
                  required
                  value={smtpForm.smtp_server}
                  placeholder="smtp.gmail.com"
                  onChange={(e) => setSmtpForm({...smtpForm, smtp_server: e.target.value})}
                />
              </div>
              <div>
                <Label htmlFor="smtp_port">Port</Label>
                <Input
                  id="smtp_port"
                  type="number"
                  required
                  value={smtpForm.smtp_port}
                  onChange={(e) => setSmtpForm({...smtpForm, smtp_port: parseInt(e.target.value)})}
                />
              </div>
            </div>
            <div>
              <Label htmlFor="sender_email">Email expéditeur</Label>
              <Input
                id="sender_email"
                type="email"
                required
                value={smtpForm.sender_email}
                placeholder="rh@entreprise.ci"
                onChange={(e) => setSmtpForm({...smtpForm, sender_email: e.target.value})}
              />
            </div>
            <div>
              <Label htmlFor="sender_password">Mot de passe email</Label>
              <Input
                id="sender_password"
                type="password"
                value={smtpForm.sender_password}
                placeholder={smtpConfig ? "Laisser vide pour conserver" : "Mot de passe"}
                onChange={(e) => setSmtpForm({...smtpForm, sender_password: e.target.value})}
              />
            </div>
            <div>
              <Label htmlFor="sender_name">Nom expéditeur</Label>
              <Input
                id="sender_name"
                required
                value={smtpForm.sender_name}
                placeholder="Service RH"
                onChange={(e) => setSmtpForm({...smtpForm, sender_name: e.target.value})}
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="use_tls"
                checked={smtpForm.use_tls}
                onChange={(e) => setSmtpForm({...smtpForm, use_tls: e.target.checked})}
                className="rounded border-gray-300 focus:ring-blue-500"
              />
              <Label htmlFor="use_tls">Utiliser TLS/SSL (recommandé)</Label>
            </div>
            <div className="flex justify-end space-x-3 pt-4">
              <Button
                type="button"
                variant="outline"
                onClick={() => setIsSmtpConfigOpen(false)}
              >
                Annuler
              </Button>
              <Button 
                type="submit" 
                className="bg-blue-600 hover:bg-blue-700"
                style={{ 
                  pointerEvents: 'auto',
                  cursor: 'pointer',
                  position: 'relative',
                  zIndex: 1
                }}
              >
                {smtpConfig ? 'Mettre à jour' : 'Créer'} la configuration
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      {/* ITS Declaration Dialog */}
      <Dialog open={isITSDeclarationOpen} onOpenChange={setIsITSDeclarationOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Génération Déclaration ITS (État 301)</DialogTitle>
            <DialogDescription>
              Sélectionnez la période pour générer la déclaration ITS mensuelle
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="its_year">Année</Label>
                <select
                  id="its_year"
                  value={itsDeclarationForm.year}
                  onChange={(e) => setItsDeclarationForm({...itsDeclarationForm, year: parseInt(e.target.value)})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {[...Array(5)].map((_, i) => {
                    const year = new Date().getFullYear() - 2 + i;
                    return (
                      <option key={year} value={year}>{year}</option>
                    );
                  })}
                </select>
              </div>
              <div>
                <Label htmlFor="its_month">Mois</Label>
                <select
                  id="its_month"
                  value={itsDeclarationForm.month}
                  onChange={(e) => setItsDeclarationForm({...itsDeclarationForm, month: parseInt(e.target.value)})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {[
                    {value: 1, label: 'Janvier'},
                    {value: 2, label: 'Février'},
                    {value: 3, label: 'Mars'},
                    {value: 4, label: 'Avril'},
                    {value: 5, label: 'Mai'},
                    {value: 6, label: 'Juin'},
                    {value: 7, label: 'Juillet'},
                    {value: 8, label: 'Août'},
                    {value: 9, label: 'Septembre'},
                    {value: 10, label: 'Octobre'},
                    {value: 11, label: 'Novembre'},
                    {value: 12, label: 'Décembre'}
                  ].map(month => (
                    <option key={month.value} value={month.value}>{month.label}</option>
                  ))}
                </select>
              </div>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-lg">
              <h4 className="text-sm font-medium text-blue-900 mb-2">Informations importantes</h4>
              <ul className="text-sm text-blue-800 space-y-1">
                <li>• Le fichier généré est basé sur le modèle officiel ITS (État 301)</li>
                <li>• Les données sont pré-remplies avec les informations de paie</li>
                <li>• Vérifiez les données avant transmission aux services fiscaux</li>
                <li>• Le N°CC de l'entreprise sera automatiquement inclus</li>
              </ul>
            </div>
          </div>
          <div className="flex justify-end space-x-2 mt-4">
            <Button variant="outline" onClick={() => setIsITSDeclarationOpen(false)}>
              Annuler
            </Button>
            <Button 
              onClick={handleGenerateITSDeclaration}
              className="bg-orange-600 hover:bg-orange-700"
            >
              <FileText className="w-4 h-4 mr-2" />
              Générer la déclaration
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Vue plein écran - Gestion des éléments de salaire (accessible depuis tous les onglets) */}
      {isManageSalaryComponentsOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            width: '100%',
            maxWidth: '900px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
          }}>
            {/* Header */}
            <div style={{
              padding: '24px',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f9fafb'
            }}>
              <div>
                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>
                  <Settings className="w-6 h-6 inline mr-2 text-orange-600" />
                  Gestion des éléments de salaire
                </h2>
                <p style={{ fontSize: '14px', color: '#6b7280' }}>
                  Créer et gérer les indemnités, primes et compléments de retraite
                </p>
              </div>
              <button
                onClick={() => setIsManageSalaryComponentsOpen(false)}
                style={{
                  padding: '8px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  color: '#6b7280',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Body */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '24px'
            }}>
              {/* Formulaire de création */}
              <div style={{
                backgroundColor: '#fff7ed',
                border: '2px solid #fed7aa',
                borderRadius: '8px',
                padding: '20px',
                marginBottom: '24px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#9a3412', margin: 0 }}>
                    {editingSalaryComponent ? '✏️ Modifier l\'élément' : '➕ Créer un nouvel élément'}
                  </h3>
                  {editingSalaryComponent && (
                    <button
                      type="button"
                      onClick={handleCancelEdit}
                      style={{
                        padding: '6px 12px',
                        backgroundColor: '#6b7280',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: '600',
                        cursor: 'pointer'
                      }}
                    >
                      ❌ Annuler
                    </button>
                  )}
                </div>
                <form onSubmit={handleCreateSalaryComponent} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                        Nom de l'élément *
                      </label>
                      <input
                        type="text"
                        required
                        value={salaryComponentForm.name}
                        onChange={(e) => setSalaryComponentForm({...salaryComponentForm, name: e.target.value})}
                        placeholder="Ex: Prime de rendement"
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '14px',
                          pointerEvents: 'auto',
                          position: 'relative'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                        Type *
                      </label>
                      <SimpleNativeSelect
                        value={salaryComponentForm.type}
                        onValueChange={handleSalaryComponentTypeChange}
                        placeholder="Type de composante"
                        options={[
                          {value: 'indemnite', label: 'Indemnité'},
                          {value: 'prime', label: 'Prime'},
                          {value: 'frais', label: 'Frais'},
                          {value: 'complement_retraite', label: 'Allocation spéciale Art. 116-1'}
                        ]}
                      />
                    </div>
                  </div>
                  
                  {/* Checkbox Allocation spéciale */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', backgroundColor: '#fef3c7', borderRadius: '6px', border: '2px solid #f59e0b' }}>
                    <input
                      type="checkbox"
                      id="is_special_allowance_fullscreen"
                      checked={salaryComponentForm.is_special_allowance || false}
                      onChange={(e) => setSalaryComponentForm({...salaryComponentForm, is_special_allowance: e.target.checked})}
                      style={{
                        width: '18px',
                        height: '18px',
                        cursor: 'pointer',
                        pointerEvents: 'auto'
                      }}
                    />
                    <label htmlFor="is_special_allowance_fullscreen" style={{ fontSize: '14px', color: '#92400e', cursor: 'pointer', fontWeight: '600' }}>
                      📋 Allocation spéciale (exonération 10% Art. 116-1 CGI)
                    </label>
                  </div>
                  
                  {/* Note explicative pour les allocations spéciales */}
                  {salaryComponentForm.is_special_allowance && (
                    <div style={{ padding: '12px', backgroundColor: '#fffbeb', borderRadius: '6px', border: '1px solid #fbbf24' }}>
                      <p style={{ fontSize: '13px', color: '#92400e', margin: 0, marginBottom: '6px', fontWeight: '600' }}>
                        ℹ️ <strong>Note sur les allocations spéciales :</strong>
                      </p>
                      <p style={{ fontSize: '12px', color: '#92400e', margin: 0, marginBottom: '4px' }}>
                        • L'exonération est plafonnée à <strong>10% de la rémunération totale hors avantages</strong>
                      </p>
                      <p style={{ fontSize: '12px', color: '#92400e', margin: 0, marginBottom: '4px' }}>
                        • Le calcul se fait <strong>globalement</strong> pour toutes les allocations spéciales lors de la paie
                      </p>
                      <p style={{ fontSize: '12px', color: '#92400e', margin: 0 }}>
                        • Éléments concernés : Indemnité de mission, représentation, fonction, responsabilité, frais de vêtements, indemnité kilométrique, etc.
                      </p>
                    </div>
                  )}
                  
                  {/* Calcul automatique de la part imposable - masqué si allocation spéciale */}
                  {!salaryComponentForm.is_special_allowance && (
                  <>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', backgroundColor: '#fef3c7', borderRadius: '6px', border: '2px solid #fbbf24' }}>
                    <input
                      type="checkbox"
                      id="auto_taxable_fullscreen"
                      checked={salaryComponentForm.auto_taxable_calculation || false}
                      onChange={(e) => setSalaryComponentForm({...salaryComponentForm, auto_taxable_calculation: e.target.checked})}
                      style={{
                        width: '18px',
                        height: '18px',
                        cursor: 'pointer',
                        pointerEvents: 'auto'
                      }}
                    />
                    <label htmlFor="auto_taxable_fullscreen" style={{ fontSize: '14px', color: '#92400e', cursor: 'pointer', fontWeight: '600' }}>
                      🧮 Calcul automatique de la part imposable
                    </label>
                  </div>
                  
                  {/* Taux d'imposition (visible seulement si calcul automatique activé) */}
                  {salaryComponentForm.auto_taxable_calculation && (
                    <div style={{ padding: '16px', backgroundColor: '#fff7ed', borderRadius: '6px', border: '1px solid #fed7aa' }}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#9a3412', marginBottom: '12px' }}>
                        📊 Type de calcul de la part imposable
                      </label>
                      
                      {/* Radio buttons pour choisir entre Taux et Montant fixe */}
                      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <input
                            type="radio"
                            id="calculation_type_rate"
                            name="calculation_type"
                            checked={salaryComponentForm.taxable_calculation_type === 'rate' || !salaryComponentForm.taxable_calculation_type}
                            onChange={() => setSalaryComponentForm({...salaryComponentForm, taxable_calculation_type: 'rate'})}
                            style={{ cursor: 'pointer' }}
                          />
                          <label htmlFor="calculation_type_rate" style={{ fontSize: '14px', fontWeight: '500', color: '#92400e', cursor: 'pointer' }}>
                            📈 Taux (en %)
                          </label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <input
                            type="radio"
                            id="calculation_type_fixed"
                            name="calculation_type"
                            checked={salaryComponentForm.taxable_calculation_type === 'fixed'}
                            onChange={() => setSalaryComponentForm({...salaryComponentForm, taxable_calculation_type: 'fixed'})}
                            style={{ cursor: 'pointer' }}
                          />
                          <label htmlFor="calculation_type_fixed" style={{ fontSize: '14px', fontWeight: '500', color: '#92400e', cursor: 'pointer' }}>
                            💰 Montant imposable fixe (en FCFA)
                          </label>
                        </div>
                      </div>
                      
                      {/* Section Taux (si type = rate) */}
                      {(!salaryComponentForm.taxable_calculation_type || salaryComponentForm.taxable_calculation_type === 'rate') && (
                        <div>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
                            <button
                              type="button"
                              onClick={() => applyTaxableRate(0)}
                              data-testid="taxable-rate-0-btn"
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.taxable_rate === 0 ? '2px solid #ea580c' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.taxable_rate === 0 ? '#fed7aa' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.taxable_rate === 0 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              0%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyTaxableRate(0.33333)}
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.taxable_rate === 0.33333 ? '2px solid #ea580c' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.taxable_rate === 0.33333 ? '#fed7aa' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.taxable_rate === 0.33333 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              33,333%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyTaxableRate(0.5)}
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.taxable_rate === 0.5 ? '2px solid #ea580c' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.taxable_rate === 0.5 ? '#fed7aa' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.taxable_rate === 0.5 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              50%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyTaxableRate(0.66667)}
                              data-testid="taxable-rate-two-thirds-btn"
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.taxable_rate === 0.66667 ? '2px solid #ea580c' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.taxable_rate === 0.66667 ? '#fed7aa' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.taxable_rate === 0.66667 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              66,667%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyTaxableRate(1.0)}
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.taxable_rate === 1.0 ? '2px solid #ea580c' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.taxable_rate === 1.0 ? '#fed7aa' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.taxable_rate === 1.0 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              Total (100%)
                            </button>
                          </div>
                          <div style={{ marginTop: '12px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#92400e', marginBottom: '6px' }}>
                              Ou entrer un taux personnalisé (0 à 1)
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              max="1"
                              value={salaryComponentForm.taxable_rate ?? 1.0}
                              onChange={(e) => { const v = parseFloat(e.target.value); if (!isNaN(v)) applyTaxableRate(Math.min(1, Math.max(0, v))); }}
                              placeholder="Ex: 0.33333 pour 1/3"
                              style={{
                                width: '100%',
                                padding: '10px 12px',
                            border: '1px solid #fed7aa',
                            borderRadius: '6px',
                            fontSize: '14px',
                            pointerEvents: 'auto',
                            position: 'relative'
                          }}
                        />
                        <p style={{ fontSize: '11px', color: '#92400e', marginTop: '6px', margin: 0 }}>
                          💡 Exemple : Pour 1/3 imposable (frais télécommunication, carburant...), entrer 0.33333
                        </p>
                      </div>
                        </div>
                      )}
                      
                      {/* Section Montant fixe (si type = fixed) */}
                      {salaryComponentForm.taxable_calculation_type === 'fixed' && (
                        <div>
                          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#92400e', marginBottom: '6px' }}>
                            Montant imposable fixe (en FCFA) - indépendant du montant total
                          </label>
                          <input
                            type="number"
                            step="1"
                            min="0"
                            value={salaryComponentForm.fixed_taxable_amount || 0}
                            onChange={(e) => setSalaryComponentForm({...salaryComponentForm, fixed_taxable_amount: parseFloat(e.target.value)})}
                            placeholder="Ex: 5000 pour 5 000 FCFA imposables"
                            style={{
                              width: '100%',
                              padding: '10px 12px',
                              border: '1px solid #fed7aa',
                              borderRadius: '6px',
                              fontSize: '14px',
                              pointerEvents: 'auto',
                              position: 'relative'
                            }}
                          />
                          <p style={{ fontSize: '11px', color: '#92400e', marginTop: '6px', margin: 0 }}>
                            💡 Exemple : Pour un élément de 15 000 F où seulement 5 000 F sont imposables, entrer 5000
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                  </>
                  )}
                  
                  
                  {/* Calcul automatique de la part exonérée */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', backgroundColor: '#dcfce7', borderRadius: '6px', border: '2px solid #22c55e' }}>
                    <input
                      type="checkbox"
                      id="auto_exempt_fullscreen"
                      checked={salaryComponentForm.auto_exempt_calculation || false}
                      onChange={(e) => setSalaryComponentForm({...salaryComponentForm, auto_exempt_calculation: e.target.checked})}
                      style={{
                        width: '18px',
                        height: '18px',
                        cursor: 'pointer',
                        pointerEvents: 'auto'
                      }}
                    />
                    <label htmlFor="auto_exempt_fullscreen" style={{ fontSize: '14px', color: '#15803d', cursor: 'pointer', fontWeight: '600' }}>
                      🧮 Calcul automatique de la part exonérée
                    </label>
                  </div>
                  
                  {/* Taux/Montant exonéré (visible seulement si calcul automatique exonéré activé) */}
                  {salaryComponentForm.auto_exempt_calculation && (
                    <div style={{ padding: '16px', backgroundColor: '#f0fdf4', borderRadius: '6px', border: '1px solid #86efac' }}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#15803d', marginBottom: '12px' }}>
                        📊 Type de calcul de la part exonérée
                      </label>
                      
                      {/* Radio buttons pour choisir entre Taux et Montant fixe */}
                      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <input
                            type="radio"
                            id="exempt_calculation_type_rate"
                            name="exempt_calculation_type"
                            checked={salaryComponentForm.exempt_calculation_type === 'rate' || !salaryComponentForm.exempt_calculation_type}
                            onChange={() => setSalaryComponentForm({...salaryComponentForm, exempt_calculation_type: 'rate'})}
                            style={{ cursor: 'pointer' }}
                          />
                          <label htmlFor="exempt_calculation_type_rate" style={{ fontSize: '14px', fontWeight: '500', color: '#15803d', cursor: 'pointer' }}>
                            📈 Taux (en %)
                          </label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <input
                            type="radio"
                            id="exempt_calculation_type_fixed"
                            name="exempt_calculation_type"
                            checked={salaryComponentForm.exempt_calculation_type === 'fixed'}
                            onChange={() => setSalaryComponentForm({...salaryComponentForm, exempt_calculation_type: 'fixed'})}
                            style={{ cursor: 'pointer' }}
                          />
                          <label htmlFor="exempt_calculation_type_fixed" style={{ fontSize: '14px', fontWeight: '500', color: '#15803d', cursor: 'pointer' }}>
                            💰 Montant exonéré fixe (en FCFA)
                          </label>
                        </div>
                      </div>
                      
                      {/* Section Taux exonéré (si type = rate) */}
                      {(!salaryComponentForm.exempt_calculation_type || salaryComponentForm.exempt_calculation_type === 'rate') && (
                        <div>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
                            <button
                              type="button"
                              onClick={() => applyExemptRate(0)}
                              data-testid="exempt-rate-0-btn"
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.exempt_rate === 0 ? '2px solid #16a34a' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.exempt_rate === 0 ? '#86efac' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.exempt_rate === 0 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              0%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyExemptRate(0.33333)}
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.exempt_rate === 0.33333 ? '2px solid #16a34a' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.exempt_rate === 0.33333 ? '#86efac' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.exempt_rate === 0.33333 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              33,333%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyExemptRate(0.5)}
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.exempt_rate === 0.5 ? '2px solid #16a34a' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.exempt_rate === 0.5 ? '#86efac' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.exempt_rate === 0.5 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              50%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyExemptRate(0.66667)}
                              data-testid="exempt-rate-two-thirds-btn"
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.exempt_rate === 0.66667 ? '2px solid #16a34a' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.exempt_rate === 0.66667 ? '#86efac' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.exempt_rate === 0.66667 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              66,667%
                            </button>
                            <button
                              type="button"
                              onClick={() => applyExemptRate(1.0)}
                              style={{
                                padding: '12px',
                                border: salaryComponentForm.exempt_rate === 1.0 ? '2px solid #16a34a' : '1px solid #d1d5db',
                                borderRadius: '6px',
                                backgroundColor: salaryComponentForm.exempt_rate === 1.0 ? '#86efac' : 'white',
                                cursor: 'pointer',
                                fontWeight: salaryComponentForm.exempt_rate === 1.0 ? '600' : '400',
                                fontSize: '13px',
                                transition: 'all 0.2s'
                              }}
                            >
                              Total (100%)
                            </button>
                          </div>
                          <div style={{ marginTop: '12px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#15803d', marginBottom: '6px' }}>
                              Ou entrer un taux personnalisé (0 à 1)
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              max="1"
                              value={salaryComponentForm.exempt_rate ?? 1.0}
                              onChange={(e) => { const v = parseFloat(e.target.value); if (!isNaN(v)) applyExemptRate(Math.min(1, Math.max(0, v))); }}
                              placeholder="Ex: 0.9 pour 90% exonéré"
                              style={{
                                width: '100%',
                                padding: '10px 12px',
                                border: '1px solid #86efac',
                                borderRadius: '6px',
                                fontSize: '14px',
                                pointerEvents: 'auto',
                                position: 'relative'
                              }}
                            />
                            <p style={{ fontSize: '11px', color: '#15803d', marginTop: '6px', margin: 0 }}>
                              💡 Exemple : Pour 90% exonéré (remboursement de frais), entrer 0.9
                            </p>
                          </div>
                        </div>
                      )}
                      
                      {/* Section Montant fixe exonéré (si type = fixed) */}
                      {salaryComponentForm.exempt_calculation_type === 'fixed' && (
                        <div>
                          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#15803d', marginBottom: '6px' }}>
                            Montant exonéré fixe (en FCFA) - indépendant du montant total
                          </label>
                          <input
                            type="number"
                            step="1"
                            min="0"
                            value={salaryComponentForm.fixed_exempt_amount || 0}
                            onChange={(e) => setSalaryComponentForm({...salaryComponentForm, fixed_exempt_amount: parseFloat(e.target.value)})}
                            placeholder="Ex: 10000 pour 10 000 FCFA exonérés"
                            style={{
                              width: '100%',
                              padding: '10px 12px',
                              border: '1px solid #86efac',
                              borderRadius: '6px',
                              fontSize: '14px',
                              pointerEvents: 'auto',
                              position: 'relative'
                            }}
                          />
                          <p style={{ fontSize: '11px', color: '#15803d', marginTop: '6px', margin: 0 }}>
                            💡 Exemple : Pour un remboursement où 10 000 F sont toujours exonérés, entrer 10000
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                  
                  <div style={{ padding: '12px', backgroundColor: '#eff6ff', borderRadius: '6px', border: '1px solid #bfdbfe' }}>
                    <p style={{ fontSize: '13px', color: '#1e40af', margin: 0, marginBottom: '6px' }}>
                      ℹ️ <strong>Note :</strong> Le montant sera renseigné lors de l'assignation de cet élément à un employé.
                    </p>
                    <p style={{ fontSize: '13px', color: '#1e40af', margin: 0 }}>
                      🌍 <strong>Élément global :</strong> Cet élément sera disponible pour toutes les entreprises de l'application.
                    </p>
                  </div>
                  <button
                    type="submit"
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#ea580c',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      pointerEvents: 'auto',
                      position: 'relative',
                      zIndex: 10,
                      touchAction: 'manipulation',
                      userSelect: 'none'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c2410c'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ea580c'}
                  >
                    {editingSalaryComponent ? '✏️ Modifier l\'élément' : '➕ Créer l\'élément'}
                  </button>
                </form>
              </div>

              {/* Liste des éléments existants */}
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                  📋 Éléments existants
                </h3>
                {salaryComponents.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {salaryComponents.map((component) => (
                      <div key={component.id} style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'}
                      onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}>
                        <div>
                          <h4 className="font-medium">{component.name}</h4>
                          <div className="flex items-center space-x-2 mt-1">
                            <Badge variant={component.type === 'indemnite' ? 'default' : component.type === 'prime' ? 'secondary' : component.type === 'frais' ? 'warning' : 'outline'}>
                              {component.type === 'indemnite' ? 'Indemnité' : 
                               component.type === 'prime' ? 'Prime' : 
                               component.type === 'frais' ? 'Frais' : 'Complément retraite'}
                            </Badge>
                            {component.taxable_calculation_type === 'rate' && component.taxable_rate != null && component.taxable_rate < 1.0 && (
                              <Badge variant="warning">
                                🧮 {component.taxable_rate === 0.66667 ? '66,667' : component.taxable_rate === 0.33333 ? '33,333' : Math.round(component.taxable_rate * 100)}% imposable
                              </Badge>
                            )}
                            {component.taxable_calculation_type === 'fixed' && component.fixed_taxable_amount > 0 && (
                              <Badge variant="secondary">
                                💰 {component.fixed_taxable_amount.toLocaleString()} F imposables
                              </Badge>
                            )}
                            <Badge variant={component.is_taxable ? 'destructive' : 'secondary'}>
                              {component.is_taxable ? 'Imposable' : 'Non imposable'}
                            </Badge>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button
                            onClick={() => handleEditSalaryComponent(component)}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#0284c7',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                pointerEvents: 'auto',
                                position: 'relative',
                                zIndex: 10,
                                touchAction: 'manipulation',
                                userSelect: 'none'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0369a1'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0284c7'}
                            >
                              ✏️ Modifier
                            </button>
                          <button
                            onClick={() => handleDeleteSalaryComponent(component.id)}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#dc2626',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                pointerEvents: 'auto',
                                position: 'relative',
                                zIndex: 10,
                                touchAction: 'manipulation',
                              userSelect: 'none'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#b91c1c'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
                          >
                            🗑️ Supprimer
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{
                    textAlign: 'center',
                    padding: '48px 24px',
                    backgroundColor: '#f9fafb',
                    borderRadius: '8px',
                    border: '2px dashed #d1d5db'
                  }}>
                    <Settings className="w-16 h-16 text-gray-400 mx-auto mb-3" />
                    <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '8px' }}>
                      Aucun élément de salaire configuré
                    </p>
                    <p style={{ fontSize: '14px', color: '#9ca3af' }}>
                      Utilisez le formulaire ci-dessus pour créer votre premier élément
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px 24px',
              borderTop: '1px solid #e5e7eb',
              backgroundColor: '#f9fafb',
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setIsManageSalaryComponentsOpen(false)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#6b7280',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#4b5563'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6b7280'}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal pour afficher le livre de paie */}
      {isViewingLivrePaie && livrePaieData && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            maxWidth: '95%',
            maxHeight: '90vh',
            width: '1400px',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
          }}>
            {/* Header */}
            <div style={{
              padding: '20px 30px',
              borderBottom: '2px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f9fafb'
            }}>
              <div>
                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                  📖 Livre de Paie - {selectedCompany?.name}
                </h2>
                <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '4px' }}>
                  Période : {livrePaiePeriod.month}/{livrePaiePeriod.year} • {livrePaieData.length} bulletin(s)
                </p>
              </div>
              <button
                onClick={() => setIsViewingLivrePaie(false)}
                style={{
                  backgroundColor: '#ef4444',
                  color: 'white',
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ef4444'}
              >
                ✕ Fermer
              </button>
            </div>

            {/* Content - Tableau scrollable */}
            <div style={{
              flex: 1,
              overflow: 'auto',
              padding: '20px'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '11px',
                backgroundColor: 'white'
              }}>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f3f4f6', zIndex: 10 }}>
                  <tr>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>Date</th>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>Nom</th>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>Prénoms</th>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>Sal. Catégoriel</th>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>Sal. Brut</th>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>SBI</th>
                    <th colSpan={5} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold', backgroundColor: '#fef2f2' }}>Retenues Salariales</th>
                    <th colSpan={8} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold', backgroundColor: '#fef7ed' }}>Retenues Patronales</th>
                    <th rowSpan={2} style={{ border: '1px solid #d1d5db', padding: '8px', fontWeight: 'bold' }}>Salaire Net</th>
                  </tr>
                  <tr>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef2f2' }}>CNPS</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef2f2' }}>IS</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef2f2' }}>CMU</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef2f2' }}>Autres</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef2f2' }}>Total</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>Prest. Fam.</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>Accidents</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>IS Patronal</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>CNPS Emp.</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>Taxe App.</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>Formation</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>CMU Pat.</th>
                    <th style={{ border: '1px solid #d1d5db', padding: '6px', fontSize: '10px', backgroundColor: '#fef7ed' }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {livrePaieData.map((item, index) => {
                    const emp = item.employee;
                    const results = item.payroll;
                    
                    // Récupérer les valeurs avec les bons noms de champs
                    const cnps_salarie = results.cnps_salarie || 0;
                    const is_salarie = results.is_salarie || results.is_total || 0;
                    const cmu_salarie = results.cmu_salarie || 0;
                    const avances = results.avances || 0;
                    const total_ret_sal = results.retenues_salariales_total || (cnps_salarie + is_salarie + cmu_salarie + avances);
                    
                    const prestations_familiales = results.prestations_familiales || 0;
                    const accidents_travail = results.accidents_travail || 0;
                    const is_patronal = results.is_patronal || 0;
                    const cnps_employeur = results.cnps_employeur_base || 0;
                    const taxe_apprentissage = results.taxe_apprentissage || 0;
                    const formation_continue = results.formation_continue || 0;
                    const cmu_employeur = results.cmu_employeur || 0;
                    const total_ret_pat = Math.round(prestations_familiales + accidents_travail + is_patronal + cnps_employeur + taxe_apprentissage + formation_continue + cmu_employeur);
                    
                    // Date de paie
                    const date_paie = results.created_at ? new Date(results.created_at).toLocaleDateString('fr-FR') : `${livrePaiePeriod.month}/${livrePaiePeriod.year}`;
                    
                    return (
                      <tr key={index} style={{ backgroundColor: index % 2 === 0 ? 'white' : '#f9fafb' }}>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'center' }}>{date_paie}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px' }}>{emp.last_name}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px' }}>{emp.first_name}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right' }}>{Math.round(results.salary_categoriel || 0).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right' }}>{Math.round(results.salary_brut || 0).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', fontWeight: '600' }}>{Math.round(results.salary_brut_imposable_is || 0).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef2f2' }}>{Math.round(cnps_salarie).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef2f2' }}>{Math.round(is_salarie).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef2f2' }}>{Math.round(cmu_salarie).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef2f2' }}>{Math.round(avances).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef2f2', fontWeight: '600' }}>{Math.round(total_ret_sal).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(prestations_familiales).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(accidents_travail).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(is_patronal).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(cnps_employeur).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(taxe_apprentissage).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(formation_continue).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed' }}>{Math.round(cmu_employeur).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', backgroundColor: '#fef7ed', fontWeight: '600' }}>{Math.round(total_ret_pat).toLocaleString('fr-FR')}</td>
                        <td style={{ border: '1px solid #d1d5db', padding: '6px', textAlign: 'right', fontWeight: 'bold', backgroundColor: '#dcfce7' }}>{Math.round(results.salary_net || results.net_salary || 0).toLocaleString('fr-FR')}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Footer avec totaux */}
            <div style={{
              padding: '15px 30px',
              borderTop: '2px solid #e5e7eb',
              backgroundColor: '#f9fafb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>
                📊 {livrePaieData.length} employé(s) • Période {livrePaiePeriod.month}/{livrePaiePeriod.year}
              </div>
              <button
                onClick={() => setIsViewingLivrePaie(false)}
                style={{
                  backgroundColor: '#6b7280',
                  color: 'white',
                  padding: '8px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#4b5563'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6b7280'}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal d'alerte pour les contrats expirants */}
      <Dialog open={showContractAlert} onOpenChange={setShowContractAlert}>
        <DialogContent className="sm:max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <AlertOctagon className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <DialogTitle className="text-xl font-bold text-red-600">
                  ⚠️ Alerte : Contrats à Expiration Imminente
                </DialogTitle>
                <DialogDescription className="text-gray-600 mt-1">
                  {expiringContracts.length} contrat(s) expire(nt) dans les 5 prochains jours ou ont déjà expiré
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>

          <div className="space-y-3 mt-4">
            {expiringContracts.map((contract, index) => (
              <div 
                key={contract.contract_id}
                className={`p-4 rounded-lg border-2 ${
                  contract.is_expired 
                    ? 'bg-red-50 border-red-300' 
                    : contract.days_until_expiry <= 2
                    ? 'bg-orange-50 border-orange-300'
                    : 'bg-yellow-50 border-yellow-300'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <User className="w-5 h-5 text-gray-700" />
                      <h3 className="font-bold text-lg text-gray-900">
                        {contract.employee_name}
                      </h3>
                      <span className={`px-2 py-1 rounded text-xs font-semibold ${
                        contract.is_expired 
                          ? 'bg-red-200 text-red-800' 
                          : contract.days_until_expiry <= 2
                          ? 'bg-orange-200 text-orange-800'
                          : 'bg-yellow-200 text-yellow-800'
                      }`}>
                        {contract.is_expired 
                          ? `EXPIRÉ depuis ${Math.abs(contract.days_until_expiry)} jour(s)` 
                          : `${contract.days_until_expiry} jour(s) restant(s)`
                        }
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-3 text-sm">
                      <div>
                        <span className="text-gray-600">Matricule:</span>
                        <span className="ml-2 font-semibold text-gray-900">{contract.matricule}</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Type de contrat:</span>
                        <span className="ml-2 font-semibold text-gray-900">{contract.contract_type}</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Contrat:</span>
                        <span className="ml-2 font-semibold text-gray-900">{contract.contract_title}</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Date d'expiration:</span>
                        <span className="ml-2 font-semibold text-red-600">
                          {new Date(contract.end_date).toLocaleDateString('fr-FR')}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <Button
                    onClick={() => {
                      // Trouver l'employé et ouvrir son dossier administratif
                      const employee = employees.find(e => e.id === contract.employee_id);
                      if (employee) {
                        setSelectedEmployeeForAdmin(employee);
                        setIsAdminFolderOpen(true);
                        setAdminFolderTab('contracts');
                        setShowContractAlert(false);
                      }
                    }}
                    className="bg-blue-600 hover:bg-blue-700 text-white"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Voir le dossier
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 pt-4 border-t flex justify-between items-center">
            <div className="text-sm text-gray-600">
              💡 <span className="font-semibold">Conseil:</span> Pensez à renouveler ces contrats pour éviter toute interruption d'activité.
            </div>
            <Button
              onClick={() => setShowContractAlert(false)}
              variant="outline"
            >
              Fermer
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog de recherche globale */}
      <Dialog open={isSearchOpen} onOpenChange={(open) => { setIsSearchOpen(open); if (!open) setSearchQuery(''); }}>
        <DialogContent className="sm:max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center space-x-2">
              <Search className="w-5 h-5 text-purple-600" />
              <span>Recherche rapide</span>
            </DialogTitle>
            <DialogDescription>
              Recherchez des employés, entreprises ou bulletins de paie
            </DialogDescription>
          </DialogHeader>
          
          {/* Champ de recherche */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <Input
              type="text"
              placeholder="Tapez pour rechercher... (nom, matricule, email, entreprise...)"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 pr-4 py-3 text-lg border-2 border-purple-200 focus:border-purple-500 rounded-lg"
              autoFocus
            />
            {searchQuery && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setSearchQuery('')}
                className="absolute right-2 top-1/2 transform -translate-y-1/2"
              >
                <X className="w-4 h-4" />
              </Button>
            )}
          </div>
          
          {/* Résultats de recherche */}
          <div className="flex-1 overflow-y-auto mt-4 space-y-4">
            {isSearching && (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-6 h-6 animate-spin text-purple-600" />
                <span className="ml-2 text-gray-600">Recherche en cours...</span>
              </div>
            )}
            
            {!isSearching && searchQuery.length >= 2 && (
              <>
                {/* Résultats Employés */}
                {searchResults.employees.length > 0 && (
                  <div>
                    <h3 className="text-sm font-semibold text-gray-600 mb-2 flex items-center">
                      <Users className="w-4 h-4 mr-2 text-orange-600" />
                      Employés ({searchResults.employees.length})
                    </h3>
                    <p className="text-xs text-gray-400 mb-2">Cliquez sur un employé pour voir son bulletin</p>
                    <div className="space-y-1">
                      {searchResults.employees.map((emp) => (
                        <button
                          key={emp.id}
                          onClick={() => navigateToSearchResult('employee', emp)}
                          className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-purple-50 transition-colors text-left border border-transparent hover:border-purple-200"
                          title="Cliquez pour voir le bulletin de paie"
                        >
                          <div className="flex items-center space-x-3">
                            <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                              <FileText className="w-5 h-5 text-orange-600" />
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">{emp.prenoms} {emp.nom}</p>
                              <p className="text-sm text-gray-500">{emp.poste} • {emp.matricule}</p>
                            </div>
                          </div>
                          <div className="text-right">
                            <p className="text-sm font-medium text-green-600">{formatCurrency(emp.salary_categoriel || 0)}</p>
                            <p className="text-xs text-purple-500 font-medium">→ Voir bulletin</p>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Résultats Entreprises */}
                {searchResults.companies.length > 0 && (
                  <div>
                    <h3 className="text-sm font-semibold text-gray-600 mb-2 flex items-center">
                      <Building2 className="w-4 h-4 mr-2 text-green-600" />
                      Entreprises ({searchResults.companies.length})
                    </h3>
                    <div className="space-y-1">
                      {searchResults.companies.map((comp) => (
                        <button
                          key={comp.id}
                          onClick={() => navigateToSearchResult('company', comp)}
                          className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-green-50 transition-colors text-left border border-transparent hover:border-green-200"
                        >
                          <div className="flex items-center space-x-3">
                            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                              <Building2 className="w-5 h-5 text-green-600" />
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">{comp.name}</p>
                              <p className="text-sm text-gray-500">{comp.ville === 'abidjan' ? 'Abidjan' : comp.ville === 'bouake' ? 'Bouaké' : 'Autres'} • {comp.gerant || 'N/A'}</p>
                            </div>
                          </div>
                          <div className="text-right">
                            <p className="text-sm font-medium text-blue-600">{companyStats[comp.id]?.employees_count || 0} employés</p>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Résultats Bulletins */}
                {searchResults.payrolls.length > 0 && (
                  <div>
                    <h3 className="text-sm font-semibold text-gray-600 mb-2 flex items-center">
                      <FileText className="w-4 h-4 mr-2 text-blue-600" />
                      Bulletins de paie ({searchResults.payrolls.length})
                    </h3>
                    <div className="space-y-1">
                      {searchResults.payrolls.map((p, idx) => {
                        const payroll = p.payroll || p;
                        const employee = p.employee || employees.find(e => e.id === payroll.employee_id);
                        return (
                          <button
                            key={idx}
                            onClick={() => navigateToSearchResult('payroll', { ...payroll, employee })}
                            className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-blue-50 transition-colors text-left border border-transparent hover:border-blue-200"
                          >
                            <div className="flex items-center space-x-3">
                              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                <FileText className="w-5 h-5 text-blue-600" />
                              </div>
                              <div>
                                <p className="font-medium text-gray-900">{employee?.prenoms} {employee?.nom}</p>
                                <p className="text-sm text-gray-500">{payroll.month}/{payroll.year} • {employee?.matricule}</p>
                              </div>
                            </div>
                            <div className="text-right">
                              <p className="text-sm font-medium text-green-600">{formatCurrency(payroll.salary_net || 0)}</p>
                              <p className="text-xs text-gray-400">Net à payer</p>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
                
                {/* Aucun résultat */}
                {searchResults.employees.length === 0 && 
                 searchResults.companies.length === 0 && 
                 searchResults.payrolls.length === 0 && (
                  <div className="text-center py-8">
                    <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                    <p className="text-gray-500">Aucun résultat pour "{searchQuery}"</p>
                    <p className="text-sm text-gray-400 mt-1">Essayez avec un autre terme de recherche</p>
                  </div>
                )}
              </>
            )}
            
            {/* Message initial */}
            {!isSearching && searchQuery.length < 2 && (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Search className="w-8 h-8 text-purple-600" />
                </div>
                <p className="text-gray-600 font-medium">Recherche rapide</p>
                <p className="text-sm text-gray-400 mt-1">Tapez au moins 2 caractères pour lancer la recherche</p>
                <div className="mt-4 flex flex-wrap justify-center gap-2">
                  <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs">Employés</span>
                  <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs">Entreprises</span>
                  <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs">Bulletins</span>
                </div>
              </div>
            )}
          </div>
          
          {/* Footer avec raccourci */}
          <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-between text-sm text-gray-500">
            <span>Appuyez sur <kbd className="px-2 py-1 bg-gray-100 rounded font-semibold">Échap</kbd> pour fermer</span>
            <span className="hidden tablet:inline">Raccourci: <kbd className="px-2 py-1 bg-gray-100 rounded font-semibold">Ctrl+K</kbd></span>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog de résumé salarial */}
      <Dialog open={showSalaryPreview} onOpenChange={setShowSalaryPreview}>
        <DialogContent className="sm:max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center space-x-2">
              <Calculator className="w-6 h-6 text-green-600" />
              <span>Résumé Salarial</span>
            </DialogTitle>
            <DialogDescription>
              Détail du calcul de paie pour {salaryPreviewData?.employee_name || 'Employé'}
            </DialogDescription>
          </DialogHeader>
          
          {isLoadingSalaryPreview ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="w-8 h-8 animate-spin text-green-600" />
              <span className="ml-3 text-gray-600">Calcul en cours...</span>
            </div>
          ) : salaryPreviewData && (
            <div className="space-y-6">
              {/* Informations de l'employé */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Employé</p>
                    <p className="font-semibold text-gray-900">{salaryPreviewData.employee_name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Matricule</p>
                    <p className="font-semibold text-gray-900">{salaryPreviewData.matricule}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Poste</p>
                    <p className="font-semibold text-gray-900">{salaryPreviewData.poste}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Entreprise</p>
                    <p className="font-semibold text-gray-900">{salaryPreviewData.company_name}</p>
                  </div>
                </div>
              </div>

              {/* Éléments du salaire */}
              <div>
                <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <Plus className="w-4 h-4 mr-2 text-green-600" />
                  Éléments du Salaire
                </h3>
                <div className="bg-white border rounded-lg divide-y">
                  <div className="flex justify-between p-3">
                    <span className="text-gray-600">Salaire catégoriel</span>
                    <span className="font-medium">{formatCurrency(salaryPreviewData.salaire_categoriel)}</span>
                  </div>
                  {salaryPreviewData.sursalaire > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Sursalaire</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.sursalaire)}</span>
                    </div>
                  )}
                  {salaryPreviewData.prime_transport > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Prime de transport</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.prime_transport)}</span>
                    </div>
                  )}
                  {salaryPreviewData.prime_logement > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Prime de logement</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.prime_logement)}</span>
                    </div>
                  )}
                  {salaryPreviewData.prime_fonction > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Prime de fonction</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.prime_fonction)}</span>
                    </div>
                  )}
                  {salaryPreviewData.prime_anciennete > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Prime d'ancienneté</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.prime_anciennete)}</span>
                    </div>
                  )}
                  {salaryPreviewData.avantages_nature > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Avantages en nature</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.avantages_nature)}</span>
                    </div>
                  )}
                  {salaryPreviewData.avantages_argent > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-gray-600">Avantages en argent</span>
                      <span className="font-medium">{formatCurrency(salaryPreviewData.avantages_argent)}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Résumé des montants principaux */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Salaire Brut */}
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <div className="flex items-center space-x-2 mb-2">
                    <TrendingUp className="w-5 h-5 text-blue-600" />
                    <span className="text-sm font-medium text-blue-700">Salaire Brut</span>
                  </div>
                  <div className="text-2xl font-bold text-blue-800">
                    {formatCurrency(salaryPreviewData.salaire_brut)}
                  </div>
                </div>

                {/* Salaire Brut Imposable */}
                <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
                  <div className="flex items-center space-x-2 mb-2">
                    <Calculator className="w-5 h-5 text-orange-600" />
                    <span className="text-sm font-medium text-orange-700">Brut Imposable</span>
                  </div>
                  <div className="text-2xl font-bold text-orange-800">
                    {formatCurrency(salaryPreviewData.salaire_brut_imposable)}
                  </div>
                  <p className="text-xs text-orange-600 mt-1">
                    Transport exonéré: {formatCurrency(salaryPreviewData.transport_non_imposable)}
                  </p>
                </div>

                {/* Net à Payer */}
                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                  <div className="flex items-center space-x-2 mb-2">
                    <Banknote className="w-5 h-5 text-green-600" />
                    <span className="text-sm font-medium text-green-700">Net à Payer</span>
                  </div>
                  <div className="text-2xl font-bold text-green-800">
                    {formatCurrency(salaryPreviewData.salaire_net)}
                  </div>
                </div>
              </div>

              {/* Détail des retenues */}
              <div>
                <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <Minus className="w-4 h-4 mr-2 text-red-600" />
                  Retenues
                </h3>
                <div className="bg-red-50 border border-red-200 rounded-lg divide-y divide-red-200">
                  <div className="flex justify-between p-3">
                    <span className="text-red-700">CNPS Salarié (6.3%)</span>
                    <span className="font-medium text-red-800">{formatCurrency(salaryPreviewData.cnps_salarie)}</span>
                  </div>
                  <div className="flex justify-between p-3">
                    <span className="text-red-700">ITS</span>
                    <span className="font-medium text-red-800">{formatCurrency(salaryPreviewData.its)}</span>
                  </div>
                  <div className="flex justify-between p-3">
                    <span className="text-red-700">IGR (CN)</span>
                    <span className="font-medium text-red-800">{formatCurrency(salaryPreviewData.igr)}</span>
                  </div>
                  {salaryPreviewData.cmu > 0 && (
                    <div className="flex justify-between p-3">
                      <span className="text-red-700">CMU</span>
                      <span className="font-medium text-red-800">{formatCurrency(salaryPreviewData.cmu)}</span>
                    </div>
                  )}
                  <div className="flex justify-between p-3 bg-red-100">
                    <span className="font-bold text-red-800">Total Retenues</span>
                    <span className="font-bold text-red-900">{formatCurrency(salaryPreviewData.total_retenues)}</span>
                  </div>
                </div>
              </div>

              {/* Note d'information */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <Info className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                  <div className="text-sm text-yellow-800">
                    <p className="font-medium">Information</p>
                    <p>Ce résumé est une estimation basée sur les données salariales de l'employé. 
                       Le bulletin de paie officiel peut inclure des éléments supplémentaires (heures supplémentaires, primes exceptionnelles, avances, prêts, etc.).</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {/* Boutons d'action */}
          <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
            <Button variant="outline" onClick={() => setShowSalaryPreview(false)}>
              Fermer
            </Button>
            <Button onClick={goToFullBulletin} className="bg-green-600 hover:bg-green-700">
              <FileText className="w-4 h-4 mr-2" />
              Voir le bulletin complet
            </Button>
          </div>
        </DialogContent>
      </Dialog>

    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AuthAppWrapper />
    </AuthProvider>
  );
}

const AuthAppWrapper = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 to-green-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-green-600 rounded-lg flex items-center justify-center mx-auto mb-4 animate-pulse">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">SIRH-CI/PAIE</h2>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <MainApp /> : <AuthPages />;
};

export default App;
